/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never;
    };

import {
  cacheExchange,
  OptimisticMutationResolver as GraphCacheOptimisticMutationResolver,
  Resolver as GraphCacheResolver,
  UpdateResolver as GraphCacheUpdateResolver,
} from '@urql/exchange-graphcache';

import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  BigInt: { input: string; output: string };
  ISO8601Date: { input: string; output: string };
  ISO8601DateTime: { input: string; output: string };
  JSON: { input: unknown; output: unknown };
};

export type IActionLog = {
  __typename: 'ActionLog';
  actionType: IActionLogTypeEnum;
  actionValue?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  invalidatedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  mod?: Maybe<IMod>;
};

export type IActionLogTally = {
  __typename: 'ActionLogTally';
  armor: Scalars['Int']['output'];
  body: Scalars['Int']['output'];
  mind: Scalars['Int']['output'];
  resolve: Scalars['Int']['output'];
  skillUses: Array<ICharacterSkill>;
};

export enum IActionLogTypeEnum {
  ApplyStatusEffect = 'apply_status_effect',
  Armor = 'armor',
  Body = 'body',
  ClearStatusEffects = 'clear_status_effects',
  EconMind = 'econ_mind',
  EconResolve = 'econ_resolve',
  EquipArmor = 'equip_armor',
  EquipMainHand = 'equip_main_hand',
  EquipOffHand = 'equip_off_hand',
  GiveSkill = 'give_skill',
  LeaveBattlefield = 'leave_battlefield',
  LeftLeg = 'left_leg',
  MainHand = 'main_hand',
  Mind = 'mind',
  OffHand = 'off_hand',
  RefreshImpactSkills = 'refresh_impact_skills',
  Resolve = 'resolve',
  RightLeg = 'right_leg',
  SkillUse = 'skill_use',
  TrackShot = 'track_shot',
}

/** Autogenerated input type of AddSkillMutation */
export type IAddSkillMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['Int']['input'];
  entityType: IModEntityTypeEnum;
  level: Scalars['Int']['input'];
  modId: Scalars['Int']['input'];
  skillId: Scalars['Int']['input'];
};

/** Autogenerated return type of AddSkillMutation. */
export type IAddSkillMutationPayload = {
  __typename: 'AddSkillMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of AdvanceTurnMutation */
export type IAdvanceTurnMutationInput = {
  advance?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modId: Scalars['Int']['input'];
};

/** Autogenerated return type of AdvanceTurnMutation. */
export type IAdvanceTurnMutationPayload = {
  __typename: 'AdvanceTurnMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of AppendItemTransactionMutation */
export type IAppendItemTransactionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['Int']['input'];
  parentTransactionId: Scalars['Int']['input'];
  stack?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of AppendItemTransactionMutation. */
export type IAppendItemTransactionMutationPayload = {
  __typename: 'AppendItemTransactionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  event?: Maybe<IEvent>;
};

/** Autogenerated input type of ApplyBranchContractMutation */
export type IApplyBranchContractMutationInput = {
  branchId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  contractId: Scalars['Int']['input'];
  nextYear?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of ApplyBranchContractMutation. */
export type IApplyBranchContractMutationPayload = {
  __typename: 'ApplyBranchContractMutationPayload';
  branch?: Maybe<IBranch>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ApplyChallengeResolutionMutation */
export type IApplyChallengeResolutionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['Int']['input'];
  entityType: IModEntityTypeEnum;
  modId: Scalars['Int']['input'];
  modLogId?: InputMaybe<Scalars['Int']['input']>;
  result?: InputMaybe<IModChallengeResolutionEnum>;
  targetId: Scalars['Int']['input'];
  targetType: IModEntityTypeEnum;
};

/** Autogenerated return type of ApplyChallengeResolutionMutation. */
export type IApplyChallengeResolutionMutationPayload = {
  __typename: 'ApplyChallengeResolutionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of ApplyChangeMutation */
export type IApplyChangeMutationInput = {
  actionType: IModSettableAttributeEnum;
  actionValue?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['Int']['input'];
  entityType: IModEntityTypeEnum;
  modId: Scalars['Int']['input'];
  removeStatusEffect?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of ApplyChangeMutation. */
export type IApplyChangeMutationPayload = {
  __typename: 'ApplyChangeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of ApplyDamageMutation */
export type IApplyDamageMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  damages: Array<IModDamageInput>;
  entityId: Scalars['Int']['input'];
  entityType: IModEntityTypeEnum;
  modId: Scalars['Int']['input'];
  modLogId?: InputMaybe<Scalars['Int']['input']>;
  originId?: InputMaybe<Scalars['Int']['input']>;
  originType?: InputMaybe<IModEntityTypeEnum>;
};

/** Autogenerated return type of ApplyDamageMutation. */
export type IApplyDamageMutationPayload = {
  __typename: 'ApplyDamageMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
  modLog?: Maybe<IModLog>;
};

/** Autogenerated input type of ApplyEnvironmentalEffectMutation */
export type IApplyEnvironmentalEffectMutationInput = {
  apply?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  targetEntities?: InputMaybe<Array<IModParticipantInput>>;
  targetType?: InputMaybe<IModEntityTypeEnum>;
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of ApplyEnvironmentalEffectMutation. */
export type IApplyEnvironmentalEffectMutationPayload = {
  __typename: 'ApplyEnvironmentalEffectMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of ApplyShieldingMutation */
export type IApplyShieldingMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<IModEntityTypeEnum>;
  modId: Scalars['Int']['input'];
  sharedDefense?: InputMaybe<Scalars['Boolean']['input']>;
  targetId: Scalars['Int']['input'];
  targetType: IModEntityTypeEnum;
};

/** Autogenerated return type of ApplyShieldingMutation. */
export type IApplyShieldingMutationPayload = {
  __typename: 'ApplyShieldingMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of ApplySkillEffectMutation */
export type IApplySkillEffectMutationInput = {
  apply: Scalars['Boolean']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['Int']['input'];
  entityType: IModEntityTypeEnum;
  modId: Scalars['Int']['input'];
  modLogId: Scalars['Int']['input'];
  skillId: Scalars['Int']['input'];
  subtarget?: InputMaybe<Scalars['String']['input']>;
  targetId: Scalars['Int']['input'];
  targetType: IModEntityTypeEnum;
};

/** Autogenerated return type of ApplySkillEffectMutation. */
export type IApplySkillEffectMutationPayload = {
  __typename: 'ApplySkillEffectMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
  modLog?: Maybe<IModLog>;
};

/** Autogenerated input type of AssignBranchLocationMutation */
export type IAssignBranchLocationMutationInput = {
  branchId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  forRemoval?: InputMaybe<Scalars['Boolean']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Autogenerated return type of AssignBranchLocationMutation. */
export type IAssignBranchLocationMutationPayload = {
  __typename: 'AssignBranchLocationMutationPayload';
  branch?: Maybe<IBranch>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AssignBranchOwnershipMutation */
export type IAssignBranchOwnershipMutationInput = {
  branchId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  playerId: Scalars['Int']['input'];
};

/** Autogenerated return type of AssignBranchOwnershipMutation. */
export type IAssignBranchOwnershipMutationPayload = {
  __typename: 'AssignBranchOwnershipMutationPayload';
  branch?: Maybe<IBranch>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AssignTemporaryManagerMutation */
export type IAssignTemporaryManagerMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['Int']['input'];
  forRemoval?: InputMaybe<Scalars['Boolean']['input']>;
  playerId: Scalars['Int']['input'];
};

/** Autogenerated return type of AssignTemporaryManagerMutation. */
export type IAssignTemporaryManagerMutationPayload = {
  __typename: 'AssignTemporaryManagerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  event?: Maybe<IEvent>;
};

/** Autogenerated input type of AssistImpactSkillMutation */
export type IAssistImpactSkillMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<IModEntityTypeEnum>;
  modId: Scalars['Int']['input'];
  skillId: Scalars['Int']['input'];
  targetId: Scalars['Int']['input'];
  targetType: IModEntityTypeEnum;
};

/** Autogenerated return type of AssistImpactSkillMutation. */
export type IAssistImpactSkillMutationPayload = {
  __typename: 'AssistImpactSkillMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

export enum IAssistantFlagEnum {
  Directorship = 'directorship',
  Logistics = 'logistics',
  ModManager = 'mod_manager',
  NewPlayerAssistant = 'new_player_assistant',
  Registration = 'registration',
}

export type IAttendanceInvoice = {
  __typename: 'AttendanceInvoice';
  attending: Scalars['Boolean']['output'];
  baseCost: Scalars['Float']['output'];
  buildGrowth?: Maybe<Scalars['Int']['output']>;
  change?: Maybe<IInvoiceChange>;
  extraXpCost: Scalars['Float']['output'];
  id: Scalars['Int']['output'];
  kind: IEventAttendeeKindEnum;
  paid: Scalars['Boolean']['output'];
  ticket: ITicketInvoice;
  totalCost: Scalars['Float']['output'];
  user: IUserInvoice;
};

export type IAttendeeCharacter = {
  __typename: 'AttendeeCharacter';
  actionLogs: Array<ITalliedActionLog>;
  attendance: IAttendeeCharacterAttendanceEnum;
  buildGrowth: Scalars['Int']['output'];
  cap?: Maybe<ICap>;
  character: ICharacter;
  id: Scalars['Int']['output'];
  payment: IAttendeeCharacterPaymentEnum;
  printRequestStatus: IAttendeeCharacterPrintRequestStatusEnum;
  ticket: ITicket;
};

export enum IAttendeeCharacterAttendanceEnum {
  Attending = 'attending',
  NonAttending = 'non_attending',
}

export enum IAttendeeCharacterPaymentEnum {
  Paid = 'paid',
  Unpaid = 'unpaid',
}

export enum IAttendeeCharacterPrintRequestStatusEnum {
  PrintDeclined = 'print_declined',
  PrintRequested = 'print_requested',
}

export type IAttendeeShift = {
  __typename: 'AttendeeShift';
  id: Scalars['Int']['output'];
  player: IUser;
  shift: IShift;
  status: IAttendeeShiftStatusEnum;
};

export enum IAttendeeShiftStatusEnum {
  Fulfilled = 'fulfilled',
  Unfulfilled = 'unfulfilled',
}

export enum IBlueprintActionEnum {
  Label = 'label',
  Print = 'print',
}

export type IBranch = {
  __typename: 'Branch';
  activePlayers?: Maybe<Array<IUserOrganization>>;
  branchAssistants: Array<IUserOrganization>;
  branchContracts: Array<IBranchContract>;
  branchOwners: Array<IBranchOwner>;
  caps?: Maybe<Array<ICap>>;
  correctiveActions?: Maybe<Array<ICorrectiveAction>>;
  district?: Maybe<Scalars['String']['output']>;
  eventsWithinContract: Array<IEvent>;
  id: Scalars['Int']['output'];
  invoice?: Maybe<IInvoice>;
  location?: Maybe<ILocation>;
  locations: Array<ILocation>;
  name: Scalars['String']['output'];
  organization: IOrganization;
  region: Scalars['String']['output'];
  registrationUrl?: Maybe<Scalars['String']['output']>;
  shorthand: Scalars['String']['output'];
  website?: Maybe<Scalars['String']['output']>;
};

export type IBranchEventsWithinContractArgs = {
  at?: InputMaybe<Scalars['String']['input']>;
};

export type IBranchLocationArgs = {
  locationId: Scalars['Int']['input'];
};

export type IBranchContract = {
  __typename: 'BranchContract';
  active: Scalars['Boolean']['output'];
  contract: IContract;
  endsAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  startsAt: Scalars['ISO8601DateTime']['output'];
};

export type IBranchOwner = {
  __typename: 'BranchOwner';
  id: Scalars['Int']['output'];
  user: IUser;
};

export type ICachedUserAttendance = {
  __typename: 'CachedUserAttendance';
  activeCorrectiveActionsCount: Scalars['Int']['output'];
  attendanceCount: Scalars['Int']['output'];
  branch: IBranch;
  firstEvent?: Maybe<IEvent>;
  firstEventAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  lastEvent?: Maybe<IEvent>;
  lastEventAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  roleInOrganization: IOrganizationRoleEnum;
  user: IUser;
};

export type ICap = {
  __typename: 'Cap';
  amount: Scalars['Int']['output'];
  branch: IBranch;
  createdAt: Scalars['ISO8601DateTime']['output'];
  grantor: IUser;
  id: Scalars['Int']['output'];
  reason: Scalars['String']['output'];
  state: ICapStateEnum;
  user: IUser;
};

export enum ICapStateEnum {
  Active = 'active',
  Removed = 'removed',
}

export type ICharacter = {
  __typename: 'Character';
  alive: Scalars['Boolean']['output'];
  body: Scalars['Int']['output'];
  buildEarned: Scalars['Int']['output'];
  buildUsed: Scalars['Int']['output'];
  canBeDeleted: Scalars['Boolean']['output'];
  characterFellowships: Array<ICharacterFellowship>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  currentBody: Scalars['Int']['output'];
  currentLife: Scalars['Int']['output'];
  currentMind: Scalars['Int']['output'];
  currentResolve: Scalars['Int']['output'];
  faithId: Scalars['Int']['output'];
  faithLevel: Scalars['Int']['output'];
  fellowshipsMissingSubpillar: Array<IFellowship>;
  fractures: Array<IFracture>;
  id: Scalars['Int']['output'];
  infection: Scalars['Int']['output'];
  inventories: Array<IInventory>;
  itemTransaction?: Maybe<IItemTransaction>;
  itemTransactions: Array<IItemTransaction>;
  latestLifecycleGainsThisYear: Array<Scalars['ISO8601DateTime']['output']>;
  legacyHomeGameCount: Scalars['Int']['output'];
  lifeCapacity: Scalars['Int']['output'];
  lifeGain: Scalars['Int']['output'];
  lifeLoss: Scalars['Int']['output'];
  lifecycles: Array<ILifecycle>;
  lineageId: Scalars['Int']['output'];
  loreIds: Array<Scalars['Int']['output']>;
  mind: Scalars['Int']['output'];
  mindPenalty: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  organization: IOrganization;
  playerNotes?: Maybe<Scalars['String']['output']>;
  resolve: Scalars['Int']['output'];
  retiredCharacter?: Maybe<ICharacter>;
  retirementPaths: IRetirementPaths;
  skills: Array<ICharacterSkill>;
  staffNotes?: Maybe<Scalars['String']['output']>;
  status: ICharacterStatusEnum;
  strainId: Scalars['Int']['output'];
  totalHomeGameCount: Scalars['Int']['output'];
  user: IUser;
  variant: Scalars['String']['output'];
  version: Scalars['Int']['output'];
  xpAudits: Array<IXpAudit>;
};

export type ICharacterFracturesArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ICharacterItemTransactionArgs = {
  id: Scalars['Int']['input'];
};

export type ICharacterItemTransactionsArgs = {
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  itemId?: InputMaybe<Scalars['Int']['input']>;
};

export type ICharacterConstraint = {
  __typename: 'CharacterConstraint';
  faiths?: Maybe<Array<ICharacterSubConstraint>>;
  reputations?: Maybe<Array<ICharacterSubConstraint>>;
  requiresSubpillar?: Maybe<Array<ICharacterSubConstraint>>;
  skills?: Maybe<Array<ICharacterSubConstraint>>;
  societies?: Maybe<Array<ICharacterSubConstraint>>;
};

export type ICharacterConstraintInput = {
  id: Scalars['Int']['input'];
  level: Scalars['Int']['input'];
  positions?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type ICharacterFellowship = {
  __typename: 'CharacterFellowship';
  character: ICharacter;
  fellowship: IFellowship;
  id: Scalars['Int']['output'];
  rank: Scalars['Int']['output'];
  removedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type ICharacterFellowshipInput = {
  fellowshipId?: InputMaybe<Scalars['Int']['input']>;
  forRemoval?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
};

export type ICharacterSkill = {
  __typename: 'CharacterSkill';
  characterSkillId: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  level: Scalars['Int']['output'];
  positions?: Maybe<Array<Scalars['Int']['output']>>;
  remainingUses?: Maybe<Scalars['Int']['output']>;
};

export enum ICharacterStatusEnum {
  Active = 'active',
  Npc = 'npc',
  Retired = 'retired',
  Staged = 'staged',
}

export type ICharacterSubConstraint = {
  __typename: 'CharacterSubConstraint';
  id: Scalars['Int']['output'];
  level: Scalars['Int']['output'];
};

export type ICheckinCharacterInput = {
  capConversion?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['Int']['input'];
};

/** Autogenerated input type of CheckinCharacterMutation */
export type ICheckinCharacterMutationInput = {
  characters?: InputMaybe<Array<ICheckinCharacterInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventAttendeeId: Scalars['Int']['input'];
};

/** Autogenerated return type of CheckinCharacterMutation. */
export type ICheckinCharacterMutationPayload = {
  __typename: 'CheckinCharacterMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  eventAttendee?: Maybe<IEventAttendee>;
};

/** Autogenerated input type of CheckinMutation */
export type ICheckinMutationInput = {
  buildGrowth?: InputMaybe<Scalars['Int']['input']>;
  characters?: InputMaybe<Array<ICheckinCharacterInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  inviterId?: InputMaybe<Scalars['Int']['input']>;
  isAttending?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  playerId?: InputMaybe<Scalars['Int']['input']>;
  printRequestOnCharacterIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  referralInfo?: InputMaybe<Scalars['String']['input']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ticketId: Scalars['Int']['input'];
};

/** Autogenerated return type of CheckinMutation. */
export type ICheckinMutationPayload = {
  __typename: 'CheckinMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  eventAttendee?: Maybe<IEventAttendee>;
};

/** Autogenerated input type of ClaimModRewardsMutation */
export type IClaimModRewardsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemsToClaim: Array<IModRewardClaimInput>;
  modId: Scalars['Int']['input'];
  modSignupId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of ClaimModRewardsMutation. */
export type IClaimModRewardsMutationPayload = {
  __typename: 'ClaimModRewardsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  modSignup?: Maybe<IModSignup>;
};

export type IClearingHouse = {
  __typename: 'ClearingHouse';
  distribution: IItemTransactionDistributionEnum;
  itemId: Scalars['Int']['output'];
  itemKind: IItemKindEnum;
  itemName: Scalars['String']['output'];
  source: IItemTransactionSourceEnum;
  stack: Scalars['Int']['output'];
};

/** Autogenerated input type of CompleteScatterShotMutation */
export type ICompleteScatterShotMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<IModEntityTypeEnum>;
  modId: Scalars['Int']['input'];
};

/** Autogenerated return type of CompleteScatterShotMutation. */
export type ICompleteScatterShotMutationPayload = {
  __typename: 'CompleteScatterShotMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

export type IConstraintContainerInput = {
  faiths?: InputMaybe<Array<ICharacterConstraintInput>>;
  reputations?: InputMaybe<Array<ICharacterConstraintInput>>;
  requiresSubpillar?: InputMaybe<Array<ICharacterConstraintInput>>;
  skills?: InputMaybe<Array<ICharacterConstraintInput>>;
  societies?: InputMaybe<Array<ICharacterConstraintInput>>;
};

export type IContract = {
  __typename: 'Contract';
  id: Scalars['Int']['output'];
  maxGames: Scalars['Int']['output'];
  maxVirtualGames: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type ICoord = {
  __typename: 'Coord';
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type ICoordInput = {
  x: Scalars['Float']['input'];
  y: Scalars['Float']['input'];
};

/** Autogenerated input type of CopyCharacterBuildMutation */
export type ICopyCharacterBuildMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sourceCharacterId: Scalars['Int']['input'];
  targetCharacterId: Scalars['Int']['input'];
};

/** Autogenerated return type of CopyCharacterBuildMutation. */
export type ICopyCharacterBuildMutationPayload = {
  __typename: 'CopyCharacterBuildMutationPayload';
  character?: Maybe<ICharacter>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CopyEventSetupMutation */
export type ICopyEventSetupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  sourceEventId: Scalars['Int']['input'];
  targetEventId: Scalars['Int']['input'];
};

/** Autogenerated return type of CopyEventSetupMutation. */
export type ICopyEventSetupMutationPayload = {
  __typename: 'CopyEventSetupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  event?: Maybe<IEvent>;
};

export type ICorrectiveAction = {
  __typename: 'CorrectiveAction';
  branch: IBranch;
  createdAt: Scalars['ISO8601Date']['output'];
  endsAt?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['Int']['output'];
  issuer: IUser;
  kind: ICorrectiveActionKindEnum;
  reason?: Maybe<Scalars['String']['output']>;
  startsAt?: Maybe<Scalars['ISO8601Date']['output']>;
  user: IUser;
};

export enum ICorrectiveActionKindEnum {
  RefusalOfService = 'refusal_of_service',
  Suspension = 'suspension',
  Violation = 'violation',
  Warning = 'warning',
}

export type ICraftableItem = {
  __typename: 'CraftableItem';
  id: Scalars['Int']['output'];
  kind: IItemKindEnum;
  metadata: IItemMetadata;
  name: Scalars['String']['output'];
};

export type ICraftingComponent = {
  __typename: 'CraftingComponent';
  acceptsExpiredItemWithinDays: Scalars['Int']['output'];
  amount: Scalars['Int']['output'];
  component: IItem;
  id: Scalars['Int']['output'];
  itemCrafting: IItemCrafting;
};

export type ICraftingFinalProduct = {
  __typename: 'CraftingFinalProduct';
  finalProduct: IItem;
  id: Scalars['Int']['output'];
  stack: Scalars['Int']['output'];
};

/** Autogenerated input type of CreateCapMutation */
export type ICreateCapMutationInput = {
  amount: Scalars['Int']['input'];
  branchId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reason: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateCapMutation. */
export type ICreateCapMutationPayload = {
  __typename: 'CreateCapMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<IUser>;
};

/** Autogenerated input type of CreateCharacterActionLogMutation */
export type ICreateCharacterActionLogMutationInput = {
  actionType: IActionLogTypeEnum;
  actionValue?: InputMaybe<Scalars['Int']['input']>;
  attendeeCharacterId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  modId?: InputMaybe<Scalars['Int']['input']>;
  repeats?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateCharacterActionLogMutation. */
export type ICreateCharacterActionLogMutationPayload = {
  __typename: 'CreateCharacterActionLogMutationPayload';
  attendeeCharacter?: Maybe<IAttendeeCharacter>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCharacterFellowshipMutation */
export type ICreateCharacterFellowshipMutationInput = {
  characterId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fellowshipId: Scalars['Int']['input'];
  rank?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateCharacterFellowshipMutation. */
export type ICreateCharacterFellowshipMutationPayload = {
  __typename: 'CreateCharacterFellowshipMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  fellowship?: Maybe<IFellowship>;
};

/** Autogenerated input type of CreateCharacterMutation */
export type ICreateCharacterMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  npc?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateCharacterMutation. */
export type ICreateCharacterMutationPayload = {
  __typename: 'CreateCharacterMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<IUser>;
};

/** Autogenerated input type of CreateCorrectiveActionMutation */
export type ICreateCorrectiveActionMutationInput = {
  branchId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['String']['input']>;
  kind: Scalars['String']['input'];
  reason: Scalars['String']['input'];
  startsAt: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateCorrectiveActionMutation. */
export type ICreateCorrectiveActionMutationPayload = {
  __typename: 'CreateCorrectiveActionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<IUser>;
};

/** Autogenerated input type of CreateEventLifecycleMutation */
export type ICreateEventLifecycleMutationInput = {
  characterId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['Int']['input'];
  kind: ILifecycleKindEnum;
};

/** Autogenerated return type of CreateEventLifecycleMutation. */
export type ICreateEventLifecycleMutationPayload = {
  __typename: 'CreateEventLifecycleMutationPayload';
  character?: Maybe<ICharacter>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateEventMutation */
export type ICreateEventMutationInput = {
  branchId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt: Scalars['String']['input'];
  kind?: InputMaybe<IEventKindEnum>;
  locationId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  registrationOpensAt?: InputMaybe<Scalars['String']['input']>;
  startsAt: Scalars['String']['input'];
};

/** Autogenerated return type of CreateEventMutation. */
export type ICreateEventMutationPayload = {
  __typename: 'CreateEventMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  event?: Maybe<IEvent>;
};

/** Autogenerated input type of CreateEventShiftMutation */
export type ICreateEventShiftMutationInput = {
  baseRatio: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['Int']['input'];
  kind: IShiftKindEnum;
  label: Scalars['String']['input'];
};

/** Autogenerated return type of CreateEventShiftMutation. */
export type ICreateEventShiftMutationPayload = {
  __typename: 'CreateEventShiftMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  event?: Maybe<IEvent>;
};

/** Autogenerated input type of CreateEventTicketMutation */
export type ICreateEventTicketMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cost: Scalars['Int']['input'];
  eventId: Scalars['Int']['input'];
  label: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  restrictionType: ITicketRestrictionEnum;
  shiftResponsibilities: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateEventTicketMutation. */
export type ICreateEventTicketMutationPayload = {
  __typename: 'CreateEventTicketMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  event?: Maybe<IEvent>;
};

/** Autogenerated input type of CreateFellowshipMutation */
export type ICreateFellowshipMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  kind: IFellowshipKindEnum;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateFellowshipMutation. */
export type ICreateFellowshipMutationPayload = {
  __typename: 'CreateFellowshipMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<IOrganization>;
};

/** Autogenerated input type of CreateFellowshipRuleTagMutation */
export type ICreateFellowshipRuleTagMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fellowshipId: Scalars['Int']['input'];
  ruleTagId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateFellowshipRuleTagMutation. */
export type ICreateFellowshipRuleTagMutationPayload = {
  __typename: 'CreateFellowshipRuleTagMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  fellowship?: Maybe<IFellowship>;
};

/** Autogenerated input type of CreateItemClassificationMutation */
export type ICreateItemClassificationMutationInput = {
  childItemId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  parentItemId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateItemClassificationMutation. */
export type ICreateItemClassificationMutationPayload = {
  __typename: 'CreateItemClassificationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<IItem>;
};

/** Autogenerated input type of CreateItemCraftingComponentMutation */
export type ICreateItemCraftingComponentMutationInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  componentId: Scalars['Int']['input'];
  itemCraftingId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateItemCraftingComponentMutation. */
export type ICreateItemCraftingComponentMutationPayload = {
  __typename: 'CreateItemCraftingComponentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  itemCrafting?: Maybe<IItemCrafting>;
};

/** Autogenerated input type of CreateItemCraftingFinalProductMutation */
export type ICreateItemCraftingFinalProductMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  finalProductId: Scalars['Int']['input'];
  itemCraftingId: Scalars['Int']['input'];
  stack?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateItemCraftingFinalProductMutation. */
export type ICreateItemCraftingFinalProductMutationPayload = {
  __typename: 'CreateItemCraftingFinalProductMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  itemCrafting?: Maybe<IItemCrafting>;
};

/** Autogenerated input type of CreateItemCraftingMutation */
export type ICreateItemCraftingMutationInput = {
  blueprintId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateItemCraftingMutation. */
export type ICreateItemCraftingMutationPayload = {
  __typename: 'CreateItemCraftingMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<IItem>;
};

/** Autogenerated input type of CreateItemMutation */
export type ICreateItemMutationInput = {
  activationRequirement?: InputMaybe<Scalars['String']['input']>;
  allowBlueprintCopying?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  descriptionOfRoleplay?: InputMaybe<Scalars['String']['input']>;
  durationOfEffect?: InputMaybe<Scalars['String']['input']>;
  durationOfRoleplay?: InputMaybe<Scalars['String']['input']>;
  equipmentRequiredForUse?: InputMaybe<Scalars['String']['input']>;
  grade: IItemGradeEnum;
  kind: IItemKindEnum;
  lifetimeAmount?: InputMaybe<Scalars['Int']['input']>;
  locationOfUse?: InputMaybe<Scalars['String']['input']>;
  mechanics?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  printHeader?: InputMaybe<Scalars['String']['input']>;
  requirementsToUse?: InputMaybe<Scalars['String']['input']>;
  uses?: InputMaybe<Scalars['String']['input']>;
  validTargetDescription?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateItemMutation. */
export type ICreateItemMutationPayload = {
  __typename: 'CreateItemMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<IItem>;
};

/** Autogenerated input type of CreateItemReproductionComponentMutation */
export type ICreateItemReproductionComponentMutationInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  componentId: Scalars['Int']['input'];
  itemReproductionId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateItemReproductionComponentMutation. */
export type ICreateItemReproductionComponentMutationPayload = {
  __typename: 'CreateItemReproductionComponentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  itemReproduction?: Maybe<IItemReproduction>;
};

/** Autogenerated input type of CreateItemReproductionMutation */
export type ICreateItemReproductionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateItemReproductionMutation. */
export type ICreateItemReproductionMutationPayload = {
  __typename: 'CreateItemReproductionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<IItem>;
};

/** Autogenerated input type of CreateItemTransactionMutation */
export type ICreateItemTransactionMutationInput = {
  armorUpgradePoints?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  copyBlueprintId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  durationInMinute?: InputMaybe<Scalars['Int']['input']>;
  eventId: Scalars['Int']['input'];
  itemCraftingId?: InputMaybe<Scalars['Int']['input']>;
  mailoutRecipientId?: InputMaybe<Scalars['Int']['input']>;
  mindCost?: InputMaybe<Scalars['Int']['input']>;
  modId?: InputMaybe<Scalars['Int']['input']>;
  priority?: InputMaybe<IItemTransactionPriorityEnum>;
  repeats?: InputMaybe<Scalars['Int']['input']>;
  resolveCost?: InputMaybe<Scalars['Int']['input']>;
  skillId?: InputMaybe<Scalars['Int']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  transactionPartnerId?: InputMaybe<Scalars['Int']['input']>;
  transactions: Array<IItemTransactionInput>;
};

/** Autogenerated return type of CreateItemTransactionMutation. */
export type ICreateItemTransactionMutationPayload = {
  __typename: 'CreateItemTransactionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  itemTransactions?: Maybe<Array<IItemTransaction>>;
};

/** Autogenerated input type of CreateLocationMutation */
export type ICreateLocationMutationInput = {
  branchId: Scalars['Int']['input'];
  city: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  region: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

/** Autogenerated return type of CreateLocationMutation. */
export type ICreateLocationMutationPayload = {
  __typename: 'CreateLocationMutationPayload';
  branch?: Maybe<IBranch>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateMembershipMutation */
export type ICreateMembershipMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateMembershipMutation. */
export type ICreateMembershipMutationPayload = {
  __typename: 'CreateMembershipMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<IUser>;
};

/** Autogenerated input type of CreateMessageMutation */
export type ICreateMessageMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  content: Scalars['String']['input'];
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<IModEntityTypeEnum>;
  modId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateMessageMutation. */
export type ICreateMessageMutationPayload = {
  __typename: 'CreateMessageMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of CreateModAssetMutation */
export type ICreateModAssetMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  url: Scalars['String']['input'];
};

/** Autogenerated return type of CreateModAssetMutation. */
export type ICreateModAssetMutationPayload = {
  __typename: 'CreateModAssetMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of CreateModChallengeMutation */
export type ICreateModChallengeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  kind: IModChallengeKindEnum;
  modId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  threatId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateModChallengeMutation. */
export type ICreateModChallengeMutationPayload = {
  __typename: 'CreateModChallengeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of CreateModMutation */
export type ICreateModMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  modSectionId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  participationLimit?: InputMaybe<Scalars['Int']['input']>;
  reputationConstraints?: InputMaybe<Array<ICharacterConstraintInput>>;
  skillConstraints?: InputMaybe<Array<ICharacterConstraintInput>>;
  timeframe?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateModMutation. */
export type ICreateModMutationPayload = {
  __typename: 'CreateModMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  modSection?: Maybe<IModSection>;
};

/** Autogenerated input type of CreateModNarrativeRolePlayMutation */
export type ICreateModNarrativeRolePlayMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  modId: Scalars['Int']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateModNarrativeRolePlayMutation. */
export type ICreateModNarrativeRolePlayMutationPayload = {
  __typename: 'CreateModNarrativeRolePlayMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of CreateModRewardMutation */
export type ICreateModRewardMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['Int']['input'];
  modRewardTemplateId: Scalars['Int']['input'];
  stack?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateModRewardMutation. */
export type ICreateModRewardMutationPayload = {
  __typename: 'CreateModRewardMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  modRewardTemplate?: Maybe<IModRewardTemplate>;
};

/** Autogenerated input type of CreateModRewardTemplateMutation */
export type ICreateModRewardTemplateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  modId: Scalars['Int']['input'];
  modRunnerNote?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateModRewardTemplateMutation. */
export type ICreateModRewardTemplateMutationPayload = {
  __typename: 'CreateModRewardTemplateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of CreateModSectionMutation */
export type ICreateModSectionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  signupLimit: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateModSectionMutation. */
export type ICreateModSectionMutationPayload = {
  __typename: 'CreateModSectionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  event?: Maybe<IEvent>;
};

/** Autogenerated input type of CreateModSignupMutation */
export type ICreateModSignupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modId?: InputMaybe<Scalars['Int']['input']>;
  playerId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of CreateModSignupMutation. */
export type ICreateModSignupMutationPayload = {
  __typename: 'CreateModSignupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of CreateNewPlayerMutation */
export type ICreateNewPlayerMutationInput = {
  branchId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailAddress: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  preferredName?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateNewPlayerMutation. */
export type ICreateNewPlayerMutationPayload = {
  __typename: 'CreateNewPlayerMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<IUser>;
};

/** Autogenerated input type of CreateReferralMutation */
export type ICreateReferralMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  counterPartyId: Scalars['Int']['input'];
  predicate: Scalars['String']['input'];
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of CreateReferralMutation. */
export type ICreateReferralMutationPayload = {
  __typename: 'CreateReferralMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<IUser>;
};

/** Autogenerated input type of CreateSpecialDateMutation */
export type ICreateSpecialDateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endsAt: Scalars['String']['input'];
  kind: ISpecialDateKindEnum;
  startsAt: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateSpecialDateMutation. */
export type ICreateSpecialDateMutationPayload = {
  __typename: 'CreateSpecialDateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<IOrganization>;
};

export type IDamageRollInput = {
  advantage?: InputMaybe<Scalars['Boolean']['input']>;
  max: Scalars['Int']['input'];
  min?: InputMaybe<Scalars['Int']['input']>;
};

export type IDefenseRoll = {
  __typename: 'DefenseRoll';
  id: Scalars['Int']['output'];
  type: IModEntityTypeEnum;
  value?: Maybe<Array<Scalars['Int']['output']>>;
};

/** Autogenerated input type of DestroyAttendeeCharacterMutation */
export type IDestroyAttendeeCharacterMutationInput = {
  attendeeCharacterId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DestroyAttendeeCharacterMutation. */
export type IDestroyAttendeeCharacterMutationPayload = {
  __typename: 'DestroyAttendeeCharacterMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  eventAttendee?: Maybe<IEventAttendee>;
};

/** Autogenerated input type of DestroyAuthTokenMutation */
export type IDestroyAuthTokenMutationInput = {
  all?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of DestroyAuthTokenMutation. */
export type IDestroyAuthTokenMutationPayload = {
  __typename: 'DestroyAuthTokenMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyCharacterMutation */
export type IDestroyCharacterMutationInput = {
  characterId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyCharacterMutation. */
export type IDestroyCharacterMutationPayload = {
  __typename: 'DestroyCharacterMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<IUser>;
};

/** Autogenerated input type of DestroyCorrectiveActionMutation */
export type IDestroyCorrectiveActionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  correctiveActionId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyCorrectiveActionMutation. */
export type IDestroyCorrectiveActionMutationPayload = {
  __typename: 'DestroyCorrectiveActionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  correctiveAction?: Maybe<ICorrectiveAction>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyEventAttendeeMutation */
export type IDestroyEventAttendeeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventAttendeeId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyEventAttendeeMutation. */
export type IDestroyEventAttendeeMutationPayload = {
  __typename: 'DestroyEventAttendeeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  eventAttendee?: Maybe<IEventAttendee>;
};

/** Autogenerated input type of DestroyEventShiftMutation */
export type IDestroyEventShiftMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  shiftId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyEventShiftMutation. */
export type IDestroyEventShiftMutationPayload = {
  __typename: 'DestroyEventShiftMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  event?: Maybe<IEvent>;
};

/** Autogenerated input type of DestroyEventTicketMutation */
export type IDestroyEventTicketMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  ticketId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyEventTicketMutation. */
export type IDestroyEventTicketMutationPayload = {
  __typename: 'DestroyEventTicketMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<ITicket>;
};

/** Autogenerated input type of DestroyFellowshipRuleTagMutation */
export type IDestroyFellowshipRuleTagMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fellowshipRuleTagId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyFellowshipRuleTagMutation. */
export type IDestroyFellowshipRuleTagMutationPayload = {
  __typename: 'DestroyFellowshipRuleTagMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  fellowship?: Maybe<IFellowship>;
};

/** Autogenerated input type of DestroyItemClassificationMutation */
export type IDestroyItemClassificationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemClassificationId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyItemClassificationMutation. */
export type IDestroyItemClassificationMutationPayload = {
  __typename: 'DestroyItemClassificationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  itemClassification?: Maybe<IItemClassification>;
};

/** Autogenerated input type of DestroyItemCraftingComponentMutation */
export type IDestroyItemCraftingComponentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemCraftingComponentId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyItemCraftingComponentMutation. */
export type IDestroyItemCraftingComponentMutationPayload = {
  __typename: 'DestroyItemCraftingComponentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  craftingComponent?: Maybe<ICraftingComponent>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyItemCraftingFinalProductMutation */
export type IDestroyItemCraftingFinalProductMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemCraftingFinalProductId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyItemCraftingFinalProductMutation. */
export type IDestroyItemCraftingFinalProductMutationPayload = {
  __typename: 'DestroyItemCraftingFinalProductMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  craftingFinalProduct?: Maybe<ICraftingFinalProduct>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DestroyItemCraftingMutation */
export type IDestroyItemCraftingMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemCraftingId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyItemCraftingMutation. */
export type IDestroyItemCraftingMutationPayload = {
  __typename: 'DestroyItemCraftingMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  itemCrafting?: Maybe<IItemCrafting>;
};

/** Autogenerated input type of DestroyItemReproductionComponentMutation */
export type IDestroyItemReproductionComponentMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemReproductionComponentId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyItemReproductionComponentMutation. */
export type IDestroyItemReproductionComponentMutationPayload = {
  __typename: 'DestroyItemReproductionComponentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  itemReproductionComponent?: Maybe<IItemReproductionComponent>;
};

/** Autogenerated input type of DestroyItemReproductionMutation */
export type IDestroyItemReproductionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemReproductionId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyItemReproductionMutation. */
export type IDestroyItemReproductionMutationPayload = {
  __typename: 'DestroyItemReproductionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  itemReproduction?: Maybe<IItemReproduction>;
};

/** Autogenerated input type of DestroyLocationMutation */
export type IDestroyLocationMutationInput = {
  branchId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyLocationMutation. */
export type IDestroyLocationMutationPayload = {
  __typename: 'DestroyLocationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  location?: Maybe<ILocation>;
};

/** Autogenerated input type of DestroyMembershipMutation */
export type IDestroyMembershipMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  membershipId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyMembershipMutation. */
export type IDestroyMembershipMutationPayload = {
  __typename: 'DestroyMembershipMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  membership?: Maybe<IMembership>;
};

/** Autogenerated input type of DestroyModAssetMutation */
export type IDestroyModAssetMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modAssetId: Scalars['Int']['input'];
  modId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyModAssetMutation. */
export type IDestroyModAssetMutationPayload = {
  __typename: 'DestroyModAssetMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of DestroyModMutation */
export type IDestroyModMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyModMutation. */
export type IDestroyModMutationPayload = {
  __typename: 'DestroyModMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  modSection?: Maybe<IModSection>;
};

/** Autogenerated input type of DestroyModRewardMutation */
export type IDestroyModRewardMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modRewardId: Scalars['Int']['input'];
  modRewardTemplateId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyModRewardMutation. */
export type IDestroyModRewardMutationPayload = {
  __typename: 'DestroyModRewardMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  modRewardTemplate?: Maybe<IModRewardTemplate>;
};

/** Autogenerated input type of DestroyModRewardTemplateMutation */
export type IDestroyModRewardTemplateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modRewardTemplateId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyModRewardTemplateMutation. */
export type IDestroyModRewardTemplateMutationPayload = {
  __typename: 'DestroyModRewardTemplateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of DestroyModSignupMutation */
export type IDestroyModSignupMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modSignupId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyModSignupMutation. */
export type IDestroyModSignupMutationPayload = {
  __typename: 'DestroyModSignupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of DestroyReferralMutation */
export type IDestroyReferralMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  referralId: Scalars['Int']['input'];
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroyReferralMutation. */
export type IDestroyReferralMutationPayload = {
  __typename: 'DestroyReferralMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<IUser>;
};

/** Autogenerated input type of DestroySpecialDateMutation */
export type IDestroySpecialDateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  specialDateId: Scalars['Int']['input'];
};

/** Autogenerated return type of DestroySpecialDateMutation. */
export type IDestroySpecialDateMutationPayload = {
  __typename: 'DestroySpecialDateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  specialDate?: Maybe<ISpecialDate>;
};

export type IDiceRollAutoResolve = {
  __typename: 'DiceRollAutoResolve';
  matchingProfessionIds: Array<Scalars['Int']['output']>;
  sufficientMind: Scalars['Boolean']['output'];
};

export type IDiceRollDamage = {
  __typename: 'DiceRollDamage';
  add: Scalars['Int']['output'];
  baseRoll: Scalars['Int']['output'];
  damageType: IModDamageTypeEnum;
  kind?: Maybe<IItemKindEnum>;
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type IDiceRollResult = {
  __typename: 'DiceRollResult';
  add: Scalars['Int']['output'];
  baseRoll: Scalars['Int']['output'];
  connects: Scalars['Boolean']['output'];
  damageTally?: Maybe<Scalars['Int']['output']>;
  damages?: Maybe<Array<IDiceRollDamage>>;
  defensiveRoll: Scalars['Int']['output'];
  max: Scalars['Int']['output'];
  min: Scalars['Int']['output'];
  skillId?: Maybe<Scalars['Int']['output']>;
  subtarget?: Maybe<Scalars['String']['output']>;
  total: Scalars['Int']['output'];
};

export type IDiceRollSummary = {
  __typename: 'DiceRollSummary';
  autoResolve?: Maybe<IDiceRollAutoResolve>;
  rolls: Array<IDiceRollResult>;
  totalDamage?: Maybe<Scalars['Int']['output']>;
};

export type IDiceRollerInput = {
  addChances?: InputMaybe<Array<Scalars['Int']['input']>>;
  damageRolls?: InputMaybe<Array<IDamageRollInput>>;
  defensiveRoll?: InputMaybe<Scalars['Int']['input']>;
  defensiveRolls?: InputMaybe<Array<Scalars['Int']['input']>>;
  strategy?: InputMaybe<Scalars['String']['input']>;
};

export enum IEmailCorrespondenceEnum {
  OptIn = 'opt_in',
  OptOut = 'opt_out',
}

/** Autogenerated input type of EndModMutation */
export type IEndModMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modId: Scalars['Int']['input'];
  refreshImpactSkills?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of EndModMutation. */
export type IEndModMutationPayload = {
  __typename: 'EndModMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of EnterBattlefieldMutation */
export type IEnterBattlefieldMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['Int']['input'];
  entityType: IModEntityTypeEnum;
  modId: Scalars['Int']['input'];
};

/** Autogenerated return type of EnterBattlefieldMutation. */
export type IEnterBattlefieldMutationPayload = {
  __typename: 'EnterBattlefieldMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

export enum IEquipCommandEnum {
  EquipArmor = 'equip_armor',
  EquipMainHand = 'equip_main_hand',
  EquipOffHand = 'equip_off_hand',
}

/** Autogenerated input type of EquipMutation */
export type IEquipMutationInput = {
  additionalArmorPoints?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<IModEntityTypeEnum>;
  equipCommand: IEquipCommandEnum;
  itemId: Scalars['Int']['input'];
  modId: Scalars['Int']['input'];
  starterEquipmentType?: InputMaybe<IItemKindEnum>;
};

/** Autogenerated return type of EquipMutation. */
export type IEquipMutationPayload = {
  __typename: 'EquipMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

export type IError = {
  __typename: 'Error';
  error?: Maybe<Scalars['String']['output']>;
};

export type IEvent = {
  __typename: 'Event';
  activeCorrectiveActions: Array<ICorrectiveAction>;
  activeMembership?: Maybe<Scalars['Boolean']['output']>;
  branch: IBranch;
  canSelfCheckin: Scalars['Boolean']['output'];
  checkinableCharacters?: Maybe<Array<ICharacter>>;
  config: IEventConfig;
  description?: Maybe<Scalars['String']['output']>;
  endsAt: Scalars['ISO8601DateTime']['output'];
  eventAttendee?: Maybe<IEventAttendee>;
  eventAttendees?: Maybe<Array<IEventAttendee>>;
  eventAttendeesSize?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  isEventAssistant?: Maybe<Scalars['Boolean']['output']>;
  isEventManager?: Maybe<Scalars['Boolean']['output']>;
  isEventRegistrar?: Maybe<Scalars['Boolean']['output']>;
  isHomeGame?: Maybe<Scalars['Boolean']['output']>;
  isVirtual: Scalars['Boolean']['output'];
  itemTransactionStatistics?: Maybe<Array<IClearingHouse>>;
  itemTransactions?: Maybe<Array<IItemTransaction>>;
  kind: IEventKindEnum;
  location: ILocation;
  maximumCheckinableCharacters?: Maybe<Scalars['Int']['output']>;
  mod?: Maybe<IMod>;
  modDescription?: Maybe<Scalars['String']['output']>;
  modEnableWaitlist?: Maybe<Scalars['Boolean']['output']>;
  modMaxSignup?: Maybe<Scalars['Int']['output']>;
  modSections: Array<IModSection>;
  modSignupOpensAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  name: Scalars['String']['output'];
  nextEvent?: Maybe<IEvent>;
  prevEvent?: Maybe<IEvent>;
  printouts?: Maybe<Array<IEventAttendee>>;
  registrationOpensAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  revenue?: Maybe<IEventRevenue>;
  shiftKinds: Array<IShiftKindEnum>;
  shifts: Array<IShift>;
  startsAt: Scalars['ISO8601DateTime']['output'];
  temporaryManagers: Array<ITemporaryManager>;
  ticketStatistics?: Maybe<Array<ITicket>>;
  tickets: Array<ITicket>;
  ticketsBaseConfig?: Maybe<ITicketsBaseConfig>;
};

export type IEventActiveCorrectiveActionsArgs = {
  playerId: Scalars['Int']['input'];
};

export type IEventActiveMembershipArgs = {
  playerId?: InputMaybe<Scalars['Int']['input']>;
};

export type IEventCanSelfCheckinArgs = {
  playerId: Scalars['Int']['input'];
};

export type IEventCheckinableCharactersArgs = {
  playerId: Scalars['Int']['input'];
};

export type IEventEventAttendeeArgs = {
  eventAttendeeId?: InputMaybe<Scalars['Int']['input']>;
  playerId?: InputMaybe<Scalars['Int']['input']>;
};

export type IEventEventAttendeesArgs = {
  ticketId?: InputMaybe<Scalars['Int']['input']>;
};

export type IEventIsHomeGameArgs = {
  playerId?: InputMaybe<Scalars['Int']['input']>;
};

export type IEventItemTransactionsArgs = {
  characterId?: InputMaybe<Scalars['Int']['input']>;
  modId?: InputMaybe<Scalars['Int']['input']>;
};

export type IEventMaximumCheckinableCharactersArgs = {
  playerId?: InputMaybe<Scalars['Int']['input']>;
};

export type IEventModArgs = {
  id: Scalars['Int']['input'];
};

export type IEventPrintoutsArgs = {
  homeGame?: InputMaybe<Scalars['Boolean']['input']>;
  paid?: InputMaybe<Scalars['Boolean']['input']>;
  printRequested?: InputMaybe<Scalars['Boolean']['input']>;
  ticketIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IEventShiftsArgs = {
  withFulfillments?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IEventTicketsArgs = {
  editMode?: InputMaybe<Scalars['Boolean']['input']>;
  playerId?: InputMaybe<Scalars['Int']['input']>;
};

export type IEventAttendee = {
  __typename: 'EventAttendee';
  attendeeCharacters: Array<IAttendeeCharacter>;
  attendeeShifts: Array<IAttendeeShift>;
  attending: Scalars['Boolean']['output'];
  buildAwarded: Scalars['Boolean']['output'];
  buildGrowth: Scalars['Int']['output'];
  checkedInCharactersCount: Scalars['Int']['output'];
  checkinApproved: Scalars['Boolean']['output'];
  costOverride?: Maybe<Scalars['Int']['output']>;
  econMindExpenditure: Scalars['Int']['output'];
  econResolveExpenditure: Scalars['Int']['output'];
  econTimeExpenditureInMinutes: Scalars['Int']['output'];
  event: IEvent;
  id: Scalars['Int']['output'];
  inviter?: Maybe<IUser>;
  itemTransactionsTally: Array<IItemTransactionTally>;
  kind: IEventAttendeeKindEnum;
  paid: Scalars['Boolean']['output'];
  referralInfo?: Maybe<Scalars['String']['output']>;
  restrictedMailout: Scalars['Boolean']['output'];
  shifts: Array<IShift>;
  ticket: ITicket;
  ticketId: Scalars['Int']['output'];
  user: IUser;
};

export type IEventAttendeeEconMindExpenditureArgs = {
  characterId: Scalars['Int']['input'];
};

export type IEventAttendeeEconResolveExpenditureArgs = {
  characterId: Scalars['Int']['input'];
};

export enum IEventAttendeeKindEnum {
  HomeGame = 'home_game',
  TravelAsHomeGame = 'travel_as_home_game',
  TravelGame = 'travel_game',
}

export type IEventConfig = {
  __typename: 'EventConfig';
  baseBuild: Scalars['Int']['output'];
  considersTravelersLocal: Scalars['Boolean']['output'];
  extraXpCost: Scalars['Float']['output'];
  maxCurveXp: Scalars['Int']['output'];
  maxExtraXp: Scalars['Int']['output'];
  maxExtraXpLimit: Scalars['Int']['output'];
  maxShift: Scalars['Int']['output'];
  shiftKinds: Array<IShiftKindEnum>;
  shiftMultiplier: Scalars['Int']['output'];
  shiftUnit: Scalars['String']['output'];
};

export type IEventInvoice = {
  __typename: 'EventInvoice';
  attendances: Array<IAttendanceInvoice>;
  baseCompensationTicketCount: Scalars['Int']['output'];
  billableAmount: Scalars['Float']['output'];
  endsAt: Scalars['ISO8601DateTime']['output'];
  extraXpSold: Scalars['Int']['output'];
  fullCompensationTicketCount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  isCommunity: Scalars['Boolean']['output'];
  isCurrentCycle: Scalars['Boolean']['output'];
  isLegacy: Scalars['Boolean']['output'];
  isVirtual: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  startsAt: Scalars['ISO8601DateTime']['output'];
  ticketsSold: Scalars['Int']['output'];
};

export enum IEventKindEnum {
  Community = 'community',
  Live = 'live',
  National = 'national',
  NationalPremiere = 'national_premiere',
  Premiere = 'premiere',
  Regular = 'regular',
}

export type IEventRevenue = {
  __typename: 'EventRevenue';
  aggregates: IRevenueAggregates;
  itemizedLineItems: Array<ITicketRevenue>;
};

/** Autogenerated input type of ExecuteScatterShotMutation */
export type IExecuteScatterShotMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<IModEntityTypeEnum>;
  modId: Scalars['Int']['input'];
  targets: Array<IModParticipantInput>;
};

/** Autogenerated return type of ExecuteScatterShotMutation. */
export type IExecuteScatterShotMutationPayload = {
  __typename: 'ExecuteScatterShotMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of ExpendItemMutation */
export type IExpendItemMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<IModEntityTypeEnum>;
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  itemId: Scalars['Int']['input'];
  modId: Scalars['Int']['input'];
  registeredItemId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of ExpendItemMutation. */
export type IExpendItemMutationPayload = {
  __typename: 'ExpendItemMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of ExpendResolveMutation */
export type IExpendResolveMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<IModEntityTypeEnum>;
  modId: Scalars['Int']['input'];
};

/** Autogenerated return type of ExpendResolveMutation. */
export type IExpendResolveMutationPayload = {
  __typename: 'ExpendResolveMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

export type IFellowship = {
  __typename: 'Fellowship';
  branch?: Maybe<IBranch>;
  characterFellowships: Array<ICharacterFellowship>;
  characters: Array<ICharacter>;
  charactersCount: Scalars['Int']['output'];
  constraint?: Maybe<Array<ICharacterConstraint>>;
  description?: Maybe<Scalars['String']['output']>;
  fellowshipRuleTags: Array<IFellowshipRuleTag>;
  groupIdentifier: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  kind: IFellowshipKindEnum;
  maxRank: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  organization: IOrganization;
  rankNames: Array<Scalars['String']['output']>;
  removedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type IFellowshipInput = {
  forRemoval?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export enum IFellowshipKindEnum {
  Disease = 'disease',
  Faith = 'faith',
  Society = 'society',
}

export type IFellowshipRuleTag = {
  __typename: 'FellowshipRuleTag';
  fellowship: IFellowship;
  id: Scalars['Int']['output'];
  ruleTag: IRuleTag;
};

/** Autogenerated input type of FinalizeModRewardClaimsMutation */
export type IFinalizeModRewardClaimsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modId: Scalars['Int']['input'];
};

/** Autogenerated return type of FinalizeModRewardClaimsMutation. */
export type IFinalizeModRewardClaimsMutationPayload = {
  __typename: 'FinalizeModRewardClaimsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

export type IFracture = {
  __typename: 'Fracture';
  character: ICharacter;
  createdAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  removedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
};

export type IFractureInput = {
  forRemoval?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of FulfillShiftMutation */
export type IFulfillShiftMutationInput = {
  attendeeShiftId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isFulfilled: Scalars['Boolean']['input'];
};

/** Autogenerated return type of FulfillShiftMutation. */
export type IFulfillShiftMutationPayload = {
  __typename: 'FulfillShiftMutationPayload';
  attendeeShift?: Maybe<IAttendeeShift>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of GenerateAuthTokenMutation */
export type IGenerateAuthTokenMutationInput = {
  browser?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  hardware?: InputMaybe<Scalars['String']['input']>;
  os?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

/** Autogenerated return type of GenerateAuthTokenMutation. */
export type IGenerateAuthTokenMutationPayload = {
  __typename: 'GenerateAuthTokenMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<IUser>;
};

/** Autogenerated input type of GenerateBattlefieldTokenMutation */
export type IGenerateBattlefieldTokenMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of GenerateBattlefieldTokenMutation. */
export type IGenerateBattlefieldTokenMutationPayload = {
  __typename: 'GenerateBattlefieldTokenMutationPayload';
  clientId?: Maybe<Scalars['Int']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  keyName?: Maybe<Scalars['String']['output']>;
  mac?: Maybe<Scalars['String']['output']>;
  nonce?: Maybe<Scalars['String']['output']>;
  timestamp?: Maybe<Scalars['BigInt']['output']>;
};

export type IInventory = {
  __typename: 'Inventory';
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  item: IItem;
  itemId: Scalars['Int']['output'];
  registeredItem?: Maybe<IRegisteredItem>;
  registeredItemId?: Maybe<Scalars['Int']['output']>;
  remainingUses?: Maybe<Scalars['Int']['output']>;
  stack: Scalars['Int']['output'];
  stackPending: Scalars['Int']['output'];
};

export type IInvoice = {
  __typename: 'Invoice';
  additionalXpBuybackCount: Scalars['Int']['output'];
  additionalXpCount: Scalars['Int']['output'];
  billableAmount: Scalars['Float']['output'];
  events: Array<IEventInvoice>;
  liveEventTicketBuybackCount: Scalars['Int']['output'];
  liveEventTicketCount: Scalars['Int']['output'];
  virtualEventTicketBuybackCount: Scalars['Int']['output'];
  virtualEventTicketCount: Scalars['Int']['output'];
};

export type IInvoiceChange = {
  __typename: 'InvoiceChange';
  attending?: Maybe<Scalars['String']['output']>;
  buildGrowth?: Maybe<Scalars['String']['output']>;
  gameKind?: Maybe<Scalars['String']['output']>;
  kind: IInvoiceChangeKindEnum;
  paid?: Maybe<Scalars['String']['output']>;
  ticketId?: Maybe<Scalars['String']['output']>;
  ticketLabel?: Maybe<Scalars['String']['output']>;
};

export enum IInvoiceChangeKindEnum {
  Addition = 'addition',
  Modification = 'modification',
  Removal = 'removal',
}

export type IItem = {
  __typename: 'Item';
  blueprintForCraftings: Array<IItem>;
  childItemClassifications: Array<IItemClassification>;
  craftsItemWithMultipleUses: Scalars['Boolean']['output'];
  grade: IItemGradeEnum;
  id: Scalars['Int']['output'];
  itemCraftings: Array<IItemCrafting>;
  itemReproductions: Array<IItemReproduction>;
  kind: IItemKindEnum;
  lifetimeAmount?: Maybe<Scalars['Int']['output']>;
  lifetimeUnit: IItemLifetimeUnitEnum;
  metadata: IItemMetadata;
  multipleUses: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  numberOfUses?: Maybe<Scalars['Int']['output']>;
  parts: Array<ICraftingComponent>;
  updatedAt: Scalars['ISO8601DateTime']['output'];
  validFrom?: Maybe<Scalars['ISO8601DateTime']['output']>;
  validUntil?: Maybe<Scalars['ISO8601DateTime']['output']>;
  version: Scalars['Int']['output'];
  visibility: IItemVisibilityEnum;
};

export type IItemClaim = {
  __typename: 'ItemClaim';
  characterId?: Maybe<Scalars['Int']['output']>;
  stack: Scalars['Int']['output'];
  status: IItemTransactionStatusEnum;
};

export type IItemClassification = {
  __typename: 'ItemClassification';
  childItem: IItem;
  id: Scalars['Int']['output'];
};

export type IItemCrafting = {
  __typename: 'ItemCrafting';
  blueprint: IItem;
  craftingComponents: Array<ICraftingComponent>;
  craftingFinalProducts: Array<ICraftingFinalProduct>;
  craftingMindCost?: Maybe<Scalars['Int']['output']>;
  craftingResolveCost?: Maybe<Scalars['Int']['output']>;
  craftingSkills?: Maybe<Scalars['String']['output']>;
  craftingTimeInMinute?: Maybe<Scalars['Int']['output']>;
  craftingZone?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
};

export enum IItemGradeEnum {
  Basic = 'basic',
  Master = 'master',
  Proficient = 'proficient',
  Ungraded = 'ungraded',
}

export enum IItemKindEnum {
  Abstract = 'abstract',
  Armor = 'armor',
  ArmorNecrology = 'armor_necrology',
  Benediction = 'benediction',
  Blueprint = 'blueprint',
  BoltActionFlorentine = 'bolt_action_florentine',
  BoltActionNecrology = 'bolt_action_necrology',
  BoltActionOneHanded = 'bolt_action_one_handed',
  BoltActionTwoHanded = 'bolt_action_two_handed',
  Bow = 'bow',
  BuyList = 'buy_list',
  Conversion = 'conversion',
  CraftingInput = 'crafting_input',
  CraftingOutput = 'crafting_output',
  CraftingResource = 'crafting_resource',
  CulinaryProcedure = 'culinary_procedure',
  Currency = 'currency',
  DeathBrew = 'death_brew',
  EngineeredSpace = 'engineered_space',
  EngineeredSpaceNecrology = 'engineered_space_necrology',
  ExoticWeapon = 'exotic_weapon',
  ForageCard = 'forage_card',
  Foraged = 'foraged',
  GenericItem = 'generic_item',
  Gizmo = 'gizmo',
  GizmoNecrology = 'gizmo_necrology',
  Gun = 'gun',
  HallucinogenicBrew = 'hallucinogenic_brew',
  HealingBrew = 'healing_brew',
  HealingMeal = 'healing_meal',
  InjectedBrew = 'injected_brew',
  IntoxicationBrew = 'intoxication_brew',
  Knucks = 'knucks',
  MeleeFlorentine = 'melee_florentine',
  MeleeSmall = 'melee_small',
  MeleeSmallNecrology = 'melee_small_necrology',
  MeleeStandard = 'melee_standard',
  MeleeTwoHanded = 'melee_two_handed',
  Metal = 'metal',
  MindBrew = 'mind_brew',
  NamedHerb = 'named_herb',
  National = 'national',
  NaturalResource = 'natural_resource',
  NecrologyBrew = 'necrology_brew',
  NecrologyEngineeredItem = 'necrology_engineered_item',
  NecrologyResource = 'necrology_resource',
  OtherBrew = 'other_brew',
  OtherMeal = 'other_meal',
  Others = 'others',
  PoisonApplied = 'poison_applied',
  PoisonBrew = 'poison_brew',
  Procedure = 'procedure',
  Produce = 'produce',
  RecoveryBrew = 'recovery_brew',
  RecoveryMeal = 'recovery_meal',
  RoomAugment = 'room_augment',
  Salvaged = 'salvaged',
  Service = 'service',
  Shield = 'shield',
  ShieldLarge = 'shield_large',
  ShieldNecrology = 'shield_necrology',
  SpecificAugment = 'specific_augment',
  Startup = 'startup',
  Taxonomy = 'taxonomy',
  ThrownWeapon = 'thrown_weapon',
  TradeResource = 'trade_resource',
  Transactable = 'transactable',
  TransactionLimited = 'transaction_limited',
  Trap = 'trap',
  UnnamedHerb = 'unnamed_herb',
  UnnamedScrap = 'unnamed_scrap',
  Vehicle = 'vehicle',
  VehicleAirship = 'vehicle_airship',
  VehicleAugment = 'vehicle_augment',
  VehicleWatercraft = 'vehicle_watercraft',
  Voucher = 'voucher',
}

export enum IItemLifetimeUnitEnum {
  Day = 'day',
  Month = 'month',
}

export type IItemMetadata = {
  __typename: 'ItemMetadata';
  activationRequirement?: Maybe<Scalars['String']['output']>;
  allowBlueprintCopying?: Maybe<Scalars['Boolean']['output']>;
  craftableItems?: Maybe<Array<ICraftableItem>>;
  descriptionOfRoleplay?: Maybe<Scalars['String']['output']>;
  durationOfEffect?: Maybe<Scalars['String']['output']>;
  durationOfRoleplay?: Maybe<Scalars['String']['output']>;
  equipmentRequiredForUse?: Maybe<Scalars['String']['output']>;
  locationOfUse?: Maybe<Scalars['String']['output']>;
  mechanics?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  printHeader?: Maybe<Scalars['String']['output']>;
  requirementsToUse?: Maybe<Scalars['String']['output']>;
  uses?: Maybe<Scalars['String']['output']>;
  validTargetDescription?: Maybe<Scalars['String']['output']>;
  vehicleArmor?: Maybe<Scalars['String']['output']>;
  vehicleCrewCapacity?: Maybe<Scalars['String']['output']>;
  vehicleHull?: Maybe<Scalars['String']['output']>;
  vehicleSpeed?: Maybe<Scalars['String']['output']>;
  vehicleTurnRadius?: Maybe<Scalars['String']['output']>;
};

export type IItemReproduction = {
  __typename: 'ItemReproduction';
  id: Scalars['Int']['output'];
  itemReproductionComponents: Array<IItemReproductionComponent>;
  metadata: IItemReproductionMetadata;
  reproductionMindCost?: Maybe<Scalars['Int']['output']>;
  reproductionSkills?: Maybe<Scalars['String']['output']>;
  reproductionTimeInMinute?: Maybe<Scalars['Int']['output']>;
};

export type IItemReproductionComponent = {
  __typename: 'ItemReproductionComponent';
  amount: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  item: IItem;
};

export type IItemReproductionMetadata = {
  __typename: 'ItemReproductionMetadata';
  notes?: Maybe<Scalars['String']['output']>;
};

export type IItemTransaction = {
  __typename: 'ItemTransaction';
  armorUpgradePoints?: Maybe<Scalars['Int']['output']>;
  character: ICharacter;
  childTransactions: Array<IItemTransaction>;
  copyBlueprint?: Maybe<IItem>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  durationInMinute?: Maybe<Scalars['Int']['output']>;
  event: IEvent;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  expiresOn?: Maybe<Scalars['ISO8601Date']['output']>;
  id: Scalars['Int']['output'];
  isMailout: Scalars['Boolean']['output'];
  item: IItem;
  itemCrafting?: Maybe<IItemCrafting>;
  itemTransactionUses: Array<IItemTransactionUse>;
  mailingAddress?: Maybe<Scalars['String']['output']>;
  mailoutRecipient?: Maybe<IUser>;
  mindCost?: Maybe<Scalars['Int']['output']>;
  mod?: Maybe<IMod>;
  postie: IUser;
  priority: IItemTransactionPriorityEnum;
  registeredItem?: Maybe<IRegisteredItem>;
  remainingUses?: Maybe<Scalars['Int']['output']>;
  resolveCost?: Maybe<Scalars['Int']['output']>;
  skillId?: Maybe<Scalars['Int']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  stack: Scalars['Int']['output'];
  status: IItemTransactionStatusEnum;
  transactionPartner?: Maybe<ICharacter>;
};

export enum IItemTransactionDistributionEnum {
  Generated = 'generated',
  Removed = 'removed',
}

export type IItemTransactionInput = {
  characterId: Scalars['Int']['input'];
  expiresAt?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  itemId: Scalars['Int']['input'];
  registeredItemDescription?: InputMaybe<Scalars['String']['input']>;
  registeredItemId?: InputMaybe<Scalars['Int']['input']>;
  stack?: InputMaybe<Scalars['Int']['input']>;
  transactionPartnerId?: InputMaybe<Scalars['Int']['input']>;
};

export enum IItemTransactionPriorityEnum {
  High = 'high',
  Normal = 'normal',
}

export enum IItemTransactionSourceEnum {
  Crafting = 'crafting',
  ModReward = 'mod_reward',
}

export enum IItemTransactionStatusEnum {
  InProgress = 'in_progress',
  Invalidated = 'invalidated',
  Legit = 'legit',
}

export type IItemTransactionTally = {
  __typename: 'ItemTransactionTally';
  children?: Maybe<Array<IItemTransactionTally>>;
  claims: Array<IItemClaim>;
  groupLimit?: Maybe<Scalars['Int']['output']>;
  itemId?: Maybe<Scalars['Int']['output']>;
  itemKind?: Maybe<IItemKindEnum>;
  itemName: Scalars['String']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  statusClaims: Array<IItemClaim>;
  subtotal: Scalars['Int']['output'];
};

export type IItemTransactionUse = {
  __typename: 'ItemTransactionUse';
  createdAt: Scalars['ISO8601DateTime']['output'];
  event: IEvent;
  id: Scalars['Int']['output'];
  postie: IUser;
  use: Scalars['Int']['output'];
};

export enum IItemVisibilityEnum {
  PubliclyVisible = 'publicly_visible',
  Restricted = 'restricted',
}

/** Autogenerated input type of LeaveBattlefieldMutation */
export type ILeaveBattlefieldMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['Int']['input'];
  entityType: IModEntityTypeEnum;
  modId: Scalars['Int']['input'];
};

/** Autogenerated return type of LeaveBattlefieldMutation. */
export type ILeaveBattlefieldMutationPayload = {
  __typename: 'LeaveBattlefieldMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

export type ILifecycle = {
  __typename: 'Lifecycle';
  createdAt: Scalars['ISO8601DateTime']['output'];
  deletedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  event: IEvent;
  id: Scalars['Int']['output'];
  kind: ILifecycleKindEnum;
};

export enum ILifecycleKindEnum {
  Gain = 'gain',
  Loss = 'loss',
  Purchase = 'purchase',
}

export type ILocation = {
  __typename: 'Location';
  city: Scalars['String']['output'];
  events?: Maybe<Array<IEvent>>;
  existingEventsSize?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  region: IRegionEnum;
  streetAddress: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

export type ILocationEventsArgs = {
  branchId: Scalars['Int']['input'];
};

export type ILocationExistingEventsSizeArgs = {
  branchId: Scalars['Int']['input'];
};

/** Autogenerated input type of LogBlueprintActionMutation */
export type ILogBlueprintActionMutationInput = {
  action: IBlueprintActionEnum;
  blueprintId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  copies: Scalars['Int']['input'];
  eventId: Scalars['Int']['input'];
  fingerprints: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of LogBlueprintActionMutation. */
export type ILogBlueprintActionMutationPayload = {
  __typename: 'LogBlueprintActionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export enum IMaskedHealthEnum {
  Bruised = 'bruised',
  Critical = 'critical',
  Healthy = 'healthy',
  Injured = 'injured',
  Zero = 'zero',
}

export type IMembership = {
  __typename: 'Membership';
  createdAt: Scalars['ISO8601DateTime']['output'];
  endsAt: Scalars['ISO8601DateTime']['output'];
  grantingBranch?: Maybe<IBranch>;
  grantor?: Maybe<IUser>;
  id: Scalars['Int']['output'];
  organization: IOrganization;
  startsAt: Scalars['ISO8601DateTime']['output'];
  user: IUser;
};

export type IMod = {
  __typename: 'Mod';
  activeModRewardTemplate?: Maybe<IModRewardTemplate>;
  constraint?: Maybe<Scalars['JSON']['output']>;
  currentAsset?: Maybe<IModAsset>;
  currentEntity?: Maybe<IModEntity>;
  currentModNarrativeRolePlay?: Maybe<IModNarrativeRolePlay>;
  currentTurn: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  itemTransactions: Array<IItemTransaction>;
  modAssets: Array<IModAsset>;
  modChallenge?: Maybe<IModChallenge>;
  modEntities: Array<IModEntity>;
  modLogs: Array<IModLog>;
  modNarrativeRolePlays: Array<IModNarrativeRolePlay>;
  modRewardTemplate?: Maybe<IModRewardTemplate>;
  modRewardTemplates: Array<IModRewardTemplate>;
  modRunner?: Maybe<IEventAttendee>;
  modSection: IModSection;
  modSignup?: Maybe<IModSignup>;
  modSignups: Array<IModSignup>;
  myEntity?: Maybe<IModEntity>;
  name: Scalars['String']['output'];
  participationLimit: Scalars['Int']['output'];
  ping?: Maybe<ICoord>;
  timeframe?: Maybe<Scalars['String']['output']>;
};

export type IModModChallengeArgs = {
  id: Scalars['Int']['input'];
};

export type IModModLogsArgs = {
  at?: InputMaybe<Scalars['String']['input']>;
  chronological?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type IModModRewardTemplateArgs = {
  id: Scalars['Int']['input'];
};

export type IModModSignupArgs = {
  id: Scalars['Int']['input'];
};

export type IModAsset = {
  __typename: 'ModAsset';
  id: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type IModBids = {
  __typename: 'ModBids';
  body?: Maybe<Scalars['Int']['output']>;
  limbs?: Maybe<Array<IModLimbEnum>>;
  mind?: Maybe<Scalars['Int']['output']>;
  resolve?: Maybe<Scalars['Int']['output']>;
  skills?: Maybe<Array<IModBidsSkill>>;
};

export type IModBidsSkill = {
  __typename: 'ModBidsSkill';
  id: Scalars['Int']['output'];
  value: Scalars['Int']['output'];
};

export type IModChallenge = {
  __typename: 'ModChallenge';
  defenseRollMatrix: Array<IDefenseRoll>;
  id: Scalars['Int']['output'];
  initiative: Scalars['Int']['output'];
  kind: IModChallengeKindEnum;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<ICoord>;
  publicNote?: Maybe<Scalars['String']['output']>;
  stack?: Maybe<Scalars['Int']['output']>;
  state?: Maybe<IModParticipantGenericState>;
  storytellerNote?: Maybe<Scalars['String']['output']>;
  visibility: IModChallengeVisibilityEnum;
};

export enum IModChallengeKindEnum {
  Challenge = 'challenge',
  Entity = 'entity',
  Friendly = 'friendly',
}

export enum IModChallengeResolutionEnum {
  AutoSuccess = 'auto_success',
  EpicFail = 'epic_fail',
  Failure = 'failure',
  Success = 'success',
}

export type IModChallengeResolutionOption = {
  __typename: 'ModChallengeResolutionOption';
  level: Scalars['Int']['output'];
  skillId: Scalars['Int']['output'];
};

export type IModChallengeState = {
  __typename: 'ModChallengeState';
  professionOptions: Array<IModChallengeResolutionOption>;
  resolutionOptions: Array<IModChallengeResolutionOption>;
  stack: Scalars['Int']['output'];
  statusEffects: Array<IModParticipantStatusEffect>;
};

export enum IModChallengeVisibilityEnum {
  Engaged = 'engaged',
  InGame = 'in_game',
  OutOfGame = 'out_of_game',
}

export type IModDamageInput = {
  amount: Scalars['Int']['input'];
  damageType?: InputMaybe<IModDamageTypeEnum>;
  equipmentKind?: InputMaybe<IItemKindEnum>;
  murder?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum IModDamageTypeEnum {
  AutoSuccess = 'auto_success',
  Body = 'body',
  EpicFail = 'epic_fail',
  Failure = 'failure',
  Healing = 'healing',
  ImpactSkillAssist = 'impact_skill_assist',
  Mixed = 'mixed',
  Radiation = 'radiation',
  Reroll = 'reroll',
  SkillApplied = 'skill_applied',
  SkillFailed = 'skill_failed',
  Standard = 'standard',
  Success = 'success',
}

export type IModEntity = IError | IModChallenge | IModSignup;

export enum IModEntityTypeEnum {
  ModChallenge = 'ModChallenge',
  ModSignup = 'ModSignup',
}

export enum IModLimbEnum {
  LeftLeg = 'left_leg',
  MainHand = 'main_hand',
  OffHand = 'off_hand',
  RightLeg = 'right_leg',
}

export type IModLog = {
  __typename: 'ModLog';
  content?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  damageAmount?: Maybe<Scalars['Int']['output']>;
  damageType?: Maybe<IModDamageTypeEnum>;
  diceRollLog?: Maybe<IDiceRollSummary>;
  entity?: Maybe<IModEntity>;
  id: Scalars['Int']['output'];
  initiative?: Maybe<Scalars['Int']['output']>;
  interferer?: Maybe<IModEntity>;
  originalLog?: Maybe<IModLog>;
  systemMessage?: Maybe<Scalars['String']['output']>;
  target?: Maybe<IModEntity>;
  turn?: Maybe<Scalars['Int']['output']>;
  user: IUser;
};

export type IModNarrativeRolePlay = {
  __typename: 'ModNarrativeRolePlay';
  body: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  limbs: Scalars['Int']['output'];
  mind: Scalars['Int']['output'];
  modNarrativeRolePlayBids: Array<IModNarrativeRolePlayBid>;
  resolve: Scalars['Int']['output'];
  skills: Scalars['Int']['output'];
  status: IModNarrativeRolePlayStatusEnum;
  title?: Maybe<Scalars['String']['output']>;
};

export type IModNarrativeRolePlayBid = {
  __typename: 'ModNarrativeRolePlayBid';
  bids: IModBids;
  id: Scalars['Int']['output'];
  modSignup: IModSignup;
  status: IModNarrativeRolePlayBidStatusEnum;
};

export enum IModNarrativeRolePlayBidStatusEnum {
  Completed = 'completed',
  Confirmed = 'confirmed',
  Pending = 'pending',
}

export enum IModNarrativeRolePlayStatusEnum {
  Completed = 'completed',
  OpenForBidding = 'open_for_bidding',
  Pending = 'pending',
}

export type IModParticipantEquipment = {
  __typename: 'ModParticipantEquipment';
  id?: Maybe<Scalars['String']['output']>;
  kind: IItemKindEnum;
  name: Scalars['String']['output'];
  shotCount: Scalars['Int']['output'];
  tracksShot: Scalars['Boolean']['output'];
};

export type IModParticipantGenericState =
  | IModChallengeState
  | IModParticipantMaskedState
  | IModParticipantState;

export type IModParticipantInput = {
  id: Scalars['Int']['input'];
  kind: IModEntityTypeEnum;
};

export type IModParticipantLimb = {
  __typename: 'ModParticipantLimb';
  equipment?: Maybe<IModParticipantEquipment>;
  limbName: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type IModParticipantMaskedState = {
  __typename: 'ModParticipantMaskedState';
  armor: Scalars['Int']['output'];
  health: IMaskedHealthEnum;
  limbs: Array<IModParticipantLimb>;
  statusEffects: Array<IModParticipantStatusEffect>;
};

export type IModParticipantSkillUse = {
  __typename: 'ModParticipantSkillUse';
  id: Scalars['Int']['output'];
  level: Scalars['Int']['output'];
  remainingUses: Scalars['Int']['output'];
};

export type IModParticipantState = {
  __typename: 'ModParticipantState';
  armor: Scalars['Int']['output'];
  body: Scalars['Int']['output'];
  limbs: Array<IModParticipantLimb>;
  maxBody: Scalars['Int']['output'];
  maxMind: Scalars['Int']['output'];
  maxResolve: Scalars['Int']['output'];
  mind: Scalars['Int']['output'];
  resolve: Scalars['Int']['output'];
  skillUses: Array<IModParticipantSkillUse>;
  statusEffects: Array<IModParticipantStatusEffect>;
};

export type IModParticipantStatusEffect = {
  __typename: 'ModParticipantStatusEffect';
  appliedAtInitiative?: Maybe<Scalars['Int']['output']>;
  appliedAtTurn?: Maybe<Scalars['Int']['output']>;
  appliedByEntityId?: Maybe<Scalars['Int']['output']>;
  appliedByEntityName?: Maybe<Scalars['String']['output']>;
  appliedByEntityType?: Maybe<Scalars['String']['output']>;
  entities?: Maybe<Array<IModParticipantStatusEffectEntity>>;
  expiresAtInitiative?: Maybe<Scalars['Int']['output']>;
  expiresAtTurn?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  skillId?: Maybe<Scalars['Int']['output']>;
  subtarget?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type IModParticipantStatusEffectEntity = {
  __typename: 'ModParticipantStatusEffectEntity';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  type: IModEntityTypeEnum;
};

export type IModReward = {
  __typename: 'ModReward';
  id: Scalars['Int']['output'];
  item: IItem;
  modRewardClaims: Array<IModRewardClaim>;
  stack: Scalars['Int']['output'];
};

export type IModRewardClaim = {
  __typename: 'ModRewardClaim';
  id: Scalars['Int']['output'];
  modSignup: IModSignup;
  stack: Scalars['Int']['output'];
};

export type IModRewardClaimInput = {
  itemId: Scalars['Int']['input'];
  stack?: InputMaybe<Scalars['Int']['input']>;
};

export type IModRewardTemplate = {
  __typename: 'ModRewardTemplate';
  description?: Maybe<Scalars['String']['output']>;
  finalized: Scalars['Boolean']['output'];
  finalizedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  id: Scalars['Int']['output'];
  modRewards: Array<IModReward>;
  modRunnerNote?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type IModSection = {
  __typename: 'ModSection';
  id: Scalars['Int']['output'];
  mods: Array<IMod>;
  name: Scalars['String']['output'];
  signupLimit: Scalars['Int']['output'];
};

export enum IModSettableAttributeEnum {
  Armor = 'armor',
  AttackRollBoost = 'attack_roll_boost',
  Blinded = 'blinded',
  Body = 'body',
  Bound = 'bound',
  ChallengeDifficulty = 'challenge_difficulty',
  DamageImmunity = 'damage_immunity',
  DeadBodyImmunity = 'dead_body_immunity',
  Death = 'death',
  DefenseRollBoost = 'defense_roll_boost',
  Grappling = 'grappling',
  Hidden = 'hidden',
  ImpactSkillRollBoost = 'impact_skill_roll_boost',
  Incapacitated = 'incapacitated',
  LeftLeg = 'left_leg',
  MainHand = 'main_hand',
  MeleeDamageReduction = 'melee_damage_reduction',
  Mind = 'mind',
  MultiGrapple = 'multi_grapple',
  Nailed = 'nailed',
  NailedByGrappling = 'nailed_by_grappling',
  OffHand = 'off_hand',
  PerformingScatterShot = 'performing_scatter_shot',
  RaiderRage = 'raider_rage',
  RangedDamageReduction = 'ranged_damage_reduction',
  RapidRiseAgain = 'rapid_rise_again',
  RapidRiseAgainDelay = 'rapid_rise_again_delay',
  ResetInitiative = 'reset_initiative',
  Resolve = 'resolve',
  RightLeg = 'right_leg',
  RiseAgain = 'rise_again',
  RiseAgainDelay = 'rise_again_delay',
  RobustRiseAgain = 'robust_rise_again',
  RobustRiseAgainDelay = 'robust_rise_again_delay',
  SharedDefense = 'shared_defense',
  Shielded = 'shielded',
  Silenced = 'silenced',
  SkillRefund = 'skill_refund',
  SkillUse = 'skill_use',
  Stack = 'stack',
  Stealthed = 'stealthed',
  Stunned = 'stunned',
  Surprised = 'surprised',
  Unbreakable = 'unbreakable',
  Unconscious = 'unconscious',
  Unstealthed = 'unstealthed',
  WsWildwindMachete = 'ws_wildwind_machete',
}

export type IModSignup = {
  __typename: 'ModSignup';
  character?: Maybe<ICharacter>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  defenseRollMatrix: Array<IDefenseRoll>;
  eventAttendee: IEventAttendee;
  id: Scalars['Int']['output'];
  initiative: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
  ping?: Maybe<ICoord>;
  position?: Maybe<ICoord>;
  state?: Maybe<IModParticipantGenericState>;
  user: IUser;
  visibility: IModChallengeVisibilityEnum;
};

/** Autogenerated input type of MoveMutation */
export type IMoveMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<IModEntityTypeEnum>;
  modId: Scalars['Int']['input'];
  position?: InputMaybe<ICoordInput>;
};

/** Autogenerated return type of MoveMutation. */
export type IMoveMutationPayload = {
  __typename: 'MoveMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

export type IMutation = {
  __typename: 'Mutation';
  appendItemTransaction?: Maybe<IAppendItemTransactionMutationPayload>;
  applyBranchContract?: Maybe<IApplyBranchContractMutationPayload>;
  assignBranchLocation?: Maybe<IAssignBranchLocationMutationPayload>;
  assignBranchOwnership?: Maybe<IAssignBranchOwnershipMutationPayload>;
  assignTemporaryManager?: Maybe<IAssignTemporaryManagerMutationPayload>;
  checkin?: Maybe<ICheckinMutationPayload>;
  checkinCharacter?: Maybe<ICheckinCharacterMutationPayload>;
  claimModRewards?: Maybe<IClaimModRewardsMutationPayload>;
  copyCharacterBuild?: Maybe<ICopyCharacterBuildMutationPayload>;
  copyEventSetup?: Maybe<ICopyEventSetupMutationPayload>;
  createCap?: Maybe<ICreateCapMutationPayload>;
  createCharacter?: Maybe<ICreateCharacterMutationPayload>;
  createCharacterActionLog?: Maybe<ICreateCharacterActionLogMutationPayload>;
  createCharacterFellowship?: Maybe<ICreateCharacterFellowshipMutationPayload>;
  createCorrectiveAction?: Maybe<ICreateCorrectiveActionMutationPayload>;
  createEvent?: Maybe<ICreateEventMutationPayload>;
  createEventLifecycle?: Maybe<ICreateEventLifecycleMutationPayload>;
  createEventShift?: Maybe<ICreateEventShiftMutationPayload>;
  createEventTicket?: Maybe<ICreateEventTicketMutationPayload>;
  createFellowship?: Maybe<ICreateFellowshipMutationPayload>;
  createFellowshipRuleTag?: Maybe<ICreateFellowshipRuleTagMutationPayload>;
  createItem?: Maybe<ICreateItemMutationPayload>;
  createItemClassification?: Maybe<ICreateItemClassificationMutationPayload>;
  createItemCrafting?: Maybe<ICreateItemCraftingMutationPayload>;
  createItemCraftingComponent?: Maybe<ICreateItemCraftingComponentMutationPayload>;
  createItemCraftingFinalProduct?: Maybe<ICreateItemCraftingFinalProductMutationPayload>;
  createItemReproduction?: Maybe<ICreateItemReproductionMutationPayload>;
  createItemReproductionComponent?: Maybe<ICreateItemReproductionComponentMutationPayload>;
  createItemTransaction?: Maybe<ICreateItemTransactionMutationPayload>;
  createLocation?: Maybe<ICreateLocationMutationPayload>;
  createMembership?: Maybe<ICreateMembershipMutationPayload>;
  createMod?: Maybe<ICreateModMutationPayload>;
  createModAsset?: Maybe<ICreateModAssetMutationPayload>;
  createModReward?: Maybe<ICreateModRewardMutationPayload>;
  createModRewardTemplate?: Maybe<ICreateModRewardTemplateMutationPayload>;
  createModSection?: Maybe<ICreateModSectionMutationPayload>;
  createModSignup?: Maybe<ICreateModSignupMutationPayload>;
  createNewPlayer?: Maybe<ICreateNewPlayerMutationPayload>;
  createReferral?: Maybe<ICreateReferralMutationPayload>;
  createSpecialDate?: Maybe<ICreateSpecialDateMutationPayload>;
  destroyAttendeeCharacter?: Maybe<IDestroyAttendeeCharacterMutationPayload>;
  destroyAuthToken?: Maybe<IDestroyAuthTokenMutationPayload>;
  destroyCharacter?: Maybe<IDestroyCharacterMutationPayload>;
  destroyCorrectiveAction?: Maybe<IDestroyCorrectiveActionMutationPayload>;
  destroyEventAttendee?: Maybe<IDestroyEventAttendeeMutationPayload>;
  destroyEventShift?: Maybe<IDestroyEventShiftMutationPayload>;
  destroyEventTicket?: Maybe<IDestroyEventTicketMutationPayload>;
  destroyFellowshipRuleTag?: Maybe<IDestroyFellowshipRuleTagMutationPayload>;
  destroyItemClassification?: Maybe<IDestroyItemClassificationMutationPayload>;
  destroyItemCrafting?: Maybe<IDestroyItemCraftingMutationPayload>;
  destroyItemCraftingComponent?: Maybe<IDestroyItemCraftingComponentMutationPayload>;
  destroyItemCraftingFinalProduct?: Maybe<IDestroyItemCraftingFinalProductMutationPayload>;
  destroyItemReproduction?: Maybe<IDestroyItemReproductionMutationPayload>;
  destroyItemReproductionComponent?: Maybe<IDestroyItemReproductionComponentMutationPayload>;
  destroyLocation?: Maybe<IDestroyLocationMutationPayload>;
  destroyMembership?: Maybe<IDestroyMembershipMutationPayload>;
  destroyMod?: Maybe<IDestroyModMutationPayload>;
  destroyModAsset?: Maybe<IDestroyModAssetMutationPayload>;
  destroyModReward?: Maybe<IDestroyModRewardMutationPayload>;
  destroyModRewardTemplate?: Maybe<IDestroyModRewardTemplateMutationPayload>;
  destroyModSignup?: Maybe<IDestroyModSignupMutationPayload>;
  destroyReferral?: Maybe<IDestroyReferralMutationPayload>;
  destroySpecialDate?: Maybe<IDestroySpecialDateMutationPayload>;
  finalizeModRewardClaims?: Maybe<IFinalizeModRewardClaimsMutationPayload>;
  fulfillShift?: Maybe<IFulfillShiftMutationPayload>;
  generateAuthToken?: Maybe<IGenerateAuthTokenMutationPayload>;
  generateBattlefieldToken?: Maybe<IGenerateBattlefieldTokenMutationPayload>;
  logBlueprintAction?: Maybe<ILogBlueprintActionMutationPayload>;
  modAddSkill?: Maybe<IAddSkillMutationPayload>;
  modAdvanceTurn?: Maybe<IAdvanceTurnMutationPayload>;
  modApplyChallengeResolution?: Maybe<IApplyChallengeResolutionMutationPayload>;
  modApplyChange?: Maybe<IApplyChangeMutationPayload>;
  modApplyDamage?: Maybe<IApplyDamageMutationPayload>;
  modApplyEnvironmentalEffect?: Maybe<IApplyEnvironmentalEffectMutationPayload>;
  modApplyShielding?: Maybe<IApplyShieldingMutationPayload>;
  modApplySkillEffect?: Maybe<IApplySkillEffectMutationPayload>;
  modAssistImpactSkill?: Maybe<IAssistImpactSkillMutationPayload>;
  modCompleteScatterShot?: Maybe<ICompleteScatterShotMutationPayload>;
  modCreateMessage?: Maybe<ICreateMessageMutationPayload>;
  modCreateModChallenge?: Maybe<ICreateModChallengeMutationPayload>;
  modCreateModNarrativeRolePlay?: Maybe<ICreateModNarrativeRolePlayMutationPayload>;
  modEndMod?: Maybe<IEndModMutationPayload>;
  modEnterBattlefield?: Maybe<IEnterBattlefieldMutationPayload>;
  modEquip?: Maybe<IEquipMutationPayload>;
  modExecuteScatterShot?: Maybe<IExecuteScatterShotMutationPayload>;
  modExpendItem?: Maybe<IExpendItemMutationPayload>;
  modExpendResolve?: Maybe<IExpendResolveMutationPayload>;
  modLeaveBattlefield?: Maybe<ILeaveBattlefieldMutationPayload>;
  modMove?: Maybe<IMoveMutationPayload>;
  modPerformKillingBlow?: Maybe<IPerformKillingBlowMutationPayload>;
  modReattemptAction?: Maybe<IReattemptActionMutationPayload>;
  modReload?: Maybe<IReloadMutationPayload>;
  modRollAttack?: Maybe<IRollAttackMutationPayload>;
  modRollDevelopmentSkill?: Maybe<IRollDevelopmentSkillMutationPayload>;
  modRollImpactSkill?: Maybe<IRollImpactSkillMutationPayload>;
  modRollInitiative?: Maybe<IRollInitiativeMutationPayload>;
  modSubmitNarrativeRolePlayBids?: Maybe<ISubmitNarrativeRolePlayBidsMutationPayload>;
  modUpdateModChallenge?: Maybe<IUpdateModChallengeMutationPayload>;
  modUpdateModChallengeResolutionOption?: Maybe<IUpdateModChallengeResolutionOptionMutationPayload>;
  modUpdateModNarrativeRolePlay?: Maybe<IUpdateModNarrativeRolePlayMutationPayload>;
  modUseCover?: Maybe<IUseCoverMutationPayload>;
  removeItemTransaction?: Maybe<IRemoveItemTransactionMutationPayload>;
  requestPasswordReset?: Maybe<IRequestPasswordResetMutationPayload>;
  resetPassword?: Maybe<IResetPasswordMutationPayload>;
  retireCharacter?: Maybe<IRetireCharacterMutationPayload>;
  rollDice?: Maybe<IRollDiceMutationPayload>;
  trackItemUse?: Maybe<ITrackItemUseMutationPayload>;
  updateBranch?: Maybe<IUpdateBranchMutationPayload>;
  updateCap?: Maybe<IUpdateCapMutationPayload>;
  updateCharacterActionLog?: Maybe<IUpdateCharacterActionLogMutationPayload>;
  updateCharacterData?: Maybe<IUpdateCharacterDataMutationPayload>;
  updateCharacterFellowship?: Maybe<IUpdateCharacterFellowshipMutationPayload>;
  updateCorrectiveAction?: Maybe<IUpdateCorrectiveActionMutationPayload>;
  updateEvent?: Maybe<IUpdateEventMutationPayload>;
  updateEventAttendee?: Maybe<IUpdateEventAttendeeMutationPayload>;
  updateEventLifecycle?: Maybe<IUpdateEventLifecycleMutationPayload>;
  updateEventShift?: Maybe<IUpdateEventShiftMutationPayload>;
  updateEventTicket?: Maybe<IUpdateEventTicketMutationPayload>;
  updateFellowship?: Maybe<IUpdateFellowshipMutationPayload>;
  updateItem?: Maybe<IUpdateItemMutationPayload>;
  updateItemCrafting?: Maybe<IUpdateItemCraftingMutationPayload>;
  updateItemCraftingComponent?: Maybe<IUpdateItemCraftingComponentMutationPayload>;
  updateItemCraftingFinalProduct?: Maybe<IUpdateItemCraftingFinalProductMutationPayload>;
  updateItemReproduction?: Maybe<IUpdateItemReproductionMutationPayload>;
  updateItemReproductionComponent?: Maybe<IUpdateItemReproductionComponentMutationPayload>;
  updateItemTransaction?: Maybe<IUpdateItemTransactionMutationPayload>;
  updateLocation?: Maybe<IUpdateLocationMutationPayload>;
  updateMembership?: Maybe<IUpdateMembershipMutationPayload>;
  updateMod?: Maybe<IUpdateModMutationPayload>;
  updateModAsset?: Maybe<IUpdateModAssetMutationPayload>;
  updateModReward?: Maybe<IUpdateModRewardMutationPayload>;
  updateModRewardTemplate?: Maybe<IUpdateModRewardTemplateMutationPayload>;
  updateModSection?: Maybe<IUpdateModSectionMutationPayload>;
  updateModSignup?: Maybe<IUpdateModSignupMutationPayload>;
  updateOrganization?: Maybe<IUpdateOrganizationMutationPayload>;
  updatePassword?: Maybe<IUpdatePasswordMutationPayload>;
  updatePlayerBranchOwnership?: Maybe<IUpdatePlayerBranchOwnershipMutationPayload>;
  updatePlayerData?: Maybe<IUpdatePlayerDataMutationPayload>;
  updatePlayerOrganizationData?: Maybe<IUpdatePlayerOrganizationDataMutationPayload>;
  updateSpecialDate?: Maybe<IUpdateSpecialDateMutationPayload>;
};

export type IMutationAppendItemTransactionArgs = {
  input: IAppendItemTransactionMutationInput;
};

export type IMutationApplyBranchContractArgs = {
  input: IApplyBranchContractMutationInput;
};

export type IMutationAssignBranchLocationArgs = {
  input: IAssignBranchLocationMutationInput;
};

export type IMutationAssignBranchOwnershipArgs = {
  input: IAssignBranchOwnershipMutationInput;
};

export type IMutationAssignTemporaryManagerArgs = {
  input: IAssignTemporaryManagerMutationInput;
};

export type IMutationCheckinArgs = {
  input: ICheckinMutationInput;
};

export type IMutationCheckinCharacterArgs = {
  input: ICheckinCharacterMutationInput;
};

export type IMutationClaimModRewardsArgs = {
  input: IClaimModRewardsMutationInput;
};

export type IMutationCopyCharacterBuildArgs = {
  input: ICopyCharacterBuildMutationInput;
};

export type IMutationCopyEventSetupArgs = {
  input: ICopyEventSetupMutationInput;
};

export type IMutationCreateCapArgs = {
  input: ICreateCapMutationInput;
};

export type IMutationCreateCharacterArgs = {
  input: ICreateCharacterMutationInput;
};

export type IMutationCreateCharacterActionLogArgs = {
  input: ICreateCharacterActionLogMutationInput;
};

export type IMutationCreateCharacterFellowshipArgs = {
  input: ICreateCharacterFellowshipMutationInput;
};

export type IMutationCreateCorrectiveActionArgs = {
  input: ICreateCorrectiveActionMutationInput;
};

export type IMutationCreateEventArgs = {
  input: ICreateEventMutationInput;
};

export type IMutationCreateEventLifecycleArgs = {
  input: ICreateEventLifecycleMutationInput;
};

export type IMutationCreateEventShiftArgs = {
  input: ICreateEventShiftMutationInput;
};

export type IMutationCreateEventTicketArgs = {
  input: ICreateEventTicketMutationInput;
};

export type IMutationCreateFellowshipArgs = {
  input: ICreateFellowshipMutationInput;
};

export type IMutationCreateFellowshipRuleTagArgs = {
  input: ICreateFellowshipRuleTagMutationInput;
};

export type IMutationCreateItemArgs = {
  input: ICreateItemMutationInput;
};

export type IMutationCreateItemClassificationArgs = {
  input: ICreateItemClassificationMutationInput;
};

export type IMutationCreateItemCraftingArgs = {
  input: ICreateItemCraftingMutationInput;
};

export type IMutationCreateItemCraftingComponentArgs = {
  input: ICreateItemCraftingComponentMutationInput;
};

export type IMutationCreateItemCraftingFinalProductArgs = {
  input: ICreateItemCraftingFinalProductMutationInput;
};

export type IMutationCreateItemReproductionArgs = {
  input: ICreateItemReproductionMutationInput;
};

export type IMutationCreateItemReproductionComponentArgs = {
  input: ICreateItemReproductionComponentMutationInput;
};

export type IMutationCreateItemTransactionArgs = {
  input: ICreateItemTransactionMutationInput;
};

export type IMutationCreateLocationArgs = {
  input: ICreateLocationMutationInput;
};

export type IMutationCreateMembershipArgs = {
  input: ICreateMembershipMutationInput;
};

export type IMutationCreateModArgs = {
  input: ICreateModMutationInput;
};

export type IMutationCreateModAssetArgs = {
  input: ICreateModAssetMutationInput;
};

export type IMutationCreateModRewardArgs = {
  input: ICreateModRewardMutationInput;
};

export type IMutationCreateModRewardTemplateArgs = {
  input: ICreateModRewardTemplateMutationInput;
};

export type IMutationCreateModSectionArgs = {
  input: ICreateModSectionMutationInput;
};

export type IMutationCreateModSignupArgs = {
  input: ICreateModSignupMutationInput;
};

export type IMutationCreateNewPlayerArgs = {
  input: ICreateNewPlayerMutationInput;
};

export type IMutationCreateReferralArgs = {
  input: ICreateReferralMutationInput;
};

export type IMutationCreateSpecialDateArgs = {
  input: ICreateSpecialDateMutationInput;
};

export type IMutationDestroyAttendeeCharacterArgs = {
  input: IDestroyAttendeeCharacterMutationInput;
};

export type IMutationDestroyAuthTokenArgs = {
  input: IDestroyAuthTokenMutationInput;
};

export type IMutationDestroyCharacterArgs = {
  input: IDestroyCharacterMutationInput;
};

export type IMutationDestroyCorrectiveActionArgs = {
  input: IDestroyCorrectiveActionMutationInput;
};

export type IMutationDestroyEventAttendeeArgs = {
  input: IDestroyEventAttendeeMutationInput;
};

export type IMutationDestroyEventShiftArgs = {
  input: IDestroyEventShiftMutationInput;
};

export type IMutationDestroyEventTicketArgs = {
  input: IDestroyEventTicketMutationInput;
};

export type IMutationDestroyFellowshipRuleTagArgs = {
  input: IDestroyFellowshipRuleTagMutationInput;
};

export type IMutationDestroyItemClassificationArgs = {
  input: IDestroyItemClassificationMutationInput;
};

export type IMutationDestroyItemCraftingArgs = {
  input: IDestroyItemCraftingMutationInput;
};

export type IMutationDestroyItemCraftingComponentArgs = {
  input: IDestroyItemCraftingComponentMutationInput;
};

export type IMutationDestroyItemCraftingFinalProductArgs = {
  input: IDestroyItemCraftingFinalProductMutationInput;
};

export type IMutationDestroyItemReproductionArgs = {
  input: IDestroyItemReproductionMutationInput;
};

export type IMutationDestroyItemReproductionComponentArgs = {
  input: IDestroyItemReproductionComponentMutationInput;
};

export type IMutationDestroyLocationArgs = {
  input: IDestroyLocationMutationInput;
};

export type IMutationDestroyMembershipArgs = {
  input: IDestroyMembershipMutationInput;
};

export type IMutationDestroyModArgs = {
  input: IDestroyModMutationInput;
};

export type IMutationDestroyModAssetArgs = {
  input: IDestroyModAssetMutationInput;
};

export type IMutationDestroyModRewardArgs = {
  input: IDestroyModRewardMutationInput;
};

export type IMutationDestroyModRewardTemplateArgs = {
  input: IDestroyModRewardTemplateMutationInput;
};

export type IMutationDestroyModSignupArgs = {
  input: IDestroyModSignupMutationInput;
};

export type IMutationDestroyReferralArgs = {
  input: IDestroyReferralMutationInput;
};

export type IMutationDestroySpecialDateArgs = {
  input: IDestroySpecialDateMutationInput;
};

export type IMutationFinalizeModRewardClaimsArgs = {
  input: IFinalizeModRewardClaimsMutationInput;
};

export type IMutationFulfillShiftArgs = {
  input: IFulfillShiftMutationInput;
};

export type IMutationGenerateAuthTokenArgs = {
  input: IGenerateAuthTokenMutationInput;
};

export type IMutationGenerateBattlefieldTokenArgs = {
  input: IGenerateBattlefieldTokenMutationInput;
};

export type IMutationLogBlueprintActionArgs = {
  input: ILogBlueprintActionMutationInput;
};

export type IMutationModAddSkillArgs = {
  input: IAddSkillMutationInput;
};

export type IMutationModAdvanceTurnArgs = {
  input: IAdvanceTurnMutationInput;
};

export type IMutationModApplyChallengeResolutionArgs = {
  input: IApplyChallengeResolutionMutationInput;
};

export type IMutationModApplyChangeArgs = {
  input: IApplyChangeMutationInput;
};

export type IMutationModApplyDamageArgs = {
  input: IApplyDamageMutationInput;
};

export type IMutationModApplyEnvironmentalEffectArgs = {
  input: IApplyEnvironmentalEffectMutationInput;
};

export type IMutationModApplyShieldingArgs = {
  input: IApplyShieldingMutationInput;
};

export type IMutationModApplySkillEffectArgs = {
  input: IApplySkillEffectMutationInput;
};

export type IMutationModAssistImpactSkillArgs = {
  input: IAssistImpactSkillMutationInput;
};

export type IMutationModCompleteScatterShotArgs = {
  input: ICompleteScatterShotMutationInput;
};

export type IMutationModCreateMessageArgs = {
  input: ICreateMessageMutationInput;
};

export type IMutationModCreateModChallengeArgs = {
  input: ICreateModChallengeMutationInput;
};

export type IMutationModCreateModNarrativeRolePlayArgs = {
  input: ICreateModNarrativeRolePlayMutationInput;
};

export type IMutationModEndModArgs = {
  input: IEndModMutationInput;
};

export type IMutationModEnterBattlefieldArgs = {
  input: IEnterBattlefieldMutationInput;
};

export type IMutationModEquipArgs = {
  input: IEquipMutationInput;
};

export type IMutationModExecuteScatterShotArgs = {
  input: IExecuteScatterShotMutationInput;
};

export type IMutationModExpendItemArgs = {
  input: IExpendItemMutationInput;
};

export type IMutationModExpendResolveArgs = {
  input: IExpendResolveMutationInput;
};

export type IMutationModLeaveBattlefieldArgs = {
  input: ILeaveBattlefieldMutationInput;
};

export type IMutationModMoveArgs = {
  input: IMoveMutationInput;
};

export type IMutationModPerformKillingBlowArgs = {
  input: IPerformKillingBlowMutationInput;
};

export type IMutationModReattemptActionArgs = {
  input: IReattemptActionMutationInput;
};

export type IMutationModReloadArgs = {
  input: IReloadMutationInput;
};

export type IMutationModRollAttackArgs = {
  input: IRollAttackMutationInput;
};

export type IMutationModRollDevelopmentSkillArgs = {
  input: IRollDevelopmentSkillMutationInput;
};

export type IMutationModRollImpactSkillArgs = {
  input: IRollImpactSkillMutationInput;
};

export type IMutationModRollInitiativeArgs = {
  input: IRollInitiativeMutationInput;
};

export type IMutationModSubmitNarrativeRolePlayBidsArgs = {
  input: ISubmitNarrativeRolePlayBidsMutationInput;
};

export type IMutationModUpdateModChallengeArgs = {
  input: IUpdateModChallengeMutationInput;
};

export type IMutationModUpdateModChallengeResolutionOptionArgs = {
  input: IUpdateModChallengeResolutionOptionMutationInput;
};

export type IMutationModUpdateModNarrativeRolePlayArgs = {
  input: IUpdateModNarrativeRolePlayMutationInput;
};

export type IMutationModUseCoverArgs = {
  input: IUseCoverMutationInput;
};

export type IMutationRemoveItemTransactionArgs = {
  input: IRemoveItemTransactionMutationInput;
};

export type IMutationRequestPasswordResetArgs = {
  input: IRequestPasswordResetMutationInput;
};

export type IMutationResetPasswordArgs = {
  input: IResetPasswordMutationInput;
};

export type IMutationRetireCharacterArgs = {
  input: IRetireCharacterMutationInput;
};

export type IMutationRollDiceArgs = {
  input: IRollDiceMutationInput;
};

export type IMutationTrackItemUseArgs = {
  input: ITrackItemUseMutationInput;
};

export type IMutationUpdateBranchArgs = {
  input: IUpdateBranchMutationInput;
};

export type IMutationUpdateCapArgs = {
  input: IUpdateCapMutationInput;
};

export type IMutationUpdateCharacterActionLogArgs = {
  input: IUpdateCharacterActionLogMutationInput;
};

export type IMutationUpdateCharacterDataArgs = {
  input: IUpdateCharacterDataMutationInput;
};

export type IMutationUpdateCharacterFellowshipArgs = {
  input: IUpdateCharacterFellowshipMutationInput;
};

export type IMutationUpdateCorrectiveActionArgs = {
  input: IUpdateCorrectiveActionMutationInput;
};

export type IMutationUpdateEventArgs = {
  input: IUpdateEventMutationInput;
};

export type IMutationUpdateEventAttendeeArgs = {
  input: IUpdateEventAttendeeMutationInput;
};

export type IMutationUpdateEventLifecycleArgs = {
  input: IUpdateEventLifecycleMutationInput;
};

export type IMutationUpdateEventShiftArgs = {
  input: IUpdateEventShiftMutationInput;
};

export type IMutationUpdateEventTicketArgs = {
  input: IUpdateEventTicketMutationInput;
};

export type IMutationUpdateFellowshipArgs = {
  input: IUpdateFellowshipMutationInput;
};

export type IMutationUpdateItemArgs = {
  input: IUpdateItemMutationInput;
};

export type IMutationUpdateItemCraftingArgs = {
  input: IUpdateItemCraftingMutationInput;
};

export type IMutationUpdateItemCraftingComponentArgs = {
  input: IUpdateItemCraftingComponentMutationInput;
};

export type IMutationUpdateItemCraftingFinalProductArgs = {
  input: IUpdateItemCraftingFinalProductMutationInput;
};

export type IMutationUpdateItemReproductionArgs = {
  input: IUpdateItemReproductionMutationInput;
};

export type IMutationUpdateItemReproductionComponentArgs = {
  input: IUpdateItemReproductionComponentMutationInput;
};

export type IMutationUpdateItemTransactionArgs = {
  input: IUpdateItemTransactionMutationInput;
};

export type IMutationUpdateLocationArgs = {
  input: IUpdateLocationMutationInput;
};

export type IMutationUpdateMembershipArgs = {
  input: IUpdateMembershipMutationInput;
};

export type IMutationUpdateModArgs = {
  input: IUpdateModMutationInput;
};

export type IMutationUpdateModAssetArgs = {
  input: IUpdateModAssetMutationInput;
};

export type IMutationUpdateModRewardArgs = {
  input: IUpdateModRewardMutationInput;
};

export type IMutationUpdateModRewardTemplateArgs = {
  input: IUpdateModRewardTemplateMutationInput;
};

export type IMutationUpdateModSectionArgs = {
  input: IUpdateModSectionMutationInput;
};

export type IMutationUpdateModSignupArgs = {
  input: IUpdateModSignupMutationInput;
};

export type IMutationUpdateOrganizationArgs = {
  input: IUpdateOrganizationMutationInput;
};

export type IMutationUpdatePasswordArgs = {
  input: IUpdatePasswordMutationInput;
};

export type IMutationUpdatePlayerBranchOwnershipArgs = {
  input: IUpdatePlayerBranchOwnershipMutationInput;
};

export type IMutationUpdatePlayerDataArgs = {
  input: IUpdatePlayerDataMutationInput;
};

export type IMutationUpdatePlayerOrganizationDataArgs = {
  input: IUpdatePlayerOrganizationDataMutationInput;
};

export type IMutationUpdateSpecialDateArgs = {
  input: IUpdateSpecialDateMutationInput;
};

export type INarrativeRolePlayBidsInput = {
  body?: InputMaybe<Scalars['Int']['input']>;
  limbs?: InputMaybe<Array<IModLimbEnum>>;
  mind?: InputMaybe<Scalars['Int']['input']>;
  resolve?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<INarrativeRolePlayBidsSkillInput>>;
};

export type INarrativeRolePlayBidsSkillInput = {
  id: Scalars['Int']['input'];
  value: Scalars['Int']['input'];
};

export type IOrganization = {
  __typename: 'Organization';
  armorUpgradeComponents: Array<ICraftingComponent>;
  attendances: Array<ICachedUserAttendance>;
  blueprintCopyProcedure?: Maybe<IItem>;
  branch: IBranch;
  branches: Array<IBranch>;
  characters?: Maybe<Array<ICharacter>>;
  configs?: Maybe<IOrganizationConfig>;
  contracts: Array<IContract>;
  fellowship?: Maybe<IFellowship>;
  fellowships?: Maybe<Array<IFellowship>>;
  id: Scalars['Int']['output'];
  item?: Maybe<IItem>;
  itemGrades: Array<IItemGradeEnum>;
  itemKinds: Array<IItemKindEnum>;
  items: Array<IItem>;
  lastEventAttendanceSnapshotOn?: Maybe<Scalars['ISO8601DateTime']['output']>;
  lastEventDiffOn?: Maybe<Scalars['ISO8601DateTime']['output']>;
  memberships?: Maybe<Array<IMembership>>;
  name: Scalars['String']['output'];
  rebirthedCharacters?: Maybe<Array<ICharacter>>;
  role: IOrganizationRoleEnum;
  ruleTags?: Maybe<Array<IRuleTag>>;
  shorthand: Scalars['String']['output'];
  slug: Scalars['String']['output'];
  specialDates?: Maybe<Array<ISpecialDate>>;
  statistics?: Maybe<IStatisticsResult>;
  threats?: Maybe<Array<IThreat>>;
  timelines?: Maybe<Array<ITimeline>>;
  userGrowths: Array<IUserGrowth>;
};

export type IOrganizationAttendancesArgs = {
  absence?: InputMaybe<Scalars['Boolean']['input']>;
  branchIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  bypassAttendance?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  includeNonAttendance?: InputMaybe<Scalars['Boolean']['input']>;
  roles?: InputMaybe<Array<IOrganizationRoleEnum>>;
  trailingWindow?: InputMaybe<Scalars['String']['input']>;
  upto?: InputMaybe<Scalars['String']['input']>;
  withInfractions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IOrganizationBranchesArgs = {
  owned?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IOrganizationCharactersArgs = {
  branchIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  buildEarned?: InputMaybe<Array<Scalars['Int']['input']>>;
  currentBody?: InputMaybe<Array<Scalars['Int']['input']>>;
  currentLife?: InputMaybe<Array<Scalars['Int']['input']>>;
  currentMind?: InputMaybe<Array<Scalars['Int']['input']>>;
  currentResolve?: InputMaybe<Array<Scalars['Int']['input']>>;
  eventId?: InputMaybe<Scalars['Int']['input']>;
  isLocal?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  level?: InputMaybe<Scalars['Int']['input']>;
  loreIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  printRequested?: InputMaybe<Scalars['Boolean']['input']>;
  reputationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  skillIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IOrganizationFellowshipArgs = {
  fellowshipId: Scalars['Int']['input'];
};

export type IOrganizationFellowshipsArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  kind: IFellowshipKindEnum;
};

export type IOrganizationItemArgs = {
  id: Scalars['Int']['input'];
};

export type IOrganizationItemsArgs = {
  keyword?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<IItemKindEnum>;
  versions: Array<Scalars['Int']['input']>;
};

export type IOrganizationMembershipsArgs = {
  on?: InputMaybe<Scalars['String']['input']>;
};

export type IOrganizationStatisticsArgs = {
  branchIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  eventId?: InputMaybe<Scalars['Int']['input']>;
  isLocal?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  modId?: InputMaybe<Scalars['Int']['input']>;
  printRequested?: InputMaybe<Scalars['Boolean']['input']>;
  type: IStatisticsTypeEnum;
};

export type IOrganizationUserGrowthsArgs = {
  branchIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IOrganizationConfig = {
  __typename: 'OrganizationConfig';
  charactersActiveCountMax: Scalars['Int']['output'];
  charactersCountMax: Scalars['Int']['output'];
  charactersCountStaffMax: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
};

export enum IOrganizationRoleEnum {
  Admin = 'admin',
  Assistant = 'assistant',
  Employee = 'employee',
  Regular = 'regular',
  Unset = 'unset',
}

/** Autogenerated input type of PerformKillingBlowMutation */
export type IPerformKillingBlowMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<IModEntityTypeEnum>;
  modId: Scalars['Int']['input'];
  targetId: Scalars['Int']['input'];
  targetType: IModEntityTypeEnum;
};

/** Autogenerated return type of PerformKillingBlowMutation. */
export type IPerformKillingBlowMutationPayload = {
  __typename: 'PerformKillingBlowMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

export type IPermission = {
  __typename: 'Permission';
  entity: IUser;
  permitted: Scalars['Boolean']['output'];
};

export type IQuery = {
  __typename: 'Query';
  branch?: Maybe<IBranch>;
  event?: Maybe<IEvent>;
  events: Array<IEvent>;
  locations: Array<ILocation>;
  memberships: Array<IMembership>;
  organization: IOrganization;
  organizationRoles: Array<IOrganizationRoleEnum>;
  organizations: Array<IOrganization>;
  permission: IPermission;
  resetPasswordTokenStatus: Scalars['Boolean']['output'];
  searchPlayer: Array<ISearchPlayerResult>;
  temporaryTokenStatus: Scalars['Boolean']['output'];
  tokenId?: Maybe<Scalars['Int']['output']>;
  user?: Maybe<IUser>;
};

export type IQueryBranchArgs = {
  branchId: Scalars['Int']['input'];
};

export type IQueryEventArgs = {
  eventId: Scalars['Int']['input'];
};

export type IQueryEventsArgs = {
  branchIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  from?: InputMaybe<Scalars['String']['input']>;
  organizationIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  upto?: InputMaybe<Scalars['String']['input']>;
};

export type IQueryMembershipsArgs = {
  branchIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type IQueryOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type IQueryPermissionArgs = {
  action: Scalars['String']['input'];
  branchId?: InputMaybe<Scalars['Int']['input']>;
  characterId?: InputMaybe<Scalars['Int']['input']>;
  eventId?: InputMaybe<Scalars['Int']['input']>;
  modId?: InputMaybe<Scalars['Int']['input']>;
  playerId?: InputMaybe<Scalars['Int']['input']>;
};

export type IQueryResetPasswordTokenStatusArgs = {
  token: Scalars['String']['input'];
};

export type IQuerySearchPlayerArgs = {
  accessLevelFilters?: InputMaybe<Array<IOrganizationRoleEnum>>;
  activeFrom?: InputMaybe<Scalars['String']['input']>;
  activeInversion?: InputMaybe<Scalars['Boolean']['input']>;
  activeUpto?: InputMaybe<Scalars['String']['input']>;
  branchId?: InputMaybe<Scalars['Int']['input']>;
  branchIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  eventId?: InputMaybe<Scalars['Int']['input']>;
  modId?: InputMaybe<Scalars['Int']['input']>;
  playersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  query: Scalars['String']['input'];
  withCorrectiveActions?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IQueryUserArgs = {
  userId: Scalars['Int']['input'];
};

/** Autogenerated input type of ReattemptActionMutation */
export type IReattemptActionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modId: Scalars['Int']['input'];
  modLogId: Scalars['Int']['input'];
};

/** Autogenerated return type of ReattemptActionMutation. */
export type IReattemptActionMutationPayload = {
  __typename: 'ReattemptActionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

export enum IRegionEnum {
  Ab = 'AB',
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Atl = 'ATL',
  Az = 'AZ',
  Bc = 'BC',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Fm = 'FM',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Mb = 'MB',
  Md = 'MD',
  Me = 'ME',
  Mh = 'MH',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Mp = 'MP',
  Ms = 'MS',
  Mt = 'MT',
  Na = 'NA',
  National = 'NATIONAL',
  Nb = 'NB',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nl = 'NL',
  Nm = 'NM',
  Noca = 'NOCA',
  Ns = 'NS',
  Nt = 'NT',
  Nu = 'NU',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  On = 'ON',
  Or = 'OR',
  Pa = 'PA',
  Pe = 'PE',
  Pnw = 'PNW',
  Pr = 'PR',
  Psw = 'PSW',
  Pw = 'PW',
  Qc = 'QC',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Sk = 'SK',
  Socal = 'SOCAL',
  Tn = 'TN',
  To = 'TO',
  Tx = 'TX',
  Unspecified = 'UNSPECIFIED',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Virtual = 'VIRTUAL',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY',
  Yt = 'YT',
}

export type IRegisteredItem = {
  __typename: 'RegisteredItem';
  description: Scalars['String']['output'];
  id: Scalars['Int']['output'];
};

/** Autogenerated input type of ReloadMutation */
export type IReloadMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<IModEntityTypeEnum>;
  limb: IModLimbEnum;
  modId: Scalars['Int']['input'];
};

/** Autogenerated return type of ReloadMutation. */
export type IReloadMutationPayload = {
  __typename: 'ReloadMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of RemoveItemTransactionMutation */
export type IRemoveItemTransactionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemTransactionId: Scalars['Int']['input'];
};

/** Autogenerated return type of RemoveItemTransactionMutation. */
export type IRemoveItemTransactionMutationPayload = {
  __typename: 'RemoveItemTransactionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  event?: Maybe<IEvent>;
};

/** Autogenerated input type of RequestPasswordResetMutation */
export type IRequestPasswordResetMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
};

/** Autogenerated return type of RequestPasswordResetMutation. */
export type IRequestPasswordResetMutationPayload = {
  __typename: 'RequestPasswordResetMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of ResetPasswordMutation */
export type IResetPasswordMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
};

/** Autogenerated return type of ResetPasswordMutation. */
export type IResetPasswordMutationPayload = {
  __typename: 'ResetPasswordMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  user?: Maybe<IUser>;
};

export type IResidenciesStatistics = {
  __typename: 'ResidenciesStatistics';
  branchIds?: Maybe<Array<Scalars['Int']['output']>>;
  eventId?: Maybe<Scalars['Int']['output']>;
  modId?: Maybe<Scalars['Int']['output']>;
  type: IStatisticsTypeEnum;
  values: Array<IResidencyStatistics>;
};

export type IResidencyStatistics = {
  __typename: 'ResidencyStatistics';
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  shorthand: Scalars['String']['output'];
};

/** Autogenerated input type of RetireCharacterMutation */
export type IRetireCharacterMutationInput = {
  characterId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RetireCharacterMutation. */
export type IRetireCharacterMutationPayload = {
  __typename: 'RetireCharacterMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<IUser>;
};

export type IRetirementPaths = {
  __typename: 'RetirementPaths';
  alive: Array<IRetirementXp>;
  dead: Array<IRetirementXp>;
};

export type IRetirementXp = {
  __typename: 'RetirementXp';
  amount: Scalars['Int']['output'];
  earnedOn?: Maybe<Scalars['ISO8601Date']['output']>;
};

export type IRevenueAggregates = {
  __typename: 'RevenueAggregates';
  attendeesPaid: Scalars['Int']['output'];
  attendeesTotal: Scalars['Int']['output'];
  revenue: Scalars['Float']['output'];
  revenueDiscounted: Scalars['Float']['output'];
  revenueLiable: Scalars['Float']['output'];
};

/** Autogenerated input type of RollAttackMutation */
export type IRollAttackMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<IModEntityTypeEnum>;
  modId: Scalars['Int']['input'];
  targetId: Scalars['Int']['input'];
  targetType: IModEntityTypeEnum;
};

/** Autogenerated return type of RollAttackMutation. */
export type IRollAttackMutationPayload = {
  __typename: 'RollAttackMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of RollDevelopmentSkillMutation */
export type IRollDevelopmentSkillMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<IModEntityTypeEnum>;
  modId: Scalars['Int']['input'];
  skillId: Scalars['Int']['input'];
  targetId: Scalars['Int']['input'];
  targetType: IModEntityTypeEnum;
};

/** Autogenerated return type of RollDevelopmentSkillMutation. */
export type IRollDevelopmentSkillMutationPayload = {
  __typename: 'RollDevelopmentSkillMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of RollDiceMutation */
export type IRollDiceMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  diceRoll?: InputMaybe<IDiceRollerInput>;
};

/** Autogenerated return type of RollDiceMutation. */
export type IRollDiceMutationPayload = {
  __typename: 'RollDiceMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  diceRollSummary?: Maybe<IDiceRollSummary>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RollImpactSkillMutation */
export type IRollImpactSkillMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<IModEntityTypeEnum>;
  modId: Scalars['Int']['input'];
  modLogId?: InputMaybe<Scalars['Int']['input']>;
  modLogInterfereId?: InputMaybe<Scalars['Int']['input']>;
  secondarySkillId?: InputMaybe<Scalars['Int']['input']>;
  skillId: Scalars['Int']['input'];
  subtarget?: InputMaybe<Scalars['String']['input']>;
  targetId: Scalars['Int']['input'];
  targetType: IModEntityTypeEnum;
};

/** Autogenerated return type of RollImpactSkillMutation. */
export type IRollImpactSkillMutationPayload = {
  __typename: 'RollImpactSkillMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of RollInitiativeMutation */
export type IRollInitiativeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<IModEntityTypeEnum>;
  modId: Scalars['Int']['input'];
};

/** Autogenerated return type of RollInitiativeMutation. */
export type IRollInitiativeMutationPayload = {
  __typename: 'RollInitiativeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

export type IRuleTag = {
  __typename: 'RuleTag';
  fellowshipRuleTags: Array<IFellowshipRuleTag>;
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type ISearchPlayerResult = ICharacter | IError | IUser;

export type IShift = {
  __typename: 'Shift';
  adjustableExpansionStrategy: Scalars['Boolean']['output'];
  attendeeShifts?: Maybe<Array<IAttendeeShift>>;
  autoExpand: Scalars['Boolean']['output'];
  baseRatio?: Maybe<Scalars['Int']['output']>;
  eventId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  identifier?: Maybe<Scalars['Int']['output']>;
  isEnabled: Scalars['Boolean']['output'];
  isFullyBooked: Scalars['Boolean']['output'];
  kind: Scalars['String']['output'];
  label?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  playersCount?: Maybe<Scalars['Int']['output']>;
};

export enum IShiftKindEnum {
  Casting = 'casting',
  Cleanup = 'cleanup',
  Special = 'special',
}

export type ISkillCategoriesStatistics = {
  __typename: 'SkillCategoriesStatistics';
  branchIds?: Maybe<Array<Scalars['Int']['output']>>;
  eventId?: Maybe<Scalars['Int']['output']>;
  modId?: Maybe<Scalars['Int']['output']>;
  type: IStatisticsTypeEnum;
  values: Array<ISkillCategoryStatistics>;
};

export type ISkillCategoryStatistics = {
  __typename: 'SkillCategoryStatistics';
  aberrants: Array<ICharacter>;
  criminals: Array<ICharacter>;
  total: Scalars['Int']['output'];
};

export type ISkillStatistics = {
  __typename: 'SkillStatistics';
  count: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  level: Scalars['Int']['output'];
};

export type ISkillsStatistics = {
  __typename: 'SkillsStatistics';
  branchIds?: Maybe<Array<Scalars['Int']['output']>>;
  eventId?: Maybe<Scalars['Int']['output']>;
  modId?: Maybe<Scalars['Int']['output']>;
  type: IStatisticsTypeEnum;
  values: Array<ISkillStatistics>;
};

export type ISpecialDate = {
  __typename: 'SpecialDate';
  endsAt: Scalars['ISO8601DateTime']['output'];
  id: Scalars['Int']['output'];
  kind: ISpecialDateKindEnum;
  startsAt: Scalars['ISO8601DateTime']['output'];
  title: Scalars['String']['output'];
};

export enum ISpecialDateKindEnum {
  CalendarBlock = 'calendar_block',
}

export type IStatStatistics = {
  __typename: 'StatStatistics';
  body: Array<Array<Scalars['Int']['output']>>;
  buildEarned: Array<Array<Scalars['Int']['output']>>;
  buildUsed: Array<Array<Scalars['Int']['output']>>;
  currentLife: Array<Array<Scalars['Int']['output']>>;
  faithId: Array<Array<Scalars['Int']['output']>>;
  mind: Array<Array<Scalars['Int']['output']>>;
  resolve: Array<Array<Scalars['Int']['output']>>;
  strainId: Array<Array<Scalars['Int']['output']>>;
};

export type IStatisticsResult =
  | IResidenciesStatistics
  | ISkillCategoriesStatistics
  | ISkillsStatistics
  | IStatsStatistics;

export enum IStatisticsTypeEnum {
  Lores = 'lores',
  Reputations = 'reputations',
  Residencies = 'residencies',
  SkillCategories = 'skill_categories',
  Skills = 'skills',
  Stats = 'stats',
}

export type IStatsStatistics = {
  __typename: 'StatsStatistics';
  branchIds?: Maybe<Array<Scalars['Int']['output']>>;
  eventId?: Maybe<Scalars['Int']['output']>;
  modId?: Maybe<Scalars['Int']['output']>;
  type: IStatisticsTypeEnum;
  values: Array<IStatStatistics>;
};

/** Autogenerated input type of SubmitNarrativeRolePlayBidsMutation */
export type ISubmitNarrativeRolePlayBidsMutationInput = {
  bids: INarrativeRolePlayBidsInput;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  confirm?: InputMaybe<Scalars['Boolean']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  modId: Scalars['Int']['input'];
  modNarrativeRolePlayId: Scalars['Int']['input'];
};

/** Autogenerated return type of SubmitNarrativeRolePlayBidsMutation. */
export type ISubmitNarrativeRolePlayBidsMutationPayload = {
  __typename: 'SubmitNarrativeRolePlayBidsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
  modNarrativeRolePlayBid?: Maybe<IModNarrativeRolePlayBid>;
};

export type ITalliedActionLog = {
  __typename: 'TalliedActionLog';
  id: Scalars['Int']['output'];
  log?: Maybe<IActionLog>;
  tally: IActionLogTally;
  valid: Scalars['Boolean']['output'];
};

export type ITemporaryManager = {
  __typename: 'TemporaryManager';
  event: IEvent;
  id: Scalars['Int']['output'];
  user: IUser;
};

export type ITemporaryToken = {
  __typename: 'TemporaryToken';
  browser?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  hardware?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  os?: Maybe<Scalars['String']['output']>;
  token: Scalars['String']['output'];
};

export type IThreat = {
  __typename: 'Threat';
  body: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  kind: IThreatKindEnum;
  name: IThreatNameEnum;
  rank: Scalars['Int']['output'];
  skillUses: Array<IModParticipantSkillUse>;
  statusEffects: Array<IModParticipantStatusEffect>;
  variant: IThreatVariantEnum;
};

export enum IThreatKindEnum {
  ApocalypseGradeThreat = 'apocalypse_grade_threat',
  EndlessHorde = 'endless_horde',
  LurkingThreat = 'lurking_threat',
  ViolentDead = 'violent_dead',
}

export enum IThreatNameEnum {
  Abomination = 'abomination',
  BoneHarvester = 'bone_harvester',
  BoneHead = 'bone_head',
  Burster = 'burster',
  FleshTank = 'flesh_tank',
  GoreHound = 'gore_hound',
  Hunter = 'hunter',
  MassCadaver = 'mass_cadaver',
  Mauler = 'mauler',
  RadHunter = 'rad_hunter',
  Rager = 'rager',
  Shambler = 'shambler',
  Trapper = 'trapper',
}

export enum IThreatVariantEnum {
  Standard = 'standard',
  Variant = 'variant',
}

export type ITicket = {
  __typename: 'Ticket';
  cost: Scalars['Int']['output'];
  discountType: ITicketDiscountEnum;
  econRestriction: ITicketEconRestrictionEnum;
  eventAttendeesCount?: Maybe<Scalars['Int']['output']>;
  eventId: Scalars['Int']['output'];
  extraXpCost?: Maybe<Scalars['Int']['output']>;
  fixedLimit?: Maybe<Scalars['Boolean']['output']>;
  fullyBooked: Scalars['Boolean']['output'];
  id: Scalars['Int']['output'];
  identifier: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  limit?: Maybe<Scalars['Int']['output']>;
  modMaxSignup?: Maybe<Scalars['Int']['output']>;
  passType: ITicketPassEnum;
  restrictionType: ITicketRestrictionEnum;
  shiftResponsibilities: Scalars['Int']['output'];
};

export enum ITicketDiscountEnum {
  BaseCompensation = 'base_compensation',
  FullCompensation = 'full_compensation',
  FullLiability = 'full_liability',
  FullWaiver = 'full_waiver',
  LegacyNoDiscount = 'legacy_no_discount',
}

export enum ITicketEconRestrictionEnum {
  RestrictedMailout = 'restricted_mailout',
  UnrestrictedEcon = 'unrestricted_econ',
}

export type ITicketInvoice = {
  __typename: 'TicketInvoice';
  discountType: ITicketDiscountEnum;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export enum ITicketPassEnum {
  DayPass = 'day_pass',
  EventPass = 'event_pass',
  NonAttendingPass = 'non_attending_pass',
  NpcPass = 'npc_pass',
  TravelingDirectorPass = 'traveling_director_pass',
}

export enum ITicketRestrictionEnum {
  AssistantRestricted = 'assistant_restricted',
  EmployeeRestricted = 'employee_restricted',
  NewPlayerRestricted = 'new_player_restricted',
  Unrestricted = 'unrestricted',
}

export type ITicketRevenue = {
  __typename: 'TicketRevenue';
  attendeesPaid: Scalars['Int']['output'];
  attendeesTotal?: Maybe<Scalars['Int']['output']>;
  cost: Scalars['Float']['output'];
  discountType?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  revenue: Scalars['Float']['output'];
  revenueDiscounted: Scalars['Float']['output'];
  revenueLiable: Scalars['Float']['output'];
  subitems?: Maybe<Array<ITicketRevenue>>;
};

export type ITicketsBaseConfig = {
  __typename: 'TicketsBaseConfig';
  discountTypes: Array<ITicketDiscountEnum>;
  passTypes: Array<ITicketPassEnum>;
  restrictionTypes: Array<ITicketRestrictionEnum>;
};

export type ITimeline = {
  __typename: 'Timeline';
  attendance: Scalars['Int']['output'];
  eventId: Scalars['Int']['output'];
  eventName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  local: Scalars['Boolean']['output'];
  shorthand: Scalars['String']['output'];
  timecode: Scalars['ISO8601Date']['output'];
  virtual: Scalars['Boolean']['output'];
};

/** Autogenerated input type of TrackItemUseMutation */
export type ITrackItemUseMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['Int']['input'];
  itemTransactionId: Scalars['Int']['input'];
  value?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of TrackItemUseMutation. */
export type ITrackItemUseMutationPayload = {
  __typename: 'TrackItemUseMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  itemTransaction?: Maybe<IItemTransaction>;
};

/** Autogenerated input type of UpdateBranchMutation */
export type IUpdateBranchMutationInput = {
  branchId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  district?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  registrationUrl?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateBranchMutation. */
export type IUpdateBranchMutationPayload = {
  __typename: 'UpdateBranchMutationPayload';
  branch?: Maybe<IBranch>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCapMutation */
export type IUpdateCapMutationInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  capId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<ICapStateEnum>;
};

/** Autogenerated return type of UpdateCapMutation. */
export type IUpdateCapMutationPayload = {
  __typename: 'UpdateCapMutationPayload';
  cap?: Maybe<ICap>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCharacterActionLogMutation */
export type IUpdateCharacterActionLogMutationInput = {
  actionLogId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isValid?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateCharacterActionLogMutation. */
export type IUpdateCharacterActionLogMutationPayload = {
  __typename: 'UpdateCharacterActionLogMutationPayload';
  attendeeCharacter?: Maybe<IAttendeeCharacter>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCharacterDataMutation */
export type IUpdateCharacterDataMutationInput = {
  body?: InputMaybe<Scalars['Int']['input']>;
  characterFellowship?: InputMaybe<ICharacterFellowshipInput>;
  characterId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  faithId?: InputMaybe<Scalars['Int']['input']>;
  faithLevel?: InputMaybe<Scalars['Int']['input']>;
  fracture?: InputMaybe<IFractureInput>;
  infection?: InputMaybe<Scalars['Int']['input']>;
  legacyHomeGameCount?: InputMaybe<Scalars['Int']['input']>;
  loreIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  mind?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  playerNotes?: InputMaybe<Scalars['String']['input']>;
  resolve?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Array<ICharacterConstraintInput>>;
  staffNotes?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<ICharacterStatusEnum>;
  strainId?: InputMaybe<Scalars['Int']['input']>;
  variant?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCharacterDataMutation. */
export type IUpdateCharacterDataMutationPayload = {
  __typename: 'UpdateCharacterDataMutationPayload';
  character?: Maybe<ICharacter>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCharacterFellowshipMutation */
export type IUpdateCharacterFellowshipMutationInput = {
  characterFellowshipId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  forRemoval?: InputMaybe<Scalars['Boolean']['input']>;
  rank?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateCharacterFellowshipMutation. */
export type IUpdateCharacterFellowshipMutationPayload = {
  __typename: 'UpdateCharacterFellowshipMutationPayload';
  characterFellowship?: Maybe<ICharacterFellowship>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCorrectiveActionMutation */
export type IUpdateCorrectiveActionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  correctiveActionId: Scalars['Int']['input'];
  endsAt?: InputMaybe<Scalars['String']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateCorrectiveActionMutation. */
export type IUpdateCorrectiveActionMutationPayload = {
  __typename: 'UpdateCorrectiveActionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  correctiveAction?: Maybe<ICorrectiveAction>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEventAttendeeMutation */
export type IUpdateEventAttendeeMutationInput = {
  buildGrowth?: InputMaybe<Scalars['Int']['input']>;
  characters?: InputMaybe<Array<ICheckinCharacterInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  costOverride?: InputMaybe<Scalars['Int']['input']>;
  eventAttendeeId: Scalars['Int']['input'];
  inviterId?: InputMaybe<Scalars['Int']['input']>;
  isAttending?: InputMaybe<Scalars['Boolean']['input']>;
  isPaid?: InputMaybe<Scalars['Boolean']['input']>;
  printRequestOnCharacterIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  referralInfo?: InputMaybe<Scalars['String']['input']>;
  shiftIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  ticketId?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateEventAttendeeMutation. */
export type IUpdateEventAttendeeMutationPayload = {
  __typename: 'UpdateEventAttendeeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  eventAttendee?: Maybe<IEventAttendee>;
};

/** Autogenerated input type of UpdateEventLifecycleMutation */
export type IUpdateEventLifecycleMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lifecycleId: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateEventLifecycleMutation. */
export type IUpdateEventLifecycleMutationPayload = {
  __typename: 'UpdateEventLifecycleMutationPayload';
  character?: Maybe<ICharacter>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEventMutation */
export type IUpdateEventMutationInput = {
  baseBuild?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  considersTravelersLocal?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['String']['input']>;
  eventId: Scalars['Int']['input'];
  extraXpCost?: InputMaybe<Scalars['Float']['input']>;
  kind?: InputMaybe<IEventKindEnum>;
  locationId?: InputMaybe<Scalars['Int']['input']>;
  maxExtraXp?: InputMaybe<Scalars['Int']['input']>;
  modDescription?: InputMaybe<Scalars['String']['input']>;
  modEnableWaitlist?: InputMaybe<Scalars['Boolean']['input']>;
  modMaxSignup?: InputMaybe<Scalars['Int']['input']>;
  modSignupOpensAt?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  registrationOpensAt?: InputMaybe<Scalars['String']['input']>;
  startsAt?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateEventMutation. */
export type IUpdateEventMutationPayload = {
  __typename: 'UpdateEventMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  event?: Maybe<IEvent>;
};

/** Autogenerated input type of UpdateEventShiftMutation */
export type IUpdateEventShiftMutationInput = {
  autoExpand?: InputMaybe<Scalars['Boolean']['input']>;
  baseRatio?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  shiftId: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateEventShiftMutation. */
export type IUpdateEventShiftMutationPayload = {
  __typename: 'UpdateEventShiftMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  shift?: Maybe<IShift>;
};

/** Autogenerated input type of UpdateEventTicketMutation */
export type IUpdateEventTicketMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  cost?: InputMaybe<Scalars['Int']['input']>;
  discountType?: InputMaybe<ITicketDiscountEnum>;
  econRestriction?: InputMaybe<ITicketEconRestrictionEnum>;
  extraXpCost?: InputMaybe<Scalars['Int']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  modMaxSignup?: InputMaybe<Scalars['Int']['input']>;
  passType?: InputMaybe<ITicketPassEnum>;
  restrictionType?: InputMaybe<ITicketRestrictionEnum>;
  shiftResponsibilities?: InputMaybe<Scalars['Int']['input']>;
  ticketId: Scalars['Int']['input'];
  unlimited?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateEventTicketMutation. */
export type IUpdateEventTicketMutationPayload = {
  __typename: 'UpdateEventTicketMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<ITicket>;
};

/** Autogenerated input type of UpdateFellowshipMutation */
export type IUpdateFellowshipMutationInput = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  constraint?: InputMaybe<Array<IConstraintContainerInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  fellowshipId: Scalars['Int']['input'];
  forRemoval?: InputMaybe<Scalars['Boolean']['input']>;
  maxRank?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  rankNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of UpdateFellowshipMutation. */
export type IUpdateFellowshipMutationPayload = {
  __typename: 'UpdateFellowshipMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  fellowship?: Maybe<IFellowship>;
};

/** Autogenerated input type of UpdateItemCraftingComponentMutation */
export type IUpdateItemCraftingComponentMutationInput = {
  acceptsExpiredItemWithinDays?: InputMaybe<Scalars['Int']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemCraftingComponentId: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateItemCraftingComponentMutation. */
export type IUpdateItemCraftingComponentMutationPayload = {
  __typename: 'UpdateItemCraftingComponentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  craftingComponent?: Maybe<ICraftingComponent>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateItemCraftingFinalProductMutation */
export type IUpdateItemCraftingFinalProductMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemCraftingFinalProductId: Scalars['Int']['input'];
  stack?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateItemCraftingFinalProductMutation. */
export type IUpdateItemCraftingFinalProductMutationPayload = {
  __typename: 'UpdateItemCraftingFinalProductMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  craftingFinalProduct?: Maybe<ICraftingFinalProduct>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateItemCraftingMutation */
export type IUpdateItemCraftingMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  craftingMindCost?: InputMaybe<Scalars['Int']['input']>;
  craftingResolveCost?: InputMaybe<Scalars['Int']['input']>;
  craftingSkills?: InputMaybe<Scalars['String']['input']>;
  craftingTimeInMinute?: InputMaybe<Scalars['Int']['input']>;
  craftingZone?: InputMaybe<Scalars['String']['input']>;
  itemCraftingId: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateItemCraftingMutation. */
export type IUpdateItemCraftingMutationPayload = {
  __typename: 'UpdateItemCraftingMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  itemCrafting?: Maybe<IItemCrafting>;
};

/** Autogenerated input type of UpdateItemMutation */
export type IUpdateItemMutationInput = {
  activationRequirement?: InputMaybe<Scalars['String']['input']>;
  allowBlueprintCopying?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  descriptionOfRoleplay?: InputMaybe<Scalars['String']['input']>;
  durationOfEffect?: InputMaybe<Scalars['String']['input']>;
  durationOfRoleplay?: InputMaybe<Scalars['String']['input']>;
  equipmentRequiredForUse?: InputMaybe<Scalars['String']['input']>;
  grade?: InputMaybe<IItemGradeEnum>;
  itemId: Scalars['Int']['input'];
  kind?: InputMaybe<IItemKindEnum>;
  lifetimeAmount?: InputMaybe<Scalars['Int']['input']>;
  locationOfUse?: InputMaybe<Scalars['String']['input']>;
  mechanics?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  printHeader?: InputMaybe<Scalars['String']['input']>;
  requirementsToUse?: InputMaybe<Scalars['String']['input']>;
  uses?: InputMaybe<Scalars['String']['input']>;
  validFrom?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  validTargetDescription?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['ISO8601DateTime']['input']>;
  vehicleArmor?: InputMaybe<Scalars['String']['input']>;
  vehicleCrewCapacity?: InputMaybe<Scalars['String']['input']>;
  vehicleHull?: InputMaybe<Scalars['String']['input']>;
  vehicleSpeed?: InputMaybe<Scalars['String']['input']>;
  vehicleTurnRadius?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<IItemVisibilityEnum>;
};

/** Autogenerated return type of UpdateItemMutation. */
export type IUpdateItemMutationPayload = {
  __typename: 'UpdateItemMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  item?: Maybe<IItem>;
};

/** Autogenerated input type of UpdateItemReproductionComponentMutation */
export type IUpdateItemReproductionComponentMutationInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemReproductionComponentId: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateItemReproductionComponentMutation. */
export type IUpdateItemReproductionComponentMutationPayload = {
  __typename: 'UpdateItemReproductionComponentMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  itemReproductionComponent?: Maybe<IItemReproductionComponent>;
};

/** Autogenerated input type of UpdateItemReproductionMutation */
export type IUpdateItemReproductionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  itemReproductionId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  reproductionMindCost?: InputMaybe<Scalars['Int']['input']>;
  reproductionSkills?: InputMaybe<Scalars['String']['input']>;
  reproductionTimeInMinute?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateItemReproductionMutation. */
export type IUpdateItemReproductionMutationPayload = {
  __typename: 'UpdateItemReproductionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  itemReproduction?: Maybe<IItemReproduction>;
};

/** Autogenerated input type of UpdateItemTransactionMutation */
export type IUpdateItemTransactionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  itemTransactionId: Scalars['Int']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  stack?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<IItemTransactionStatusEnum>;
};

/** Autogenerated return type of UpdateItemTransactionMutation. */
export type IUpdateItemTransactionMutationPayload = {
  __typename: 'UpdateItemTransactionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  itemTransaction?: Maybe<IItemTransaction>;
};

/** Autogenerated input type of UpdateLocationMutation */
export type IUpdateLocationMutationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  region?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateLocationMutation. */
export type IUpdateLocationMutationPayload = {
  __typename: 'UpdateLocationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  location?: Maybe<ILocation>;
};

/** Autogenerated input type of UpdateMembershipMutation */
export type IUpdateMembershipMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['String']['input']>;
  membershipId: Scalars['Int']['input'];
  startsAt?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateMembershipMutation. */
export type IUpdateMembershipMutationPayload = {
  __typename: 'UpdateMembershipMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  membership?: Maybe<IMembership>;
};

/** Autogenerated input type of UpdateModAssetMutation */
export type IUpdateModAssetMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modAssetId: Scalars['Int']['input'];
  modId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateModAssetMutation. */
export type IUpdateModAssetMutationPayload = {
  __typename: 'UpdateModAssetMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  modAsset?: Maybe<IModAsset>;
};

/** Autogenerated input type of UpdateModChallengeMutation */
export type IUpdateModChallengeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['Int']['input'];
  modId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<IModChallengeVisibilityEnum>;
};

/** Autogenerated return type of UpdateModChallengeMutation. */
export type IUpdateModChallengeMutationPayload = {
  __typename: 'UpdateModChallengeMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of UpdateModChallengeResolutionOptionMutation */
export type IUpdateModChallengeResolutionOptionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId: Scalars['Int']['input'];
  level: Scalars['Int']['input'];
  modId: Scalars['Int']['input'];
  profession?: InputMaybe<Scalars['Boolean']['input']>;
  skillId: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateModChallengeResolutionOptionMutation. */
export type IUpdateModChallengeResolutionOptionMutationPayload = {
  __typename: 'UpdateModChallengeResolutionOptionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of UpdateModMutation */
export type IUpdateModMutationInput = {
  activeModRewardTemplateId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  constraint?: InputMaybe<Array<IConstraintContainerInput>>;
  currentAssetId?: InputMaybe<Scalars['Int']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  modId: Scalars['Int']['input'];
  modRunnerId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  participationLimit?: InputMaybe<Scalars['Int']['input']>;
  ping?: InputMaybe<ICoordInput>;
  timeframe?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateModMutation. */
export type IUpdateModMutationPayload = {
  __typename: 'UpdateModMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of UpdateModNarrativeRolePlayMutation */
export type IUpdateModNarrativeRolePlayMutationInput = {
  activate?: InputMaybe<Scalars['Boolean']['input']>;
  body?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  commit?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  limbs?: InputMaybe<Scalars['Int']['input']>;
  mind?: InputMaybe<Scalars['Int']['input']>;
  modId: Scalars['Int']['input'];
  modNarrativeRolePlayId: Scalars['Int']['input'];
  resolve?: InputMaybe<Scalars['Int']['input']>;
  skills?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<IModNarrativeRolePlayStatusEnum>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateModNarrativeRolePlayMutation. */
export type IUpdateModNarrativeRolePlayMutationPayload = {
  __typename: 'UpdateModNarrativeRolePlayMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of UpdateModRewardMutation */
export type IUpdateModRewardMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modRewardId: Scalars['Int']['input'];
  stack?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateModRewardMutation. */
export type IUpdateModRewardMutationPayload = {
  __typename: 'UpdateModRewardMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  modReward?: Maybe<IModReward>;
};

/** Autogenerated input type of UpdateModRewardTemplateMutation */
export type IUpdateModRewardTemplateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  modRewardTemplateId: Scalars['Int']['input'];
  modRunnerNote?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateModRewardTemplateMutation. */
export type IUpdateModRewardTemplateMutationPayload = {
  __typename: 'UpdateModRewardTemplateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  modRewardTemplate?: Maybe<IModRewardTemplate>;
};

/** Autogenerated input type of UpdateModSectionMutation */
export type IUpdateModSectionMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modSectionId: Scalars['Int']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  signupLimit?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateModSectionMutation. */
export type IUpdateModSectionMutationPayload = {
  __typename: 'UpdateModSectionMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  modSection?: Maybe<IModSection>;
};

/** Autogenerated input type of UpdateModSignupMutation */
export type IUpdateModSignupMutationInput = {
  characterId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  modSignupId: Scalars['Int']['input'];
  ping?: InputMaybe<ICoordInput>;
  position?: InputMaybe<ICoordInput>;
};

/** Autogenerated return type of UpdateModSignupMutation. */
export type IUpdateModSignupMutationPayload = {
  __typename: 'UpdateModSignupMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

/** Autogenerated input type of UpdateOrganizationMutation */
export type IUpdateOrganizationMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  fellowship?: InputMaybe<IFellowshipInput>;
  organizationId: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdateOrganizationMutation. */
export type IUpdateOrganizationMutationPayload = {
  __typename: 'UpdateOrganizationMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  organization?: Maybe<IOrganization>;
};

/** Autogenerated input type of UpdatePasswordMutation */
export type IUpdatePasswordMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
};

/** Autogenerated return type of UpdatePasswordMutation. */
export type IUpdatePasswordMutationPayload = {
  __typename: 'UpdatePasswordMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdatePlayerBranchOwnershipMutation */
export type IUpdatePlayerBranchOwnershipMutationInput = {
  branchId: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  isOwned: Scalars['Boolean']['input'];
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdatePlayerBranchOwnershipMutation. */
export type IUpdatePlayerBranchOwnershipMutationPayload = {
  __typename: 'UpdatePlayerBranchOwnershipMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<IUser>;
};

/** Autogenerated input type of UpdatePlayerDataMutation */
export type IUpdatePlayerDataMutationInput = {
  assistantFlags?: InputMaybe<Array<IAssistantFlagEnum>>;
  branchId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  emailCorrespondence?: InputMaybe<IEmailCorrespondenceEnum>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingAddress?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<IOrganizationRoleEnum>;
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdatePlayerDataMutation. */
export type IUpdatePlayerDataMutationPayload = {
  __typename: 'UpdatePlayerDataMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<IUser>;
};

/** Autogenerated input type of UpdatePlayerOrganizationDataMutation */
export type IUpdatePlayerOrganizationDataMutationInput = {
  branchId?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  organizationId: Scalars['Int']['input'];
  role?: InputMaybe<IOrganizationRoleEnum>;
  userId: Scalars['Int']['input'];
};

/** Autogenerated return type of UpdatePlayerOrganizationDataMutation. */
export type IUpdatePlayerOrganizationDataMutationPayload = {
  __typename: 'UpdatePlayerOrganizationDataMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  user?: Maybe<IUser>;
};

/** Autogenerated input type of UpdateSpecialDateMutation */
export type IUpdateSpecialDateMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  endsAt?: InputMaybe<Scalars['String']['input']>;
  kind?: InputMaybe<ISpecialDateKindEnum>;
  specialDateId: Scalars['Int']['input'];
  startsAt?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateSpecialDateMutation. */
export type IUpdateSpecialDateMutationPayload = {
  __typename: 'UpdateSpecialDateMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  specialDate?: Maybe<ISpecialDate>;
};

/** Autogenerated input type of UseCoverMutation */
export type IUseCoverMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  entityId?: InputMaybe<Scalars['Int']['input']>;
  entityType?: InputMaybe<IModEntityTypeEnum>;
  isFlanked?: InputMaybe<Scalars['Boolean']['input']>;
  modId: Scalars['Int']['input'];
  targetId: Scalars['Int']['input'];
  targetType: IModEntityTypeEnum;
};

/** Autogenerated return type of UseCoverMutation. */
export type IUseCoverMutationPayload = {
  __typename: 'UseCoverMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Scalars['String']['output']>;
  mod?: Maybe<IMod>;
};

export type IUser = {
  __typename: 'User';
  assistantFlags: Array<IAssistantFlagEnum>;
  caps: Array<ICap>;
  character?: Maybe<ICharacter>;
  characters: Array<ICharacter>;
  correctiveActions: Array<ICorrectiveAction>;
  createdAt: Scalars['ISO8601DateTime']['output'];
  emailAddress: Scalars['String']['output'];
  emailCorrespondence: IEmailCorrespondenceEnum;
  eventAttendances: Array<IEventAttendee>;
  firstName?: Maybe<Scalars['String']['output']>;
  fullName: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  invitations?: Maybe<Array<IUserReferral>>;
  lastMembership?: Maybe<IMembership>;
  lastName: Scalars['String']['output'];
  mailingAddress?: Maybe<Scalars['String']['output']>;
  maxActiveCharactersCount: Scalars['Int']['output'];
  maxCharactersCount: Scalars['Int']['output'];
  membershipActiveDuringEvent?: Maybe<Scalars['Boolean']['output']>;
  memberships: Array<IMembership>;
  notes?: Maybe<Scalars['String']['output']>;
  organizations: Array<IOrganization>;
  ownedBranches: Array<IBranch>;
  preferredName?: Maybe<Scalars['String']['output']>;
  recentEventAttendances: Array<IEventAttendee>;
  referrals: Array<IUserReferral>;
  roleInOrganization: IOrganizationRoleEnum;
  temporaryTokens: Array<ITemporaryToken>;
  totalCapsForEvent: Scalars['Int']['output'];
  upcomingEvents: Array<IEventAttendee>;
  userOrganization?: Maybe<IUserOrganization>;
  userOrganizations: Array<IUserOrganization>;
};

export type IUserAssistantFlagsArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type IUserCapsArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type IUserCharacterArgs = {
  characterId: Scalars['Int']['input'];
};

export type IUserCharactersArgs = {
  checkinableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IUserEventAttendancesArgs = {
  from?: InputMaybe<Scalars['String']['input']>;
  upto?: InputMaybe<Scalars['String']['input']>;
};

export type IUserInvitationsArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type IUserLastMembershipArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type IUserMembershipActiveDuringEventArgs = {
  eventId: Scalars['Int']['input'];
};

export type IUserMembershipsArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type IUserReferralsArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type IUserRoleInOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type IUserTotalCapsForEventArgs = {
  eventId: Scalars['Int']['input'];
};

export type IUserUpcomingEventsArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type IUserUserOrganizationArgs = {
  organizationId?: InputMaybe<Scalars['Int']['input']>;
};

export type IUserGrowth = {
  __typename: 'UserGrowth';
  count: Scalars['Int']['output'];
  timeframe: Scalars['ISO8601Date']['output'];
};

export type IUserInvoice = {
  __typename: 'UserInvoice';
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type IUserOrganization = {
  __typename: 'UserOrganization';
  assistantFlags: Array<IAssistantFlagEnum>;
  branch: IBranch;
  branchId: Scalars['Int']['output'];
  id: Scalars['Int']['output'];
  organizationId: Scalars['Int']['output'];
  role: IOrganizationRoleEnum;
  user: IUser;
};

export type IUserReferral = {
  __typename: 'UserReferral';
  createdAt: Scalars['ISO8601Date']['output'];
  id: Scalars['Int']['output'];
  inviter: IUser;
  newbie: IUser;
};

export type IXpAudit = {
  __typename: 'XpAudit';
  applicableOn?: Maybe<Scalars['ISO8601Date']['output']>;
  awardedAt?: Maybe<Scalars['ISO8601DateTime']['output']>;
  branchTransferId?: Maybe<Scalars['Int']['output']>;
  destinationBranch?: Maybe<Scalars['String']['output']>;
  eventId?: Maybe<Scalars['Int']['output']>;
  eventName?: Maybe<Scalars['String']['output']>;
  extraBuildId?: Maybe<Scalars['Int']['output']>;
  homeGameEventsIndex?: Maybe<Scalars['Int']['output']>;
  kind: Scalars['String']['output'];
  originBranch?: Maybe<Scalars['String']['output']>;
  xpAddOn?: Maybe<Scalars['Int']['output']>;
  xpAwarded?: Maybe<Scalars['Int']['output']>;
};

export type WithTypename<T extends { __typename?: any }> = Partial<T> & {
  __typename: NonNullable<T['__typename']>;
};

export type GraphCacheKeysConfig = {
  ActionLog?: (data: WithTypename<IActionLog>) => null | string;
  ActionLogTally?: (data: WithTypename<IActionLogTally>) => null | string;
  AddSkillMutationPayload?: (
    data: WithTypename<IAddSkillMutationPayload>,
  ) => null | string;
  AdvanceTurnMutationPayload?: (
    data: WithTypename<IAdvanceTurnMutationPayload>,
  ) => null | string;
  AppendItemTransactionMutationPayload?: (
    data: WithTypename<IAppendItemTransactionMutationPayload>,
  ) => null | string;
  ApplyBranchContractMutationPayload?: (
    data: WithTypename<IApplyBranchContractMutationPayload>,
  ) => null | string;
  ApplyChallengeResolutionMutationPayload?: (
    data: WithTypename<IApplyChallengeResolutionMutationPayload>,
  ) => null | string;
  ApplyChangeMutationPayload?: (
    data: WithTypename<IApplyChangeMutationPayload>,
  ) => null | string;
  ApplyDamageMutationPayload?: (
    data: WithTypename<IApplyDamageMutationPayload>,
  ) => null | string;
  ApplyEnvironmentalEffectMutationPayload?: (
    data: WithTypename<IApplyEnvironmentalEffectMutationPayload>,
  ) => null | string;
  ApplyShieldingMutationPayload?: (
    data: WithTypename<IApplyShieldingMutationPayload>,
  ) => null | string;
  ApplySkillEffectMutationPayload?: (
    data: WithTypename<IApplySkillEffectMutationPayload>,
  ) => null | string;
  AssignBranchLocationMutationPayload?: (
    data: WithTypename<IAssignBranchLocationMutationPayload>,
  ) => null | string;
  AssignBranchOwnershipMutationPayload?: (
    data: WithTypename<IAssignBranchOwnershipMutationPayload>,
  ) => null | string;
  AssignTemporaryManagerMutationPayload?: (
    data: WithTypename<IAssignTemporaryManagerMutationPayload>,
  ) => null | string;
  AssistImpactSkillMutationPayload?: (
    data: WithTypename<IAssistImpactSkillMutationPayload>,
  ) => null | string;
  AttendanceInvoice?: (data: WithTypename<IAttendanceInvoice>) => null | string;
  AttendeeCharacter?: (data: WithTypename<IAttendeeCharacter>) => null | string;
  AttendeeShift?: (data: WithTypename<IAttendeeShift>) => null | string;
  Branch?: (data: WithTypename<IBranch>) => null | string;
  BranchContract?: (data: WithTypename<IBranchContract>) => null | string;
  BranchOwner?: (data: WithTypename<IBranchOwner>) => null | string;
  CachedUserAttendance?: (
    data: WithTypename<ICachedUserAttendance>,
  ) => null | string;
  Cap?: (data: WithTypename<ICap>) => null | string;
  Character?: (data: WithTypename<ICharacter>) => null | string;
  CharacterConstraint?: (
    data: WithTypename<ICharacterConstraint>,
  ) => null | string;
  CharacterFellowship?: (
    data: WithTypename<ICharacterFellowship>,
  ) => null | string;
  CharacterSkill?: (data: WithTypename<ICharacterSkill>) => null | string;
  CharacterSubConstraint?: (
    data: WithTypename<ICharacterSubConstraint>,
  ) => null | string;
  CheckinCharacterMutationPayload?: (
    data: WithTypename<ICheckinCharacterMutationPayload>,
  ) => null | string;
  CheckinMutationPayload?: (
    data: WithTypename<ICheckinMutationPayload>,
  ) => null | string;
  ClaimModRewardsMutationPayload?: (
    data: WithTypename<IClaimModRewardsMutationPayload>,
  ) => null | string;
  ClearingHouse?: (data: WithTypename<IClearingHouse>) => null | string;
  CompleteScatterShotMutationPayload?: (
    data: WithTypename<ICompleteScatterShotMutationPayload>,
  ) => null | string;
  Contract?: (data: WithTypename<IContract>) => null | string;
  Coord?: (data: WithTypename<ICoord>) => null | string;
  CopyCharacterBuildMutationPayload?: (
    data: WithTypename<ICopyCharacterBuildMutationPayload>,
  ) => null | string;
  CopyEventSetupMutationPayload?: (
    data: WithTypename<ICopyEventSetupMutationPayload>,
  ) => null | string;
  CorrectiveAction?: (data: WithTypename<ICorrectiveAction>) => null | string;
  CraftableItem?: (data: WithTypename<ICraftableItem>) => null | string;
  CraftingComponent?: (data: WithTypename<ICraftingComponent>) => null | string;
  CraftingFinalProduct?: (
    data: WithTypename<ICraftingFinalProduct>,
  ) => null | string;
  CreateCapMutationPayload?: (
    data: WithTypename<ICreateCapMutationPayload>,
  ) => null | string;
  CreateCharacterActionLogMutationPayload?: (
    data: WithTypename<ICreateCharacterActionLogMutationPayload>,
  ) => null | string;
  CreateCharacterFellowshipMutationPayload?: (
    data: WithTypename<ICreateCharacterFellowshipMutationPayload>,
  ) => null | string;
  CreateCharacterMutationPayload?: (
    data: WithTypename<ICreateCharacterMutationPayload>,
  ) => null | string;
  CreateCorrectiveActionMutationPayload?: (
    data: WithTypename<ICreateCorrectiveActionMutationPayload>,
  ) => null | string;
  CreateEventLifecycleMutationPayload?: (
    data: WithTypename<ICreateEventLifecycleMutationPayload>,
  ) => null | string;
  CreateEventMutationPayload?: (
    data: WithTypename<ICreateEventMutationPayload>,
  ) => null | string;
  CreateEventShiftMutationPayload?: (
    data: WithTypename<ICreateEventShiftMutationPayload>,
  ) => null | string;
  CreateEventTicketMutationPayload?: (
    data: WithTypename<ICreateEventTicketMutationPayload>,
  ) => null | string;
  CreateFellowshipMutationPayload?: (
    data: WithTypename<ICreateFellowshipMutationPayload>,
  ) => null | string;
  CreateFellowshipRuleTagMutationPayload?: (
    data: WithTypename<ICreateFellowshipRuleTagMutationPayload>,
  ) => null | string;
  CreateItemClassificationMutationPayload?: (
    data: WithTypename<ICreateItemClassificationMutationPayload>,
  ) => null | string;
  CreateItemCraftingComponentMutationPayload?: (
    data: WithTypename<ICreateItemCraftingComponentMutationPayload>,
  ) => null | string;
  CreateItemCraftingFinalProductMutationPayload?: (
    data: WithTypename<ICreateItemCraftingFinalProductMutationPayload>,
  ) => null | string;
  CreateItemCraftingMutationPayload?: (
    data: WithTypename<ICreateItemCraftingMutationPayload>,
  ) => null | string;
  CreateItemMutationPayload?: (
    data: WithTypename<ICreateItemMutationPayload>,
  ) => null | string;
  CreateItemReproductionComponentMutationPayload?: (
    data: WithTypename<ICreateItemReproductionComponentMutationPayload>,
  ) => null | string;
  CreateItemReproductionMutationPayload?: (
    data: WithTypename<ICreateItemReproductionMutationPayload>,
  ) => null | string;
  CreateItemTransactionMutationPayload?: (
    data: WithTypename<ICreateItemTransactionMutationPayload>,
  ) => null | string;
  CreateLocationMutationPayload?: (
    data: WithTypename<ICreateLocationMutationPayload>,
  ) => null | string;
  CreateMembershipMutationPayload?: (
    data: WithTypename<ICreateMembershipMutationPayload>,
  ) => null | string;
  CreateMessageMutationPayload?: (
    data: WithTypename<ICreateMessageMutationPayload>,
  ) => null | string;
  CreateModAssetMutationPayload?: (
    data: WithTypename<ICreateModAssetMutationPayload>,
  ) => null | string;
  CreateModChallengeMutationPayload?: (
    data: WithTypename<ICreateModChallengeMutationPayload>,
  ) => null | string;
  CreateModMutationPayload?: (
    data: WithTypename<ICreateModMutationPayload>,
  ) => null | string;
  CreateModNarrativeRolePlayMutationPayload?: (
    data: WithTypename<ICreateModNarrativeRolePlayMutationPayload>,
  ) => null | string;
  CreateModRewardMutationPayload?: (
    data: WithTypename<ICreateModRewardMutationPayload>,
  ) => null | string;
  CreateModRewardTemplateMutationPayload?: (
    data: WithTypename<ICreateModRewardTemplateMutationPayload>,
  ) => null | string;
  CreateModSectionMutationPayload?: (
    data: WithTypename<ICreateModSectionMutationPayload>,
  ) => null | string;
  CreateModSignupMutationPayload?: (
    data: WithTypename<ICreateModSignupMutationPayload>,
  ) => null | string;
  CreateNewPlayerMutationPayload?: (
    data: WithTypename<ICreateNewPlayerMutationPayload>,
  ) => null | string;
  CreateReferralMutationPayload?: (
    data: WithTypename<ICreateReferralMutationPayload>,
  ) => null | string;
  CreateSpecialDateMutationPayload?: (
    data: WithTypename<ICreateSpecialDateMutationPayload>,
  ) => null | string;
  DefenseRoll?: (data: WithTypename<IDefenseRoll>) => null | string;
  DestroyAttendeeCharacterMutationPayload?: (
    data: WithTypename<IDestroyAttendeeCharacterMutationPayload>,
  ) => null | string;
  DestroyAuthTokenMutationPayload?: (
    data: WithTypename<IDestroyAuthTokenMutationPayload>,
  ) => null | string;
  DestroyCharacterMutationPayload?: (
    data: WithTypename<IDestroyCharacterMutationPayload>,
  ) => null | string;
  DestroyCorrectiveActionMutationPayload?: (
    data: WithTypename<IDestroyCorrectiveActionMutationPayload>,
  ) => null | string;
  DestroyEventAttendeeMutationPayload?: (
    data: WithTypename<IDestroyEventAttendeeMutationPayload>,
  ) => null | string;
  DestroyEventShiftMutationPayload?: (
    data: WithTypename<IDestroyEventShiftMutationPayload>,
  ) => null | string;
  DestroyEventTicketMutationPayload?: (
    data: WithTypename<IDestroyEventTicketMutationPayload>,
  ) => null | string;
  DestroyFellowshipRuleTagMutationPayload?: (
    data: WithTypename<IDestroyFellowshipRuleTagMutationPayload>,
  ) => null | string;
  DestroyItemClassificationMutationPayload?: (
    data: WithTypename<IDestroyItemClassificationMutationPayload>,
  ) => null | string;
  DestroyItemCraftingComponentMutationPayload?: (
    data: WithTypename<IDestroyItemCraftingComponentMutationPayload>,
  ) => null | string;
  DestroyItemCraftingFinalProductMutationPayload?: (
    data: WithTypename<IDestroyItemCraftingFinalProductMutationPayload>,
  ) => null | string;
  DestroyItemCraftingMutationPayload?: (
    data: WithTypename<IDestroyItemCraftingMutationPayload>,
  ) => null | string;
  DestroyItemReproductionComponentMutationPayload?: (
    data: WithTypename<IDestroyItemReproductionComponentMutationPayload>,
  ) => null | string;
  DestroyItemReproductionMutationPayload?: (
    data: WithTypename<IDestroyItemReproductionMutationPayload>,
  ) => null | string;
  DestroyLocationMutationPayload?: (
    data: WithTypename<IDestroyLocationMutationPayload>,
  ) => null | string;
  DestroyMembershipMutationPayload?: (
    data: WithTypename<IDestroyMembershipMutationPayload>,
  ) => null | string;
  DestroyModAssetMutationPayload?: (
    data: WithTypename<IDestroyModAssetMutationPayload>,
  ) => null | string;
  DestroyModMutationPayload?: (
    data: WithTypename<IDestroyModMutationPayload>,
  ) => null | string;
  DestroyModRewardMutationPayload?: (
    data: WithTypename<IDestroyModRewardMutationPayload>,
  ) => null | string;
  DestroyModRewardTemplateMutationPayload?: (
    data: WithTypename<IDestroyModRewardTemplateMutationPayload>,
  ) => null | string;
  DestroyModSignupMutationPayload?: (
    data: WithTypename<IDestroyModSignupMutationPayload>,
  ) => null | string;
  DestroyReferralMutationPayload?: (
    data: WithTypename<IDestroyReferralMutationPayload>,
  ) => null | string;
  DestroySpecialDateMutationPayload?: (
    data: WithTypename<IDestroySpecialDateMutationPayload>,
  ) => null | string;
  DiceRollAutoResolve?: (
    data: WithTypename<IDiceRollAutoResolve>,
  ) => null | string;
  DiceRollDamage?: (data: WithTypename<IDiceRollDamage>) => null | string;
  DiceRollResult?: (data: WithTypename<IDiceRollResult>) => null | string;
  DiceRollSummary?: (data: WithTypename<IDiceRollSummary>) => null | string;
  EndModMutationPayload?: (
    data: WithTypename<IEndModMutationPayload>,
  ) => null | string;
  EnterBattlefieldMutationPayload?: (
    data: WithTypename<IEnterBattlefieldMutationPayload>,
  ) => null | string;
  EquipMutationPayload?: (
    data: WithTypename<IEquipMutationPayload>,
  ) => null | string;
  Error?: (data: WithTypename<IError>) => null | string;
  Event?: (data: WithTypename<IEvent>) => null | string;
  EventAttendee?: (data: WithTypename<IEventAttendee>) => null | string;
  EventConfig?: (data: WithTypename<IEventConfig>) => null | string;
  EventInvoice?: (data: WithTypename<IEventInvoice>) => null | string;
  EventRevenue?: (data: WithTypename<IEventRevenue>) => null | string;
  ExecuteScatterShotMutationPayload?: (
    data: WithTypename<IExecuteScatterShotMutationPayload>,
  ) => null | string;
  ExpendItemMutationPayload?: (
    data: WithTypename<IExpendItemMutationPayload>,
  ) => null | string;
  ExpendResolveMutationPayload?: (
    data: WithTypename<IExpendResolveMutationPayload>,
  ) => null | string;
  Fellowship?: (data: WithTypename<IFellowship>) => null | string;
  FellowshipRuleTag?: (data: WithTypename<IFellowshipRuleTag>) => null | string;
  FinalizeModRewardClaimsMutationPayload?: (
    data: WithTypename<IFinalizeModRewardClaimsMutationPayload>,
  ) => null | string;
  Fracture?: (data: WithTypename<IFracture>) => null | string;
  FulfillShiftMutationPayload?: (
    data: WithTypename<IFulfillShiftMutationPayload>,
  ) => null | string;
  GenerateAuthTokenMutationPayload?: (
    data: WithTypename<IGenerateAuthTokenMutationPayload>,
  ) => null | string;
  GenerateBattlefieldTokenMutationPayload?: (
    data: WithTypename<IGenerateBattlefieldTokenMutationPayload>,
  ) => null | string;
  Inventory?: (data: WithTypename<IInventory>) => null | string;
  Invoice?: (data: WithTypename<IInvoice>) => null | string;
  InvoiceChange?: (data: WithTypename<IInvoiceChange>) => null | string;
  Item?: (data: WithTypename<IItem>) => null | string;
  ItemClaim?: (data: WithTypename<IItemClaim>) => null | string;
  ItemClassification?: (
    data: WithTypename<IItemClassification>,
  ) => null | string;
  ItemCrafting?: (data: WithTypename<IItemCrafting>) => null | string;
  ItemMetadata?: (data: WithTypename<IItemMetadata>) => null | string;
  ItemReproduction?: (data: WithTypename<IItemReproduction>) => null | string;
  ItemReproductionComponent?: (
    data: WithTypename<IItemReproductionComponent>,
  ) => null | string;
  ItemReproductionMetadata?: (
    data: WithTypename<IItemReproductionMetadata>,
  ) => null | string;
  ItemTransaction?: (data: WithTypename<IItemTransaction>) => null | string;
  ItemTransactionTally?: (
    data: WithTypename<IItemTransactionTally>,
  ) => null | string;
  ItemTransactionUse?: (
    data: WithTypename<IItemTransactionUse>,
  ) => null | string;
  LeaveBattlefieldMutationPayload?: (
    data: WithTypename<ILeaveBattlefieldMutationPayload>,
  ) => null | string;
  Lifecycle?: (data: WithTypename<ILifecycle>) => null | string;
  Location?: (data: WithTypename<ILocation>) => null | string;
  LogBlueprintActionMutationPayload?: (
    data: WithTypename<ILogBlueprintActionMutationPayload>,
  ) => null | string;
  Membership?: (data: WithTypename<IMembership>) => null | string;
  Mod?: (data: WithTypename<IMod>) => null | string;
  ModAsset?: (data: WithTypename<IModAsset>) => null | string;
  ModBids?: (data: WithTypename<IModBids>) => null | string;
  ModBidsSkill?: (data: WithTypename<IModBidsSkill>) => null | string;
  ModChallenge?: (data: WithTypename<IModChallenge>) => null | string;
  ModChallengeResolutionOption?: (
    data: WithTypename<IModChallengeResolutionOption>,
  ) => null | string;
  ModChallengeState?: (data: WithTypename<IModChallengeState>) => null | string;
  ModLog?: (data: WithTypename<IModLog>) => null | string;
  ModNarrativeRolePlay?: (
    data: WithTypename<IModNarrativeRolePlay>,
  ) => null | string;
  ModNarrativeRolePlayBid?: (
    data: WithTypename<IModNarrativeRolePlayBid>,
  ) => null | string;
  ModParticipantEquipment?: (
    data: WithTypename<IModParticipantEquipment>,
  ) => null | string;
  ModParticipantLimb?: (
    data: WithTypename<IModParticipantLimb>,
  ) => null | string;
  ModParticipantMaskedState?: (
    data: WithTypename<IModParticipantMaskedState>,
  ) => null | string;
  ModParticipantSkillUse?: (
    data: WithTypename<IModParticipantSkillUse>,
  ) => null | string;
  ModParticipantState?: (
    data: WithTypename<IModParticipantState>,
  ) => null | string;
  ModParticipantStatusEffect?: (
    data: WithTypename<IModParticipantStatusEffect>,
  ) => null | string;
  ModParticipantStatusEffectEntity?: (
    data: WithTypename<IModParticipantStatusEffectEntity>,
  ) => null | string;
  ModReward?: (data: WithTypename<IModReward>) => null | string;
  ModRewardClaim?: (data: WithTypename<IModRewardClaim>) => null | string;
  ModRewardTemplate?: (data: WithTypename<IModRewardTemplate>) => null | string;
  ModSection?: (data: WithTypename<IModSection>) => null | string;
  ModSignup?: (data: WithTypename<IModSignup>) => null | string;
  MoveMutationPayload?: (
    data: WithTypename<IMoveMutationPayload>,
  ) => null | string;
  Organization?: (data: WithTypename<IOrganization>) => null | string;
  OrganizationConfig?: (
    data: WithTypename<IOrganizationConfig>,
  ) => null | string;
  PerformKillingBlowMutationPayload?: (
    data: WithTypename<IPerformKillingBlowMutationPayload>,
  ) => null | string;
  Permission?: (data: WithTypename<IPermission>) => null | string;
  ReattemptActionMutationPayload?: (
    data: WithTypename<IReattemptActionMutationPayload>,
  ) => null | string;
  RegisteredItem?: (data: WithTypename<IRegisteredItem>) => null | string;
  ReloadMutationPayload?: (
    data: WithTypename<IReloadMutationPayload>,
  ) => null | string;
  RemoveItemTransactionMutationPayload?: (
    data: WithTypename<IRemoveItemTransactionMutationPayload>,
  ) => null | string;
  RequestPasswordResetMutationPayload?: (
    data: WithTypename<IRequestPasswordResetMutationPayload>,
  ) => null | string;
  ResetPasswordMutationPayload?: (
    data: WithTypename<IResetPasswordMutationPayload>,
  ) => null | string;
  ResidenciesStatistics?: (
    data: WithTypename<IResidenciesStatistics>,
  ) => null | string;
  ResidencyStatistics?: (
    data: WithTypename<IResidencyStatistics>,
  ) => null | string;
  RetireCharacterMutationPayload?: (
    data: WithTypename<IRetireCharacterMutationPayload>,
  ) => null | string;
  RetirementPaths?: (data: WithTypename<IRetirementPaths>) => null | string;
  RetirementXp?: (data: WithTypename<IRetirementXp>) => null | string;
  RevenueAggregates?: (data: WithTypename<IRevenueAggregates>) => null | string;
  RollAttackMutationPayload?: (
    data: WithTypename<IRollAttackMutationPayload>,
  ) => null | string;
  RollDevelopmentSkillMutationPayload?: (
    data: WithTypename<IRollDevelopmentSkillMutationPayload>,
  ) => null | string;
  RollDiceMutationPayload?: (
    data: WithTypename<IRollDiceMutationPayload>,
  ) => null | string;
  RollImpactSkillMutationPayload?: (
    data: WithTypename<IRollImpactSkillMutationPayload>,
  ) => null | string;
  RollInitiativeMutationPayload?: (
    data: WithTypename<IRollInitiativeMutationPayload>,
  ) => null | string;
  RuleTag?: (data: WithTypename<IRuleTag>) => null | string;
  Shift?: (data: WithTypename<IShift>) => null | string;
  SkillCategoriesStatistics?: (
    data: WithTypename<ISkillCategoriesStatistics>,
  ) => null | string;
  SkillCategoryStatistics?: (
    data: WithTypename<ISkillCategoryStatistics>,
  ) => null | string;
  SkillStatistics?: (data: WithTypename<ISkillStatistics>) => null | string;
  SkillsStatistics?: (data: WithTypename<ISkillsStatistics>) => null | string;
  SpecialDate?: (data: WithTypename<ISpecialDate>) => null | string;
  StatStatistics?: (data: WithTypename<IStatStatistics>) => null | string;
  StatsStatistics?: (data: WithTypename<IStatsStatistics>) => null | string;
  SubmitNarrativeRolePlayBidsMutationPayload?: (
    data: WithTypename<ISubmitNarrativeRolePlayBidsMutationPayload>,
  ) => null | string;
  TalliedActionLog?: (data: WithTypename<ITalliedActionLog>) => null | string;
  TemporaryManager?: (data: WithTypename<ITemporaryManager>) => null | string;
  TemporaryToken?: (data: WithTypename<ITemporaryToken>) => null | string;
  Threat?: (data: WithTypename<IThreat>) => null | string;
  Ticket?: (data: WithTypename<ITicket>) => null | string;
  TicketInvoice?: (data: WithTypename<ITicketInvoice>) => null | string;
  TicketRevenue?: (data: WithTypename<ITicketRevenue>) => null | string;
  TicketsBaseConfig?: (data: WithTypename<ITicketsBaseConfig>) => null | string;
  Timeline?: (data: WithTypename<ITimeline>) => null | string;
  TrackItemUseMutationPayload?: (
    data: WithTypename<ITrackItemUseMutationPayload>,
  ) => null | string;
  UpdateBranchMutationPayload?: (
    data: WithTypename<IUpdateBranchMutationPayload>,
  ) => null | string;
  UpdateCapMutationPayload?: (
    data: WithTypename<IUpdateCapMutationPayload>,
  ) => null | string;
  UpdateCharacterActionLogMutationPayload?: (
    data: WithTypename<IUpdateCharacterActionLogMutationPayload>,
  ) => null | string;
  UpdateCharacterDataMutationPayload?: (
    data: WithTypename<IUpdateCharacterDataMutationPayload>,
  ) => null | string;
  UpdateCharacterFellowshipMutationPayload?: (
    data: WithTypename<IUpdateCharacterFellowshipMutationPayload>,
  ) => null | string;
  UpdateCorrectiveActionMutationPayload?: (
    data: WithTypename<IUpdateCorrectiveActionMutationPayload>,
  ) => null | string;
  UpdateEventAttendeeMutationPayload?: (
    data: WithTypename<IUpdateEventAttendeeMutationPayload>,
  ) => null | string;
  UpdateEventLifecycleMutationPayload?: (
    data: WithTypename<IUpdateEventLifecycleMutationPayload>,
  ) => null | string;
  UpdateEventMutationPayload?: (
    data: WithTypename<IUpdateEventMutationPayload>,
  ) => null | string;
  UpdateEventShiftMutationPayload?: (
    data: WithTypename<IUpdateEventShiftMutationPayload>,
  ) => null | string;
  UpdateEventTicketMutationPayload?: (
    data: WithTypename<IUpdateEventTicketMutationPayload>,
  ) => null | string;
  UpdateFellowshipMutationPayload?: (
    data: WithTypename<IUpdateFellowshipMutationPayload>,
  ) => null | string;
  UpdateItemCraftingComponentMutationPayload?: (
    data: WithTypename<IUpdateItemCraftingComponentMutationPayload>,
  ) => null | string;
  UpdateItemCraftingFinalProductMutationPayload?: (
    data: WithTypename<IUpdateItemCraftingFinalProductMutationPayload>,
  ) => null | string;
  UpdateItemCraftingMutationPayload?: (
    data: WithTypename<IUpdateItemCraftingMutationPayload>,
  ) => null | string;
  UpdateItemMutationPayload?: (
    data: WithTypename<IUpdateItemMutationPayload>,
  ) => null | string;
  UpdateItemReproductionComponentMutationPayload?: (
    data: WithTypename<IUpdateItemReproductionComponentMutationPayload>,
  ) => null | string;
  UpdateItemReproductionMutationPayload?: (
    data: WithTypename<IUpdateItemReproductionMutationPayload>,
  ) => null | string;
  UpdateItemTransactionMutationPayload?: (
    data: WithTypename<IUpdateItemTransactionMutationPayload>,
  ) => null | string;
  UpdateLocationMutationPayload?: (
    data: WithTypename<IUpdateLocationMutationPayload>,
  ) => null | string;
  UpdateMembershipMutationPayload?: (
    data: WithTypename<IUpdateMembershipMutationPayload>,
  ) => null | string;
  UpdateModAssetMutationPayload?: (
    data: WithTypename<IUpdateModAssetMutationPayload>,
  ) => null | string;
  UpdateModChallengeMutationPayload?: (
    data: WithTypename<IUpdateModChallengeMutationPayload>,
  ) => null | string;
  UpdateModChallengeResolutionOptionMutationPayload?: (
    data: WithTypename<IUpdateModChallengeResolutionOptionMutationPayload>,
  ) => null | string;
  UpdateModMutationPayload?: (
    data: WithTypename<IUpdateModMutationPayload>,
  ) => null | string;
  UpdateModNarrativeRolePlayMutationPayload?: (
    data: WithTypename<IUpdateModNarrativeRolePlayMutationPayload>,
  ) => null | string;
  UpdateModRewardMutationPayload?: (
    data: WithTypename<IUpdateModRewardMutationPayload>,
  ) => null | string;
  UpdateModRewardTemplateMutationPayload?: (
    data: WithTypename<IUpdateModRewardTemplateMutationPayload>,
  ) => null | string;
  UpdateModSectionMutationPayload?: (
    data: WithTypename<IUpdateModSectionMutationPayload>,
  ) => null | string;
  UpdateModSignupMutationPayload?: (
    data: WithTypename<IUpdateModSignupMutationPayload>,
  ) => null | string;
  UpdateOrganizationMutationPayload?: (
    data: WithTypename<IUpdateOrganizationMutationPayload>,
  ) => null | string;
  UpdatePasswordMutationPayload?: (
    data: WithTypename<IUpdatePasswordMutationPayload>,
  ) => null | string;
  UpdatePlayerBranchOwnershipMutationPayload?: (
    data: WithTypename<IUpdatePlayerBranchOwnershipMutationPayload>,
  ) => null | string;
  UpdatePlayerDataMutationPayload?: (
    data: WithTypename<IUpdatePlayerDataMutationPayload>,
  ) => null | string;
  UpdatePlayerOrganizationDataMutationPayload?: (
    data: WithTypename<IUpdatePlayerOrganizationDataMutationPayload>,
  ) => null | string;
  UpdateSpecialDateMutationPayload?: (
    data: WithTypename<IUpdateSpecialDateMutationPayload>,
  ) => null | string;
  UseCoverMutationPayload?: (
    data: WithTypename<IUseCoverMutationPayload>,
  ) => null | string;
  User?: (data: WithTypename<IUser>) => null | string;
  UserGrowth?: (data: WithTypename<IUserGrowth>) => null | string;
  UserInvoice?: (data: WithTypename<IUserInvoice>) => null | string;
  UserOrganization?: (data: WithTypename<IUserOrganization>) => null | string;
  UserReferral?: (data: WithTypename<IUserReferral>) => null | string;
  XpAudit?: (data: WithTypename<IXpAudit>) => null | string;
};

export type GraphCacheResolvers = {
  Query?: {
    branch?: GraphCacheResolver<
      WithTypename<IQuery>,
      IQueryBranchArgs,
      WithTypename<IBranch> | string
    >;
    event?: GraphCacheResolver<
      WithTypename<IQuery>,
      IQueryEventArgs,
      WithTypename<IEvent> | string
    >;
    events?: GraphCacheResolver<
      WithTypename<IQuery>,
      IQueryEventsArgs,
      Array<WithTypename<IEvent> | string>
    >;
    locations?: GraphCacheResolver<
      WithTypename<IQuery>,
      Record<string, never>,
      Array<WithTypename<ILocation> | string>
    >;
    memberships?: GraphCacheResolver<
      WithTypename<IQuery>,
      IQueryMembershipsArgs,
      Array<WithTypename<IMembership> | string>
    >;
    organization?: GraphCacheResolver<
      WithTypename<IQuery>,
      IQueryOrganizationArgs,
      WithTypename<IOrganization> | string
    >;
    organizationRoles?: GraphCacheResolver<
      WithTypename<IQuery>,
      Record<string, never>,
      Array<IOrganizationRoleEnum | string>
    >;
    organizations?: GraphCacheResolver<
      WithTypename<IQuery>,
      Record<string, never>,
      Array<WithTypename<IOrganization> | string>
    >;
    permission?: GraphCacheResolver<
      WithTypename<IQuery>,
      IQueryPermissionArgs,
      WithTypename<IPermission> | string
    >;
    resetPasswordTokenStatus?: GraphCacheResolver<
      WithTypename<IQuery>,
      IQueryResetPasswordTokenStatusArgs,
      Scalars['Boolean']['output'] | string
    >;
    searchPlayer?: GraphCacheResolver<
      WithTypename<IQuery>,
      IQuerySearchPlayerArgs,
      Array<WithTypename<ISearchPlayerResult> | string>
    >;
    temporaryTokenStatus?: GraphCacheResolver<
      WithTypename<IQuery>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    tokenId?: GraphCacheResolver<
      WithTypename<IQuery>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<IQuery>,
      IQueryUserArgs,
      WithTypename<IUser> | string
    >;
  };
  ActionLog?: {
    actionType?: GraphCacheResolver<
      WithTypename<IActionLog>,
      Record<string, never>,
      IActionLogTypeEnum | string
    >;
    actionValue?: GraphCacheResolver<
      WithTypename<IActionLog>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<IActionLog>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    description?: GraphCacheResolver<
      WithTypename<IActionLog>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IActionLog>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    invalidatedAt?: GraphCacheResolver<
      WithTypename<IActionLog>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IActionLog>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  ActionLogTally?: {
    armor?: GraphCacheResolver<
      WithTypename<IActionLogTally>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    body?: GraphCacheResolver<
      WithTypename<IActionLogTally>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    mind?: GraphCacheResolver<
      WithTypename<IActionLogTally>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    resolve?: GraphCacheResolver<
      WithTypename<IActionLogTally>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    skillUses?: GraphCacheResolver<
      WithTypename<IActionLogTally>,
      Record<string, never>,
      Array<WithTypename<ICharacterSkill> | string>
    >;
  };
  AddSkillMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IAddSkillMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IAddSkillMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IAddSkillMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  AdvanceTurnMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IAdvanceTurnMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IAdvanceTurnMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IAdvanceTurnMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  AppendItemTransactionMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IAppendItemTransactionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IAppendItemTransactionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    event?: GraphCacheResolver<
      WithTypename<IAppendItemTransactionMutationPayload>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
  };
  ApplyBranchContractMutationPayload?: {
    branch?: GraphCacheResolver<
      WithTypename<IApplyBranchContractMutationPayload>,
      Record<string, never>,
      WithTypename<IBranch> | string
    >;
    clientMutationId?: GraphCacheResolver<
      WithTypename<IApplyBranchContractMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IApplyBranchContractMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  ApplyChallengeResolutionMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IApplyChallengeResolutionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IApplyChallengeResolutionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IApplyChallengeResolutionMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  ApplyChangeMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IApplyChangeMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IApplyChangeMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IApplyChangeMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  ApplyDamageMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IApplyDamageMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IApplyDamageMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IApplyDamageMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
    modLog?: GraphCacheResolver<
      WithTypename<IApplyDamageMutationPayload>,
      Record<string, never>,
      WithTypename<IModLog> | string
    >;
  };
  ApplyEnvironmentalEffectMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IApplyEnvironmentalEffectMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IApplyEnvironmentalEffectMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IApplyEnvironmentalEffectMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  ApplyShieldingMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IApplyShieldingMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IApplyShieldingMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IApplyShieldingMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  ApplySkillEffectMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IApplySkillEffectMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IApplySkillEffectMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IApplySkillEffectMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
    modLog?: GraphCacheResolver<
      WithTypename<IApplySkillEffectMutationPayload>,
      Record<string, never>,
      WithTypename<IModLog> | string
    >;
  };
  AssignBranchLocationMutationPayload?: {
    branch?: GraphCacheResolver<
      WithTypename<IAssignBranchLocationMutationPayload>,
      Record<string, never>,
      WithTypename<IBranch> | string
    >;
    clientMutationId?: GraphCacheResolver<
      WithTypename<IAssignBranchLocationMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IAssignBranchLocationMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AssignBranchOwnershipMutationPayload?: {
    branch?: GraphCacheResolver<
      WithTypename<IAssignBranchOwnershipMutationPayload>,
      Record<string, never>,
      WithTypename<IBranch> | string
    >;
    clientMutationId?: GraphCacheResolver<
      WithTypename<IAssignBranchOwnershipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IAssignBranchOwnershipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  AssignTemporaryManagerMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IAssignTemporaryManagerMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IAssignTemporaryManagerMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    event?: GraphCacheResolver<
      WithTypename<IAssignTemporaryManagerMutationPayload>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
  };
  AssistImpactSkillMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IAssistImpactSkillMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IAssistImpactSkillMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IAssistImpactSkillMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  AttendanceInvoice?: {
    attending?: GraphCacheResolver<
      WithTypename<IAttendanceInvoice>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    baseCost?: GraphCacheResolver<
      WithTypename<IAttendanceInvoice>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    buildGrowth?: GraphCacheResolver<
      WithTypename<IAttendanceInvoice>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    change?: GraphCacheResolver<
      WithTypename<IAttendanceInvoice>,
      Record<string, never>,
      WithTypename<IInvoiceChange> | string
    >;
    extraXpCost?: GraphCacheResolver<
      WithTypename<IAttendanceInvoice>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IAttendanceInvoice>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<IAttendanceInvoice>,
      Record<string, never>,
      IEventAttendeeKindEnum | string
    >;
    paid?: GraphCacheResolver<
      WithTypename<IAttendanceInvoice>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    ticket?: GraphCacheResolver<
      WithTypename<IAttendanceInvoice>,
      Record<string, never>,
      WithTypename<ITicketInvoice> | string
    >;
    totalCost?: GraphCacheResolver<
      WithTypename<IAttendanceInvoice>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<IAttendanceInvoice>,
      Record<string, never>,
      WithTypename<IUserInvoice> | string
    >;
  };
  AttendeeCharacter?: {
    actionLogs?: GraphCacheResolver<
      WithTypename<IAttendeeCharacter>,
      Record<string, never>,
      Array<WithTypename<ITalliedActionLog> | string>
    >;
    attendance?: GraphCacheResolver<
      WithTypename<IAttendeeCharacter>,
      Record<string, never>,
      IAttendeeCharacterAttendanceEnum | string
    >;
    buildGrowth?: GraphCacheResolver<
      WithTypename<IAttendeeCharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    cap?: GraphCacheResolver<
      WithTypename<IAttendeeCharacter>,
      Record<string, never>,
      WithTypename<ICap> | string
    >;
    character?: GraphCacheResolver<
      WithTypename<IAttendeeCharacter>,
      Record<string, never>,
      WithTypename<ICharacter> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IAttendeeCharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    payment?: GraphCacheResolver<
      WithTypename<IAttendeeCharacter>,
      Record<string, never>,
      IAttendeeCharacterPaymentEnum | string
    >;
    printRequestStatus?: GraphCacheResolver<
      WithTypename<IAttendeeCharacter>,
      Record<string, never>,
      IAttendeeCharacterPrintRequestStatusEnum | string
    >;
    ticket?: GraphCacheResolver<
      WithTypename<IAttendeeCharacter>,
      Record<string, never>,
      WithTypename<ITicket> | string
    >;
  };
  AttendeeShift?: {
    id?: GraphCacheResolver<
      WithTypename<IAttendeeShift>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    player?: GraphCacheResolver<
      WithTypename<IAttendeeShift>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
    shift?: GraphCacheResolver<
      WithTypename<IAttendeeShift>,
      Record<string, never>,
      WithTypename<IShift> | string
    >;
    status?: GraphCacheResolver<
      WithTypename<IAttendeeShift>,
      Record<string, never>,
      IAttendeeShiftStatusEnum | string
    >;
  };
  Branch?: {
    activePlayers?: GraphCacheResolver<
      WithTypename<IBranch>,
      Record<string, never>,
      Array<WithTypename<IUserOrganization> | string>
    >;
    branchAssistants?: GraphCacheResolver<
      WithTypename<IBranch>,
      Record<string, never>,
      Array<WithTypename<IUserOrganization> | string>
    >;
    branchContracts?: GraphCacheResolver<
      WithTypename<IBranch>,
      Record<string, never>,
      Array<WithTypename<IBranchContract> | string>
    >;
    branchOwners?: GraphCacheResolver<
      WithTypename<IBranch>,
      Record<string, never>,
      Array<WithTypename<IBranchOwner> | string>
    >;
    caps?: GraphCacheResolver<
      WithTypename<IBranch>,
      Record<string, never>,
      Array<WithTypename<ICap> | string>
    >;
    correctiveActions?: GraphCacheResolver<
      WithTypename<IBranch>,
      Record<string, never>,
      Array<WithTypename<ICorrectiveAction> | string>
    >;
    district?: GraphCacheResolver<
      WithTypename<IBranch>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    eventsWithinContract?: GraphCacheResolver<
      WithTypename<IBranch>,
      IBranchEventsWithinContractArgs,
      Array<WithTypename<IEvent> | string>
    >;
    id?: GraphCacheResolver<
      WithTypename<IBranch>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    invoice?: GraphCacheResolver<
      WithTypename<IBranch>,
      Record<string, never>,
      WithTypename<IInvoice> | string
    >;
    location?: GraphCacheResolver<
      WithTypename<IBranch>,
      IBranchLocationArgs,
      WithTypename<ILocation> | string
    >;
    locations?: GraphCacheResolver<
      WithTypename<IBranch>,
      Record<string, never>,
      Array<WithTypename<ILocation> | string>
    >;
    name?: GraphCacheResolver<
      WithTypename<IBranch>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    organization?: GraphCacheResolver<
      WithTypename<IBranch>,
      Record<string, never>,
      WithTypename<IOrganization> | string
    >;
    region?: GraphCacheResolver<
      WithTypename<IBranch>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    registrationUrl?: GraphCacheResolver<
      WithTypename<IBranch>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    shorthand?: GraphCacheResolver<
      WithTypename<IBranch>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    website?: GraphCacheResolver<
      WithTypename<IBranch>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  BranchContract?: {
    active?: GraphCacheResolver<
      WithTypename<IBranchContract>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    contract?: GraphCacheResolver<
      WithTypename<IBranchContract>,
      Record<string, never>,
      WithTypename<IContract> | string
    >;
    endsAt?: GraphCacheResolver<
      WithTypename<IBranchContract>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IBranchContract>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    startsAt?: GraphCacheResolver<
      WithTypename<IBranchContract>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
  };
  BranchOwner?: {
    id?: GraphCacheResolver<
      WithTypename<IBranchOwner>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<IBranchOwner>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  CachedUserAttendance?: {
    activeCorrectiveActionsCount?: GraphCacheResolver<
      WithTypename<ICachedUserAttendance>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    attendanceCount?: GraphCacheResolver<
      WithTypename<ICachedUserAttendance>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    branch?: GraphCacheResolver<
      WithTypename<ICachedUserAttendance>,
      Record<string, never>,
      WithTypename<IBranch> | string
    >;
    firstEvent?: GraphCacheResolver<
      WithTypename<ICachedUserAttendance>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
    firstEventAt?: GraphCacheResolver<
      WithTypename<ICachedUserAttendance>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ICachedUserAttendance>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    lastEvent?: GraphCacheResolver<
      WithTypename<ICachedUserAttendance>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
    lastEventAt?: GraphCacheResolver<
      WithTypename<ICachedUserAttendance>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    roleInOrganization?: GraphCacheResolver<
      WithTypename<ICachedUserAttendance>,
      Record<string, never>,
      IOrganizationRoleEnum | string
    >;
    user?: GraphCacheResolver<
      WithTypename<ICachedUserAttendance>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  Cap?: {
    amount?: GraphCacheResolver<
      WithTypename<ICap>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    branch?: GraphCacheResolver<
      WithTypename<ICap>,
      Record<string, never>,
      WithTypename<IBranch> | string
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<ICap>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    grantor?: GraphCacheResolver<
      WithTypename<ICap>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ICap>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    reason?: GraphCacheResolver<
      WithTypename<ICap>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    state?: GraphCacheResolver<
      WithTypename<ICap>,
      Record<string, never>,
      ICapStateEnum | string
    >;
    user?: GraphCacheResolver<
      WithTypename<ICap>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  Character?: {
    alive?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    body?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    buildEarned?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    buildUsed?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    canBeDeleted?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    characterFellowships?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Array<WithTypename<ICharacterFellowship> | string>
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    currentBody?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    currentLife?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    currentMind?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    currentResolve?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    faithId?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    faithLevel?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    fellowshipsMissingSubpillar?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Array<WithTypename<IFellowship> | string>
    >;
    fractures?: GraphCacheResolver<
      WithTypename<ICharacter>,
      ICharacterFracturesArgs,
      Array<WithTypename<IFracture> | string>
    >;
    id?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    infection?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    inventories?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Array<WithTypename<IInventory> | string>
    >;
    itemTransaction?: GraphCacheResolver<
      WithTypename<ICharacter>,
      ICharacterItemTransactionArgs,
      WithTypename<IItemTransaction> | string
    >;
    itemTransactions?: GraphCacheResolver<
      WithTypename<ICharacter>,
      ICharacterItemTransactionsArgs,
      Array<WithTypename<IItemTransaction> | string>
    >;
    latestLifecycleGainsThisYear?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Array<Scalars['ISO8601DateTime']['output'] | string>
    >;
    legacyHomeGameCount?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    lifeCapacity?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    lifeGain?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    lifeLoss?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    lifecycles?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Array<WithTypename<ILifecycle> | string>
    >;
    lineageId?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    loreIds?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Array<Scalars['Int']['output'] | string>
    >;
    mind?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    mindPenalty?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    organization?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      WithTypename<IOrganization> | string
    >;
    playerNotes?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    resolve?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    retiredCharacter?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      WithTypename<ICharacter> | string
    >;
    retirementPaths?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      WithTypename<IRetirementPaths> | string
    >;
    skills?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Array<WithTypename<ICharacterSkill> | string>
    >;
    staffNotes?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      ICharacterStatusEnum | string
    >;
    strainId?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    totalHomeGameCount?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
    variant?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    version?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    xpAudits?: GraphCacheResolver<
      WithTypename<ICharacter>,
      Record<string, never>,
      Array<WithTypename<IXpAudit> | string>
    >;
  };
  CharacterConstraint?: {
    faiths?: GraphCacheResolver<
      WithTypename<ICharacterConstraint>,
      Record<string, never>,
      Array<WithTypename<ICharacterSubConstraint> | string>
    >;
    reputations?: GraphCacheResolver<
      WithTypename<ICharacterConstraint>,
      Record<string, never>,
      Array<WithTypename<ICharacterSubConstraint> | string>
    >;
    requiresSubpillar?: GraphCacheResolver<
      WithTypename<ICharacterConstraint>,
      Record<string, never>,
      Array<WithTypename<ICharacterSubConstraint> | string>
    >;
    skills?: GraphCacheResolver<
      WithTypename<ICharacterConstraint>,
      Record<string, never>,
      Array<WithTypename<ICharacterSubConstraint> | string>
    >;
    societies?: GraphCacheResolver<
      WithTypename<ICharacterConstraint>,
      Record<string, never>,
      Array<WithTypename<ICharacterSubConstraint> | string>
    >;
  };
  CharacterFellowship?: {
    character?: GraphCacheResolver<
      WithTypename<ICharacterFellowship>,
      Record<string, never>,
      WithTypename<ICharacter> | string
    >;
    fellowship?: GraphCacheResolver<
      WithTypename<ICharacterFellowship>,
      Record<string, never>,
      WithTypename<IFellowship> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ICharacterFellowship>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    rank?: GraphCacheResolver<
      WithTypename<ICharacterFellowship>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    removedAt?: GraphCacheResolver<
      WithTypename<ICharacterFellowship>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
  };
  CharacterSkill?: {
    characterSkillId?: GraphCacheResolver<
      WithTypename<ICharacterSkill>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ICharacterSkill>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    level?: GraphCacheResolver<
      WithTypename<ICharacterSkill>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    positions?: GraphCacheResolver<
      WithTypename<ICharacterSkill>,
      Record<string, never>,
      Array<Scalars['Int']['output'] | string>
    >;
    remainingUses?: GraphCacheResolver<
      WithTypename<ICharacterSkill>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  CharacterSubConstraint?: {
    id?: GraphCacheResolver<
      WithTypename<ICharacterSubConstraint>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    level?: GraphCacheResolver<
      WithTypename<ICharacterSubConstraint>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  CheckinCharacterMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICheckinCharacterMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICheckinCharacterMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    eventAttendee?: GraphCacheResolver<
      WithTypename<ICheckinCharacterMutationPayload>,
      Record<string, never>,
      WithTypename<IEventAttendee> | string
    >;
  };
  CheckinMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICheckinMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICheckinMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    eventAttendee?: GraphCacheResolver<
      WithTypename<ICheckinMutationPayload>,
      Record<string, never>,
      WithTypename<IEventAttendee> | string
    >;
  };
  ClaimModRewardsMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IClaimModRewardsMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IClaimModRewardsMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    modSignup?: GraphCacheResolver<
      WithTypename<IClaimModRewardsMutationPayload>,
      Record<string, never>,
      WithTypename<IModSignup> | string
    >;
  };
  ClearingHouse?: {
    distribution?: GraphCacheResolver<
      WithTypename<IClearingHouse>,
      Record<string, never>,
      IItemTransactionDistributionEnum | string
    >;
    itemId?: GraphCacheResolver<
      WithTypename<IClearingHouse>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    itemKind?: GraphCacheResolver<
      WithTypename<IClearingHouse>,
      Record<string, never>,
      IItemKindEnum | string
    >;
    itemName?: GraphCacheResolver<
      WithTypename<IClearingHouse>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    source?: GraphCacheResolver<
      WithTypename<IClearingHouse>,
      Record<string, never>,
      IItemTransactionSourceEnum | string
    >;
    stack?: GraphCacheResolver<
      WithTypename<IClearingHouse>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  CompleteScatterShotMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICompleteScatterShotMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICompleteScatterShotMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<ICompleteScatterShotMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  Contract?: {
    id?: GraphCacheResolver<
      WithTypename<IContract>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    maxGames?: GraphCacheResolver<
      WithTypename<IContract>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    maxVirtualGames?: GraphCacheResolver<
      WithTypename<IContract>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IContract>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  Coord?: {
    x?: GraphCacheResolver<
      WithTypename<ICoord>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    y?: GraphCacheResolver<
      WithTypename<ICoord>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
  };
  CopyCharacterBuildMutationPayload?: {
    character?: GraphCacheResolver<
      WithTypename<ICopyCharacterBuildMutationPayload>,
      Record<string, never>,
      WithTypename<ICharacter> | string
    >;
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICopyCharacterBuildMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICopyCharacterBuildMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CopyEventSetupMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICopyEventSetupMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICopyEventSetupMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    event?: GraphCacheResolver<
      WithTypename<ICopyEventSetupMutationPayload>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
  };
  CorrectiveAction?: {
    branch?: GraphCacheResolver<
      WithTypename<ICorrectiveAction>,
      Record<string, never>,
      WithTypename<IBranch> | string
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<ICorrectiveAction>,
      Record<string, never>,
      Scalars['ISO8601Date']['output'] | string
    >;
    endsAt?: GraphCacheResolver<
      WithTypename<ICorrectiveAction>,
      Record<string, never>,
      Scalars['ISO8601Date']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ICorrectiveAction>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    issuer?: GraphCacheResolver<
      WithTypename<ICorrectiveAction>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<ICorrectiveAction>,
      Record<string, never>,
      ICorrectiveActionKindEnum | string
    >;
    reason?: GraphCacheResolver<
      WithTypename<ICorrectiveAction>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    startsAt?: GraphCacheResolver<
      WithTypename<ICorrectiveAction>,
      Record<string, never>,
      Scalars['ISO8601Date']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<ICorrectiveAction>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  CraftableItem?: {
    id?: GraphCacheResolver<
      WithTypename<ICraftableItem>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<ICraftableItem>,
      Record<string, never>,
      IItemKindEnum | string
    >;
    metadata?: GraphCacheResolver<
      WithTypename<ICraftableItem>,
      Record<string, never>,
      WithTypename<IItemMetadata> | string
    >;
    name?: GraphCacheResolver<
      WithTypename<ICraftableItem>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CraftingComponent?: {
    acceptsExpiredItemWithinDays?: GraphCacheResolver<
      WithTypename<ICraftingComponent>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    amount?: GraphCacheResolver<
      WithTypename<ICraftingComponent>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    component?: GraphCacheResolver<
      WithTypename<ICraftingComponent>,
      Record<string, never>,
      WithTypename<IItem> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ICraftingComponent>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    itemCrafting?: GraphCacheResolver<
      WithTypename<ICraftingComponent>,
      Record<string, never>,
      WithTypename<IItemCrafting> | string
    >;
  };
  CraftingFinalProduct?: {
    finalProduct?: GraphCacheResolver<
      WithTypename<ICraftingFinalProduct>,
      Record<string, never>,
      WithTypename<IItem> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ICraftingFinalProduct>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    stack?: GraphCacheResolver<
      WithTypename<ICraftingFinalProduct>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  CreateCapMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateCapMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateCapMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<ICreateCapMutationPayload>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  CreateCharacterActionLogMutationPayload?: {
    attendeeCharacter?: GraphCacheResolver<
      WithTypename<ICreateCharacterActionLogMutationPayload>,
      Record<string, never>,
      WithTypename<IAttendeeCharacter> | string
    >;
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateCharacterActionLogMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateCharacterActionLogMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CreateCharacterFellowshipMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateCharacterFellowshipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateCharacterFellowshipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    fellowship?: GraphCacheResolver<
      WithTypename<ICreateCharacterFellowshipMutationPayload>,
      Record<string, never>,
      WithTypename<IFellowship> | string
    >;
  };
  CreateCharacterMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateCharacterMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateCharacterMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<ICreateCharacterMutationPayload>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  CreateCorrectiveActionMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateCorrectiveActionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateCorrectiveActionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<ICreateCorrectiveActionMutationPayload>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  CreateEventLifecycleMutationPayload?: {
    character?: GraphCacheResolver<
      WithTypename<ICreateEventLifecycleMutationPayload>,
      Record<string, never>,
      WithTypename<ICharacter> | string
    >;
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateEventLifecycleMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateEventLifecycleMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CreateEventMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateEventMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateEventMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    event?: GraphCacheResolver<
      WithTypename<ICreateEventMutationPayload>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
  };
  CreateEventShiftMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateEventShiftMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateEventShiftMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    event?: GraphCacheResolver<
      WithTypename<ICreateEventShiftMutationPayload>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
  };
  CreateEventTicketMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateEventTicketMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateEventTicketMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    event?: GraphCacheResolver<
      WithTypename<ICreateEventTicketMutationPayload>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
  };
  CreateFellowshipMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateFellowshipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateFellowshipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    organization?: GraphCacheResolver<
      WithTypename<ICreateFellowshipMutationPayload>,
      Record<string, never>,
      WithTypename<IOrganization> | string
    >;
  };
  CreateFellowshipRuleTagMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateFellowshipRuleTagMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateFellowshipRuleTagMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    fellowship?: GraphCacheResolver<
      WithTypename<ICreateFellowshipRuleTagMutationPayload>,
      Record<string, never>,
      WithTypename<IFellowship> | string
    >;
  };
  CreateItemClassificationMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateItemClassificationMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateItemClassificationMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    item?: GraphCacheResolver<
      WithTypename<ICreateItemClassificationMutationPayload>,
      Record<string, never>,
      WithTypename<IItem> | string
    >;
  };
  CreateItemCraftingComponentMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateItemCraftingComponentMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateItemCraftingComponentMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    itemCrafting?: GraphCacheResolver<
      WithTypename<ICreateItemCraftingComponentMutationPayload>,
      Record<string, never>,
      WithTypename<IItemCrafting> | string
    >;
  };
  CreateItemCraftingFinalProductMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateItemCraftingFinalProductMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateItemCraftingFinalProductMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    itemCrafting?: GraphCacheResolver<
      WithTypename<ICreateItemCraftingFinalProductMutationPayload>,
      Record<string, never>,
      WithTypename<IItemCrafting> | string
    >;
  };
  CreateItemCraftingMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateItemCraftingMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateItemCraftingMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    item?: GraphCacheResolver<
      WithTypename<ICreateItemCraftingMutationPayload>,
      Record<string, never>,
      WithTypename<IItem> | string
    >;
  };
  CreateItemMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateItemMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateItemMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    item?: GraphCacheResolver<
      WithTypename<ICreateItemMutationPayload>,
      Record<string, never>,
      WithTypename<IItem> | string
    >;
  };
  CreateItemReproductionComponentMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateItemReproductionComponentMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateItemReproductionComponentMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    itemReproduction?: GraphCacheResolver<
      WithTypename<ICreateItemReproductionComponentMutationPayload>,
      Record<string, never>,
      WithTypename<IItemReproduction> | string
    >;
  };
  CreateItemReproductionMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateItemReproductionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateItemReproductionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    item?: GraphCacheResolver<
      WithTypename<ICreateItemReproductionMutationPayload>,
      Record<string, never>,
      WithTypename<IItem> | string
    >;
  };
  CreateItemTransactionMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateItemTransactionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateItemTransactionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    itemTransactions?: GraphCacheResolver<
      WithTypename<ICreateItemTransactionMutationPayload>,
      Record<string, never>,
      Array<WithTypename<IItemTransaction> | string>
    >;
  };
  CreateLocationMutationPayload?: {
    branch?: GraphCacheResolver<
      WithTypename<ICreateLocationMutationPayload>,
      Record<string, never>,
      WithTypename<IBranch> | string
    >;
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateLocationMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateLocationMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  CreateMembershipMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateMembershipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateMembershipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<ICreateMembershipMutationPayload>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  CreateMessageMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateMessageMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateMessageMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<ICreateMessageMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  CreateModAssetMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateModAssetMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateModAssetMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<ICreateModAssetMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  CreateModChallengeMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateModChallengeMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateModChallengeMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<ICreateModChallengeMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  CreateModMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateModMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateModMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    modSection?: GraphCacheResolver<
      WithTypename<ICreateModMutationPayload>,
      Record<string, never>,
      WithTypename<IModSection> | string
    >;
  };
  CreateModNarrativeRolePlayMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateModNarrativeRolePlayMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateModNarrativeRolePlayMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<ICreateModNarrativeRolePlayMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  CreateModRewardMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateModRewardMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateModRewardMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    modRewardTemplate?: GraphCacheResolver<
      WithTypename<ICreateModRewardMutationPayload>,
      Record<string, never>,
      WithTypename<IModRewardTemplate> | string
    >;
  };
  CreateModRewardTemplateMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateModRewardTemplateMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateModRewardTemplateMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<ICreateModRewardTemplateMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  CreateModSectionMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateModSectionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateModSectionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    event?: GraphCacheResolver<
      WithTypename<ICreateModSectionMutationPayload>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
  };
  CreateModSignupMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateModSignupMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateModSignupMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<ICreateModSignupMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  CreateNewPlayerMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateNewPlayerMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateNewPlayerMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<ICreateNewPlayerMutationPayload>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  CreateReferralMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateReferralMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateReferralMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<ICreateReferralMutationPayload>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  CreateSpecialDateMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ICreateSpecialDateMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ICreateSpecialDateMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    organization?: GraphCacheResolver<
      WithTypename<ICreateSpecialDateMutationPayload>,
      Record<string, never>,
      WithTypename<IOrganization> | string
    >;
  };
  DefenseRoll?: {
    id?: GraphCacheResolver<
      WithTypename<IDefenseRoll>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    type?: GraphCacheResolver<
      WithTypename<IDefenseRoll>,
      Record<string, never>,
      IModEntityTypeEnum | string
    >;
    value?: GraphCacheResolver<
      WithTypename<IDefenseRoll>,
      Record<string, never>,
      Array<Scalars['Int']['output'] | string>
    >;
  };
  DestroyAttendeeCharacterMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyAttendeeCharacterMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyAttendeeCharacterMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    eventAttendee?: GraphCacheResolver<
      WithTypename<IDestroyAttendeeCharacterMutationPayload>,
      Record<string, never>,
      WithTypename<IEventAttendee> | string
    >;
  };
  DestroyAuthTokenMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyAuthTokenMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyAuthTokenMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  DestroyCharacterMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyCharacterMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyCharacterMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<IDestroyCharacterMutationPayload>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  DestroyCorrectiveActionMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyCorrectiveActionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    correctiveAction?: GraphCacheResolver<
      WithTypename<IDestroyCorrectiveActionMutationPayload>,
      Record<string, never>,
      WithTypename<ICorrectiveAction> | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyCorrectiveActionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  DestroyEventAttendeeMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyEventAttendeeMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyEventAttendeeMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    eventAttendee?: GraphCacheResolver<
      WithTypename<IDestroyEventAttendeeMutationPayload>,
      Record<string, never>,
      WithTypename<IEventAttendee> | string
    >;
  };
  DestroyEventShiftMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyEventShiftMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyEventShiftMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    event?: GraphCacheResolver<
      WithTypename<IDestroyEventShiftMutationPayload>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
  };
  DestroyEventTicketMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyEventTicketMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyEventTicketMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    ticket?: GraphCacheResolver<
      WithTypename<IDestroyEventTicketMutationPayload>,
      Record<string, never>,
      WithTypename<ITicket> | string
    >;
  };
  DestroyFellowshipRuleTagMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyFellowshipRuleTagMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyFellowshipRuleTagMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    fellowship?: GraphCacheResolver<
      WithTypename<IDestroyFellowshipRuleTagMutationPayload>,
      Record<string, never>,
      WithTypename<IFellowship> | string
    >;
  };
  DestroyItemClassificationMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyItemClassificationMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyItemClassificationMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    itemClassification?: GraphCacheResolver<
      WithTypename<IDestroyItemClassificationMutationPayload>,
      Record<string, never>,
      WithTypename<IItemClassification> | string
    >;
  };
  DestroyItemCraftingComponentMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyItemCraftingComponentMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    craftingComponent?: GraphCacheResolver<
      WithTypename<IDestroyItemCraftingComponentMutationPayload>,
      Record<string, never>,
      WithTypename<ICraftingComponent> | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyItemCraftingComponentMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  DestroyItemCraftingFinalProductMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyItemCraftingFinalProductMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    craftingFinalProduct?: GraphCacheResolver<
      WithTypename<IDestroyItemCraftingFinalProductMutationPayload>,
      Record<string, never>,
      WithTypename<ICraftingFinalProduct> | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyItemCraftingFinalProductMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  DestroyItemCraftingMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyItemCraftingMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyItemCraftingMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    itemCrafting?: GraphCacheResolver<
      WithTypename<IDestroyItemCraftingMutationPayload>,
      Record<string, never>,
      WithTypename<IItemCrafting> | string
    >;
  };
  DestroyItemReproductionComponentMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyItemReproductionComponentMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyItemReproductionComponentMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    itemReproductionComponent?: GraphCacheResolver<
      WithTypename<IDestroyItemReproductionComponentMutationPayload>,
      Record<string, never>,
      WithTypename<IItemReproductionComponent> | string
    >;
  };
  DestroyItemReproductionMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyItemReproductionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyItemReproductionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    itemReproduction?: GraphCacheResolver<
      WithTypename<IDestroyItemReproductionMutationPayload>,
      Record<string, never>,
      WithTypename<IItemReproduction> | string
    >;
  };
  DestroyLocationMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyLocationMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyLocationMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    location?: GraphCacheResolver<
      WithTypename<IDestroyLocationMutationPayload>,
      Record<string, never>,
      WithTypename<ILocation> | string
    >;
  };
  DestroyMembershipMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyMembershipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyMembershipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    membership?: GraphCacheResolver<
      WithTypename<IDestroyMembershipMutationPayload>,
      Record<string, never>,
      WithTypename<IMembership> | string
    >;
  };
  DestroyModAssetMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyModAssetMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyModAssetMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IDestroyModAssetMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  DestroyModMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyModMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyModMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    modSection?: GraphCacheResolver<
      WithTypename<IDestroyModMutationPayload>,
      Record<string, never>,
      WithTypename<IModSection> | string
    >;
  };
  DestroyModRewardMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyModRewardMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyModRewardMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    modRewardTemplate?: GraphCacheResolver<
      WithTypename<IDestroyModRewardMutationPayload>,
      Record<string, never>,
      WithTypename<IModRewardTemplate> | string
    >;
  };
  DestroyModRewardTemplateMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyModRewardTemplateMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyModRewardTemplateMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IDestroyModRewardTemplateMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  DestroyModSignupMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyModSignupMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyModSignupMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IDestroyModSignupMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  DestroyReferralMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroyReferralMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroyReferralMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<IDestroyReferralMutationPayload>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  DestroySpecialDateMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IDestroySpecialDateMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IDestroySpecialDateMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    specialDate?: GraphCacheResolver<
      WithTypename<IDestroySpecialDateMutationPayload>,
      Record<string, never>,
      WithTypename<ISpecialDate> | string
    >;
  };
  DiceRollAutoResolve?: {
    matchingProfessionIds?: GraphCacheResolver<
      WithTypename<IDiceRollAutoResolve>,
      Record<string, never>,
      Array<Scalars['Int']['output'] | string>
    >;
    sufficientMind?: GraphCacheResolver<
      WithTypename<IDiceRollAutoResolve>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  DiceRollDamage?: {
    add?: GraphCacheResolver<
      WithTypename<IDiceRollDamage>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    baseRoll?: GraphCacheResolver<
      WithTypename<IDiceRollDamage>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    damageType?: GraphCacheResolver<
      WithTypename<IDiceRollDamage>,
      Record<string, never>,
      IModDamageTypeEnum | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<IDiceRollDamage>,
      Record<string, never>,
      IItemKindEnum | string
    >;
    max?: GraphCacheResolver<
      WithTypename<IDiceRollDamage>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    min?: GraphCacheResolver<
      WithTypename<IDiceRollDamage>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    total?: GraphCacheResolver<
      WithTypename<IDiceRollDamage>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  DiceRollResult?: {
    add?: GraphCacheResolver<
      WithTypename<IDiceRollResult>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    baseRoll?: GraphCacheResolver<
      WithTypename<IDiceRollResult>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    connects?: GraphCacheResolver<
      WithTypename<IDiceRollResult>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    damageTally?: GraphCacheResolver<
      WithTypename<IDiceRollResult>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    damages?: GraphCacheResolver<
      WithTypename<IDiceRollResult>,
      Record<string, never>,
      Array<WithTypename<IDiceRollDamage> | string>
    >;
    defensiveRoll?: GraphCacheResolver<
      WithTypename<IDiceRollResult>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    max?: GraphCacheResolver<
      WithTypename<IDiceRollResult>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    min?: GraphCacheResolver<
      WithTypename<IDiceRollResult>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    skillId?: GraphCacheResolver<
      WithTypename<IDiceRollResult>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    subtarget?: GraphCacheResolver<
      WithTypename<IDiceRollResult>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    total?: GraphCacheResolver<
      WithTypename<IDiceRollResult>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  DiceRollSummary?: {
    autoResolve?: GraphCacheResolver<
      WithTypename<IDiceRollSummary>,
      Record<string, never>,
      WithTypename<IDiceRollAutoResolve> | string
    >;
    rolls?: GraphCacheResolver<
      WithTypename<IDiceRollSummary>,
      Record<string, never>,
      Array<WithTypename<IDiceRollResult> | string>
    >;
    totalDamage?: GraphCacheResolver<
      WithTypename<IDiceRollSummary>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  EndModMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IEndModMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IEndModMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IEndModMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  EnterBattlefieldMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IEnterBattlefieldMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IEnterBattlefieldMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IEnterBattlefieldMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  EquipMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IEquipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IEquipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IEquipMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  Error?: {
    error?: GraphCacheResolver<
      WithTypename<IError>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  Event?: {
    activeCorrectiveActions?: GraphCacheResolver<
      WithTypename<IEvent>,
      IEventActiveCorrectiveActionsArgs,
      Array<WithTypename<ICorrectiveAction> | string>
    >;
    activeMembership?: GraphCacheResolver<
      WithTypename<IEvent>,
      IEventActiveMembershipArgs,
      Scalars['Boolean']['output'] | string
    >;
    branch?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      WithTypename<IBranch> | string
    >;
    canSelfCheckin?: GraphCacheResolver<
      WithTypename<IEvent>,
      IEventCanSelfCheckinArgs,
      Scalars['Boolean']['output'] | string
    >;
    checkinableCharacters?: GraphCacheResolver<
      WithTypename<IEvent>,
      IEventCheckinableCharactersArgs,
      Array<WithTypename<ICharacter> | string>
    >;
    config?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      WithTypename<IEventConfig> | string
    >;
    description?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    endsAt?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    eventAttendee?: GraphCacheResolver<
      WithTypename<IEvent>,
      IEventEventAttendeeArgs,
      WithTypename<IEventAttendee> | string
    >;
    eventAttendees?: GraphCacheResolver<
      WithTypename<IEvent>,
      IEventEventAttendeesArgs,
      Array<WithTypename<IEventAttendee> | string>
    >;
    eventAttendeesSize?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    isEventAssistant?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isEventManager?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isEventRegistrar?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isHomeGame?: GraphCacheResolver<
      WithTypename<IEvent>,
      IEventIsHomeGameArgs,
      Scalars['Boolean']['output'] | string
    >;
    isVirtual?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    itemTransactionStatistics?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Array<WithTypename<IClearingHouse> | string>
    >;
    itemTransactions?: GraphCacheResolver<
      WithTypename<IEvent>,
      IEventItemTransactionsArgs,
      Array<WithTypename<IItemTransaction> | string>
    >;
    kind?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      IEventKindEnum | string
    >;
    location?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      WithTypename<ILocation> | string
    >;
    maximumCheckinableCharacters?: GraphCacheResolver<
      WithTypename<IEvent>,
      IEventMaximumCheckinableCharactersArgs,
      Scalars['Int']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IEvent>,
      IEventModArgs,
      WithTypename<IMod> | string
    >;
    modDescription?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    modEnableWaitlist?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    modMaxSignup?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    modSections?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Array<WithTypename<IModSection> | string>
    >;
    modSignupOpensAt?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    nextEvent?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
    prevEvent?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
    printouts?: GraphCacheResolver<
      WithTypename<IEvent>,
      IEventPrintoutsArgs,
      Array<WithTypename<IEventAttendee> | string>
    >;
    registrationOpensAt?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    revenue?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      WithTypename<IEventRevenue> | string
    >;
    shiftKinds?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Array<IShiftKindEnum | string>
    >;
    shifts?: GraphCacheResolver<
      WithTypename<IEvent>,
      IEventShiftsArgs,
      Array<WithTypename<IShift> | string>
    >;
    startsAt?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    temporaryManagers?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Array<WithTypename<ITemporaryManager> | string>
    >;
    ticketStatistics?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      Array<WithTypename<ITicket> | string>
    >;
    tickets?: GraphCacheResolver<
      WithTypename<IEvent>,
      IEventTicketsArgs,
      Array<WithTypename<ITicket> | string>
    >;
    ticketsBaseConfig?: GraphCacheResolver<
      WithTypename<IEvent>,
      Record<string, never>,
      WithTypename<ITicketsBaseConfig> | string
    >;
  };
  EventAttendee?: {
    attendeeCharacters?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      Array<WithTypename<IAttendeeCharacter> | string>
    >;
    attendeeShifts?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      Array<WithTypename<IAttendeeShift> | string>
    >;
    attending?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    buildAwarded?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    buildGrowth?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    checkedInCharactersCount?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    checkinApproved?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    costOverride?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    econMindExpenditure?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      IEventAttendeeEconMindExpenditureArgs,
      Scalars['Int']['output'] | string
    >;
    econResolveExpenditure?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      IEventAttendeeEconResolveExpenditureArgs,
      Scalars['Int']['output'] | string
    >;
    econTimeExpenditureInMinutes?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    event?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    inviter?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
    itemTransactionsTally?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      Array<WithTypename<IItemTransactionTally> | string>
    >;
    kind?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      IEventAttendeeKindEnum | string
    >;
    paid?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    referralInfo?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    restrictedMailout?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    shifts?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      Array<WithTypename<IShift> | string>
    >;
    ticket?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      WithTypename<ITicket> | string
    >;
    ticketId?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<IEventAttendee>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  EventConfig?: {
    baseBuild?: GraphCacheResolver<
      WithTypename<IEventConfig>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    considersTravelersLocal?: GraphCacheResolver<
      WithTypename<IEventConfig>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    extraXpCost?: GraphCacheResolver<
      WithTypename<IEventConfig>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    maxCurveXp?: GraphCacheResolver<
      WithTypename<IEventConfig>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    maxExtraXp?: GraphCacheResolver<
      WithTypename<IEventConfig>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    maxExtraXpLimit?: GraphCacheResolver<
      WithTypename<IEventConfig>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    maxShift?: GraphCacheResolver<
      WithTypename<IEventConfig>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    shiftKinds?: GraphCacheResolver<
      WithTypename<IEventConfig>,
      Record<string, never>,
      Array<IShiftKindEnum | string>
    >;
    shiftMultiplier?: GraphCacheResolver<
      WithTypename<IEventConfig>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    shiftUnit?: GraphCacheResolver<
      WithTypename<IEventConfig>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  EventInvoice?: {
    attendances?: GraphCacheResolver<
      WithTypename<IEventInvoice>,
      Record<string, never>,
      Array<WithTypename<IAttendanceInvoice> | string>
    >;
    baseCompensationTicketCount?: GraphCacheResolver<
      WithTypename<IEventInvoice>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    billableAmount?: GraphCacheResolver<
      WithTypename<IEventInvoice>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    endsAt?: GraphCacheResolver<
      WithTypename<IEventInvoice>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    extraXpSold?: GraphCacheResolver<
      WithTypename<IEventInvoice>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    fullCompensationTicketCount?: GraphCacheResolver<
      WithTypename<IEventInvoice>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IEventInvoice>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    isCommunity?: GraphCacheResolver<
      WithTypename<IEventInvoice>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isCurrentCycle?: GraphCacheResolver<
      WithTypename<IEventInvoice>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isLegacy?: GraphCacheResolver<
      WithTypename<IEventInvoice>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isVirtual?: GraphCacheResolver<
      WithTypename<IEventInvoice>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IEventInvoice>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    startsAt?: GraphCacheResolver<
      WithTypename<IEventInvoice>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    ticketsSold?: GraphCacheResolver<
      WithTypename<IEventInvoice>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  EventRevenue?: {
    aggregates?: GraphCacheResolver<
      WithTypename<IEventRevenue>,
      Record<string, never>,
      WithTypename<IRevenueAggregates> | string
    >;
    itemizedLineItems?: GraphCacheResolver<
      WithTypename<IEventRevenue>,
      Record<string, never>,
      Array<WithTypename<ITicketRevenue> | string>
    >;
  };
  ExecuteScatterShotMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IExecuteScatterShotMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IExecuteScatterShotMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IExecuteScatterShotMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  ExpendItemMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IExpendItemMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IExpendItemMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IExpendItemMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  ExpendResolveMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IExpendResolveMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IExpendResolveMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IExpendResolveMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  Fellowship?: {
    branch?: GraphCacheResolver<
      WithTypename<IFellowship>,
      Record<string, never>,
      WithTypename<IBranch> | string
    >;
    characterFellowships?: GraphCacheResolver<
      WithTypename<IFellowship>,
      Record<string, never>,
      Array<WithTypename<ICharacterFellowship> | string>
    >;
    characters?: GraphCacheResolver<
      WithTypename<IFellowship>,
      Record<string, never>,
      Array<WithTypename<ICharacter> | string>
    >;
    charactersCount?: GraphCacheResolver<
      WithTypename<IFellowship>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    constraint?: GraphCacheResolver<
      WithTypename<IFellowship>,
      Record<string, never>,
      Array<WithTypename<ICharacterConstraint> | string>
    >;
    description?: GraphCacheResolver<
      WithTypename<IFellowship>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    fellowshipRuleTags?: GraphCacheResolver<
      WithTypename<IFellowship>,
      Record<string, never>,
      Array<WithTypename<IFellowshipRuleTag> | string>
    >;
    groupIdentifier?: GraphCacheResolver<
      WithTypename<IFellowship>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IFellowship>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<IFellowship>,
      Record<string, never>,
      IFellowshipKindEnum | string
    >;
    maxRank?: GraphCacheResolver<
      WithTypename<IFellowship>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IFellowship>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    organization?: GraphCacheResolver<
      WithTypename<IFellowship>,
      Record<string, never>,
      WithTypename<IOrganization> | string
    >;
    rankNames?: GraphCacheResolver<
      WithTypename<IFellowship>,
      Record<string, never>,
      Array<Scalars['String']['output'] | string>
    >;
    removedAt?: GraphCacheResolver<
      WithTypename<IFellowship>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
  };
  FellowshipRuleTag?: {
    fellowship?: GraphCacheResolver<
      WithTypename<IFellowshipRuleTag>,
      Record<string, never>,
      WithTypename<IFellowship> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IFellowshipRuleTag>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    ruleTag?: GraphCacheResolver<
      WithTypename<IFellowshipRuleTag>,
      Record<string, never>,
      WithTypename<IRuleTag> | string
    >;
  };
  FinalizeModRewardClaimsMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IFinalizeModRewardClaimsMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IFinalizeModRewardClaimsMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IFinalizeModRewardClaimsMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  Fracture?: {
    character?: GraphCacheResolver<
      WithTypename<IFracture>,
      Record<string, never>,
      WithTypename<ICharacter> | string
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<IFracture>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IFracture>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IFracture>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    removedAt?: GraphCacheResolver<
      WithTypename<IFracture>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
  };
  FulfillShiftMutationPayload?: {
    attendeeShift?: GraphCacheResolver<
      WithTypename<IFulfillShiftMutationPayload>,
      Record<string, never>,
      WithTypename<IAttendeeShift> | string
    >;
    clientMutationId?: GraphCacheResolver<
      WithTypename<IFulfillShiftMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IFulfillShiftMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  GenerateAuthTokenMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IGenerateAuthTokenMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IGenerateAuthTokenMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    token?: GraphCacheResolver<
      WithTypename<IGenerateAuthTokenMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<IGenerateAuthTokenMutationPayload>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  GenerateBattlefieldTokenMutationPayload?: {
    clientId?: GraphCacheResolver<
      WithTypename<IGenerateBattlefieldTokenMutationPayload>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    clientMutationId?: GraphCacheResolver<
      WithTypename<IGenerateBattlefieldTokenMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IGenerateBattlefieldTokenMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    keyName?: GraphCacheResolver<
      WithTypename<IGenerateBattlefieldTokenMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mac?: GraphCacheResolver<
      WithTypename<IGenerateBattlefieldTokenMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    nonce?: GraphCacheResolver<
      WithTypename<IGenerateBattlefieldTokenMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    timestamp?: GraphCacheResolver<
      WithTypename<IGenerateBattlefieldTokenMutationPayload>,
      Record<string, never>,
      Scalars['BigInt']['output'] | string
    >;
  };
  Inventory?: {
    expiresAt?: GraphCacheResolver<
      WithTypename<IInventory>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    expiresOn?: GraphCacheResolver<
      WithTypename<IInventory>,
      Record<string, never>,
      Scalars['ISO8601Date']['output'] | string
    >;
    item?: GraphCacheResolver<
      WithTypename<IInventory>,
      Record<string, never>,
      WithTypename<IItem> | string
    >;
    itemId?: GraphCacheResolver<
      WithTypename<IInventory>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    registeredItem?: GraphCacheResolver<
      WithTypename<IInventory>,
      Record<string, never>,
      WithTypename<IRegisteredItem> | string
    >;
    registeredItemId?: GraphCacheResolver<
      WithTypename<IInventory>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    remainingUses?: GraphCacheResolver<
      WithTypename<IInventory>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    stack?: GraphCacheResolver<
      WithTypename<IInventory>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    stackPending?: GraphCacheResolver<
      WithTypename<IInventory>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  Invoice?: {
    additionalXpBuybackCount?: GraphCacheResolver<
      WithTypename<IInvoice>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    additionalXpCount?: GraphCacheResolver<
      WithTypename<IInvoice>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    billableAmount?: GraphCacheResolver<
      WithTypename<IInvoice>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    events?: GraphCacheResolver<
      WithTypename<IInvoice>,
      Record<string, never>,
      Array<WithTypename<IEventInvoice> | string>
    >;
    liveEventTicketBuybackCount?: GraphCacheResolver<
      WithTypename<IInvoice>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    liveEventTicketCount?: GraphCacheResolver<
      WithTypename<IInvoice>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    virtualEventTicketBuybackCount?: GraphCacheResolver<
      WithTypename<IInvoice>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    virtualEventTicketCount?: GraphCacheResolver<
      WithTypename<IInvoice>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  InvoiceChange?: {
    attending?: GraphCacheResolver<
      WithTypename<IInvoiceChange>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    buildGrowth?: GraphCacheResolver<
      WithTypename<IInvoiceChange>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    gameKind?: GraphCacheResolver<
      WithTypename<IInvoiceChange>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<IInvoiceChange>,
      Record<string, never>,
      IInvoiceChangeKindEnum | string
    >;
    paid?: GraphCacheResolver<
      WithTypename<IInvoiceChange>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    ticketId?: GraphCacheResolver<
      WithTypename<IInvoiceChange>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    ticketLabel?: GraphCacheResolver<
      WithTypename<IInvoiceChange>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  Item?: {
    blueprintForCraftings?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      Array<WithTypename<IItem> | string>
    >;
    childItemClassifications?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      Array<WithTypename<IItemClassification> | string>
    >;
    craftsItemWithMultipleUses?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    grade?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      IItemGradeEnum | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    itemCraftings?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      Array<WithTypename<IItemCrafting> | string>
    >;
    itemReproductions?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      Array<WithTypename<IItemReproduction> | string>
    >;
    kind?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      IItemKindEnum | string
    >;
    lifetimeAmount?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    lifetimeUnit?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      IItemLifetimeUnitEnum | string
    >;
    metadata?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      WithTypename<IItemMetadata> | string
    >;
    multipleUses?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    numberOfUses?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    parts?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      Array<WithTypename<ICraftingComponent> | string>
    >;
    updatedAt?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    validFrom?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    validUntil?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    version?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    visibility?: GraphCacheResolver<
      WithTypename<IItem>,
      Record<string, never>,
      IItemVisibilityEnum | string
    >;
  };
  ItemClaim?: {
    characterId?: GraphCacheResolver<
      WithTypename<IItemClaim>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    stack?: GraphCacheResolver<
      WithTypename<IItemClaim>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<IItemClaim>,
      Record<string, never>,
      IItemTransactionStatusEnum | string
    >;
  };
  ItemClassification?: {
    childItem?: GraphCacheResolver<
      WithTypename<IItemClassification>,
      Record<string, never>,
      WithTypename<IItem> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IItemClassification>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  ItemCrafting?: {
    blueprint?: GraphCacheResolver<
      WithTypename<IItemCrafting>,
      Record<string, never>,
      WithTypename<IItem> | string
    >;
    craftingComponents?: GraphCacheResolver<
      WithTypename<IItemCrafting>,
      Record<string, never>,
      Array<WithTypename<ICraftingComponent> | string>
    >;
    craftingFinalProducts?: GraphCacheResolver<
      WithTypename<IItemCrafting>,
      Record<string, never>,
      Array<WithTypename<ICraftingFinalProduct> | string>
    >;
    craftingMindCost?: GraphCacheResolver<
      WithTypename<IItemCrafting>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    craftingResolveCost?: GraphCacheResolver<
      WithTypename<IItemCrafting>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    craftingSkills?: GraphCacheResolver<
      WithTypename<IItemCrafting>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    craftingTimeInMinute?: GraphCacheResolver<
      WithTypename<IItemCrafting>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    craftingZone?: GraphCacheResolver<
      WithTypename<IItemCrafting>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IItemCrafting>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  ItemMetadata?: {
    activationRequirement?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    allowBlueprintCopying?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    craftableItems?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Array<WithTypename<ICraftableItem> | string>
    >;
    descriptionOfRoleplay?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    durationOfEffect?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    durationOfRoleplay?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    equipmentRequiredForUse?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    locationOfUse?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mechanics?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    notes?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    printHeader?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    requirementsToUse?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    uses?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    validTargetDescription?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    vehicleArmor?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    vehicleCrewCapacity?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    vehicleHull?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    vehicleSpeed?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    vehicleTurnRadius?: GraphCacheResolver<
      WithTypename<IItemMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  ItemReproduction?: {
    id?: GraphCacheResolver<
      WithTypename<IItemReproduction>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    itemReproductionComponents?: GraphCacheResolver<
      WithTypename<IItemReproduction>,
      Record<string, never>,
      Array<WithTypename<IItemReproductionComponent> | string>
    >;
    metadata?: GraphCacheResolver<
      WithTypename<IItemReproduction>,
      Record<string, never>,
      WithTypename<IItemReproductionMetadata> | string
    >;
    reproductionMindCost?: GraphCacheResolver<
      WithTypename<IItemReproduction>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    reproductionSkills?: GraphCacheResolver<
      WithTypename<IItemReproduction>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    reproductionTimeInMinute?: GraphCacheResolver<
      WithTypename<IItemReproduction>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  ItemReproductionComponent?: {
    amount?: GraphCacheResolver<
      WithTypename<IItemReproductionComponent>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IItemReproductionComponent>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    item?: GraphCacheResolver<
      WithTypename<IItemReproductionComponent>,
      Record<string, never>,
      WithTypename<IItem> | string
    >;
  };
  ItemReproductionMetadata?: {
    notes?: GraphCacheResolver<
      WithTypename<IItemReproductionMetadata>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  ItemTransaction?: {
    armorUpgradePoints?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    character?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      WithTypename<ICharacter> | string
    >;
    childTransactions?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      Array<WithTypename<IItemTransaction> | string>
    >;
    copyBlueprint?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      WithTypename<IItem> | string
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    description?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    durationInMinute?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    event?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
    expiresAt?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    expiresOn?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      Scalars['ISO8601Date']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    isMailout?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    item?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      WithTypename<IItem> | string
    >;
    itemCrafting?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      WithTypename<IItemCrafting> | string
    >;
    itemTransactionUses?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      Array<WithTypename<IItemTransactionUse> | string>
    >;
    mailingAddress?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mailoutRecipient?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
    mindCost?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
    postie?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
    priority?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      IItemTransactionPriorityEnum | string
    >;
    registeredItem?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      WithTypename<IRegisteredItem> | string
    >;
    remainingUses?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    resolveCost?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    skillId?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    source?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    stack?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      IItemTransactionStatusEnum | string
    >;
    transactionPartner?: GraphCacheResolver<
      WithTypename<IItemTransaction>,
      Record<string, never>,
      WithTypename<ICharacter> | string
    >;
  };
  ItemTransactionTally?: {
    children?: GraphCacheResolver<
      WithTypename<IItemTransactionTally>,
      Record<string, never>,
      Array<WithTypename<IItemTransactionTally> | string>
    >;
    claims?: GraphCacheResolver<
      WithTypename<IItemTransactionTally>,
      Record<string, never>,
      Array<WithTypename<IItemClaim> | string>
    >;
    groupLimit?: GraphCacheResolver<
      WithTypename<IItemTransactionTally>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    itemId?: GraphCacheResolver<
      WithTypename<IItemTransactionTally>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    itemKind?: GraphCacheResolver<
      WithTypename<IItemTransactionTally>,
      Record<string, never>,
      IItemKindEnum | string
    >;
    itemName?: GraphCacheResolver<
      WithTypename<IItemTransactionTally>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    limit?: GraphCacheResolver<
      WithTypename<IItemTransactionTally>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    statusClaims?: GraphCacheResolver<
      WithTypename<IItemTransactionTally>,
      Record<string, never>,
      Array<WithTypename<IItemClaim> | string>
    >;
    subtotal?: GraphCacheResolver<
      WithTypename<IItemTransactionTally>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  ItemTransactionUse?: {
    createdAt?: GraphCacheResolver<
      WithTypename<IItemTransactionUse>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    event?: GraphCacheResolver<
      WithTypename<IItemTransactionUse>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IItemTransactionUse>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    postie?: GraphCacheResolver<
      WithTypename<IItemTransactionUse>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
    use?: GraphCacheResolver<
      WithTypename<IItemTransactionUse>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  LeaveBattlefieldMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ILeaveBattlefieldMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ILeaveBattlefieldMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<ILeaveBattlefieldMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  Lifecycle?: {
    createdAt?: GraphCacheResolver<
      WithTypename<ILifecycle>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    deletedAt?: GraphCacheResolver<
      WithTypename<ILifecycle>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    description?: GraphCacheResolver<
      WithTypename<ILifecycle>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    event?: GraphCacheResolver<
      WithTypename<ILifecycle>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ILifecycle>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<ILifecycle>,
      Record<string, never>,
      ILifecycleKindEnum | string
    >;
  };
  Location?: {
    city?: GraphCacheResolver<
      WithTypename<ILocation>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    events?: GraphCacheResolver<
      WithTypename<ILocation>,
      ILocationEventsArgs,
      Array<WithTypename<IEvent> | string>
    >;
    existingEventsSize?: GraphCacheResolver<
      WithTypename<ILocation>,
      ILocationExistingEventsSizeArgs,
      Scalars['Int']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ILocation>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<ILocation>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    region?: GraphCacheResolver<
      WithTypename<ILocation>,
      Record<string, never>,
      IRegionEnum | string
    >;
    streetAddress?: GraphCacheResolver<
      WithTypename<ILocation>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    zipCode?: GraphCacheResolver<
      WithTypename<ILocation>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  LogBlueprintActionMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ILogBlueprintActionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ILogBlueprintActionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    success?: GraphCacheResolver<
      WithTypename<ILogBlueprintActionMutationPayload>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  Membership?: {
    createdAt?: GraphCacheResolver<
      WithTypename<IMembership>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    endsAt?: GraphCacheResolver<
      WithTypename<IMembership>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    grantingBranch?: GraphCacheResolver<
      WithTypename<IMembership>,
      Record<string, never>,
      WithTypename<IBranch> | string
    >;
    grantor?: GraphCacheResolver<
      WithTypename<IMembership>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IMembership>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    organization?: GraphCacheResolver<
      WithTypename<IMembership>,
      Record<string, never>,
      WithTypename<IOrganization> | string
    >;
    startsAt?: GraphCacheResolver<
      WithTypename<IMembership>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<IMembership>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  Mod?: {
    activeModRewardTemplate?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      WithTypename<IModRewardTemplate> | string
    >;
    constraint?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      Scalars['JSON']['output'] | string
    >;
    currentAsset?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      WithTypename<IModAsset> | string
    >;
    currentEntity?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      WithTypename<IModEntity> | string
    >;
    currentModNarrativeRolePlay?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      WithTypename<IModNarrativeRolePlay> | string
    >;
    currentTurn?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    description?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    itemTransactions?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      Array<WithTypename<IItemTransaction> | string>
    >;
    modAssets?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      Array<WithTypename<IModAsset> | string>
    >;
    modChallenge?: GraphCacheResolver<
      WithTypename<IMod>,
      IModModChallengeArgs,
      WithTypename<IModChallenge> | string
    >;
    modEntities?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      Array<WithTypename<IModEntity> | string>
    >;
    modLogs?: GraphCacheResolver<
      WithTypename<IMod>,
      IModModLogsArgs,
      Array<WithTypename<IModLog> | string>
    >;
    modNarrativeRolePlays?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      Array<WithTypename<IModNarrativeRolePlay> | string>
    >;
    modRewardTemplate?: GraphCacheResolver<
      WithTypename<IMod>,
      IModModRewardTemplateArgs,
      WithTypename<IModRewardTemplate> | string
    >;
    modRewardTemplates?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      Array<WithTypename<IModRewardTemplate> | string>
    >;
    modRunner?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      WithTypename<IEventAttendee> | string
    >;
    modSection?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      WithTypename<IModSection> | string
    >;
    modSignup?: GraphCacheResolver<
      WithTypename<IMod>,
      IModModSignupArgs,
      WithTypename<IModSignup> | string
    >;
    modSignups?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      Array<WithTypename<IModSignup> | string>
    >;
    myEntity?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      WithTypename<IModEntity> | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    participationLimit?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    ping?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      WithTypename<ICoord> | string
    >;
    timeframe?: GraphCacheResolver<
      WithTypename<IMod>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  ModAsset?: {
    id?: GraphCacheResolver<
      WithTypename<IModAsset>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IModAsset>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    url?: GraphCacheResolver<
      WithTypename<IModAsset>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  ModBids?: {
    body?: GraphCacheResolver<
      WithTypename<IModBids>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    limbs?: GraphCacheResolver<
      WithTypename<IModBids>,
      Record<string, never>,
      Array<IModLimbEnum | string>
    >;
    mind?: GraphCacheResolver<
      WithTypename<IModBids>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    resolve?: GraphCacheResolver<
      WithTypename<IModBids>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    skills?: GraphCacheResolver<
      WithTypename<IModBids>,
      Record<string, never>,
      Array<WithTypename<IModBidsSkill> | string>
    >;
  };
  ModBidsSkill?: {
    id?: GraphCacheResolver<
      WithTypename<IModBidsSkill>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    value?: GraphCacheResolver<
      WithTypename<IModBidsSkill>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  ModChallenge?: {
    defenseRollMatrix?: GraphCacheResolver<
      WithTypename<IModChallenge>,
      Record<string, never>,
      Array<WithTypename<IDefenseRoll> | string>
    >;
    id?: GraphCacheResolver<
      WithTypename<IModChallenge>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    initiative?: GraphCacheResolver<
      WithTypename<IModChallenge>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<IModChallenge>,
      Record<string, never>,
      IModChallengeKindEnum | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IModChallenge>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    position?: GraphCacheResolver<
      WithTypename<IModChallenge>,
      Record<string, never>,
      WithTypename<ICoord> | string
    >;
    publicNote?: GraphCacheResolver<
      WithTypename<IModChallenge>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    stack?: GraphCacheResolver<
      WithTypename<IModChallenge>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    state?: GraphCacheResolver<
      WithTypename<IModChallenge>,
      Record<string, never>,
      WithTypename<IModParticipantGenericState> | string
    >;
    storytellerNote?: GraphCacheResolver<
      WithTypename<IModChallenge>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    visibility?: GraphCacheResolver<
      WithTypename<IModChallenge>,
      Record<string, never>,
      IModChallengeVisibilityEnum | string
    >;
  };
  ModChallengeResolutionOption?: {
    level?: GraphCacheResolver<
      WithTypename<IModChallengeResolutionOption>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    skillId?: GraphCacheResolver<
      WithTypename<IModChallengeResolutionOption>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  ModChallengeState?: {
    professionOptions?: GraphCacheResolver<
      WithTypename<IModChallengeState>,
      Record<string, never>,
      Array<WithTypename<IModChallengeResolutionOption> | string>
    >;
    resolutionOptions?: GraphCacheResolver<
      WithTypename<IModChallengeState>,
      Record<string, never>,
      Array<WithTypename<IModChallengeResolutionOption> | string>
    >;
    stack?: GraphCacheResolver<
      WithTypename<IModChallengeState>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    statusEffects?: GraphCacheResolver<
      WithTypename<IModChallengeState>,
      Record<string, never>,
      Array<WithTypename<IModParticipantStatusEffect> | string>
    >;
  };
  ModLog?: {
    content?: GraphCacheResolver<
      WithTypename<IModLog>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<IModLog>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    damageAmount?: GraphCacheResolver<
      WithTypename<IModLog>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    damageType?: GraphCacheResolver<
      WithTypename<IModLog>,
      Record<string, never>,
      IModDamageTypeEnum | string
    >;
    diceRollLog?: GraphCacheResolver<
      WithTypename<IModLog>,
      Record<string, never>,
      WithTypename<IDiceRollSummary> | string
    >;
    entity?: GraphCacheResolver<
      WithTypename<IModLog>,
      Record<string, never>,
      WithTypename<IModEntity> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IModLog>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    initiative?: GraphCacheResolver<
      WithTypename<IModLog>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    interferer?: GraphCacheResolver<
      WithTypename<IModLog>,
      Record<string, never>,
      WithTypename<IModEntity> | string
    >;
    originalLog?: GraphCacheResolver<
      WithTypename<IModLog>,
      Record<string, never>,
      WithTypename<IModLog> | string
    >;
    systemMessage?: GraphCacheResolver<
      WithTypename<IModLog>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    target?: GraphCacheResolver<
      WithTypename<IModLog>,
      Record<string, never>,
      WithTypename<IModEntity> | string
    >;
    turn?: GraphCacheResolver<
      WithTypename<IModLog>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<IModLog>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  ModNarrativeRolePlay?: {
    body?: GraphCacheResolver<
      WithTypename<IModNarrativeRolePlay>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    description?: GraphCacheResolver<
      WithTypename<IModNarrativeRolePlay>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IModNarrativeRolePlay>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    limbs?: GraphCacheResolver<
      WithTypename<IModNarrativeRolePlay>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    mind?: GraphCacheResolver<
      WithTypename<IModNarrativeRolePlay>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    modNarrativeRolePlayBids?: GraphCacheResolver<
      WithTypename<IModNarrativeRolePlay>,
      Record<string, never>,
      Array<WithTypename<IModNarrativeRolePlayBid> | string>
    >;
    resolve?: GraphCacheResolver<
      WithTypename<IModNarrativeRolePlay>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    skills?: GraphCacheResolver<
      WithTypename<IModNarrativeRolePlay>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<IModNarrativeRolePlay>,
      Record<string, never>,
      IModNarrativeRolePlayStatusEnum | string
    >;
    title?: GraphCacheResolver<
      WithTypename<IModNarrativeRolePlay>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  ModNarrativeRolePlayBid?: {
    bids?: GraphCacheResolver<
      WithTypename<IModNarrativeRolePlayBid>,
      Record<string, never>,
      WithTypename<IModBids> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IModNarrativeRolePlayBid>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    modSignup?: GraphCacheResolver<
      WithTypename<IModNarrativeRolePlayBid>,
      Record<string, never>,
      WithTypename<IModSignup> | string
    >;
    status?: GraphCacheResolver<
      WithTypename<IModNarrativeRolePlayBid>,
      Record<string, never>,
      IModNarrativeRolePlayBidStatusEnum | string
    >;
  };
  ModParticipantEquipment?: {
    id?: GraphCacheResolver<
      WithTypename<IModParticipantEquipment>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<IModParticipantEquipment>,
      Record<string, never>,
      IItemKindEnum | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IModParticipantEquipment>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    shotCount?: GraphCacheResolver<
      WithTypename<IModParticipantEquipment>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    tracksShot?: GraphCacheResolver<
      WithTypename<IModParticipantEquipment>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  ModParticipantLimb?: {
    equipment?: GraphCacheResolver<
      WithTypename<IModParticipantLimb>,
      Record<string, never>,
      WithTypename<IModParticipantEquipment> | string
    >;
    limbName?: GraphCacheResolver<
      WithTypename<IModParticipantLimb>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    status?: GraphCacheResolver<
      WithTypename<IModParticipantLimb>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  ModParticipantMaskedState?: {
    armor?: GraphCacheResolver<
      WithTypename<IModParticipantMaskedState>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    health?: GraphCacheResolver<
      WithTypename<IModParticipantMaskedState>,
      Record<string, never>,
      IMaskedHealthEnum | string
    >;
    limbs?: GraphCacheResolver<
      WithTypename<IModParticipantMaskedState>,
      Record<string, never>,
      Array<WithTypename<IModParticipantLimb> | string>
    >;
    statusEffects?: GraphCacheResolver<
      WithTypename<IModParticipantMaskedState>,
      Record<string, never>,
      Array<WithTypename<IModParticipantStatusEffect> | string>
    >;
  };
  ModParticipantSkillUse?: {
    id?: GraphCacheResolver<
      WithTypename<IModParticipantSkillUse>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    level?: GraphCacheResolver<
      WithTypename<IModParticipantSkillUse>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    remainingUses?: GraphCacheResolver<
      WithTypename<IModParticipantSkillUse>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  ModParticipantState?: {
    armor?: GraphCacheResolver<
      WithTypename<IModParticipantState>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    body?: GraphCacheResolver<
      WithTypename<IModParticipantState>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    limbs?: GraphCacheResolver<
      WithTypename<IModParticipantState>,
      Record<string, never>,
      Array<WithTypename<IModParticipantLimb> | string>
    >;
    maxBody?: GraphCacheResolver<
      WithTypename<IModParticipantState>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    maxMind?: GraphCacheResolver<
      WithTypename<IModParticipantState>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    maxResolve?: GraphCacheResolver<
      WithTypename<IModParticipantState>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    mind?: GraphCacheResolver<
      WithTypename<IModParticipantState>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    resolve?: GraphCacheResolver<
      WithTypename<IModParticipantState>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    skillUses?: GraphCacheResolver<
      WithTypename<IModParticipantState>,
      Record<string, never>,
      Array<WithTypename<IModParticipantSkillUse> | string>
    >;
    statusEffects?: GraphCacheResolver<
      WithTypename<IModParticipantState>,
      Record<string, never>,
      Array<WithTypename<IModParticipantStatusEffect> | string>
    >;
  };
  ModParticipantStatusEffect?: {
    appliedAtInitiative?: GraphCacheResolver<
      WithTypename<IModParticipantStatusEffect>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    appliedAtTurn?: GraphCacheResolver<
      WithTypename<IModParticipantStatusEffect>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    appliedByEntityId?: GraphCacheResolver<
      WithTypename<IModParticipantStatusEffect>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    appliedByEntityName?: GraphCacheResolver<
      WithTypename<IModParticipantStatusEffect>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    appliedByEntityType?: GraphCacheResolver<
      WithTypename<IModParticipantStatusEffect>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    entities?: GraphCacheResolver<
      WithTypename<IModParticipantStatusEffect>,
      Record<string, never>,
      Array<WithTypename<IModParticipantStatusEffectEntity> | string>
    >;
    expiresAtInitiative?: GraphCacheResolver<
      WithTypename<IModParticipantStatusEffect>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    expiresAtTurn?: GraphCacheResolver<
      WithTypename<IModParticipantStatusEffect>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IModParticipantStatusEffect>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    skillId?: GraphCacheResolver<
      WithTypename<IModParticipantStatusEffect>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    subtarget?: GraphCacheResolver<
      WithTypename<IModParticipantStatusEffect>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    value?: GraphCacheResolver<
      WithTypename<IModParticipantStatusEffect>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  ModParticipantStatusEffectEntity?: {
    id?: GraphCacheResolver<
      WithTypename<IModParticipantStatusEffectEntity>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IModParticipantStatusEffectEntity>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    type?: GraphCacheResolver<
      WithTypename<IModParticipantStatusEffectEntity>,
      Record<string, never>,
      IModEntityTypeEnum | string
    >;
  };
  ModReward?: {
    id?: GraphCacheResolver<
      WithTypename<IModReward>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    item?: GraphCacheResolver<
      WithTypename<IModReward>,
      Record<string, never>,
      WithTypename<IItem> | string
    >;
    modRewardClaims?: GraphCacheResolver<
      WithTypename<IModReward>,
      Record<string, never>,
      Array<WithTypename<IModRewardClaim> | string>
    >;
    stack?: GraphCacheResolver<
      WithTypename<IModReward>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  ModRewardClaim?: {
    id?: GraphCacheResolver<
      WithTypename<IModRewardClaim>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    modSignup?: GraphCacheResolver<
      WithTypename<IModRewardClaim>,
      Record<string, never>,
      WithTypename<IModSignup> | string
    >;
    stack?: GraphCacheResolver<
      WithTypename<IModRewardClaim>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  ModRewardTemplate?: {
    description?: GraphCacheResolver<
      WithTypename<IModRewardTemplate>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    finalized?: GraphCacheResolver<
      WithTypename<IModRewardTemplate>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    finalizedAt?: GraphCacheResolver<
      WithTypename<IModRewardTemplate>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IModRewardTemplate>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    modRewards?: GraphCacheResolver<
      WithTypename<IModRewardTemplate>,
      Record<string, never>,
      Array<WithTypename<IModReward> | string>
    >;
    modRunnerNote?: GraphCacheResolver<
      WithTypename<IModRewardTemplate>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IModRewardTemplate>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  ModSection?: {
    id?: GraphCacheResolver<
      WithTypename<IModSection>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    mods?: GraphCacheResolver<
      WithTypename<IModSection>,
      Record<string, never>,
      Array<WithTypename<IMod> | string>
    >;
    name?: GraphCacheResolver<
      WithTypename<IModSection>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    signupLimit?: GraphCacheResolver<
      WithTypename<IModSection>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  ModSignup?: {
    character?: GraphCacheResolver<
      WithTypename<IModSignup>,
      Record<string, never>,
      WithTypename<ICharacter> | string
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<IModSignup>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    defenseRollMatrix?: GraphCacheResolver<
      WithTypename<IModSignup>,
      Record<string, never>,
      Array<WithTypename<IDefenseRoll> | string>
    >;
    eventAttendee?: GraphCacheResolver<
      WithTypename<IModSignup>,
      Record<string, never>,
      WithTypename<IEventAttendee> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IModSignup>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    initiative?: GraphCacheResolver<
      WithTypename<IModSignup>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IModSignup>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    ping?: GraphCacheResolver<
      WithTypename<IModSignup>,
      Record<string, never>,
      WithTypename<ICoord> | string
    >;
    position?: GraphCacheResolver<
      WithTypename<IModSignup>,
      Record<string, never>,
      WithTypename<ICoord> | string
    >;
    state?: GraphCacheResolver<
      WithTypename<IModSignup>,
      Record<string, never>,
      WithTypename<IModParticipantGenericState> | string
    >;
    user?: GraphCacheResolver<
      WithTypename<IModSignup>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
    visibility?: GraphCacheResolver<
      WithTypename<IModSignup>,
      Record<string, never>,
      IModChallengeVisibilityEnum | string
    >;
  };
  MoveMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IMoveMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IMoveMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IMoveMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  Organization?: {
    armorUpgradeComponents?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      Array<WithTypename<ICraftingComponent> | string>
    >;
    attendances?: GraphCacheResolver<
      WithTypename<IOrganization>,
      IOrganizationAttendancesArgs,
      Array<WithTypename<ICachedUserAttendance> | string>
    >;
    blueprintCopyProcedure?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      WithTypename<IItem> | string
    >;
    branch?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      WithTypename<IBranch> | string
    >;
    branches?: GraphCacheResolver<
      WithTypename<IOrganization>,
      IOrganizationBranchesArgs,
      Array<WithTypename<IBranch> | string>
    >;
    characters?: GraphCacheResolver<
      WithTypename<IOrganization>,
      IOrganizationCharactersArgs,
      Array<WithTypename<ICharacter> | string>
    >;
    configs?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      WithTypename<IOrganizationConfig> | string
    >;
    contracts?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      Array<WithTypename<IContract> | string>
    >;
    fellowship?: GraphCacheResolver<
      WithTypename<IOrganization>,
      IOrganizationFellowshipArgs,
      WithTypename<IFellowship> | string
    >;
    fellowships?: GraphCacheResolver<
      WithTypename<IOrganization>,
      IOrganizationFellowshipsArgs,
      Array<WithTypename<IFellowship> | string>
    >;
    id?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    item?: GraphCacheResolver<
      WithTypename<IOrganization>,
      IOrganizationItemArgs,
      WithTypename<IItem> | string
    >;
    itemGrades?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      Array<IItemGradeEnum | string>
    >;
    itemKinds?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      Array<IItemKindEnum | string>
    >;
    items?: GraphCacheResolver<
      WithTypename<IOrganization>,
      IOrganizationItemsArgs,
      Array<WithTypename<IItem> | string>
    >;
    lastEventAttendanceSnapshotOn?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    lastEventDiffOn?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    memberships?: GraphCacheResolver<
      WithTypename<IOrganization>,
      IOrganizationMembershipsArgs,
      Array<WithTypename<IMembership> | string>
    >;
    name?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    rebirthedCharacters?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      Array<WithTypename<ICharacter> | string>
    >;
    role?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      IOrganizationRoleEnum | string
    >;
    ruleTags?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      Array<WithTypename<IRuleTag> | string>
    >;
    shorthand?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    slug?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    specialDates?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      Array<WithTypename<ISpecialDate> | string>
    >;
    statistics?: GraphCacheResolver<
      WithTypename<IOrganization>,
      IOrganizationStatisticsArgs,
      WithTypename<IStatisticsResult> | string
    >;
    threats?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      Array<WithTypename<IThreat> | string>
    >;
    timelines?: GraphCacheResolver<
      WithTypename<IOrganization>,
      Record<string, never>,
      Array<WithTypename<ITimeline> | string>
    >;
    userGrowths?: GraphCacheResolver<
      WithTypename<IOrganization>,
      IOrganizationUserGrowthsArgs,
      Array<WithTypename<IUserGrowth> | string>
    >;
  };
  OrganizationConfig?: {
    charactersActiveCountMax?: GraphCacheResolver<
      WithTypename<IOrganizationConfig>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    charactersCountMax?: GraphCacheResolver<
      WithTypename<IOrganizationConfig>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    charactersCountStaffMax?: GraphCacheResolver<
      WithTypename<IOrganizationConfig>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IOrganizationConfig>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  PerformKillingBlowMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IPerformKillingBlowMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IPerformKillingBlowMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IPerformKillingBlowMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  Permission?: {
    entity?: GraphCacheResolver<
      WithTypename<IPermission>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
    permitted?: GraphCacheResolver<
      WithTypename<IPermission>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  ReattemptActionMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IReattemptActionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IReattemptActionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IReattemptActionMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  RegisteredItem?: {
    description?: GraphCacheResolver<
      WithTypename<IRegisteredItem>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IRegisteredItem>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  ReloadMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IReloadMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IReloadMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IReloadMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  RemoveItemTransactionMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IRemoveItemTransactionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IRemoveItemTransactionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    event?: GraphCacheResolver<
      WithTypename<IRemoveItemTransactionMutationPayload>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
  };
  RequestPasswordResetMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IRequestPasswordResetMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IRequestPasswordResetMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  ResetPasswordMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IResetPasswordMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IResetPasswordMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    token?: GraphCacheResolver<
      WithTypename<IResetPasswordMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<IResetPasswordMutationPayload>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  ResidenciesStatistics?: {
    branchIds?: GraphCacheResolver<
      WithTypename<IResidenciesStatistics>,
      Record<string, never>,
      Array<Scalars['Int']['output'] | string>
    >;
    eventId?: GraphCacheResolver<
      WithTypename<IResidenciesStatistics>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    modId?: GraphCacheResolver<
      WithTypename<IResidenciesStatistics>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    type?: GraphCacheResolver<
      WithTypename<IResidenciesStatistics>,
      Record<string, never>,
      IStatisticsTypeEnum | string
    >;
    values?: GraphCacheResolver<
      WithTypename<IResidenciesStatistics>,
      Record<string, never>,
      Array<WithTypename<IResidencyStatistics> | string>
    >;
  };
  ResidencyStatistics?: {
    count?: GraphCacheResolver<
      WithTypename<IResidencyStatistics>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IResidencyStatistics>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IResidencyStatistics>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    shorthand?: GraphCacheResolver<
      WithTypename<IResidencyStatistics>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  RetireCharacterMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IRetireCharacterMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IRetireCharacterMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<IRetireCharacterMutationPayload>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  RetirementPaths?: {
    alive?: GraphCacheResolver<
      WithTypename<IRetirementPaths>,
      Record<string, never>,
      Array<WithTypename<IRetirementXp> | string>
    >;
    dead?: GraphCacheResolver<
      WithTypename<IRetirementPaths>,
      Record<string, never>,
      Array<WithTypename<IRetirementXp> | string>
    >;
  };
  RetirementXp?: {
    amount?: GraphCacheResolver<
      WithTypename<IRetirementXp>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    earnedOn?: GraphCacheResolver<
      WithTypename<IRetirementXp>,
      Record<string, never>,
      Scalars['ISO8601Date']['output'] | string
    >;
  };
  RevenueAggregates?: {
    attendeesPaid?: GraphCacheResolver<
      WithTypename<IRevenueAggregates>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    attendeesTotal?: GraphCacheResolver<
      WithTypename<IRevenueAggregates>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    revenue?: GraphCacheResolver<
      WithTypename<IRevenueAggregates>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    revenueDiscounted?: GraphCacheResolver<
      WithTypename<IRevenueAggregates>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    revenueLiable?: GraphCacheResolver<
      WithTypename<IRevenueAggregates>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
  };
  RollAttackMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IRollAttackMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IRollAttackMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IRollAttackMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  RollDevelopmentSkillMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IRollDevelopmentSkillMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IRollDevelopmentSkillMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IRollDevelopmentSkillMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  RollDiceMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IRollDiceMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    diceRollSummary?: GraphCacheResolver<
      WithTypename<IRollDiceMutationPayload>,
      Record<string, never>,
      WithTypename<IDiceRollSummary> | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IRollDiceMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  RollImpactSkillMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IRollImpactSkillMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IRollImpactSkillMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IRollImpactSkillMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  RollInitiativeMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IRollInitiativeMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IRollInitiativeMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IRollInitiativeMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  RuleTag?: {
    fellowshipRuleTags?: GraphCacheResolver<
      WithTypename<IRuleTag>,
      Record<string, never>,
      Array<WithTypename<IFellowshipRuleTag> | string>
    >;
    id?: GraphCacheResolver<
      WithTypename<IRuleTag>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IRuleTag>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    value?: GraphCacheResolver<
      WithTypename<IRuleTag>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  Shift?: {
    adjustableExpansionStrategy?: GraphCacheResolver<
      WithTypename<IShift>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    attendeeShifts?: GraphCacheResolver<
      WithTypename<IShift>,
      Record<string, never>,
      Array<WithTypename<IAttendeeShift> | string>
    >;
    autoExpand?: GraphCacheResolver<
      WithTypename<IShift>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    baseRatio?: GraphCacheResolver<
      WithTypename<IShift>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    eventId?: GraphCacheResolver<
      WithTypename<IShift>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IShift>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    identifier?: GraphCacheResolver<
      WithTypename<IShift>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    isEnabled?: GraphCacheResolver<
      WithTypename<IShift>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    isFullyBooked?: GraphCacheResolver<
      WithTypename<IShift>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<IShift>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    label?: GraphCacheResolver<
      WithTypename<IShift>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    limit?: GraphCacheResolver<
      WithTypename<IShift>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    playersCount?: GraphCacheResolver<
      WithTypename<IShift>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  SkillCategoriesStatistics?: {
    branchIds?: GraphCacheResolver<
      WithTypename<ISkillCategoriesStatistics>,
      Record<string, never>,
      Array<Scalars['Int']['output'] | string>
    >;
    eventId?: GraphCacheResolver<
      WithTypename<ISkillCategoriesStatistics>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    modId?: GraphCacheResolver<
      WithTypename<ISkillCategoriesStatistics>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    type?: GraphCacheResolver<
      WithTypename<ISkillCategoriesStatistics>,
      Record<string, never>,
      IStatisticsTypeEnum | string
    >;
    values?: GraphCacheResolver<
      WithTypename<ISkillCategoriesStatistics>,
      Record<string, never>,
      Array<WithTypename<ISkillCategoryStatistics> | string>
    >;
  };
  SkillCategoryStatistics?: {
    aberrants?: GraphCacheResolver<
      WithTypename<ISkillCategoryStatistics>,
      Record<string, never>,
      Array<WithTypename<ICharacter> | string>
    >;
    criminals?: GraphCacheResolver<
      WithTypename<ISkillCategoryStatistics>,
      Record<string, never>,
      Array<WithTypename<ICharacter> | string>
    >;
    total?: GraphCacheResolver<
      WithTypename<ISkillCategoryStatistics>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  SkillStatistics?: {
    count?: GraphCacheResolver<
      WithTypename<ISkillStatistics>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ISkillStatistics>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    level?: GraphCacheResolver<
      WithTypename<ISkillStatistics>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  SkillsStatistics?: {
    branchIds?: GraphCacheResolver<
      WithTypename<ISkillsStatistics>,
      Record<string, never>,
      Array<Scalars['Int']['output'] | string>
    >;
    eventId?: GraphCacheResolver<
      WithTypename<ISkillsStatistics>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    modId?: GraphCacheResolver<
      WithTypename<ISkillsStatistics>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    type?: GraphCacheResolver<
      WithTypename<ISkillsStatistics>,
      Record<string, never>,
      IStatisticsTypeEnum | string
    >;
    values?: GraphCacheResolver<
      WithTypename<ISkillsStatistics>,
      Record<string, never>,
      Array<WithTypename<ISkillStatistics> | string>
    >;
  };
  SpecialDate?: {
    endsAt?: GraphCacheResolver<
      WithTypename<ISpecialDate>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ISpecialDate>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<ISpecialDate>,
      Record<string, never>,
      ISpecialDateKindEnum | string
    >;
    startsAt?: GraphCacheResolver<
      WithTypename<ISpecialDate>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    title?: GraphCacheResolver<
      WithTypename<ISpecialDate>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  StatStatistics?: {
    body?: GraphCacheResolver<
      WithTypename<IStatStatistics>,
      Record<string, never>,
      Array<Array<Scalars['Int']['output'] | string>>
    >;
    buildEarned?: GraphCacheResolver<
      WithTypename<IStatStatistics>,
      Record<string, never>,
      Array<Array<Scalars['Int']['output'] | string>>
    >;
    buildUsed?: GraphCacheResolver<
      WithTypename<IStatStatistics>,
      Record<string, never>,
      Array<Array<Scalars['Int']['output'] | string>>
    >;
    currentLife?: GraphCacheResolver<
      WithTypename<IStatStatistics>,
      Record<string, never>,
      Array<Array<Scalars['Int']['output'] | string>>
    >;
    faithId?: GraphCacheResolver<
      WithTypename<IStatStatistics>,
      Record<string, never>,
      Array<Array<Scalars['Int']['output'] | string>>
    >;
    mind?: GraphCacheResolver<
      WithTypename<IStatStatistics>,
      Record<string, never>,
      Array<Array<Scalars['Int']['output'] | string>>
    >;
    resolve?: GraphCacheResolver<
      WithTypename<IStatStatistics>,
      Record<string, never>,
      Array<Array<Scalars['Int']['output'] | string>>
    >;
    strainId?: GraphCacheResolver<
      WithTypename<IStatStatistics>,
      Record<string, never>,
      Array<Array<Scalars['Int']['output'] | string>>
    >;
  };
  StatsStatistics?: {
    branchIds?: GraphCacheResolver<
      WithTypename<IStatsStatistics>,
      Record<string, never>,
      Array<Scalars['Int']['output'] | string>
    >;
    eventId?: GraphCacheResolver<
      WithTypename<IStatsStatistics>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    modId?: GraphCacheResolver<
      WithTypename<IStatsStatistics>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    type?: GraphCacheResolver<
      WithTypename<IStatsStatistics>,
      Record<string, never>,
      IStatisticsTypeEnum | string
    >;
    values?: GraphCacheResolver<
      WithTypename<IStatsStatistics>,
      Record<string, never>,
      Array<WithTypename<IStatStatistics> | string>
    >;
  };
  SubmitNarrativeRolePlayBidsMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ISubmitNarrativeRolePlayBidsMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ISubmitNarrativeRolePlayBidsMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<ISubmitNarrativeRolePlayBidsMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
    modNarrativeRolePlayBid?: GraphCacheResolver<
      WithTypename<ISubmitNarrativeRolePlayBidsMutationPayload>,
      Record<string, never>,
      WithTypename<IModNarrativeRolePlayBid> | string
    >;
  };
  TalliedActionLog?: {
    id?: GraphCacheResolver<
      WithTypename<ITalliedActionLog>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    log?: GraphCacheResolver<
      WithTypename<ITalliedActionLog>,
      Record<string, never>,
      WithTypename<IActionLog> | string
    >;
    tally?: GraphCacheResolver<
      WithTypename<ITalliedActionLog>,
      Record<string, never>,
      WithTypename<IActionLogTally> | string
    >;
    valid?: GraphCacheResolver<
      WithTypename<ITalliedActionLog>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  TemporaryManager?: {
    event?: GraphCacheResolver<
      WithTypename<ITemporaryManager>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ITemporaryManager>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<ITemporaryManager>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  TemporaryToken?: {
    browser?: GraphCacheResolver<
      WithTypename<ITemporaryToken>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    expiresAt?: GraphCacheResolver<
      WithTypename<ITemporaryToken>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    hardware?: GraphCacheResolver<
      WithTypename<ITemporaryToken>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ITemporaryToken>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    ipAddress?: GraphCacheResolver<
      WithTypename<ITemporaryToken>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    os?: GraphCacheResolver<
      WithTypename<ITemporaryToken>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    token?: GraphCacheResolver<
      WithTypename<ITemporaryToken>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  Threat?: {
    body?: GraphCacheResolver<
      WithTypename<IThreat>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IThreat>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<IThreat>,
      Record<string, never>,
      IThreatKindEnum | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IThreat>,
      Record<string, never>,
      IThreatNameEnum | string
    >;
    rank?: GraphCacheResolver<
      WithTypename<IThreat>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    skillUses?: GraphCacheResolver<
      WithTypename<IThreat>,
      Record<string, never>,
      Array<WithTypename<IModParticipantSkillUse> | string>
    >;
    statusEffects?: GraphCacheResolver<
      WithTypename<IThreat>,
      Record<string, never>,
      Array<WithTypename<IModParticipantStatusEffect> | string>
    >;
    variant?: GraphCacheResolver<
      WithTypename<IThreat>,
      Record<string, never>,
      IThreatVariantEnum | string
    >;
  };
  Ticket?: {
    cost?: GraphCacheResolver<
      WithTypename<ITicket>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    discountType?: GraphCacheResolver<
      WithTypename<ITicket>,
      Record<string, never>,
      ITicketDiscountEnum | string
    >;
    econRestriction?: GraphCacheResolver<
      WithTypename<ITicket>,
      Record<string, never>,
      ITicketEconRestrictionEnum | string
    >;
    eventAttendeesCount?: GraphCacheResolver<
      WithTypename<ITicket>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    eventId?: GraphCacheResolver<
      WithTypename<ITicket>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    extraXpCost?: GraphCacheResolver<
      WithTypename<ITicket>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    fixedLimit?: GraphCacheResolver<
      WithTypename<ITicket>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    fullyBooked?: GraphCacheResolver<
      WithTypename<ITicket>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ITicket>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    identifier?: GraphCacheResolver<
      WithTypename<ITicket>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    label?: GraphCacheResolver<
      WithTypename<ITicket>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    limit?: GraphCacheResolver<
      WithTypename<ITicket>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    modMaxSignup?: GraphCacheResolver<
      WithTypename<ITicket>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    passType?: GraphCacheResolver<
      WithTypename<ITicket>,
      Record<string, never>,
      ITicketPassEnum | string
    >;
    restrictionType?: GraphCacheResolver<
      WithTypename<ITicket>,
      Record<string, never>,
      ITicketRestrictionEnum | string
    >;
    shiftResponsibilities?: GraphCacheResolver<
      WithTypename<ITicket>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
  TicketInvoice?: {
    discountType?: GraphCacheResolver<
      WithTypename<ITicketInvoice>,
      Record<string, never>,
      ITicketDiscountEnum | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ITicketInvoice>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    label?: GraphCacheResolver<
      WithTypename<ITicketInvoice>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  TicketRevenue?: {
    attendeesPaid?: GraphCacheResolver<
      WithTypename<ITicketRevenue>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    attendeesTotal?: GraphCacheResolver<
      WithTypename<ITicketRevenue>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    cost?: GraphCacheResolver<
      WithTypename<ITicketRevenue>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    discountType?: GraphCacheResolver<
      WithTypename<ITicketRevenue>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ITicketRevenue>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    label?: GraphCacheResolver<
      WithTypename<ITicketRevenue>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    revenue?: GraphCacheResolver<
      WithTypename<ITicketRevenue>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    revenueDiscounted?: GraphCacheResolver<
      WithTypename<ITicketRevenue>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    revenueLiable?: GraphCacheResolver<
      WithTypename<ITicketRevenue>,
      Record<string, never>,
      Scalars['Float']['output'] | string
    >;
    subitems?: GraphCacheResolver<
      WithTypename<ITicketRevenue>,
      Record<string, never>,
      Array<WithTypename<ITicketRevenue> | string>
    >;
  };
  TicketsBaseConfig?: {
    discountTypes?: GraphCacheResolver<
      WithTypename<ITicketsBaseConfig>,
      Record<string, never>,
      Array<ITicketDiscountEnum | string>
    >;
    passTypes?: GraphCacheResolver<
      WithTypename<ITicketsBaseConfig>,
      Record<string, never>,
      Array<ITicketPassEnum | string>
    >;
    restrictionTypes?: GraphCacheResolver<
      WithTypename<ITicketsBaseConfig>,
      Record<string, never>,
      Array<ITicketRestrictionEnum | string>
    >;
  };
  Timeline?: {
    attendance?: GraphCacheResolver<
      WithTypename<ITimeline>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    eventId?: GraphCacheResolver<
      WithTypename<ITimeline>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    eventName?: GraphCacheResolver<
      WithTypename<ITimeline>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<ITimeline>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    local?: GraphCacheResolver<
      WithTypename<ITimeline>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
    shorthand?: GraphCacheResolver<
      WithTypename<ITimeline>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    timecode?: GraphCacheResolver<
      WithTypename<ITimeline>,
      Record<string, never>,
      Scalars['ISO8601Date']['output'] | string
    >;
    virtual?: GraphCacheResolver<
      WithTypename<ITimeline>,
      Record<string, never>,
      Scalars['Boolean']['output'] | string
    >;
  };
  TrackItemUseMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<ITrackItemUseMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<ITrackItemUseMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    itemTransaction?: GraphCacheResolver<
      WithTypename<ITrackItemUseMutationPayload>,
      Record<string, never>,
      WithTypename<IItemTransaction> | string
    >;
  };
  UpdateBranchMutationPayload?: {
    branch?: GraphCacheResolver<
      WithTypename<IUpdateBranchMutationPayload>,
      Record<string, never>,
      WithTypename<IBranch> | string
    >;
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateBranchMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateBranchMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UpdateCapMutationPayload?: {
    cap?: GraphCacheResolver<
      WithTypename<IUpdateCapMutationPayload>,
      Record<string, never>,
      WithTypename<ICap> | string
    >;
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateCapMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateCapMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UpdateCharacterActionLogMutationPayload?: {
    attendeeCharacter?: GraphCacheResolver<
      WithTypename<IUpdateCharacterActionLogMutationPayload>,
      Record<string, never>,
      WithTypename<IAttendeeCharacter> | string
    >;
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateCharacterActionLogMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateCharacterActionLogMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UpdateCharacterDataMutationPayload?: {
    character?: GraphCacheResolver<
      WithTypename<IUpdateCharacterDataMutationPayload>,
      Record<string, never>,
      WithTypename<ICharacter> | string
    >;
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateCharacterDataMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateCharacterDataMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UpdateCharacterFellowshipMutationPayload?: {
    characterFellowship?: GraphCacheResolver<
      WithTypename<IUpdateCharacterFellowshipMutationPayload>,
      Record<string, never>,
      WithTypename<ICharacterFellowship> | string
    >;
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateCharacterFellowshipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateCharacterFellowshipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UpdateCorrectiveActionMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateCorrectiveActionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    correctiveAction?: GraphCacheResolver<
      WithTypename<IUpdateCorrectiveActionMutationPayload>,
      Record<string, never>,
      WithTypename<ICorrectiveAction> | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateCorrectiveActionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UpdateEventAttendeeMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateEventAttendeeMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateEventAttendeeMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    eventAttendee?: GraphCacheResolver<
      WithTypename<IUpdateEventAttendeeMutationPayload>,
      Record<string, never>,
      WithTypename<IEventAttendee> | string
    >;
  };
  UpdateEventLifecycleMutationPayload?: {
    character?: GraphCacheResolver<
      WithTypename<IUpdateEventLifecycleMutationPayload>,
      Record<string, never>,
      WithTypename<ICharacter> | string
    >;
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateEventLifecycleMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateEventLifecycleMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UpdateEventMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateEventMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateEventMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    event?: GraphCacheResolver<
      WithTypename<IUpdateEventMutationPayload>,
      Record<string, never>,
      WithTypename<IEvent> | string
    >;
  };
  UpdateEventShiftMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateEventShiftMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateEventShiftMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    shift?: GraphCacheResolver<
      WithTypename<IUpdateEventShiftMutationPayload>,
      Record<string, never>,
      WithTypename<IShift> | string
    >;
  };
  UpdateEventTicketMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateEventTicketMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateEventTicketMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    ticket?: GraphCacheResolver<
      WithTypename<IUpdateEventTicketMutationPayload>,
      Record<string, never>,
      WithTypename<ITicket> | string
    >;
  };
  UpdateFellowshipMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateFellowshipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateFellowshipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    fellowship?: GraphCacheResolver<
      WithTypename<IUpdateFellowshipMutationPayload>,
      Record<string, never>,
      WithTypename<IFellowship> | string
    >;
  };
  UpdateItemCraftingComponentMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateItemCraftingComponentMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    craftingComponent?: GraphCacheResolver<
      WithTypename<IUpdateItemCraftingComponentMutationPayload>,
      Record<string, never>,
      WithTypename<ICraftingComponent> | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateItemCraftingComponentMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UpdateItemCraftingFinalProductMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateItemCraftingFinalProductMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    craftingFinalProduct?: GraphCacheResolver<
      WithTypename<IUpdateItemCraftingFinalProductMutationPayload>,
      Record<string, never>,
      WithTypename<ICraftingFinalProduct> | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateItemCraftingFinalProductMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UpdateItemCraftingMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateItemCraftingMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateItemCraftingMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    itemCrafting?: GraphCacheResolver<
      WithTypename<IUpdateItemCraftingMutationPayload>,
      Record<string, never>,
      WithTypename<IItemCrafting> | string
    >;
  };
  UpdateItemMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateItemMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateItemMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    item?: GraphCacheResolver<
      WithTypename<IUpdateItemMutationPayload>,
      Record<string, never>,
      WithTypename<IItem> | string
    >;
  };
  UpdateItemReproductionComponentMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateItemReproductionComponentMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateItemReproductionComponentMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    itemReproductionComponent?: GraphCacheResolver<
      WithTypename<IUpdateItemReproductionComponentMutationPayload>,
      Record<string, never>,
      WithTypename<IItemReproductionComponent> | string
    >;
  };
  UpdateItemReproductionMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateItemReproductionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateItemReproductionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    itemReproduction?: GraphCacheResolver<
      WithTypename<IUpdateItemReproductionMutationPayload>,
      Record<string, never>,
      WithTypename<IItemReproduction> | string
    >;
  };
  UpdateItemTransactionMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateItemTransactionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateItemTransactionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    itemTransaction?: GraphCacheResolver<
      WithTypename<IUpdateItemTransactionMutationPayload>,
      Record<string, never>,
      WithTypename<IItemTransaction> | string
    >;
  };
  UpdateLocationMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateLocationMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateLocationMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    location?: GraphCacheResolver<
      WithTypename<IUpdateLocationMutationPayload>,
      Record<string, never>,
      WithTypename<ILocation> | string
    >;
  };
  UpdateMembershipMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateMembershipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateMembershipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    membership?: GraphCacheResolver<
      WithTypename<IUpdateMembershipMutationPayload>,
      Record<string, never>,
      WithTypename<IMembership> | string
    >;
  };
  UpdateModAssetMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateModAssetMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateModAssetMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    modAsset?: GraphCacheResolver<
      WithTypename<IUpdateModAssetMutationPayload>,
      Record<string, never>,
      WithTypename<IModAsset> | string
    >;
  };
  UpdateModChallengeMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateModChallengeMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateModChallengeMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IUpdateModChallengeMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  UpdateModChallengeResolutionOptionMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateModChallengeResolutionOptionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateModChallengeResolutionOptionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IUpdateModChallengeResolutionOptionMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  UpdateModMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateModMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateModMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IUpdateModMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  UpdateModNarrativeRolePlayMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateModNarrativeRolePlayMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateModNarrativeRolePlayMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IUpdateModNarrativeRolePlayMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  UpdateModRewardMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateModRewardMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateModRewardMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    modReward?: GraphCacheResolver<
      WithTypename<IUpdateModRewardMutationPayload>,
      Record<string, never>,
      WithTypename<IModReward> | string
    >;
  };
  UpdateModRewardTemplateMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateModRewardTemplateMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateModRewardTemplateMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    modRewardTemplate?: GraphCacheResolver<
      WithTypename<IUpdateModRewardTemplateMutationPayload>,
      Record<string, never>,
      WithTypename<IModRewardTemplate> | string
    >;
  };
  UpdateModSectionMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateModSectionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateModSectionMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    modSection?: GraphCacheResolver<
      WithTypename<IUpdateModSectionMutationPayload>,
      Record<string, never>,
      WithTypename<IModSection> | string
    >;
  };
  UpdateModSignupMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateModSignupMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateModSignupMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IUpdateModSignupMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  UpdateOrganizationMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateOrganizationMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateOrganizationMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    organization?: GraphCacheResolver<
      WithTypename<IUpdateOrganizationMutationPayload>,
      Record<string, never>,
      WithTypename<IOrganization> | string
    >;
  };
  UpdatePasswordMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdatePasswordMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdatePasswordMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UpdatePlayerBranchOwnershipMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdatePlayerBranchOwnershipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdatePlayerBranchOwnershipMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<IUpdatePlayerBranchOwnershipMutationPayload>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  UpdatePlayerDataMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdatePlayerDataMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdatePlayerDataMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<IUpdatePlayerDataMutationPayload>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  UpdatePlayerOrganizationDataMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdatePlayerOrganizationDataMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdatePlayerOrganizationDataMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    user?: GraphCacheResolver<
      WithTypename<IUpdatePlayerOrganizationDataMutationPayload>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  UpdateSpecialDateMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUpdateSpecialDateMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUpdateSpecialDateMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    specialDate?: GraphCacheResolver<
      WithTypename<IUpdateSpecialDateMutationPayload>,
      Record<string, never>,
      WithTypename<ISpecialDate> | string
    >;
  };
  UseCoverMutationPayload?: {
    clientMutationId?: GraphCacheResolver<
      WithTypename<IUseCoverMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    error?: GraphCacheResolver<
      WithTypename<IUseCoverMutationPayload>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mod?: GraphCacheResolver<
      WithTypename<IUseCoverMutationPayload>,
      Record<string, never>,
      WithTypename<IMod> | string
    >;
  };
  User?: {
    assistantFlags?: GraphCacheResolver<
      WithTypename<IUser>,
      IUserAssistantFlagsArgs,
      Array<IAssistantFlagEnum | string>
    >;
    caps?: GraphCacheResolver<
      WithTypename<IUser>,
      IUserCapsArgs,
      Array<WithTypename<ICap> | string>
    >;
    character?: GraphCacheResolver<
      WithTypename<IUser>,
      IUserCharacterArgs,
      WithTypename<ICharacter> | string
    >;
    characters?: GraphCacheResolver<
      WithTypename<IUser>,
      IUserCharactersArgs,
      Array<WithTypename<ICharacter> | string>
    >;
    correctiveActions?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      Array<WithTypename<ICorrectiveAction> | string>
    >;
    createdAt?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    emailAddress?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    emailCorrespondence?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      IEmailCorrespondenceEnum | string
    >;
    eventAttendances?: GraphCacheResolver<
      WithTypename<IUser>,
      IUserEventAttendancesArgs,
      Array<WithTypename<IEventAttendee> | string>
    >;
    firstName?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    fullName?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    invitations?: GraphCacheResolver<
      WithTypename<IUser>,
      IUserInvitationsArgs,
      Array<WithTypename<IUserReferral> | string>
    >;
    lastMembership?: GraphCacheResolver<
      WithTypename<IUser>,
      IUserLastMembershipArgs,
      WithTypename<IMembership> | string
    >;
    lastName?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    mailingAddress?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    maxActiveCharactersCount?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    maxCharactersCount?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    membershipActiveDuringEvent?: GraphCacheResolver<
      WithTypename<IUser>,
      IUserMembershipActiveDuringEventArgs,
      Scalars['Boolean']['output'] | string
    >;
    memberships?: GraphCacheResolver<
      WithTypename<IUser>,
      IUserMembershipsArgs,
      Array<WithTypename<IMembership> | string>
    >;
    notes?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    organizations?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      Array<WithTypename<IOrganization> | string>
    >;
    ownedBranches?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      Array<WithTypename<IBranch> | string>
    >;
    preferredName?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    recentEventAttendances?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      Array<WithTypename<IEventAttendee> | string>
    >;
    referrals?: GraphCacheResolver<
      WithTypename<IUser>,
      IUserReferralsArgs,
      Array<WithTypename<IUserReferral> | string>
    >;
    roleInOrganization?: GraphCacheResolver<
      WithTypename<IUser>,
      IUserRoleInOrganizationArgs,
      IOrganizationRoleEnum | string
    >;
    temporaryTokens?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      Array<WithTypename<ITemporaryToken> | string>
    >;
    totalCapsForEvent?: GraphCacheResolver<
      WithTypename<IUser>,
      IUserTotalCapsForEventArgs,
      Scalars['Int']['output'] | string
    >;
    upcomingEvents?: GraphCacheResolver<
      WithTypename<IUser>,
      IUserUpcomingEventsArgs,
      Array<WithTypename<IEventAttendee> | string>
    >;
    userOrganization?: GraphCacheResolver<
      WithTypename<IUser>,
      IUserUserOrganizationArgs,
      WithTypename<IUserOrganization> | string
    >;
    userOrganizations?: GraphCacheResolver<
      WithTypename<IUser>,
      Record<string, never>,
      Array<WithTypename<IUserOrganization> | string>
    >;
  };
  UserGrowth?: {
    count?: GraphCacheResolver<
      WithTypename<IUserGrowth>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    timeframe?: GraphCacheResolver<
      WithTypename<IUserGrowth>,
      Record<string, never>,
      Scalars['ISO8601Date']['output'] | string
    >;
  };
  UserInvoice?: {
    id?: GraphCacheResolver<
      WithTypename<IUserInvoice>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    name?: GraphCacheResolver<
      WithTypename<IUserInvoice>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
  };
  UserOrganization?: {
    assistantFlags?: GraphCacheResolver<
      WithTypename<IUserOrganization>,
      Record<string, never>,
      Array<IAssistantFlagEnum | string>
    >;
    branch?: GraphCacheResolver<
      WithTypename<IUserOrganization>,
      Record<string, never>,
      WithTypename<IBranch> | string
    >;
    branchId?: GraphCacheResolver<
      WithTypename<IUserOrganization>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IUserOrganization>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    organizationId?: GraphCacheResolver<
      WithTypename<IUserOrganization>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    role?: GraphCacheResolver<
      WithTypename<IUserOrganization>,
      Record<string, never>,
      IOrganizationRoleEnum | string
    >;
    user?: GraphCacheResolver<
      WithTypename<IUserOrganization>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  UserReferral?: {
    createdAt?: GraphCacheResolver<
      WithTypename<IUserReferral>,
      Record<string, never>,
      Scalars['ISO8601Date']['output'] | string
    >;
    id?: GraphCacheResolver<
      WithTypename<IUserReferral>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    inviter?: GraphCacheResolver<
      WithTypename<IUserReferral>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
    newbie?: GraphCacheResolver<
      WithTypename<IUserReferral>,
      Record<string, never>,
      WithTypename<IUser> | string
    >;
  };
  XpAudit?: {
    applicableOn?: GraphCacheResolver<
      WithTypename<IXpAudit>,
      Record<string, never>,
      Scalars['ISO8601Date']['output'] | string
    >;
    awardedAt?: GraphCacheResolver<
      WithTypename<IXpAudit>,
      Record<string, never>,
      Scalars['ISO8601DateTime']['output'] | string
    >;
    branchTransferId?: GraphCacheResolver<
      WithTypename<IXpAudit>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    destinationBranch?: GraphCacheResolver<
      WithTypename<IXpAudit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    eventId?: GraphCacheResolver<
      WithTypename<IXpAudit>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    eventName?: GraphCacheResolver<
      WithTypename<IXpAudit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    extraBuildId?: GraphCacheResolver<
      WithTypename<IXpAudit>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    homeGameEventsIndex?: GraphCacheResolver<
      WithTypename<IXpAudit>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    kind?: GraphCacheResolver<
      WithTypename<IXpAudit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    originBranch?: GraphCacheResolver<
      WithTypename<IXpAudit>,
      Record<string, never>,
      Scalars['String']['output'] | string
    >;
    xpAddOn?: GraphCacheResolver<
      WithTypename<IXpAudit>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
    xpAwarded?: GraphCacheResolver<
      WithTypename<IXpAudit>,
      Record<string, never>,
      Scalars['Int']['output'] | string
    >;
  };
};

export type GraphCacheOptimisticUpdaters = {
  appendItemTransaction?: GraphCacheOptimisticMutationResolver<
    IMutationAppendItemTransactionArgs,
    Maybe<WithTypename<IAppendItemTransactionMutationPayload>>
  >;
  applyBranchContract?: GraphCacheOptimisticMutationResolver<
    IMutationApplyBranchContractArgs,
    Maybe<WithTypename<IApplyBranchContractMutationPayload>>
  >;
  assignBranchLocation?: GraphCacheOptimisticMutationResolver<
    IMutationAssignBranchLocationArgs,
    Maybe<WithTypename<IAssignBranchLocationMutationPayload>>
  >;
  assignBranchOwnership?: GraphCacheOptimisticMutationResolver<
    IMutationAssignBranchOwnershipArgs,
    Maybe<WithTypename<IAssignBranchOwnershipMutationPayload>>
  >;
  assignTemporaryManager?: GraphCacheOptimisticMutationResolver<
    IMutationAssignTemporaryManagerArgs,
    Maybe<WithTypename<IAssignTemporaryManagerMutationPayload>>
  >;
  checkin?: GraphCacheOptimisticMutationResolver<
    IMutationCheckinArgs,
    Maybe<WithTypename<ICheckinMutationPayload>>
  >;
  checkinCharacter?: GraphCacheOptimisticMutationResolver<
    IMutationCheckinCharacterArgs,
    Maybe<WithTypename<ICheckinCharacterMutationPayload>>
  >;
  claimModRewards?: GraphCacheOptimisticMutationResolver<
    IMutationClaimModRewardsArgs,
    Maybe<WithTypename<IClaimModRewardsMutationPayload>>
  >;
  copyCharacterBuild?: GraphCacheOptimisticMutationResolver<
    IMutationCopyCharacterBuildArgs,
    Maybe<WithTypename<ICopyCharacterBuildMutationPayload>>
  >;
  copyEventSetup?: GraphCacheOptimisticMutationResolver<
    IMutationCopyEventSetupArgs,
    Maybe<WithTypename<ICopyEventSetupMutationPayload>>
  >;
  createCap?: GraphCacheOptimisticMutationResolver<
    IMutationCreateCapArgs,
    Maybe<WithTypename<ICreateCapMutationPayload>>
  >;
  createCharacter?: GraphCacheOptimisticMutationResolver<
    IMutationCreateCharacterArgs,
    Maybe<WithTypename<ICreateCharacterMutationPayload>>
  >;
  createCharacterActionLog?: GraphCacheOptimisticMutationResolver<
    IMutationCreateCharacterActionLogArgs,
    Maybe<WithTypename<ICreateCharacterActionLogMutationPayload>>
  >;
  createCharacterFellowship?: GraphCacheOptimisticMutationResolver<
    IMutationCreateCharacterFellowshipArgs,
    Maybe<WithTypename<ICreateCharacterFellowshipMutationPayload>>
  >;
  createCorrectiveAction?: GraphCacheOptimisticMutationResolver<
    IMutationCreateCorrectiveActionArgs,
    Maybe<WithTypename<ICreateCorrectiveActionMutationPayload>>
  >;
  createEvent?: GraphCacheOptimisticMutationResolver<
    IMutationCreateEventArgs,
    Maybe<WithTypename<ICreateEventMutationPayload>>
  >;
  createEventLifecycle?: GraphCacheOptimisticMutationResolver<
    IMutationCreateEventLifecycleArgs,
    Maybe<WithTypename<ICreateEventLifecycleMutationPayload>>
  >;
  createEventShift?: GraphCacheOptimisticMutationResolver<
    IMutationCreateEventShiftArgs,
    Maybe<WithTypename<ICreateEventShiftMutationPayload>>
  >;
  createEventTicket?: GraphCacheOptimisticMutationResolver<
    IMutationCreateEventTicketArgs,
    Maybe<WithTypename<ICreateEventTicketMutationPayload>>
  >;
  createFellowship?: GraphCacheOptimisticMutationResolver<
    IMutationCreateFellowshipArgs,
    Maybe<WithTypename<ICreateFellowshipMutationPayload>>
  >;
  createFellowshipRuleTag?: GraphCacheOptimisticMutationResolver<
    IMutationCreateFellowshipRuleTagArgs,
    Maybe<WithTypename<ICreateFellowshipRuleTagMutationPayload>>
  >;
  createItem?: GraphCacheOptimisticMutationResolver<
    IMutationCreateItemArgs,
    Maybe<WithTypename<ICreateItemMutationPayload>>
  >;
  createItemClassification?: GraphCacheOptimisticMutationResolver<
    IMutationCreateItemClassificationArgs,
    Maybe<WithTypename<ICreateItemClassificationMutationPayload>>
  >;
  createItemCrafting?: GraphCacheOptimisticMutationResolver<
    IMutationCreateItemCraftingArgs,
    Maybe<WithTypename<ICreateItemCraftingMutationPayload>>
  >;
  createItemCraftingComponent?: GraphCacheOptimisticMutationResolver<
    IMutationCreateItemCraftingComponentArgs,
    Maybe<WithTypename<ICreateItemCraftingComponentMutationPayload>>
  >;
  createItemCraftingFinalProduct?: GraphCacheOptimisticMutationResolver<
    IMutationCreateItemCraftingFinalProductArgs,
    Maybe<WithTypename<ICreateItemCraftingFinalProductMutationPayload>>
  >;
  createItemReproduction?: GraphCacheOptimisticMutationResolver<
    IMutationCreateItemReproductionArgs,
    Maybe<WithTypename<ICreateItemReproductionMutationPayload>>
  >;
  createItemReproductionComponent?: GraphCacheOptimisticMutationResolver<
    IMutationCreateItemReproductionComponentArgs,
    Maybe<WithTypename<ICreateItemReproductionComponentMutationPayload>>
  >;
  createItemTransaction?: GraphCacheOptimisticMutationResolver<
    IMutationCreateItemTransactionArgs,
    Maybe<WithTypename<ICreateItemTransactionMutationPayload>>
  >;
  createLocation?: GraphCacheOptimisticMutationResolver<
    IMutationCreateLocationArgs,
    Maybe<WithTypename<ICreateLocationMutationPayload>>
  >;
  createMembership?: GraphCacheOptimisticMutationResolver<
    IMutationCreateMembershipArgs,
    Maybe<WithTypename<ICreateMembershipMutationPayload>>
  >;
  createMod?: GraphCacheOptimisticMutationResolver<
    IMutationCreateModArgs,
    Maybe<WithTypename<ICreateModMutationPayload>>
  >;
  createModAsset?: GraphCacheOptimisticMutationResolver<
    IMutationCreateModAssetArgs,
    Maybe<WithTypename<ICreateModAssetMutationPayload>>
  >;
  createModReward?: GraphCacheOptimisticMutationResolver<
    IMutationCreateModRewardArgs,
    Maybe<WithTypename<ICreateModRewardMutationPayload>>
  >;
  createModRewardTemplate?: GraphCacheOptimisticMutationResolver<
    IMutationCreateModRewardTemplateArgs,
    Maybe<WithTypename<ICreateModRewardTemplateMutationPayload>>
  >;
  createModSection?: GraphCacheOptimisticMutationResolver<
    IMutationCreateModSectionArgs,
    Maybe<WithTypename<ICreateModSectionMutationPayload>>
  >;
  createModSignup?: GraphCacheOptimisticMutationResolver<
    IMutationCreateModSignupArgs,
    Maybe<WithTypename<ICreateModSignupMutationPayload>>
  >;
  createNewPlayer?: GraphCacheOptimisticMutationResolver<
    IMutationCreateNewPlayerArgs,
    Maybe<WithTypename<ICreateNewPlayerMutationPayload>>
  >;
  createReferral?: GraphCacheOptimisticMutationResolver<
    IMutationCreateReferralArgs,
    Maybe<WithTypename<ICreateReferralMutationPayload>>
  >;
  createSpecialDate?: GraphCacheOptimisticMutationResolver<
    IMutationCreateSpecialDateArgs,
    Maybe<WithTypename<ICreateSpecialDateMutationPayload>>
  >;
  destroyAttendeeCharacter?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyAttendeeCharacterArgs,
    Maybe<WithTypename<IDestroyAttendeeCharacterMutationPayload>>
  >;
  destroyAuthToken?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyAuthTokenArgs,
    Maybe<WithTypename<IDestroyAuthTokenMutationPayload>>
  >;
  destroyCharacter?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyCharacterArgs,
    Maybe<WithTypename<IDestroyCharacterMutationPayload>>
  >;
  destroyCorrectiveAction?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyCorrectiveActionArgs,
    Maybe<WithTypename<IDestroyCorrectiveActionMutationPayload>>
  >;
  destroyEventAttendee?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyEventAttendeeArgs,
    Maybe<WithTypename<IDestroyEventAttendeeMutationPayload>>
  >;
  destroyEventShift?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyEventShiftArgs,
    Maybe<WithTypename<IDestroyEventShiftMutationPayload>>
  >;
  destroyEventTicket?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyEventTicketArgs,
    Maybe<WithTypename<IDestroyEventTicketMutationPayload>>
  >;
  destroyFellowshipRuleTag?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyFellowshipRuleTagArgs,
    Maybe<WithTypename<IDestroyFellowshipRuleTagMutationPayload>>
  >;
  destroyItemClassification?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyItemClassificationArgs,
    Maybe<WithTypename<IDestroyItemClassificationMutationPayload>>
  >;
  destroyItemCrafting?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyItemCraftingArgs,
    Maybe<WithTypename<IDestroyItemCraftingMutationPayload>>
  >;
  destroyItemCraftingComponent?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyItemCraftingComponentArgs,
    Maybe<WithTypename<IDestroyItemCraftingComponentMutationPayload>>
  >;
  destroyItemCraftingFinalProduct?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyItemCraftingFinalProductArgs,
    Maybe<WithTypename<IDestroyItemCraftingFinalProductMutationPayload>>
  >;
  destroyItemReproduction?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyItemReproductionArgs,
    Maybe<WithTypename<IDestroyItemReproductionMutationPayload>>
  >;
  destroyItemReproductionComponent?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyItemReproductionComponentArgs,
    Maybe<WithTypename<IDestroyItemReproductionComponentMutationPayload>>
  >;
  destroyLocation?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyLocationArgs,
    Maybe<WithTypename<IDestroyLocationMutationPayload>>
  >;
  destroyMembership?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyMembershipArgs,
    Maybe<WithTypename<IDestroyMembershipMutationPayload>>
  >;
  destroyMod?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyModArgs,
    Maybe<WithTypename<IDestroyModMutationPayload>>
  >;
  destroyModAsset?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyModAssetArgs,
    Maybe<WithTypename<IDestroyModAssetMutationPayload>>
  >;
  destroyModReward?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyModRewardArgs,
    Maybe<WithTypename<IDestroyModRewardMutationPayload>>
  >;
  destroyModRewardTemplate?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyModRewardTemplateArgs,
    Maybe<WithTypename<IDestroyModRewardTemplateMutationPayload>>
  >;
  destroyModSignup?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyModSignupArgs,
    Maybe<WithTypename<IDestroyModSignupMutationPayload>>
  >;
  destroyReferral?: GraphCacheOptimisticMutationResolver<
    IMutationDestroyReferralArgs,
    Maybe<WithTypename<IDestroyReferralMutationPayload>>
  >;
  destroySpecialDate?: GraphCacheOptimisticMutationResolver<
    IMutationDestroySpecialDateArgs,
    Maybe<WithTypename<IDestroySpecialDateMutationPayload>>
  >;
  finalizeModRewardClaims?: GraphCacheOptimisticMutationResolver<
    IMutationFinalizeModRewardClaimsArgs,
    Maybe<WithTypename<IFinalizeModRewardClaimsMutationPayload>>
  >;
  fulfillShift?: GraphCacheOptimisticMutationResolver<
    IMutationFulfillShiftArgs,
    Maybe<WithTypename<IFulfillShiftMutationPayload>>
  >;
  generateAuthToken?: GraphCacheOptimisticMutationResolver<
    IMutationGenerateAuthTokenArgs,
    Maybe<WithTypename<IGenerateAuthTokenMutationPayload>>
  >;
  generateBattlefieldToken?: GraphCacheOptimisticMutationResolver<
    IMutationGenerateBattlefieldTokenArgs,
    Maybe<WithTypename<IGenerateBattlefieldTokenMutationPayload>>
  >;
  logBlueprintAction?: GraphCacheOptimisticMutationResolver<
    IMutationLogBlueprintActionArgs,
    Maybe<WithTypename<ILogBlueprintActionMutationPayload>>
  >;
  modAddSkill?: GraphCacheOptimisticMutationResolver<
    IMutationModAddSkillArgs,
    Maybe<WithTypename<IAddSkillMutationPayload>>
  >;
  modAdvanceTurn?: GraphCacheOptimisticMutationResolver<
    IMutationModAdvanceTurnArgs,
    Maybe<WithTypename<IAdvanceTurnMutationPayload>>
  >;
  modApplyChallengeResolution?: GraphCacheOptimisticMutationResolver<
    IMutationModApplyChallengeResolutionArgs,
    Maybe<WithTypename<IApplyChallengeResolutionMutationPayload>>
  >;
  modApplyChange?: GraphCacheOptimisticMutationResolver<
    IMutationModApplyChangeArgs,
    Maybe<WithTypename<IApplyChangeMutationPayload>>
  >;
  modApplyDamage?: GraphCacheOptimisticMutationResolver<
    IMutationModApplyDamageArgs,
    Maybe<WithTypename<IApplyDamageMutationPayload>>
  >;
  modApplyEnvironmentalEffect?: GraphCacheOptimisticMutationResolver<
    IMutationModApplyEnvironmentalEffectArgs,
    Maybe<WithTypename<IApplyEnvironmentalEffectMutationPayload>>
  >;
  modApplyShielding?: GraphCacheOptimisticMutationResolver<
    IMutationModApplyShieldingArgs,
    Maybe<WithTypename<IApplyShieldingMutationPayload>>
  >;
  modApplySkillEffect?: GraphCacheOptimisticMutationResolver<
    IMutationModApplySkillEffectArgs,
    Maybe<WithTypename<IApplySkillEffectMutationPayload>>
  >;
  modAssistImpactSkill?: GraphCacheOptimisticMutationResolver<
    IMutationModAssistImpactSkillArgs,
    Maybe<WithTypename<IAssistImpactSkillMutationPayload>>
  >;
  modCompleteScatterShot?: GraphCacheOptimisticMutationResolver<
    IMutationModCompleteScatterShotArgs,
    Maybe<WithTypename<ICompleteScatterShotMutationPayload>>
  >;
  modCreateMessage?: GraphCacheOptimisticMutationResolver<
    IMutationModCreateMessageArgs,
    Maybe<WithTypename<ICreateMessageMutationPayload>>
  >;
  modCreateModChallenge?: GraphCacheOptimisticMutationResolver<
    IMutationModCreateModChallengeArgs,
    Maybe<WithTypename<ICreateModChallengeMutationPayload>>
  >;
  modCreateModNarrativeRolePlay?: GraphCacheOptimisticMutationResolver<
    IMutationModCreateModNarrativeRolePlayArgs,
    Maybe<WithTypename<ICreateModNarrativeRolePlayMutationPayload>>
  >;
  modEndMod?: GraphCacheOptimisticMutationResolver<
    IMutationModEndModArgs,
    Maybe<WithTypename<IEndModMutationPayload>>
  >;
  modEnterBattlefield?: GraphCacheOptimisticMutationResolver<
    IMutationModEnterBattlefieldArgs,
    Maybe<WithTypename<IEnterBattlefieldMutationPayload>>
  >;
  modEquip?: GraphCacheOptimisticMutationResolver<
    IMutationModEquipArgs,
    Maybe<WithTypename<IEquipMutationPayload>>
  >;
  modExecuteScatterShot?: GraphCacheOptimisticMutationResolver<
    IMutationModExecuteScatterShotArgs,
    Maybe<WithTypename<IExecuteScatterShotMutationPayload>>
  >;
  modExpendItem?: GraphCacheOptimisticMutationResolver<
    IMutationModExpendItemArgs,
    Maybe<WithTypename<IExpendItemMutationPayload>>
  >;
  modExpendResolve?: GraphCacheOptimisticMutationResolver<
    IMutationModExpendResolveArgs,
    Maybe<WithTypename<IExpendResolveMutationPayload>>
  >;
  modLeaveBattlefield?: GraphCacheOptimisticMutationResolver<
    IMutationModLeaveBattlefieldArgs,
    Maybe<WithTypename<ILeaveBattlefieldMutationPayload>>
  >;
  modMove?: GraphCacheOptimisticMutationResolver<
    IMutationModMoveArgs,
    Maybe<WithTypename<IMoveMutationPayload>>
  >;
  modPerformKillingBlow?: GraphCacheOptimisticMutationResolver<
    IMutationModPerformKillingBlowArgs,
    Maybe<WithTypename<IPerformKillingBlowMutationPayload>>
  >;
  modReattemptAction?: GraphCacheOptimisticMutationResolver<
    IMutationModReattemptActionArgs,
    Maybe<WithTypename<IReattemptActionMutationPayload>>
  >;
  modReload?: GraphCacheOptimisticMutationResolver<
    IMutationModReloadArgs,
    Maybe<WithTypename<IReloadMutationPayload>>
  >;
  modRollAttack?: GraphCacheOptimisticMutationResolver<
    IMutationModRollAttackArgs,
    Maybe<WithTypename<IRollAttackMutationPayload>>
  >;
  modRollDevelopmentSkill?: GraphCacheOptimisticMutationResolver<
    IMutationModRollDevelopmentSkillArgs,
    Maybe<WithTypename<IRollDevelopmentSkillMutationPayload>>
  >;
  modRollImpactSkill?: GraphCacheOptimisticMutationResolver<
    IMutationModRollImpactSkillArgs,
    Maybe<WithTypename<IRollImpactSkillMutationPayload>>
  >;
  modRollInitiative?: GraphCacheOptimisticMutationResolver<
    IMutationModRollInitiativeArgs,
    Maybe<WithTypename<IRollInitiativeMutationPayload>>
  >;
  modSubmitNarrativeRolePlayBids?: GraphCacheOptimisticMutationResolver<
    IMutationModSubmitNarrativeRolePlayBidsArgs,
    Maybe<WithTypename<ISubmitNarrativeRolePlayBidsMutationPayload>>
  >;
  modUpdateModChallenge?: GraphCacheOptimisticMutationResolver<
    IMutationModUpdateModChallengeArgs,
    Maybe<WithTypename<IUpdateModChallengeMutationPayload>>
  >;
  modUpdateModChallengeResolutionOption?: GraphCacheOptimisticMutationResolver<
    IMutationModUpdateModChallengeResolutionOptionArgs,
    Maybe<WithTypename<IUpdateModChallengeResolutionOptionMutationPayload>>
  >;
  modUpdateModNarrativeRolePlay?: GraphCacheOptimisticMutationResolver<
    IMutationModUpdateModNarrativeRolePlayArgs,
    Maybe<WithTypename<IUpdateModNarrativeRolePlayMutationPayload>>
  >;
  modUseCover?: GraphCacheOptimisticMutationResolver<
    IMutationModUseCoverArgs,
    Maybe<WithTypename<IUseCoverMutationPayload>>
  >;
  removeItemTransaction?: GraphCacheOptimisticMutationResolver<
    IMutationRemoveItemTransactionArgs,
    Maybe<WithTypename<IRemoveItemTransactionMutationPayload>>
  >;
  requestPasswordReset?: GraphCacheOptimisticMutationResolver<
    IMutationRequestPasswordResetArgs,
    Maybe<WithTypename<IRequestPasswordResetMutationPayload>>
  >;
  resetPassword?: GraphCacheOptimisticMutationResolver<
    IMutationResetPasswordArgs,
    Maybe<WithTypename<IResetPasswordMutationPayload>>
  >;
  retireCharacter?: GraphCacheOptimisticMutationResolver<
    IMutationRetireCharacterArgs,
    Maybe<WithTypename<IRetireCharacterMutationPayload>>
  >;
  rollDice?: GraphCacheOptimisticMutationResolver<
    IMutationRollDiceArgs,
    Maybe<WithTypename<IRollDiceMutationPayload>>
  >;
  trackItemUse?: GraphCacheOptimisticMutationResolver<
    IMutationTrackItemUseArgs,
    Maybe<WithTypename<ITrackItemUseMutationPayload>>
  >;
  updateBranch?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateBranchArgs,
    Maybe<WithTypename<IUpdateBranchMutationPayload>>
  >;
  updateCap?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateCapArgs,
    Maybe<WithTypename<IUpdateCapMutationPayload>>
  >;
  updateCharacterActionLog?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateCharacterActionLogArgs,
    Maybe<WithTypename<IUpdateCharacterActionLogMutationPayload>>
  >;
  updateCharacterData?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateCharacterDataArgs,
    Maybe<WithTypename<IUpdateCharacterDataMutationPayload>>
  >;
  updateCharacterFellowship?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateCharacterFellowshipArgs,
    Maybe<WithTypename<IUpdateCharacterFellowshipMutationPayload>>
  >;
  updateCorrectiveAction?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateCorrectiveActionArgs,
    Maybe<WithTypename<IUpdateCorrectiveActionMutationPayload>>
  >;
  updateEvent?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateEventArgs,
    Maybe<WithTypename<IUpdateEventMutationPayload>>
  >;
  updateEventAttendee?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateEventAttendeeArgs,
    Maybe<WithTypename<IUpdateEventAttendeeMutationPayload>>
  >;
  updateEventLifecycle?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateEventLifecycleArgs,
    Maybe<WithTypename<IUpdateEventLifecycleMutationPayload>>
  >;
  updateEventShift?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateEventShiftArgs,
    Maybe<WithTypename<IUpdateEventShiftMutationPayload>>
  >;
  updateEventTicket?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateEventTicketArgs,
    Maybe<WithTypename<IUpdateEventTicketMutationPayload>>
  >;
  updateFellowship?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateFellowshipArgs,
    Maybe<WithTypename<IUpdateFellowshipMutationPayload>>
  >;
  updateItem?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateItemArgs,
    Maybe<WithTypename<IUpdateItemMutationPayload>>
  >;
  updateItemCrafting?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateItemCraftingArgs,
    Maybe<WithTypename<IUpdateItemCraftingMutationPayload>>
  >;
  updateItemCraftingComponent?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateItemCraftingComponentArgs,
    Maybe<WithTypename<IUpdateItemCraftingComponentMutationPayload>>
  >;
  updateItemCraftingFinalProduct?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateItemCraftingFinalProductArgs,
    Maybe<WithTypename<IUpdateItemCraftingFinalProductMutationPayload>>
  >;
  updateItemReproduction?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateItemReproductionArgs,
    Maybe<WithTypename<IUpdateItemReproductionMutationPayload>>
  >;
  updateItemReproductionComponent?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateItemReproductionComponentArgs,
    Maybe<WithTypename<IUpdateItemReproductionComponentMutationPayload>>
  >;
  updateItemTransaction?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateItemTransactionArgs,
    Maybe<WithTypename<IUpdateItemTransactionMutationPayload>>
  >;
  updateLocation?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateLocationArgs,
    Maybe<WithTypename<IUpdateLocationMutationPayload>>
  >;
  updateMembership?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateMembershipArgs,
    Maybe<WithTypename<IUpdateMembershipMutationPayload>>
  >;
  updateMod?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateModArgs,
    Maybe<WithTypename<IUpdateModMutationPayload>>
  >;
  updateModAsset?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateModAssetArgs,
    Maybe<WithTypename<IUpdateModAssetMutationPayload>>
  >;
  updateModReward?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateModRewardArgs,
    Maybe<WithTypename<IUpdateModRewardMutationPayload>>
  >;
  updateModRewardTemplate?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateModRewardTemplateArgs,
    Maybe<WithTypename<IUpdateModRewardTemplateMutationPayload>>
  >;
  updateModSection?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateModSectionArgs,
    Maybe<WithTypename<IUpdateModSectionMutationPayload>>
  >;
  updateModSignup?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateModSignupArgs,
    Maybe<WithTypename<IUpdateModSignupMutationPayload>>
  >;
  updateOrganization?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateOrganizationArgs,
    Maybe<WithTypename<IUpdateOrganizationMutationPayload>>
  >;
  updatePassword?: GraphCacheOptimisticMutationResolver<
    IMutationUpdatePasswordArgs,
    Maybe<WithTypename<IUpdatePasswordMutationPayload>>
  >;
  updatePlayerBranchOwnership?: GraphCacheOptimisticMutationResolver<
    IMutationUpdatePlayerBranchOwnershipArgs,
    Maybe<WithTypename<IUpdatePlayerBranchOwnershipMutationPayload>>
  >;
  updatePlayerData?: GraphCacheOptimisticMutationResolver<
    IMutationUpdatePlayerDataArgs,
    Maybe<WithTypename<IUpdatePlayerDataMutationPayload>>
  >;
  updatePlayerOrganizationData?: GraphCacheOptimisticMutationResolver<
    IMutationUpdatePlayerOrganizationDataArgs,
    Maybe<WithTypename<IUpdatePlayerOrganizationDataMutationPayload>>
  >;
  updateSpecialDate?: GraphCacheOptimisticMutationResolver<
    IMutationUpdateSpecialDateArgs,
    Maybe<WithTypename<IUpdateSpecialDateMutationPayload>>
  >;
};

export type GraphCacheUpdaters = {
  Query?: {
    branch?: GraphCacheUpdateResolver<
      { branch: Maybe<WithTypename<IBranch>> },
      IQueryBranchArgs
    >;
    event?: GraphCacheUpdateResolver<
      { event: Maybe<WithTypename<IEvent>> },
      IQueryEventArgs
    >;
    events?: GraphCacheUpdateResolver<
      { events: Array<WithTypename<IEvent>> },
      IQueryEventsArgs
    >;
    locations?: GraphCacheUpdateResolver<
      { locations: Array<WithTypename<ILocation>> },
      Record<string, never>
    >;
    memberships?: GraphCacheUpdateResolver<
      { memberships: Array<WithTypename<IMembership>> },
      IQueryMembershipsArgs
    >;
    organization?: GraphCacheUpdateResolver<
      { organization: WithTypename<IOrganization> },
      IQueryOrganizationArgs
    >;
    organizationRoles?: GraphCacheUpdateResolver<
      { organizationRoles: Array<IOrganizationRoleEnum> },
      Record<string, never>
    >;
    organizations?: GraphCacheUpdateResolver<
      { organizations: Array<WithTypename<IOrganization>> },
      Record<string, never>
    >;
    permission?: GraphCacheUpdateResolver<
      { permission: WithTypename<IPermission> },
      IQueryPermissionArgs
    >;
    resetPasswordTokenStatus?: GraphCacheUpdateResolver<
      { resetPasswordTokenStatus: Scalars['Boolean']['output'] },
      IQueryResetPasswordTokenStatusArgs
    >;
    searchPlayer?: GraphCacheUpdateResolver<
      { searchPlayer: Array<WithTypename<ISearchPlayerResult>> },
      IQuerySearchPlayerArgs
    >;
    temporaryTokenStatus?: GraphCacheUpdateResolver<
      { temporaryTokenStatus: Scalars['Boolean']['output'] },
      Record<string, never>
    >;
    tokenId?: GraphCacheUpdateResolver<
      { tokenId: Maybe<Scalars['Int']['output']> },
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      { user: Maybe<WithTypename<IUser>> },
      IQueryUserArgs
    >;
  };
  Mutation?: {
    appendItemTransaction?: GraphCacheUpdateResolver<
      {
        appendItemTransaction: Maybe<
          WithTypename<IAppendItemTransactionMutationPayload>
        >;
      },
      IMutationAppendItemTransactionArgs
    >;
    applyBranchContract?: GraphCacheUpdateResolver<
      {
        applyBranchContract: Maybe<
          WithTypename<IApplyBranchContractMutationPayload>
        >;
      },
      IMutationApplyBranchContractArgs
    >;
    assignBranchLocation?: GraphCacheUpdateResolver<
      {
        assignBranchLocation: Maybe<
          WithTypename<IAssignBranchLocationMutationPayload>
        >;
      },
      IMutationAssignBranchLocationArgs
    >;
    assignBranchOwnership?: GraphCacheUpdateResolver<
      {
        assignBranchOwnership: Maybe<
          WithTypename<IAssignBranchOwnershipMutationPayload>
        >;
      },
      IMutationAssignBranchOwnershipArgs
    >;
    assignTemporaryManager?: GraphCacheUpdateResolver<
      {
        assignTemporaryManager: Maybe<
          WithTypename<IAssignTemporaryManagerMutationPayload>
        >;
      },
      IMutationAssignTemporaryManagerArgs
    >;
    checkin?: GraphCacheUpdateResolver<
      { checkin: Maybe<WithTypename<ICheckinMutationPayload>> },
      IMutationCheckinArgs
    >;
    checkinCharacter?: GraphCacheUpdateResolver<
      {
        checkinCharacter: Maybe<WithTypename<ICheckinCharacterMutationPayload>>;
      },
      IMutationCheckinCharacterArgs
    >;
    claimModRewards?: GraphCacheUpdateResolver<
      { claimModRewards: Maybe<WithTypename<IClaimModRewardsMutationPayload>> },
      IMutationClaimModRewardsArgs
    >;
    copyCharacterBuild?: GraphCacheUpdateResolver<
      {
        copyCharacterBuild: Maybe<
          WithTypename<ICopyCharacterBuildMutationPayload>
        >;
      },
      IMutationCopyCharacterBuildArgs
    >;
    copyEventSetup?: GraphCacheUpdateResolver<
      { copyEventSetup: Maybe<WithTypename<ICopyEventSetupMutationPayload>> },
      IMutationCopyEventSetupArgs
    >;
    createCap?: GraphCacheUpdateResolver<
      { createCap: Maybe<WithTypename<ICreateCapMutationPayload>> },
      IMutationCreateCapArgs
    >;
    createCharacter?: GraphCacheUpdateResolver<
      { createCharacter: Maybe<WithTypename<ICreateCharacterMutationPayload>> },
      IMutationCreateCharacterArgs
    >;
    createCharacterActionLog?: GraphCacheUpdateResolver<
      {
        createCharacterActionLog: Maybe<
          WithTypename<ICreateCharacterActionLogMutationPayload>
        >;
      },
      IMutationCreateCharacterActionLogArgs
    >;
    createCharacterFellowship?: GraphCacheUpdateResolver<
      {
        createCharacterFellowship: Maybe<
          WithTypename<ICreateCharacterFellowshipMutationPayload>
        >;
      },
      IMutationCreateCharacterFellowshipArgs
    >;
    createCorrectiveAction?: GraphCacheUpdateResolver<
      {
        createCorrectiveAction: Maybe<
          WithTypename<ICreateCorrectiveActionMutationPayload>
        >;
      },
      IMutationCreateCorrectiveActionArgs
    >;
    createEvent?: GraphCacheUpdateResolver<
      { createEvent: Maybe<WithTypename<ICreateEventMutationPayload>> },
      IMutationCreateEventArgs
    >;
    createEventLifecycle?: GraphCacheUpdateResolver<
      {
        createEventLifecycle: Maybe<
          WithTypename<ICreateEventLifecycleMutationPayload>
        >;
      },
      IMutationCreateEventLifecycleArgs
    >;
    createEventShift?: GraphCacheUpdateResolver<
      {
        createEventShift: Maybe<WithTypename<ICreateEventShiftMutationPayload>>;
      },
      IMutationCreateEventShiftArgs
    >;
    createEventTicket?: GraphCacheUpdateResolver<
      {
        createEventTicket: Maybe<
          WithTypename<ICreateEventTicketMutationPayload>
        >;
      },
      IMutationCreateEventTicketArgs
    >;
    createFellowship?: GraphCacheUpdateResolver<
      {
        createFellowship: Maybe<WithTypename<ICreateFellowshipMutationPayload>>;
      },
      IMutationCreateFellowshipArgs
    >;
    createFellowshipRuleTag?: GraphCacheUpdateResolver<
      {
        createFellowshipRuleTag: Maybe<
          WithTypename<ICreateFellowshipRuleTagMutationPayload>
        >;
      },
      IMutationCreateFellowshipRuleTagArgs
    >;
    createItem?: GraphCacheUpdateResolver<
      { createItem: Maybe<WithTypename<ICreateItemMutationPayload>> },
      IMutationCreateItemArgs
    >;
    createItemClassification?: GraphCacheUpdateResolver<
      {
        createItemClassification: Maybe<
          WithTypename<ICreateItemClassificationMutationPayload>
        >;
      },
      IMutationCreateItemClassificationArgs
    >;
    createItemCrafting?: GraphCacheUpdateResolver<
      {
        createItemCrafting: Maybe<
          WithTypename<ICreateItemCraftingMutationPayload>
        >;
      },
      IMutationCreateItemCraftingArgs
    >;
    createItemCraftingComponent?: GraphCacheUpdateResolver<
      {
        createItemCraftingComponent: Maybe<
          WithTypename<ICreateItemCraftingComponentMutationPayload>
        >;
      },
      IMutationCreateItemCraftingComponentArgs
    >;
    createItemCraftingFinalProduct?: GraphCacheUpdateResolver<
      {
        createItemCraftingFinalProduct: Maybe<
          WithTypename<ICreateItemCraftingFinalProductMutationPayload>
        >;
      },
      IMutationCreateItemCraftingFinalProductArgs
    >;
    createItemReproduction?: GraphCacheUpdateResolver<
      {
        createItemReproduction: Maybe<
          WithTypename<ICreateItemReproductionMutationPayload>
        >;
      },
      IMutationCreateItemReproductionArgs
    >;
    createItemReproductionComponent?: GraphCacheUpdateResolver<
      {
        createItemReproductionComponent: Maybe<
          WithTypename<ICreateItemReproductionComponentMutationPayload>
        >;
      },
      IMutationCreateItemReproductionComponentArgs
    >;
    createItemTransaction?: GraphCacheUpdateResolver<
      {
        createItemTransaction: Maybe<
          WithTypename<ICreateItemTransactionMutationPayload>
        >;
      },
      IMutationCreateItemTransactionArgs
    >;
    createLocation?: GraphCacheUpdateResolver<
      { createLocation: Maybe<WithTypename<ICreateLocationMutationPayload>> },
      IMutationCreateLocationArgs
    >;
    createMembership?: GraphCacheUpdateResolver<
      {
        createMembership: Maybe<WithTypename<ICreateMembershipMutationPayload>>;
      },
      IMutationCreateMembershipArgs
    >;
    createMod?: GraphCacheUpdateResolver<
      { createMod: Maybe<WithTypename<ICreateModMutationPayload>> },
      IMutationCreateModArgs
    >;
    createModAsset?: GraphCacheUpdateResolver<
      { createModAsset: Maybe<WithTypename<ICreateModAssetMutationPayload>> },
      IMutationCreateModAssetArgs
    >;
    createModReward?: GraphCacheUpdateResolver<
      { createModReward: Maybe<WithTypename<ICreateModRewardMutationPayload>> },
      IMutationCreateModRewardArgs
    >;
    createModRewardTemplate?: GraphCacheUpdateResolver<
      {
        createModRewardTemplate: Maybe<
          WithTypename<ICreateModRewardTemplateMutationPayload>
        >;
      },
      IMutationCreateModRewardTemplateArgs
    >;
    createModSection?: GraphCacheUpdateResolver<
      {
        createModSection: Maybe<WithTypename<ICreateModSectionMutationPayload>>;
      },
      IMutationCreateModSectionArgs
    >;
    createModSignup?: GraphCacheUpdateResolver<
      { createModSignup: Maybe<WithTypename<ICreateModSignupMutationPayload>> },
      IMutationCreateModSignupArgs
    >;
    createNewPlayer?: GraphCacheUpdateResolver<
      { createNewPlayer: Maybe<WithTypename<ICreateNewPlayerMutationPayload>> },
      IMutationCreateNewPlayerArgs
    >;
    createReferral?: GraphCacheUpdateResolver<
      { createReferral: Maybe<WithTypename<ICreateReferralMutationPayload>> },
      IMutationCreateReferralArgs
    >;
    createSpecialDate?: GraphCacheUpdateResolver<
      {
        createSpecialDate: Maybe<
          WithTypename<ICreateSpecialDateMutationPayload>
        >;
      },
      IMutationCreateSpecialDateArgs
    >;
    destroyAttendeeCharacter?: GraphCacheUpdateResolver<
      {
        destroyAttendeeCharacter: Maybe<
          WithTypename<IDestroyAttendeeCharacterMutationPayload>
        >;
      },
      IMutationDestroyAttendeeCharacterArgs
    >;
    destroyAuthToken?: GraphCacheUpdateResolver<
      {
        destroyAuthToken: Maybe<WithTypename<IDestroyAuthTokenMutationPayload>>;
      },
      IMutationDestroyAuthTokenArgs
    >;
    destroyCharacter?: GraphCacheUpdateResolver<
      {
        destroyCharacter: Maybe<WithTypename<IDestroyCharacterMutationPayload>>;
      },
      IMutationDestroyCharacterArgs
    >;
    destroyCorrectiveAction?: GraphCacheUpdateResolver<
      {
        destroyCorrectiveAction: Maybe<
          WithTypename<IDestroyCorrectiveActionMutationPayload>
        >;
      },
      IMutationDestroyCorrectiveActionArgs
    >;
    destroyEventAttendee?: GraphCacheUpdateResolver<
      {
        destroyEventAttendee: Maybe<
          WithTypename<IDestroyEventAttendeeMutationPayload>
        >;
      },
      IMutationDestroyEventAttendeeArgs
    >;
    destroyEventShift?: GraphCacheUpdateResolver<
      {
        destroyEventShift: Maybe<
          WithTypename<IDestroyEventShiftMutationPayload>
        >;
      },
      IMutationDestroyEventShiftArgs
    >;
    destroyEventTicket?: GraphCacheUpdateResolver<
      {
        destroyEventTicket: Maybe<
          WithTypename<IDestroyEventTicketMutationPayload>
        >;
      },
      IMutationDestroyEventTicketArgs
    >;
    destroyFellowshipRuleTag?: GraphCacheUpdateResolver<
      {
        destroyFellowshipRuleTag: Maybe<
          WithTypename<IDestroyFellowshipRuleTagMutationPayload>
        >;
      },
      IMutationDestroyFellowshipRuleTagArgs
    >;
    destroyItemClassification?: GraphCacheUpdateResolver<
      {
        destroyItemClassification: Maybe<
          WithTypename<IDestroyItemClassificationMutationPayload>
        >;
      },
      IMutationDestroyItemClassificationArgs
    >;
    destroyItemCrafting?: GraphCacheUpdateResolver<
      {
        destroyItemCrafting: Maybe<
          WithTypename<IDestroyItemCraftingMutationPayload>
        >;
      },
      IMutationDestroyItemCraftingArgs
    >;
    destroyItemCraftingComponent?: GraphCacheUpdateResolver<
      {
        destroyItemCraftingComponent: Maybe<
          WithTypename<IDestroyItemCraftingComponentMutationPayload>
        >;
      },
      IMutationDestroyItemCraftingComponentArgs
    >;
    destroyItemCraftingFinalProduct?: GraphCacheUpdateResolver<
      {
        destroyItemCraftingFinalProduct: Maybe<
          WithTypename<IDestroyItemCraftingFinalProductMutationPayload>
        >;
      },
      IMutationDestroyItemCraftingFinalProductArgs
    >;
    destroyItemReproduction?: GraphCacheUpdateResolver<
      {
        destroyItemReproduction: Maybe<
          WithTypename<IDestroyItemReproductionMutationPayload>
        >;
      },
      IMutationDestroyItemReproductionArgs
    >;
    destroyItemReproductionComponent?: GraphCacheUpdateResolver<
      {
        destroyItemReproductionComponent: Maybe<
          WithTypename<IDestroyItemReproductionComponentMutationPayload>
        >;
      },
      IMutationDestroyItemReproductionComponentArgs
    >;
    destroyLocation?: GraphCacheUpdateResolver<
      { destroyLocation: Maybe<WithTypename<IDestroyLocationMutationPayload>> },
      IMutationDestroyLocationArgs
    >;
    destroyMembership?: GraphCacheUpdateResolver<
      {
        destroyMembership: Maybe<
          WithTypename<IDestroyMembershipMutationPayload>
        >;
      },
      IMutationDestroyMembershipArgs
    >;
    destroyMod?: GraphCacheUpdateResolver<
      { destroyMod: Maybe<WithTypename<IDestroyModMutationPayload>> },
      IMutationDestroyModArgs
    >;
    destroyModAsset?: GraphCacheUpdateResolver<
      { destroyModAsset: Maybe<WithTypename<IDestroyModAssetMutationPayload>> },
      IMutationDestroyModAssetArgs
    >;
    destroyModReward?: GraphCacheUpdateResolver<
      {
        destroyModReward: Maybe<WithTypename<IDestroyModRewardMutationPayload>>;
      },
      IMutationDestroyModRewardArgs
    >;
    destroyModRewardTemplate?: GraphCacheUpdateResolver<
      {
        destroyModRewardTemplate: Maybe<
          WithTypename<IDestroyModRewardTemplateMutationPayload>
        >;
      },
      IMutationDestroyModRewardTemplateArgs
    >;
    destroyModSignup?: GraphCacheUpdateResolver<
      {
        destroyModSignup: Maybe<WithTypename<IDestroyModSignupMutationPayload>>;
      },
      IMutationDestroyModSignupArgs
    >;
    destroyReferral?: GraphCacheUpdateResolver<
      { destroyReferral: Maybe<WithTypename<IDestroyReferralMutationPayload>> },
      IMutationDestroyReferralArgs
    >;
    destroySpecialDate?: GraphCacheUpdateResolver<
      {
        destroySpecialDate: Maybe<
          WithTypename<IDestroySpecialDateMutationPayload>
        >;
      },
      IMutationDestroySpecialDateArgs
    >;
    finalizeModRewardClaims?: GraphCacheUpdateResolver<
      {
        finalizeModRewardClaims: Maybe<
          WithTypename<IFinalizeModRewardClaimsMutationPayload>
        >;
      },
      IMutationFinalizeModRewardClaimsArgs
    >;
    fulfillShift?: GraphCacheUpdateResolver<
      { fulfillShift: Maybe<WithTypename<IFulfillShiftMutationPayload>> },
      IMutationFulfillShiftArgs
    >;
    generateAuthToken?: GraphCacheUpdateResolver<
      {
        generateAuthToken: Maybe<
          WithTypename<IGenerateAuthTokenMutationPayload>
        >;
      },
      IMutationGenerateAuthTokenArgs
    >;
    generateBattlefieldToken?: GraphCacheUpdateResolver<
      {
        generateBattlefieldToken: Maybe<
          WithTypename<IGenerateBattlefieldTokenMutationPayload>
        >;
      },
      IMutationGenerateBattlefieldTokenArgs
    >;
    logBlueprintAction?: GraphCacheUpdateResolver<
      {
        logBlueprintAction: Maybe<
          WithTypename<ILogBlueprintActionMutationPayload>
        >;
      },
      IMutationLogBlueprintActionArgs
    >;
    modAddSkill?: GraphCacheUpdateResolver<
      { modAddSkill: Maybe<WithTypename<IAddSkillMutationPayload>> },
      IMutationModAddSkillArgs
    >;
    modAdvanceTurn?: GraphCacheUpdateResolver<
      { modAdvanceTurn: Maybe<WithTypename<IAdvanceTurnMutationPayload>> },
      IMutationModAdvanceTurnArgs
    >;
    modApplyChallengeResolution?: GraphCacheUpdateResolver<
      {
        modApplyChallengeResolution: Maybe<
          WithTypename<IApplyChallengeResolutionMutationPayload>
        >;
      },
      IMutationModApplyChallengeResolutionArgs
    >;
    modApplyChange?: GraphCacheUpdateResolver<
      { modApplyChange: Maybe<WithTypename<IApplyChangeMutationPayload>> },
      IMutationModApplyChangeArgs
    >;
    modApplyDamage?: GraphCacheUpdateResolver<
      { modApplyDamage: Maybe<WithTypename<IApplyDamageMutationPayload>> },
      IMutationModApplyDamageArgs
    >;
    modApplyEnvironmentalEffect?: GraphCacheUpdateResolver<
      {
        modApplyEnvironmentalEffect: Maybe<
          WithTypename<IApplyEnvironmentalEffectMutationPayload>
        >;
      },
      IMutationModApplyEnvironmentalEffectArgs
    >;
    modApplyShielding?: GraphCacheUpdateResolver<
      {
        modApplyShielding: Maybe<WithTypename<IApplyShieldingMutationPayload>>;
      },
      IMutationModApplyShieldingArgs
    >;
    modApplySkillEffect?: GraphCacheUpdateResolver<
      {
        modApplySkillEffect: Maybe<
          WithTypename<IApplySkillEffectMutationPayload>
        >;
      },
      IMutationModApplySkillEffectArgs
    >;
    modAssistImpactSkill?: GraphCacheUpdateResolver<
      {
        modAssistImpactSkill: Maybe<
          WithTypename<IAssistImpactSkillMutationPayload>
        >;
      },
      IMutationModAssistImpactSkillArgs
    >;
    modCompleteScatterShot?: GraphCacheUpdateResolver<
      {
        modCompleteScatterShot: Maybe<
          WithTypename<ICompleteScatterShotMutationPayload>
        >;
      },
      IMutationModCompleteScatterShotArgs
    >;
    modCreateMessage?: GraphCacheUpdateResolver<
      { modCreateMessage: Maybe<WithTypename<ICreateMessageMutationPayload>> },
      IMutationModCreateMessageArgs
    >;
    modCreateModChallenge?: GraphCacheUpdateResolver<
      {
        modCreateModChallenge: Maybe<
          WithTypename<ICreateModChallengeMutationPayload>
        >;
      },
      IMutationModCreateModChallengeArgs
    >;
    modCreateModNarrativeRolePlay?: GraphCacheUpdateResolver<
      {
        modCreateModNarrativeRolePlay: Maybe<
          WithTypename<ICreateModNarrativeRolePlayMutationPayload>
        >;
      },
      IMutationModCreateModNarrativeRolePlayArgs
    >;
    modEndMod?: GraphCacheUpdateResolver<
      { modEndMod: Maybe<WithTypename<IEndModMutationPayload>> },
      IMutationModEndModArgs
    >;
    modEnterBattlefield?: GraphCacheUpdateResolver<
      {
        modEnterBattlefield: Maybe<
          WithTypename<IEnterBattlefieldMutationPayload>
        >;
      },
      IMutationModEnterBattlefieldArgs
    >;
    modEquip?: GraphCacheUpdateResolver<
      { modEquip: Maybe<WithTypename<IEquipMutationPayload>> },
      IMutationModEquipArgs
    >;
    modExecuteScatterShot?: GraphCacheUpdateResolver<
      {
        modExecuteScatterShot: Maybe<
          WithTypename<IExecuteScatterShotMutationPayload>
        >;
      },
      IMutationModExecuteScatterShotArgs
    >;
    modExpendItem?: GraphCacheUpdateResolver<
      { modExpendItem: Maybe<WithTypename<IExpendItemMutationPayload>> },
      IMutationModExpendItemArgs
    >;
    modExpendResolve?: GraphCacheUpdateResolver<
      { modExpendResolve: Maybe<WithTypename<IExpendResolveMutationPayload>> },
      IMutationModExpendResolveArgs
    >;
    modLeaveBattlefield?: GraphCacheUpdateResolver<
      {
        modLeaveBattlefield: Maybe<
          WithTypename<ILeaveBattlefieldMutationPayload>
        >;
      },
      IMutationModLeaveBattlefieldArgs
    >;
    modMove?: GraphCacheUpdateResolver<
      { modMove: Maybe<WithTypename<IMoveMutationPayload>> },
      IMutationModMoveArgs
    >;
    modPerformKillingBlow?: GraphCacheUpdateResolver<
      {
        modPerformKillingBlow: Maybe<
          WithTypename<IPerformKillingBlowMutationPayload>
        >;
      },
      IMutationModPerformKillingBlowArgs
    >;
    modReattemptAction?: GraphCacheUpdateResolver<
      {
        modReattemptAction: Maybe<
          WithTypename<IReattemptActionMutationPayload>
        >;
      },
      IMutationModReattemptActionArgs
    >;
    modReload?: GraphCacheUpdateResolver<
      { modReload: Maybe<WithTypename<IReloadMutationPayload>> },
      IMutationModReloadArgs
    >;
    modRollAttack?: GraphCacheUpdateResolver<
      { modRollAttack: Maybe<WithTypename<IRollAttackMutationPayload>> },
      IMutationModRollAttackArgs
    >;
    modRollDevelopmentSkill?: GraphCacheUpdateResolver<
      {
        modRollDevelopmentSkill: Maybe<
          WithTypename<IRollDevelopmentSkillMutationPayload>
        >;
      },
      IMutationModRollDevelopmentSkillArgs
    >;
    modRollImpactSkill?: GraphCacheUpdateResolver<
      {
        modRollImpactSkill: Maybe<
          WithTypename<IRollImpactSkillMutationPayload>
        >;
      },
      IMutationModRollImpactSkillArgs
    >;
    modRollInitiative?: GraphCacheUpdateResolver<
      {
        modRollInitiative: Maybe<WithTypename<IRollInitiativeMutationPayload>>;
      },
      IMutationModRollInitiativeArgs
    >;
    modSubmitNarrativeRolePlayBids?: GraphCacheUpdateResolver<
      {
        modSubmitNarrativeRolePlayBids: Maybe<
          WithTypename<ISubmitNarrativeRolePlayBidsMutationPayload>
        >;
      },
      IMutationModSubmitNarrativeRolePlayBidsArgs
    >;
    modUpdateModChallenge?: GraphCacheUpdateResolver<
      {
        modUpdateModChallenge: Maybe<
          WithTypename<IUpdateModChallengeMutationPayload>
        >;
      },
      IMutationModUpdateModChallengeArgs
    >;
    modUpdateModChallengeResolutionOption?: GraphCacheUpdateResolver<
      {
        modUpdateModChallengeResolutionOption: Maybe<
          WithTypename<IUpdateModChallengeResolutionOptionMutationPayload>
        >;
      },
      IMutationModUpdateModChallengeResolutionOptionArgs
    >;
    modUpdateModNarrativeRolePlay?: GraphCacheUpdateResolver<
      {
        modUpdateModNarrativeRolePlay: Maybe<
          WithTypename<IUpdateModNarrativeRolePlayMutationPayload>
        >;
      },
      IMutationModUpdateModNarrativeRolePlayArgs
    >;
    modUseCover?: GraphCacheUpdateResolver<
      { modUseCover: Maybe<WithTypename<IUseCoverMutationPayload>> },
      IMutationModUseCoverArgs
    >;
    removeItemTransaction?: GraphCacheUpdateResolver<
      {
        removeItemTransaction: Maybe<
          WithTypename<IRemoveItemTransactionMutationPayload>
        >;
      },
      IMutationRemoveItemTransactionArgs
    >;
    requestPasswordReset?: GraphCacheUpdateResolver<
      {
        requestPasswordReset: Maybe<
          WithTypename<IRequestPasswordResetMutationPayload>
        >;
      },
      IMutationRequestPasswordResetArgs
    >;
    resetPassword?: GraphCacheUpdateResolver<
      { resetPassword: Maybe<WithTypename<IResetPasswordMutationPayload>> },
      IMutationResetPasswordArgs
    >;
    retireCharacter?: GraphCacheUpdateResolver<
      { retireCharacter: Maybe<WithTypename<IRetireCharacterMutationPayload>> },
      IMutationRetireCharacterArgs
    >;
    rollDice?: GraphCacheUpdateResolver<
      { rollDice: Maybe<WithTypename<IRollDiceMutationPayload>> },
      IMutationRollDiceArgs
    >;
    trackItemUse?: GraphCacheUpdateResolver<
      { trackItemUse: Maybe<WithTypename<ITrackItemUseMutationPayload>> },
      IMutationTrackItemUseArgs
    >;
    updateBranch?: GraphCacheUpdateResolver<
      { updateBranch: Maybe<WithTypename<IUpdateBranchMutationPayload>> },
      IMutationUpdateBranchArgs
    >;
    updateCap?: GraphCacheUpdateResolver<
      { updateCap: Maybe<WithTypename<IUpdateCapMutationPayload>> },
      IMutationUpdateCapArgs
    >;
    updateCharacterActionLog?: GraphCacheUpdateResolver<
      {
        updateCharacterActionLog: Maybe<
          WithTypename<IUpdateCharacterActionLogMutationPayload>
        >;
      },
      IMutationUpdateCharacterActionLogArgs
    >;
    updateCharacterData?: GraphCacheUpdateResolver<
      {
        updateCharacterData: Maybe<
          WithTypename<IUpdateCharacterDataMutationPayload>
        >;
      },
      IMutationUpdateCharacterDataArgs
    >;
    updateCharacterFellowship?: GraphCacheUpdateResolver<
      {
        updateCharacterFellowship: Maybe<
          WithTypename<IUpdateCharacterFellowshipMutationPayload>
        >;
      },
      IMutationUpdateCharacterFellowshipArgs
    >;
    updateCorrectiveAction?: GraphCacheUpdateResolver<
      {
        updateCorrectiveAction: Maybe<
          WithTypename<IUpdateCorrectiveActionMutationPayload>
        >;
      },
      IMutationUpdateCorrectiveActionArgs
    >;
    updateEvent?: GraphCacheUpdateResolver<
      { updateEvent: Maybe<WithTypename<IUpdateEventMutationPayload>> },
      IMutationUpdateEventArgs
    >;
    updateEventAttendee?: GraphCacheUpdateResolver<
      {
        updateEventAttendee: Maybe<
          WithTypename<IUpdateEventAttendeeMutationPayload>
        >;
      },
      IMutationUpdateEventAttendeeArgs
    >;
    updateEventLifecycle?: GraphCacheUpdateResolver<
      {
        updateEventLifecycle: Maybe<
          WithTypename<IUpdateEventLifecycleMutationPayload>
        >;
      },
      IMutationUpdateEventLifecycleArgs
    >;
    updateEventShift?: GraphCacheUpdateResolver<
      {
        updateEventShift: Maybe<WithTypename<IUpdateEventShiftMutationPayload>>;
      },
      IMutationUpdateEventShiftArgs
    >;
    updateEventTicket?: GraphCacheUpdateResolver<
      {
        updateEventTicket: Maybe<
          WithTypename<IUpdateEventTicketMutationPayload>
        >;
      },
      IMutationUpdateEventTicketArgs
    >;
    updateFellowship?: GraphCacheUpdateResolver<
      {
        updateFellowship: Maybe<WithTypename<IUpdateFellowshipMutationPayload>>;
      },
      IMutationUpdateFellowshipArgs
    >;
    updateItem?: GraphCacheUpdateResolver<
      { updateItem: Maybe<WithTypename<IUpdateItemMutationPayload>> },
      IMutationUpdateItemArgs
    >;
    updateItemCrafting?: GraphCacheUpdateResolver<
      {
        updateItemCrafting: Maybe<
          WithTypename<IUpdateItemCraftingMutationPayload>
        >;
      },
      IMutationUpdateItemCraftingArgs
    >;
    updateItemCraftingComponent?: GraphCacheUpdateResolver<
      {
        updateItemCraftingComponent: Maybe<
          WithTypename<IUpdateItemCraftingComponentMutationPayload>
        >;
      },
      IMutationUpdateItemCraftingComponentArgs
    >;
    updateItemCraftingFinalProduct?: GraphCacheUpdateResolver<
      {
        updateItemCraftingFinalProduct: Maybe<
          WithTypename<IUpdateItemCraftingFinalProductMutationPayload>
        >;
      },
      IMutationUpdateItemCraftingFinalProductArgs
    >;
    updateItemReproduction?: GraphCacheUpdateResolver<
      {
        updateItemReproduction: Maybe<
          WithTypename<IUpdateItemReproductionMutationPayload>
        >;
      },
      IMutationUpdateItemReproductionArgs
    >;
    updateItemReproductionComponent?: GraphCacheUpdateResolver<
      {
        updateItemReproductionComponent: Maybe<
          WithTypename<IUpdateItemReproductionComponentMutationPayload>
        >;
      },
      IMutationUpdateItemReproductionComponentArgs
    >;
    updateItemTransaction?: GraphCacheUpdateResolver<
      {
        updateItemTransaction: Maybe<
          WithTypename<IUpdateItemTransactionMutationPayload>
        >;
      },
      IMutationUpdateItemTransactionArgs
    >;
    updateLocation?: GraphCacheUpdateResolver<
      { updateLocation: Maybe<WithTypename<IUpdateLocationMutationPayload>> },
      IMutationUpdateLocationArgs
    >;
    updateMembership?: GraphCacheUpdateResolver<
      {
        updateMembership: Maybe<WithTypename<IUpdateMembershipMutationPayload>>;
      },
      IMutationUpdateMembershipArgs
    >;
    updateMod?: GraphCacheUpdateResolver<
      { updateMod: Maybe<WithTypename<IUpdateModMutationPayload>> },
      IMutationUpdateModArgs
    >;
    updateModAsset?: GraphCacheUpdateResolver<
      { updateModAsset: Maybe<WithTypename<IUpdateModAssetMutationPayload>> },
      IMutationUpdateModAssetArgs
    >;
    updateModReward?: GraphCacheUpdateResolver<
      { updateModReward: Maybe<WithTypename<IUpdateModRewardMutationPayload>> },
      IMutationUpdateModRewardArgs
    >;
    updateModRewardTemplate?: GraphCacheUpdateResolver<
      {
        updateModRewardTemplate: Maybe<
          WithTypename<IUpdateModRewardTemplateMutationPayload>
        >;
      },
      IMutationUpdateModRewardTemplateArgs
    >;
    updateModSection?: GraphCacheUpdateResolver<
      {
        updateModSection: Maybe<WithTypename<IUpdateModSectionMutationPayload>>;
      },
      IMutationUpdateModSectionArgs
    >;
    updateModSignup?: GraphCacheUpdateResolver<
      { updateModSignup: Maybe<WithTypename<IUpdateModSignupMutationPayload>> },
      IMutationUpdateModSignupArgs
    >;
    updateOrganization?: GraphCacheUpdateResolver<
      {
        updateOrganization: Maybe<
          WithTypename<IUpdateOrganizationMutationPayload>
        >;
      },
      IMutationUpdateOrganizationArgs
    >;
    updatePassword?: GraphCacheUpdateResolver<
      { updatePassword: Maybe<WithTypename<IUpdatePasswordMutationPayload>> },
      IMutationUpdatePasswordArgs
    >;
    updatePlayerBranchOwnership?: GraphCacheUpdateResolver<
      {
        updatePlayerBranchOwnership: Maybe<
          WithTypename<IUpdatePlayerBranchOwnershipMutationPayload>
        >;
      },
      IMutationUpdatePlayerBranchOwnershipArgs
    >;
    updatePlayerData?: GraphCacheUpdateResolver<
      {
        updatePlayerData: Maybe<WithTypename<IUpdatePlayerDataMutationPayload>>;
      },
      IMutationUpdatePlayerDataArgs
    >;
    updatePlayerOrganizationData?: GraphCacheUpdateResolver<
      {
        updatePlayerOrganizationData: Maybe<
          WithTypename<IUpdatePlayerOrganizationDataMutationPayload>
        >;
      },
      IMutationUpdatePlayerOrganizationDataArgs
    >;
    updateSpecialDate?: GraphCacheUpdateResolver<
      {
        updateSpecialDate: Maybe<
          WithTypename<IUpdateSpecialDateMutationPayload>
        >;
      },
      IMutationUpdateSpecialDateArgs
    >;
  };
  Subscription?: object;
  ActionLog?: {
    actionType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IActionLog>>,
      Record<string, never>
    >;
    actionValue?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IActionLog>>,
      Record<string, never>
    >;
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IActionLog>>,
      Record<string, never>
    >;
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IActionLog>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IActionLog>>,
      Record<string, never>
    >;
    invalidatedAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IActionLog>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IActionLog>>,
      Record<string, never>
    >;
  };
  ActionLogTally?: {
    armor?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IActionLogTally>>,
      Record<string, never>
    >;
    body?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IActionLogTally>>,
      Record<string, never>
    >;
    mind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IActionLogTally>>,
      Record<string, never>
    >;
    resolve?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IActionLogTally>>,
      Record<string, never>
    >;
    skillUses?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IActionLogTally>>,
      Record<string, never>
    >;
  };
  AddSkillMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAddSkillMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAddSkillMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAddSkillMutationPayload>>,
      Record<string, never>
    >;
  };
  AdvanceTurnMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAdvanceTurnMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAdvanceTurnMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAdvanceTurnMutationPayload>>,
      Record<string, never>
    >;
  };
  AppendItemTransactionMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAppendItemTransactionMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAppendItemTransactionMutationPayload>>,
      Record<string, never>
    >;
    event?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAppendItemTransactionMutationPayload>>,
      Record<string, never>
    >;
  };
  ApplyBranchContractMutationPayload?: {
    branch?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyBranchContractMutationPayload>>,
      Record<string, never>
    >;
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyBranchContractMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyBranchContractMutationPayload>>,
      Record<string, never>
    >;
  };
  ApplyChallengeResolutionMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyChallengeResolutionMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyChallengeResolutionMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyChallengeResolutionMutationPayload>>,
      Record<string, never>
    >;
  };
  ApplyChangeMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyChangeMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyChangeMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyChangeMutationPayload>>,
      Record<string, never>
    >;
  };
  ApplyDamageMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyDamageMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyDamageMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyDamageMutationPayload>>,
      Record<string, never>
    >;
    modLog?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyDamageMutationPayload>>,
      Record<string, never>
    >;
  };
  ApplyEnvironmentalEffectMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyEnvironmentalEffectMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyEnvironmentalEffectMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyEnvironmentalEffectMutationPayload>>,
      Record<string, never>
    >;
  };
  ApplyShieldingMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyShieldingMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyShieldingMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplyShieldingMutationPayload>>,
      Record<string, never>
    >;
  };
  ApplySkillEffectMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplySkillEffectMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplySkillEffectMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplySkillEffectMutationPayload>>,
      Record<string, never>
    >;
    modLog?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IApplySkillEffectMutationPayload>>,
      Record<string, never>
    >;
  };
  AssignBranchLocationMutationPayload?: {
    branch?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAssignBranchLocationMutationPayload>>,
      Record<string, never>
    >;
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAssignBranchLocationMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAssignBranchLocationMutationPayload>>,
      Record<string, never>
    >;
  };
  AssignBranchOwnershipMutationPayload?: {
    branch?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAssignBranchOwnershipMutationPayload>>,
      Record<string, never>
    >;
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAssignBranchOwnershipMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAssignBranchOwnershipMutationPayload>>,
      Record<string, never>
    >;
  };
  AssignTemporaryManagerMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAssignTemporaryManagerMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAssignTemporaryManagerMutationPayload>>,
      Record<string, never>
    >;
    event?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAssignTemporaryManagerMutationPayload>>,
      Record<string, never>
    >;
  };
  AssistImpactSkillMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAssistImpactSkillMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAssistImpactSkillMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAssistImpactSkillMutationPayload>>,
      Record<string, never>
    >;
  };
  AttendanceInvoice?: {
    attending?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendanceInvoice>>,
      Record<string, never>
    >;
    baseCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendanceInvoice>>,
      Record<string, never>
    >;
    buildGrowth?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendanceInvoice>>,
      Record<string, never>
    >;
    change?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendanceInvoice>>,
      Record<string, never>
    >;
    extraXpCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendanceInvoice>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendanceInvoice>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendanceInvoice>>,
      Record<string, never>
    >;
    paid?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendanceInvoice>>,
      Record<string, never>
    >;
    ticket?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendanceInvoice>>,
      Record<string, never>
    >;
    totalCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendanceInvoice>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendanceInvoice>>,
      Record<string, never>
    >;
  };
  AttendeeCharacter?: {
    actionLogs?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendeeCharacter>>,
      Record<string, never>
    >;
    attendance?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendeeCharacter>>,
      Record<string, never>
    >;
    buildGrowth?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendeeCharacter>>,
      Record<string, never>
    >;
    cap?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendeeCharacter>>,
      Record<string, never>
    >;
    character?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendeeCharacter>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendeeCharacter>>,
      Record<string, never>
    >;
    payment?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendeeCharacter>>,
      Record<string, never>
    >;
    printRequestStatus?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendeeCharacter>>,
      Record<string, never>
    >;
    ticket?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendeeCharacter>>,
      Record<string, never>
    >;
  };
  AttendeeShift?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendeeShift>>,
      Record<string, never>
    >;
    player?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendeeShift>>,
      Record<string, never>
    >;
    shift?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendeeShift>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IAttendeeShift>>,
      Record<string, never>
    >;
  };
  Branch?: {
    activePlayers?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      Record<string, never>
    >;
    branchAssistants?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      Record<string, never>
    >;
    branchContracts?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      Record<string, never>
    >;
    branchOwners?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      Record<string, never>
    >;
    caps?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      Record<string, never>
    >;
    correctiveActions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      Record<string, never>
    >;
    district?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      Record<string, never>
    >;
    eventsWithinContract?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      IBranchEventsWithinContractArgs
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      Record<string, never>
    >;
    invoice?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      Record<string, never>
    >;
    location?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      IBranchLocationArgs
    >;
    locations?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      Record<string, never>
    >;
    organization?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      Record<string, never>
    >;
    region?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      Record<string, never>
    >;
    registrationUrl?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      Record<string, never>
    >;
    shorthand?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      Record<string, never>
    >;
    website?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranch>>,
      Record<string, never>
    >;
  };
  BranchContract?: {
    active?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranchContract>>,
      Record<string, never>
    >;
    contract?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranchContract>>,
      Record<string, never>
    >;
    endsAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranchContract>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranchContract>>,
      Record<string, never>
    >;
    startsAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranchContract>>,
      Record<string, never>
    >;
  };
  BranchOwner?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranchOwner>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IBranchOwner>>,
      Record<string, never>
    >;
  };
  CachedUserAttendance?: {
    activeCorrectiveActionsCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICachedUserAttendance>>,
      Record<string, never>
    >;
    attendanceCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICachedUserAttendance>>,
      Record<string, never>
    >;
    branch?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICachedUserAttendance>>,
      Record<string, never>
    >;
    firstEvent?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICachedUserAttendance>>,
      Record<string, never>
    >;
    firstEventAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICachedUserAttendance>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICachedUserAttendance>>,
      Record<string, never>
    >;
    lastEvent?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICachedUserAttendance>>,
      Record<string, never>
    >;
    lastEventAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICachedUserAttendance>>,
      Record<string, never>
    >;
    roleInOrganization?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICachedUserAttendance>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICachedUserAttendance>>,
      Record<string, never>
    >;
  };
  Cap?: {
    amount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICap>>,
      Record<string, never>
    >;
    branch?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICap>>,
      Record<string, never>
    >;
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICap>>,
      Record<string, never>
    >;
    grantor?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICap>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICap>>,
      Record<string, never>
    >;
    reason?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICap>>,
      Record<string, never>
    >;
    state?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICap>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICap>>,
      Record<string, never>
    >;
  };
  Character?: {
    alive?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    body?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    buildEarned?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    buildUsed?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    canBeDeleted?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    characterFellowships?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    currentBody?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    currentLife?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    currentMind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    currentResolve?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    faithId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    faithLevel?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    fellowshipsMissingSubpillar?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    fractures?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      ICharacterFracturesArgs
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    infection?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    inventories?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    itemTransaction?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      ICharacterItemTransactionArgs
    >;
    itemTransactions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      ICharacterItemTransactionsArgs
    >;
    latestLifecycleGainsThisYear?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    legacyHomeGameCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    lifeCapacity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    lifeGain?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    lifeLoss?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    lifecycles?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    lineageId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    loreIds?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    mind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    mindPenalty?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    organization?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    playerNotes?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    resolve?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    retiredCharacter?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    retirementPaths?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    skills?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    staffNotes?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    strainId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    totalHomeGameCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    variant?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    version?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
    xpAudits?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacter>>,
      Record<string, never>
    >;
  };
  CharacterConstraint?: {
    faiths?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacterConstraint>>,
      Record<string, never>
    >;
    reputations?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacterConstraint>>,
      Record<string, never>
    >;
    requiresSubpillar?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacterConstraint>>,
      Record<string, never>
    >;
    skills?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacterConstraint>>,
      Record<string, never>
    >;
    societies?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacterConstraint>>,
      Record<string, never>
    >;
  };
  CharacterFellowship?: {
    character?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacterFellowship>>,
      Record<string, never>
    >;
    fellowship?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacterFellowship>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacterFellowship>>,
      Record<string, never>
    >;
    rank?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacterFellowship>>,
      Record<string, never>
    >;
    removedAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacterFellowship>>,
      Record<string, never>
    >;
  };
  CharacterSkill?: {
    characterSkillId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacterSkill>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacterSkill>>,
      Record<string, never>
    >;
    level?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacterSkill>>,
      Record<string, never>
    >;
    positions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacterSkill>>,
      Record<string, never>
    >;
    remainingUses?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacterSkill>>,
      Record<string, never>
    >;
  };
  CharacterSubConstraint?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacterSubConstraint>>,
      Record<string, never>
    >;
    level?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICharacterSubConstraint>>,
      Record<string, never>
    >;
  };
  CheckinCharacterMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICheckinCharacterMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICheckinCharacterMutationPayload>>,
      Record<string, never>
    >;
    eventAttendee?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICheckinCharacterMutationPayload>>,
      Record<string, never>
    >;
  };
  CheckinMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICheckinMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICheckinMutationPayload>>,
      Record<string, never>
    >;
    eventAttendee?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICheckinMutationPayload>>,
      Record<string, never>
    >;
  };
  ClaimModRewardsMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IClaimModRewardsMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IClaimModRewardsMutationPayload>>,
      Record<string, never>
    >;
    modSignup?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IClaimModRewardsMutationPayload>>,
      Record<string, never>
    >;
  };
  ClearingHouse?: {
    distribution?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IClearingHouse>>,
      Record<string, never>
    >;
    itemId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IClearingHouse>>,
      Record<string, never>
    >;
    itemKind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IClearingHouse>>,
      Record<string, never>
    >;
    itemName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IClearingHouse>>,
      Record<string, never>
    >;
    source?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IClearingHouse>>,
      Record<string, never>
    >;
    stack?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IClearingHouse>>,
      Record<string, never>
    >;
  };
  CompleteScatterShotMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICompleteScatterShotMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICompleteScatterShotMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICompleteScatterShotMutationPayload>>,
      Record<string, never>
    >;
  };
  Contract?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IContract>>,
      Record<string, never>
    >;
    maxGames?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IContract>>,
      Record<string, never>
    >;
    maxVirtualGames?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IContract>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IContract>>,
      Record<string, never>
    >;
  };
  Coord?: {
    x?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICoord>>,
      Record<string, never>
    >;
    y?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICoord>>,
      Record<string, never>
    >;
  };
  CopyCharacterBuildMutationPayload?: {
    character?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICopyCharacterBuildMutationPayload>>,
      Record<string, never>
    >;
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICopyCharacterBuildMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICopyCharacterBuildMutationPayload>>,
      Record<string, never>
    >;
  };
  CopyEventSetupMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICopyEventSetupMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICopyEventSetupMutationPayload>>,
      Record<string, never>
    >;
    event?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICopyEventSetupMutationPayload>>,
      Record<string, never>
    >;
  };
  CorrectiveAction?: {
    branch?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICorrectiveAction>>,
      Record<string, never>
    >;
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICorrectiveAction>>,
      Record<string, never>
    >;
    endsAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICorrectiveAction>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICorrectiveAction>>,
      Record<string, never>
    >;
    issuer?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICorrectiveAction>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICorrectiveAction>>,
      Record<string, never>
    >;
    reason?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICorrectiveAction>>,
      Record<string, never>
    >;
    startsAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICorrectiveAction>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICorrectiveAction>>,
      Record<string, never>
    >;
  };
  CraftableItem?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICraftableItem>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICraftableItem>>,
      Record<string, never>
    >;
    metadata?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICraftableItem>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICraftableItem>>,
      Record<string, never>
    >;
  };
  CraftingComponent?: {
    acceptsExpiredItemWithinDays?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICraftingComponent>>,
      Record<string, never>
    >;
    amount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICraftingComponent>>,
      Record<string, never>
    >;
    component?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICraftingComponent>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICraftingComponent>>,
      Record<string, never>
    >;
    itemCrafting?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICraftingComponent>>,
      Record<string, never>
    >;
  };
  CraftingFinalProduct?: {
    finalProduct?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICraftingFinalProduct>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICraftingFinalProduct>>,
      Record<string, never>
    >;
    stack?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICraftingFinalProduct>>,
      Record<string, never>
    >;
  };
  CreateCapMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateCapMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateCapMutationPayload>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateCapMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateCharacterActionLogMutationPayload?: {
    attendeeCharacter?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateCharacterActionLogMutationPayload>>,
      Record<string, never>
    >;
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateCharacterActionLogMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateCharacterActionLogMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateCharacterFellowshipMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateCharacterFellowshipMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateCharacterFellowshipMutationPayload>>,
      Record<string, never>
    >;
    fellowship?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateCharacterFellowshipMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateCharacterMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateCharacterMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateCharacterMutationPayload>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateCharacterMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateCorrectiveActionMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateCorrectiveActionMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateCorrectiveActionMutationPayload>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateCorrectiveActionMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateEventLifecycleMutationPayload?: {
    character?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateEventLifecycleMutationPayload>>,
      Record<string, never>
    >;
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateEventLifecycleMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateEventLifecycleMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateEventMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateEventMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateEventMutationPayload>>,
      Record<string, never>
    >;
    event?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateEventMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateEventShiftMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateEventShiftMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateEventShiftMutationPayload>>,
      Record<string, never>
    >;
    event?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateEventShiftMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateEventTicketMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateEventTicketMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateEventTicketMutationPayload>>,
      Record<string, never>
    >;
    event?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateEventTicketMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateFellowshipMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateFellowshipMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateFellowshipMutationPayload>>,
      Record<string, never>
    >;
    organization?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateFellowshipMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateFellowshipRuleTagMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateFellowshipRuleTagMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateFellowshipRuleTagMutationPayload>>,
      Record<string, never>
    >;
    fellowship?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateFellowshipRuleTagMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateItemClassificationMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemClassificationMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemClassificationMutationPayload>>,
      Record<string, never>
    >;
    item?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemClassificationMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateItemCraftingComponentMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemCraftingComponentMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemCraftingComponentMutationPayload>>,
      Record<string, never>
    >;
    itemCrafting?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemCraftingComponentMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateItemCraftingFinalProductMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemCraftingFinalProductMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemCraftingFinalProductMutationPayload>>,
      Record<string, never>
    >;
    itemCrafting?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemCraftingFinalProductMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateItemCraftingMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemCraftingMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemCraftingMutationPayload>>,
      Record<string, never>
    >;
    item?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemCraftingMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateItemMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemMutationPayload>>,
      Record<string, never>
    >;
    item?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateItemReproductionComponentMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemReproductionComponentMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemReproductionComponentMutationPayload>>,
      Record<string, never>
    >;
    itemReproduction?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemReproductionComponentMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateItemReproductionMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemReproductionMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemReproductionMutationPayload>>,
      Record<string, never>
    >;
    item?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemReproductionMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateItemTransactionMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemTransactionMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemTransactionMutationPayload>>,
      Record<string, never>
    >;
    itemTransactions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateItemTransactionMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateLocationMutationPayload?: {
    branch?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateLocationMutationPayload>>,
      Record<string, never>
    >;
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateLocationMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateLocationMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateMembershipMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateMembershipMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateMembershipMutationPayload>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateMembershipMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateMessageMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateMessageMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateMessageMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateMessageMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateModAssetMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModAssetMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModAssetMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModAssetMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateModChallengeMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModChallengeMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModChallengeMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModChallengeMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateModMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModMutationPayload>>,
      Record<string, never>
    >;
    modSection?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateModNarrativeRolePlayMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModNarrativeRolePlayMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModNarrativeRolePlayMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModNarrativeRolePlayMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateModRewardMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModRewardMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModRewardMutationPayload>>,
      Record<string, never>
    >;
    modRewardTemplate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModRewardMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateModRewardTemplateMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModRewardTemplateMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModRewardTemplateMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModRewardTemplateMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateModSectionMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModSectionMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModSectionMutationPayload>>,
      Record<string, never>
    >;
    event?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModSectionMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateModSignupMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModSignupMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModSignupMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateModSignupMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateNewPlayerMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateNewPlayerMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateNewPlayerMutationPayload>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateNewPlayerMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateReferralMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateReferralMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateReferralMutationPayload>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateReferralMutationPayload>>,
      Record<string, never>
    >;
  };
  CreateSpecialDateMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateSpecialDateMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateSpecialDateMutationPayload>>,
      Record<string, never>
    >;
    organization?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ICreateSpecialDateMutationPayload>>,
      Record<string, never>
    >;
  };
  DefenseRoll?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDefenseRoll>>,
      Record<string, never>
    >;
    type?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDefenseRoll>>,
      Record<string, never>
    >;
    value?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDefenseRoll>>,
      Record<string, never>
    >;
  };
  DestroyAttendeeCharacterMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyAttendeeCharacterMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyAttendeeCharacterMutationPayload>>,
      Record<string, never>
    >;
    eventAttendee?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyAttendeeCharacterMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyAuthTokenMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyAuthTokenMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyAuthTokenMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyCharacterMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyCharacterMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyCharacterMutationPayload>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyCharacterMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyCorrectiveActionMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyCorrectiveActionMutationPayload>>,
      Record<string, never>
    >;
    correctiveAction?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyCorrectiveActionMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyCorrectiveActionMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyEventAttendeeMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyEventAttendeeMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyEventAttendeeMutationPayload>>,
      Record<string, never>
    >;
    eventAttendee?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyEventAttendeeMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyEventShiftMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyEventShiftMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyEventShiftMutationPayload>>,
      Record<string, never>
    >;
    event?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyEventShiftMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyEventTicketMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyEventTicketMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyEventTicketMutationPayload>>,
      Record<string, never>
    >;
    ticket?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyEventTicketMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyFellowshipRuleTagMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyFellowshipRuleTagMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyFellowshipRuleTagMutationPayload>>,
      Record<string, never>
    >;
    fellowship?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyFellowshipRuleTagMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyItemClassificationMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemClassificationMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemClassificationMutationPayload>>,
      Record<string, never>
    >;
    itemClassification?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemClassificationMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyItemCraftingComponentMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemCraftingComponentMutationPayload>>,
      Record<string, never>
    >;
    craftingComponent?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemCraftingComponentMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemCraftingComponentMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyItemCraftingFinalProductMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemCraftingFinalProductMutationPayload>>,
      Record<string, never>
    >;
    craftingFinalProduct?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemCraftingFinalProductMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemCraftingFinalProductMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyItemCraftingMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemCraftingMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemCraftingMutationPayload>>,
      Record<string, never>
    >;
    itemCrafting?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemCraftingMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyItemReproductionComponentMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemReproductionComponentMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemReproductionComponentMutationPayload>>,
      Record<string, never>
    >;
    itemReproductionComponent?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemReproductionComponentMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyItemReproductionMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemReproductionMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemReproductionMutationPayload>>,
      Record<string, never>
    >;
    itemReproduction?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyItemReproductionMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyLocationMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyLocationMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyLocationMutationPayload>>,
      Record<string, never>
    >;
    location?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyLocationMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyMembershipMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyMembershipMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyMembershipMutationPayload>>,
      Record<string, never>
    >;
    membership?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyMembershipMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyModAssetMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyModAssetMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyModAssetMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyModAssetMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyModMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyModMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyModMutationPayload>>,
      Record<string, never>
    >;
    modSection?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyModMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyModRewardMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyModRewardMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyModRewardMutationPayload>>,
      Record<string, never>
    >;
    modRewardTemplate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyModRewardMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyModRewardTemplateMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyModRewardTemplateMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyModRewardTemplateMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyModRewardTemplateMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyModSignupMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyModSignupMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyModSignupMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyModSignupMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroyReferralMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyReferralMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyReferralMutationPayload>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroyReferralMutationPayload>>,
      Record<string, never>
    >;
  };
  DestroySpecialDateMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroySpecialDateMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroySpecialDateMutationPayload>>,
      Record<string, never>
    >;
    specialDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDestroySpecialDateMutationPayload>>,
      Record<string, never>
    >;
  };
  DiceRollAutoResolve?: {
    matchingProfessionIds?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollAutoResolve>>,
      Record<string, never>
    >;
    sufficientMind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollAutoResolve>>,
      Record<string, never>
    >;
  };
  DiceRollDamage?: {
    add?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollDamage>>,
      Record<string, never>
    >;
    baseRoll?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollDamage>>,
      Record<string, never>
    >;
    damageType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollDamage>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollDamage>>,
      Record<string, never>
    >;
    max?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollDamage>>,
      Record<string, never>
    >;
    min?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollDamage>>,
      Record<string, never>
    >;
    total?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollDamage>>,
      Record<string, never>
    >;
  };
  DiceRollResult?: {
    add?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollResult>>,
      Record<string, never>
    >;
    baseRoll?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollResult>>,
      Record<string, never>
    >;
    connects?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollResult>>,
      Record<string, never>
    >;
    damageTally?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollResult>>,
      Record<string, never>
    >;
    damages?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollResult>>,
      Record<string, never>
    >;
    defensiveRoll?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollResult>>,
      Record<string, never>
    >;
    max?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollResult>>,
      Record<string, never>
    >;
    min?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollResult>>,
      Record<string, never>
    >;
    skillId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollResult>>,
      Record<string, never>
    >;
    subtarget?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollResult>>,
      Record<string, never>
    >;
    total?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollResult>>,
      Record<string, never>
    >;
  };
  DiceRollSummary?: {
    autoResolve?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollSummary>>,
      Record<string, never>
    >;
    rolls?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollSummary>>,
      Record<string, never>
    >;
    totalDamage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IDiceRollSummary>>,
      Record<string, never>
    >;
  };
  EndModMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEndModMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEndModMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEndModMutationPayload>>,
      Record<string, never>
    >;
  };
  EnterBattlefieldMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEnterBattlefieldMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEnterBattlefieldMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEnterBattlefieldMutationPayload>>,
      Record<string, never>
    >;
  };
  EquipMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEquipMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEquipMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEquipMutationPayload>>,
      Record<string, never>
    >;
  };
  Error?: {
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IError>>,
      Record<string, never>
    >;
  };
  Event?: {
    activeCorrectiveActions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      IEventActiveCorrectiveActionsArgs
    >;
    activeMembership?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      IEventActiveMembershipArgs
    >;
    branch?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    canSelfCheckin?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      IEventCanSelfCheckinArgs
    >;
    checkinableCharacters?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      IEventCheckinableCharactersArgs
    >;
    config?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    endsAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    eventAttendee?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      IEventEventAttendeeArgs
    >;
    eventAttendees?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      IEventEventAttendeesArgs
    >;
    eventAttendeesSize?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    isEventAssistant?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    isEventManager?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    isEventRegistrar?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    isHomeGame?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      IEventIsHomeGameArgs
    >;
    isVirtual?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    itemTransactionStatistics?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    itemTransactions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      IEventItemTransactionsArgs
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    location?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    maximumCheckinableCharacters?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      IEventMaximumCheckinableCharactersArgs
    >;
    mod?: GraphCacheUpdateResolver<Maybe<WithTypename<IEvent>>, IEventModArgs>;
    modDescription?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    modEnableWaitlist?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    modMaxSignup?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    modSections?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    modSignupOpensAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    nextEvent?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    prevEvent?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    printouts?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      IEventPrintoutsArgs
    >;
    registrationOpensAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    revenue?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    shiftKinds?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    shifts?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      IEventShiftsArgs
    >;
    startsAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    temporaryManagers?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    ticketStatistics?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
    tickets?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      IEventTicketsArgs
    >;
    ticketsBaseConfig?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEvent>>,
      Record<string, never>
    >;
  };
  EventAttendee?: {
    attendeeCharacters?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    attendeeShifts?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    attending?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    buildAwarded?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    buildGrowth?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    checkedInCharactersCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    checkinApproved?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    costOverride?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    econMindExpenditure?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      IEventAttendeeEconMindExpenditureArgs
    >;
    econResolveExpenditure?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      IEventAttendeeEconResolveExpenditureArgs
    >;
    econTimeExpenditureInMinutes?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    event?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    inviter?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    itemTransactionsTally?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    paid?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    referralInfo?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    restrictedMailout?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    shifts?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    ticket?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    ticketId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventAttendee>>,
      Record<string, never>
    >;
  };
  EventConfig?: {
    baseBuild?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventConfig>>,
      Record<string, never>
    >;
    considersTravelersLocal?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventConfig>>,
      Record<string, never>
    >;
    extraXpCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventConfig>>,
      Record<string, never>
    >;
    maxCurveXp?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventConfig>>,
      Record<string, never>
    >;
    maxExtraXp?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventConfig>>,
      Record<string, never>
    >;
    maxExtraXpLimit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventConfig>>,
      Record<string, never>
    >;
    maxShift?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventConfig>>,
      Record<string, never>
    >;
    shiftKinds?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventConfig>>,
      Record<string, never>
    >;
    shiftMultiplier?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventConfig>>,
      Record<string, never>
    >;
    shiftUnit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventConfig>>,
      Record<string, never>
    >;
  };
  EventInvoice?: {
    attendances?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventInvoice>>,
      Record<string, never>
    >;
    baseCompensationTicketCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventInvoice>>,
      Record<string, never>
    >;
    billableAmount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventInvoice>>,
      Record<string, never>
    >;
    endsAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventInvoice>>,
      Record<string, never>
    >;
    extraXpSold?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventInvoice>>,
      Record<string, never>
    >;
    fullCompensationTicketCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventInvoice>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventInvoice>>,
      Record<string, never>
    >;
    isCommunity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventInvoice>>,
      Record<string, never>
    >;
    isCurrentCycle?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventInvoice>>,
      Record<string, never>
    >;
    isLegacy?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventInvoice>>,
      Record<string, never>
    >;
    isVirtual?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventInvoice>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventInvoice>>,
      Record<string, never>
    >;
    startsAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventInvoice>>,
      Record<string, never>
    >;
    ticketsSold?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventInvoice>>,
      Record<string, never>
    >;
  };
  EventRevenue?: {
    aggregates?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventRevenue>>,
      Record<string, never>
    >;
    itemizedLineItems?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IEventRevenue>>,
      Record<string, never>
    >;
  };
  ExecuteScatterShotMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IExecuteScatterShotMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IExecuteScatterShotMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IExecuteScatterShotMutationPayload>>,
      Record<string, never>
    >;
  };
  ExpendItemMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IExpendItemMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IExpendItemMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IExpendItemMutationPayload>>,
      Record<string, never>
    >;
  };
  ExpendResolveMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IExpendResolveMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IExpendResolveMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IExpendResolveMutationPayload>>,
      Record<string, never>
    >;
  };
  Fellowship?: {
    branch?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowship>>,
      Record<string, never>
    >;
    characterFellowships?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowship>>,
      Record<string, never>
    >;
    characters?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowship>>,
      Record<string, never>
    >;
    charactersCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowship>>,
      Record<string, never>
    >;
    constraint?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowship>>,
      Record<string, never>
    >;
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowship>>,
      Record<string, never>
    >;
    fellowshipRuleTags?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowship>>,
      Record<string, never>
    >;
    groupIdentifier?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowship>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowship>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowship>>,
      Record<string, never>
    >;
    maxRank?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowship>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowship>>,
      Record<string, never>
    >;
    organization?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowship>>,
      Record<string, never>
    >;
    rankNames?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowship>>,
      Record<string, never>
    >;
    removedAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowship>>,
      Record<string, never>
    >;
  };
  FellowshipRuleTag?: {
    fellowship?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowshipRuleTag>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowshipRuleTag>>,
      Record<string, never>
    >;
    ruleTag?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFellowshipRuleTag>>,
      Record<string, never>
    >;
  };
  FinalizeModRewardClaimsMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFinalizeModRewardClaimsMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFinalizeModRewardClaimsMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFinalizeModRewardClaimsMutationPayload>>,
      Record<string, never>
    >;
  };
  Fracture?: {
    character?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFracture>>,
      Record<string, never>
    >;
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFracture>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFracture>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFracture>>,
      Record<string, never>
    >;
    removedAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFracture>>,
      Record<string, never>
    >;
  };
  FulfillShiftMutationPayload?: {
    attendeeShift?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFulfillShiftMutationPayload>>,
      Record<string, never>
    >;
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFulfillShiftMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IFulfillShiftMutationPayload>>,
      Record<string, never>
    >;
  };
  GenerateAuthTokenMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IGenerateAuthTokenMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IGenerateAuthTokenMutationPayload>>,
      Record<string, never>
    >;
    token?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IGenerateAuthTokenMutationPayload>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IGenerateAuthTokenMutationPayload>>,
      Record<string, never>
    >;
  };
  GenerateBattlefieldTokenMutationPayload?: {
    clientId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IGenerateBattlefieldTokenMutationPayload>>,
      Record<string, never>
    >;
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IGenerateBattlefieldTokenMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IGenerateBattlefieldTokenMutationPayload>>,
      Record<string, never>
    >;
    keyName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IGenerateBattlefieldTokenMutationPayload>>,
      Record<string, never>
    >;
    mac?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IGenerateBattlefieldTokenMutationPayload>>,
      Record<string, never>
    >;
    nonce?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IGenerateBattlefieldTokenMutationPayload>>,
      Record<string, never>
    >;
    timestamp?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IGenerateBattlefieldTokenMutationPayload>>,
      Record<string, never>
    >;
  };
  Inventory?: {
    expiresAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInventory>>,
      Record<string, never>
    >;
    expiresOn?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInventory>>,
      Record<string, never>
    >;
    item?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInventory>>,
      Record<string, never>
    >;
    itemId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInventory>>,
      Record<string, never>
    >;
    registeredItem?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInventory>>,
      Record<string, never>
    >;
    registeredItemId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInventory>>,
      Record<string, never>
    >;
    remainingUses?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInventory>>,
      Record<string, never>
    >;
    stack?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInventory>>,
      Record<string, never>
    >;
    stackPending?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInventory>>,
      Record<string, never>
    >;
  };
  Invoice?: {
    additionalXpBuybackCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInvoice>>,
      Record<string, never>
    >;
    additionalXpCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInvoice>>,
      Record<string, never>
    >;
    billableAmount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInvoice>>,
      Record<string, never>
    >;
    events?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInvoice>>,
      Record<string, never>
    >;
    liveEventTicketBuybackCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInvoice>>,
      Record<string, never>
    >;
    liveEventTicketCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInvoice>>,
      Record<string, never>
    >;
    virtualEventTicketBuybackCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInvoice>>,
      Record<string, never>
    >;
    virtualEventTicketCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInvoice>>,
      Record<string, never>
    >;
  };
  InvoiceChange?: {
    attending?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInvoiceChange>>,
      Record<string, never>
    >;
    buildGrowth?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInvoiceChange>>,
      Record<string, never>
    >;
    gameKind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInvoiceChange>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInvoiceChange>>,
      Record<string, never>
    >;
    paid?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInvoiceChange>>,
      Record<string, never>
    >;
    ticketId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInvoiceChange>>,
      Record<string, never>
    >;
    ticketLabel?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IInvoiceChange>>,
      Record<string, never>
    >;
  };
  Item?: {
    blueprintForCraftings?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    childItemClassifications?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    craftsItemWithMultipleUses?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    grade?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    itemCraftings?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    itemReproductions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    lifetimeAmount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    lifetimeUnit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    metadata?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    multipleUses?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    numberOfUses?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    parts?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    updatedAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    validFrom?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    validUntil?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    version?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
    visibility?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItem>>,
      Record<string, never>
    >;
  };
  ItemClaim?: {
    characterId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemClaim>>,
      Record<string, never>
    >;
    stack?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemClaim>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemClaim>>,
      Record<string, never>
    >;
  };
  ItemClassification?: {
    childItem?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemClassification>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemClassification>>,
      Record<string, never>
    >;
  };
  ItemCrafting?: {
    blueprint?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemCrafting>>,
      Record<string, never>
    >;
    craftingComponents?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemCrafting>>,
      Record<string, never>
    >;
    craftingFinalProducts?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemCrafting>>,
      Record<string, never>
    >;
    craftingMindCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemCrafting>>,
      Record<string, never>
    >;
    craftingResolveCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemCrafting>>,
      Record<string, never>
    >;
    craftingSkills?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemCrafting>>,
      Record<string, never>
    >;
    craftingTimeInMinute?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemCrafting>>,
      Record<string, never>
    >;
    craftingZone?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemCrafting>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemCrafting>>,
      Record<string, never>
    >;
  };
  ItemMetadata?: {
    activationRequirement?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    allowBlueprintCopying?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    craftableItems?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    descriptionOfRoleplay?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    durationOfEffect?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    durationOfRoleplay?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    equipmentRequiredForUse?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    locationOfUse?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    mechanics?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    notes?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    printHeader?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    requirementsToUse?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    uses?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    validTargetDescription?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    vehicleArmor?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    vehicleCrewCapacity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    vehicleHull?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    vehicleSpeed?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
    vehicleTurnRadius?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemMetadata>>,
      Record<string, never>
    >;
  };
  ItemReproduction?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemReproduction>>,
      Record<string, never>
    >;
    itemReproductionComponents?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemReproduction>>,
      Record<string, never>
    >;
    metadata?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemReproduction>>,
      Record<string, never>
    >;
    reproductionMindCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemReproduction>>,
      Record<string, never>
    >;
    reproductionSkills?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemReproduction>>,
      Record<string, never>
    >;
    reproductionTimeInMinute?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemReproduction>>,
      Record<string, never>
    >;
  };
  ItemReproductionComponent?: {
    amount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemReproductionComponent>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemReproductionComponent>>,
      Record<string, never>
    >;
    item?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemReproductionComponent>>,
      Record<string, never>
    >;
  };
  ItemReproductionMetadata?: {
    notes?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemReproductionMetadata>>,
      Record<string, never>
    >;
  };
  ItemTransaction?: {
    armorUpgradePoints?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    character?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    childTransactions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    copyBlueprint?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    durationInMinute?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    event?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    expiresAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    expiresOn?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    isMailout?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    item?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    itemCrafting?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    itemTransactionUses?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    mailingAddress?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    mailoutRecipient?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    mindCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    postie?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    priority?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    registeredItem?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    remainingUses?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    resolveCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    skillId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    source?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    stack?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
    transactionPartner?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransaction>>,
      Record<string, never>
    >;
  };
  ItemTransactionTally?: {
    children?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransactionTally>>,
      Record<string, never>
    >;
    claims?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransactionTally>>,
      Record<string, never>
    >;
    groupLimit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransactionTally>>,
      Record<string, never>
    >;
    itemId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransactionTally>>,
      Record<string, never>
    >;
    itemKind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransactionTally>>,
      Record<string, never>
    >;
    itemName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransactionTally>>,
      Record<string, never>
    >;
    limit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransactionTally>>,
      Record<string, never>
    >;
    statusClaims?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransactionTally>>,
      Record<string, never>
    >;
    subtotal?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransactionTally>>,
      Record<string, never>
    >;
  };
  ItemTransactionUse?: {
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransactionUse>>,
      Record<string, never>
    >;
    event?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransactionUse>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransactionUse>>,
      Record<string, never>
    >;
    postie?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransactionUse>>,
      Record<string, never>
    >;
    use?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IItemTransactionUse>>,
      Record<string, never>
    >;
  };
  LeaveBattlefieldMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILeaveBattlefieldMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILeaveBattlefieldMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILeaveBattlefieldMutationPayload>>,
      Record<string, never>
    >;
  };
  Lifecycle?: {
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILifecycle>>,
      Record<string, never>
    >;
    deletedAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILifecycle>>,
      Record<string, never>
    >;
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILifecycle>>,
      Record<string, never>
    >;
    event?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILifecycle>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILifecycle>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILifecycle>>,
      Record<string, never>
    >;
  };
  Location?: {
    city?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILocation>>,
      Record<string, never>
    >;
    events?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILocation>>,
      ILocationEventsArgs
    >;
    existingEventsSize?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILocation>>,
      ILocationExistingEventsSizeArgs
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILocation>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILocation>>,
      Record<string, never>
    >;
    region?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILocation>>,
      Record<string, never>
    >;
    streetAddress?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILocation>>,
      Record<string, never>
    >;
    zipCode?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILocation>>,
      Record<string, never>
    >;
  };
  LogBlueprintActionMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILogBlueprintActionMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILogBlueprintActionMutationPayload>>,
      Record<string, never>
    >;
    success?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ILogBlueprintActionMutationPayload>>,
      Record<string, never>
    >;
  };
  Membership?: {
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMembership>>,
      Record<string, never>
    >;
    endsAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMembership>>,
      Record<string, never>
    >;
    grantingBranch?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMembership>>,
      Record<string, never>
    >;
    grantor?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMembership>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMembership>>,
      Record<string, never>
    >;
    organization?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMembership>>,
      Record<string, never>
    >;
    startsAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMembership>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMembership>>,
      Record<string, never>
    >;
  };
  Mod?: {
    activeModRewardTemplate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    constraint?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    currentAsset?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    currentEntity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    currentModNarrativeRolePlay?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    currentTurn?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    itemTransactions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    modAssets?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    modChallenge?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      IModModChallengeArgs
    >;
    modEntities?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    modLogs?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      IModModLogsArgs
    >;
    modNarrativeRolePlays?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    modRewardTemplate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      IModModRewardTemplateArgs
    >;
    modRewardTemplates?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    modRunner?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    modSection?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    modSignup?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      IModModSignupArgs
    >;
    modSignups?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    myEntity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    participationLimit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    ping?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
    timeframe?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMod>>,
      Record<string, never>
    >;
  };
  ModAsset?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModAsset>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModAsset>>,
      Record<string, never>
    >;
    url?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModAsset>>,
      Record<string, never>
    >;
  };
  ModBids?: {
    body?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModBids>>,
      Record<string, never>
    >;
    limbs?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModBids>>,
      Record<string, never>
    >;
    mind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModBids>>,
      Record<string, never>
    >;
    resolve?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModBids>>,
      Record<string, never>
    >;
    skills?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModBids>>,
      Record<string, never>
    >;
  };
  ModBidsSkill?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModBidsSkill>>,
      Record<string, never>
    >;
    value?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModBidsSkill>>,
      Record<string, never>
    >;
  };
  ModChallenge?: {
    defenseRollMatrix?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModChallenge>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModChallenge>>,
      Record<string, never>
    >;
    initiative?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModChallenge>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModChallenge>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModChallenge>>,
      Record<string, never>
    >;
    position?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModChallenge>>,
      Record<string, never>
    >;
    publicNote?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModChallenge>>,
      Record<string, never>
    >;
    stack?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModChallenge>>,
      Record<string, never>
    >;
    state?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModChallenge>>,
      Record<string, never>
    >;
    storytellerNote?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModChallenge>>,
      Record<string, never>
    >;
    visibility?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModChallenge>>,
      Record<string, never>
    >;
  };
  ModChallengeResolutionOption?: {
    level?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModChallengeResolutionOption>>,
      Record<string, never>
    >;
    skillId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModChallengeResolutionOption>>,
      Record<string, never>
    >;
  };
  ModChallengeState?: {
    professionOptions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModChallengeState>>,
      Record<string, never>
    >;
    resolutionOptions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModChallengeState>>,
      Record<string, never>
    >;
    stack?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModChallengeState>>,
      Record<string, never>
    >;
    statusEffects?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModChallengeState>>,
      Record<string, never>
    >;
  };
  ModLog?: {
    content?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModLog>>,
      Record<string, never>
    >;
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModLog>>,
      Record<string, never>
    >;
    damageAmount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModLog>>,
      Record<string, never>
    >;
    damageType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModLog>>,
      Record<string, never>
    >;
    diceRollLog?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModLog>>,
      Record<string, never>
    >;
    entity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModLog>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModLog>>,
      Record<string, never>
    >;
    initiative?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModLog>>,
      Record<string, never>
    >;
    interferer?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModLog>>,
      Record<string, never>
    >;
    originalLog?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModLog>>,
      Record<string, never>
    >;
    systemMessage?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModLog>>,
      Record<string, never>
    >;
    target?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModLog>>,
      Record<string, never>
    >;
    turn?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModLog>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModLog>>,
      Record<string, never>
    >;
  };
  ModNarrativeRolePlay?: {
    body?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModNarrativeRolePlay>>,
      Record<string, never>
    >;
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModNarrativeRolePlay>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModNarrativeRolePlay>>,
      Record<string, never>
    >;
    limbs?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModNarrativeRolePlay>>,
      Record<string, never>
    >;
    mind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModNarrativeRolePlay>>,
      Record<string, never>
    >;
    modNarrativeRolePlayBids?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModNarrativeRolePlay>>,
      Record<string, never>
    >;
    resolve?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModNarrativeRolePlay>>,
      Record<string, never>
    >;
    skills?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModNarrativeRolePlay>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModNarrativeRolePlay>>,
      Record<string, never>
    >;
    title?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModNarrativeRolePlay>>,
      Record<string, never>
    >;
  };
  ModNarrativeRolePlayBid?: {
    bids?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModNarrativeRolePlayBid>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModNarrativeRolePlayBid>>,
      Record<string, never>
    >;
    modSignup?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModNarrativeRolePlayBid>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModNarrativeRolePlayBid>>,
      Record<string, never>
    >;
  };
  ModParticipantEquipment?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantEquipment>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantEquipment>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantEquipment>>,
      Record<string, never>
    >;
    shotCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantEquipment>>,
      Record<string, never>
    >;
    tracksShot?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantEquipment>>,
      Record<string, never>
    >;
  };
  ModParticipantLimb?: {
    equipment?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantLimb>>,
      Record<string, never>
    >;
    limbName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantLimb>>,
      Record<string, never>
    >;
    status?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantLimb>>,
      Record<string, never>
    >;
  };
  ModParticipantMaskedState?: {
    armor?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantMaskedState>>,
      Record<string, never>
    >;
    health?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantMaskedState>>,
      Record<string, never>
    >;
    limbs?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantMaskedState>>,
      Record<string, never>
    >;
    statusEffects?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantMaskedState>>,
      Record<string, never>
    >;
  };
  ModParticipantSkillUse?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantSkillUse>>,
      Record<string, never>
    >;
    level?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantSkillUse>>,
      Record<string, never>
    >;
    remainingUses?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantSkillUse>>,
      Record<string, never>
    >;
  };
  ModParticipantState?: {
    armor?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantState>>,
      Record<string, never>
    >;
    body?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantState>>,
      Record<string, never>
    >;
    limbs?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantState>>,
      Record<string, never>
    >;
    maxBody?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantState>>,
      Record<string, never>
    >;
    maxMind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantState>>,
      Record<string, never>
    >;
    maxResolve?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantState>>,
      Record<string, never>
    >;
    mind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantState>>,
      Record<string, never>
    >;
    resolve?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantState>>,
      Record<string, never>
    >;
    skillUses?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantState>>,
      Record<string, never>
    >;
    statusEffects?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantState>>,
      Record<string, never>
    >;
  };
  ModParticipantStatusEffect?: {
    appliedAtInitiative?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantStatusEffect>>,
      Record<string, never>
    >;
    appliedAtTurn?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantStatusEffect>>,
      Record<string, never>
    >;
    appliedByEntityId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantStatusEffect>>,
      Record<string, never>
    >;
    appliedByEntityName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantStatusEffect>>,
      Record<string, never>
    >;
    appliedByEntityType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantStatusEffect>>,
      Record<string, never>
    >;
    entities?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantStatusEffect>>,
      Record<string, never>
    >;
    expiresAtInitiative?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantStatusEffect>>,
      Record<string, never>
    >;
    expiresAtTurn?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantStatusEffect>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantStatusEffect>>,
      Record<string, never>
    >;
    skillId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantStatusEffect>>,
      Record<string, never>
    >;
    subtarget?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantStatusEffect>>,
      Record<string, never>
    >;
    value?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantStatusEffect>>,
      Record<string, never>
    >;
  };
  ModParticipantStatusEffectEntity?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantStatusEffectEntity>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantStatusEffectEntity>>,
      Record<string, never>
    >;
    type?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModParticipantStatusEffectEntity>>,
      Record<string, never>
    >;
  };
  ModReward?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModReward>>,
      Record<string, never>
    >;
    item?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModReward>>,
      Record<string, never>
    >;
    modRewardClaims?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModReward>>,
      Record<string, never>
    >;
    stack?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModReward>>,
      Record<string, never>
    >;
  };
  ModRewardClaim?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModRewardClaim>>,
      Record<string, never>
    >;
    modSignup?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModRewardClaim>>,
      Record<string, never>
    >;
    stack?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModRewardClaim>>,
      Record<string, never>
    >;
  };
  ModRewardTemplate?: {
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModRewardTemplate>>,
      Record<string, never>
    >;
    finalized?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModRewardTemplate>>,
      Record<string, never>
    >;
    finalizedAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModRewardTemplate>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModRewardTemplate>>,
      Record<string, never>
    >;
    modRewards?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModRewardTemplate>>,
      Record<string, never>
    >;
    modRunnerNote?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModRewardTemplate>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModRewardTemplate>>,
      Record<string, never>
    >;
  };
  ModSection?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModSection>>,
      Record<string, never>
    >;
    mods?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModSection>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModSection>>,
      Record<string, never>
    >;
    signupLimit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModSection>>,
      Record<string, never>
    >;
  };
  ModSignup?: {
    character?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModSignup>>,
      Record<string, never>
    >;
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModSignup>>,
      Record<string, never>
    >;
    defenseRollMatrix?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModSignup>>,
      Record<string, never>
    >;
    eventAttendee?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModSignup>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModSignup>>,
      Record<string, never>
    >;
    initiative?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModSignup>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModSignup>>,
      Record<string, never>
    >;
    ping?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModSignup>>,
      Record<string, never>
    >;
    position?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModSignup>>,
      Record<string, never>
    >;
    state?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModSignup>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModSignup>>,
      Record<string, never>
    >;
    visibility?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IModSignup>>,
      Record<string, never>
    >;
  };
  MoveMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMoveMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMoveMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IMoveMutationPayload>>,
      Record<string, never>
    >;
  };
  Organization?: {
    armorUpgradeComponents?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    attendances?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      IOrganizationAttendancesArgs
    >;
    blueprintCopyProcedure?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    branch?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    branches?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      IOrganizationBranchesArgs
    >;
    characters?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      IOrganizationCharactersArgs
    >;
    configs?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    contracts?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    fellowship?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      IOrganizationFellowshipArgs
    >;
    fellowships?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      IOrganizationFellowshipsArgs
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    item?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      IOrganizationItemArgs
    >;
    itemGrades?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    itemKinds?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    items?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      IOrganizationItemsArgs
    >;
    lastEventAttendanceSnapshotOn?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    lastEventDiffOn?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    memberships?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      IOrganizationMembershipsArgs
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    rebirthedCharacters?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    role?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    ruleTags?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    shorthand?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    slug?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    specialDates?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    statistics?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      IOrganizationStatisticsArgs
    >;
    threats?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    timelines?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      Record<string, never>
    >;
    userGrowths?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganization>>,
      IOrganizationUserGrowthsArgs
    >;
  };
  OrganizationConfig?: {
    charactersActiveCountMax?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganizationConfig>>,
      Record<string, never>
    >;
    charactersCountMax?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganizationConfig>>,
      Record<string, never>
    >;
    charactersCountStaffMax?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganizationConfig>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IOrganizationConfig>>,
      Record<string, never>
    >;
  };
  PerformKillingBlowMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IPerformKillingBlowMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IPerformKillingBlowMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IPerformKillingBlowMutationPayload>>,
      Record<string, never>
    >;
  };
  Permission?: {
    entity?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IPermission>>,
      Record<string, never>
    >;
    permitted?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IPermission>>,
      Record<string, never>
    >;
  };
  ReattemptActionMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IReattemptActionMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IReattemptActionMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IReattemptActionMutationPayload>>,
      Record<string, never>
    >;
  };
  RegisteredItem?: {
    description?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRegisteredItem>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRegisteredItem>>,
      Record<string, never>
    >;
  };
  ReloadMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IReloadMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IReloadMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IReloadMutationPayload>>,
      Record<string, never>
    >;
  };
  RemoveItemTransactionMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRemoveItemTransactionMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRemoveItemTransactionMutationPayload>>,
      Record<string, never>
    >;
    event?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRemoveItemTransactionMutationPayload>>,
      Record<string, never>
    >;
  };
  RequestPasswordResetMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRequestPasswordResetMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRequestPasswordResetMutationPayload>>,
      Record<string, never>
    >;
  };
  ResetPasswordMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IResetPasswordMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IResetPasswordMutationPayload>>,
      Record<string, never>
    >;
    token?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IResetPasswordMutationPayload>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IResetPasswordMutationPayload>>,
      Record<string, never>
    >;
  };
  ResidenciesStatistics?: {
    branchIds?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IResidenciesStatistics>>,
      Record<string, never>
    >;
    eventId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IResidenciesStatistics>>,
      Record<string, never>
    >;
    modId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IResidenciesStatistics>>,
      Record<string, never>
    >;
    type?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IResidenciesStatistics>>,
      Record<string, never>
    >;
    values?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IResidenciesStatistics>>,
      Record<string, never>
    >;
  };
  ResidencyStatistics?: {
    count?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IResidencyStatistics>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IResidencyStatistics>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IResidencyStatistics>>,
      Record<string, never>
    >;
    shorthand?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IResidencyStatistics>>,
      Record<string, never>
    >;
  };
  RetireCharacterMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRetireCharacterMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRetireCharacterMutationPayload>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRetireCharacterMutationPayload>>,
      Record<string, never>
    >;
  };
  RetirementPaths?: {
    alive?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRetirementPaths>>,
      Record<string, never>
    >;
    dead?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRetirementPaths>>,
      Record<string, never>
    >;
  };
  RetirementXp?: {
    amount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRetirementXp>>,
      Record<string, never>
    >;
    earnedOn?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRetirementXp>>,
      Record<string, never>
    >;
  };
  RevenueAggregates?: {
    attendeesPaid?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRevenueAggregates>>,
      Record<string, never>
    >;
    attendeesTotal?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRevenueAggregates>>,
      Record<string, never>
    >;
    revenue?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRevenueAggregates>>,
      Record<string, never>
    >;
    revenueDiscounted?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRevenueAggregates>>,
      Record<string, never>
    >;
    revenueLiable?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRevenueAggregates>>,
      Record<string, never>
    >;
  };
  RollAttackMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRollAttackMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRollAttackMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRollAttackMutationPayload>>,
      Record<string, never>
    >;
  };
  RollDevelopmentSkillMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRollDevelopmentSkillMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRollDevelopmentSkillMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRollDevelopmentSkillMutationPayload>>,
      Record<string, never>
    >;
  };
  RollDiceMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRollDiceMutationPayload>>,
      Record<string, never>
    >;
    diceRollSummary?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRollDiceMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRollDiceMutationPayload>>,
      Record<string, never>
    >;
  };
  RollImpactSkillMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRollImpactSkillMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRollImpactSkillMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRollImpactSkillMutationPayload>>,
      Record<string, never>
    >;
  };
  RollInitiativeMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRollInitiativeMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRollInitiativeMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRollInitiativeMutationPayload>>,
      Record<string, never>
    >;
  };
  RuleTag?: {
    fellowshipRuleTags?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRuleTag>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRuleTag>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRuleTag>>,
      Record<string, never>
    >;
    value?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IRuleTag>>,
      Record<string, never>
    >;
  };
  Shift?: {
    adjustableExpansionStrategy?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IShift>>,
      Record<string, never>
    >;
    attendeeShifts?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IShift>>,
      Record<string, never>
    >;
    autoExpand?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IShift>>,
      Record<string, never>
    >;
    baseRatio?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IShift>>,
      Record<string, never>
    >;
    eventId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IShift>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IShift>>,
      Record<string, never>
    >;
    identifier?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IShift>>,
      Record<string, never>
    >;
    isEnabled?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IShift>>,
      Record<string, never>
    >;
    isFullyBooked?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IShift>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IShift>>,
      Record<string, never>
    >;
    label?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IShift>>,
      Record<string, never>
    >;
    limit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IShift>>,
      Record<string, never>
    >;
    playersCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IShift>>,
      Record<string, never>
    >;
  };
  SkillCategoriesStatistics?: {
    branchIds?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISkillCategoriesStatistics>>,
      Record<string, never>
    >;
    eventId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISkillCategoriesStatistics>>,
      Record<string, never>
    >;
    modId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISkillCategoriesStatistics>>,
      Record<string, never>
    >;
    type?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISkillCategoriesStatistics>>,
      Record<string, never>
    >;
    values?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISkillCategoriesStatistics>>,
      Record<string, never>
    >;
  };
  SkillCategoryStatistics?: {
    aberrants?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISkillCategoryStatistics>>,
      Record<string, never>
    >;
    criminals?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISkillCategoryStatistics>>,
      Record<string, never>
    >;
    total?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISkillCategoryStatistics>>,
      Record<string, never>
    >;
  };
  SkillStatistics?: {
    count?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISkillStatistics>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISkillStatistics>>,
      Record<string, never>
    >;
    level?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISkillStatistics>>,
      Record<string, never>
    >;
  };
  SkillsStatistics?: {
    branchIds?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISkillsStatistics>>,
      Record<string, never>
    >;
    eventId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISkillsStatistics>>,
      Record<string, never>
    >;
    modId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISkillsStatistics>>,
      Record<string, never>
    >;
    type?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISkillsStatistics>>,
      Record<string, never>
    >;
    values?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISkillsStatistics>>,
      Record<string, never>
    >;
  };
  SpecialDate?: {
    endsAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISpecialDate>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISpecialDate>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISpecialDate>>,
      Record<string, never>
    >;
    startsAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISpecialDate>>,
      Record<string, never>
    >;
    title?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISpecialDate>>,
      Record<string, never>
    >;
  };
  StatStatistics?: {
    body?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IStatStatistics>>,
      Record<string, never>
    >;
    buildEarned?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IStatStatistics>>,
      Record<string, never>
    >;
    buildUsed?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IStatStatistics>>,
      Record<string, never>
    >;
    currentLife?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IStatStatistics>>,
      Record<string, never>
    >;
    faithId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IStatStatistics>>,
      Record<string, never>
    >;
    mind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IStatStatistics>>,
      Record<string, never>
    >;
    resolve?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IStatStatistics>>,
      Record<string, never>
    >;
    strainId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IStatStatistics>>,
      Record<string, never>
    >;
  };
  StatsStatistics?: {
    branchIds?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IStatsStatistics>>,
      Record<string, never>
    >;
    eventId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IStatsStatistics>>,
      Record<string, never>
    >;
    modId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IStatsStatistics>>,
      Record<string, never>
    >;
    type?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IStatsStatistics>>,
      Record<string, never>
    >;
    values?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IStatsStatistics>>,
      Record<string, never>
    >;
  };
  SubmitNarrativeRolePlayBidsMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISubmitNarrativeRolePlayBidsMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISubmitNarrativeRolePlayBidsMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISubmitNarrativeRolePlayBidsMutationPayload>>,
      Record<string, never>
    >;
    modNarrativeRolePlayBid?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ISubmitNarrativeRolePlayBidsMutationPayload>>,
      Record<string, never>
    >;
  };
  TalliedActionLog?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITalliedActionLog>>,
      Record<string, never>
    >;
    log?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITalliedActionLog>>,
      Record<string, never>
    >;
    tally?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITalliedActionLog>>,
      Record<string, never>
    >;
    valid?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITalliedActionLog>>,
      Record<string, never>
    >;
  };
  TemporaryManager?: {
    event?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITemporaryManager>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITemporaryManager>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITemporaryManager>>,
      Record<string, never>
    >;
  };
  TemporaryToken?: {
    browser?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITemporaryToken>>,
      Record<string, never>
    >;
    expiresAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITemporaryToken>>,
      Record<string, never>
    >;
    hardware?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITemporaryToken>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITemporaryToken>>,
      Record<string, never>
    >;
    ipAddress?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITemporaryToken>>,
      Record<string, never>
    >;
    os?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITemporaryToken>>,
      Record<string, never>
    >;
    token?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITemporaryToken>>,
      Record<string, never>
    >;
  };
  Threat?: {
    body?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IThreat>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IThreat>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IThreat>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IThreat>>,
      Record<string, never>
    >;
    rank?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IThreat>>,
      Record<string, never>
    >;
    skillUses?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IThreat>>,
      Record<string, never>
    >;
    statusEffects?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IThreat>>,
      Record<string, never>
    >;
    variant?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IThreat>>,
      Record<string, never>
    >;
  };
  Ticket?: {
    cost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicket>>,
      Record<string, never>
    >;
    discountType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicket>>,
      Record<string, never>
    >;
    econRestriction?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicket>>,
      Record<string, never>
    >;
    eventAttendeesCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicket>>,
      Record<string, never>
    >;
    eventId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicket>>,
      Record<string, never>
    >;
    extraXpCost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicket>>,
      Record<string, never>
    >;
    fixedLimit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicket>>,
      Record<string, never>
    >;
    fullyBooked?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicket>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicket>>,
      Record<string, never>
    >;
    identifier?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicket>>,
      Record<string, never>
    >;
    label?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicket>>,
      Record<string, never>
    >;
    limit?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicket>>,
      Record<string, never>
    >;
    modMaxSignup?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicket>>,
      Record<string, never>
    >;
    passType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicket>>,
      Record<string, never>
    >;
    restrictionType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicket>>,
      Record<string, never>
    >;
    shiftResponsibilities?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicket>>,
      Record<string, never>
    >;
  };
  TicketInvoice?: {
    discountType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicketInvoice>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicketInvoice>>,
      Record<string, never>
    >;
    label?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicketInvoice>>,
      Record<string, never>
    >;
  };
  TicketRevenue?: {
    attendeesPaid?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicketRevenue>>,
      Record<string, never>
    >;
    attendeesTotal?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicketRevenue>>,
      Record<string, never>
    >;
    cost?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicketRevenue>>,
      Record<string, never>
    >;
    discountType?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicketRevenue>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicketRevenue>>,
      Record<string, never>
    >;
    label?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicketRevenue>>,
      Record<string, never>
    >;
    revenue?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicketRevenue>>,
      Record<string, never>
    >;
    revenueDiscounted?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicketRevenue>>,
      Record<string, never>
    >;
    revenueLiable?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicketRevenue>>,
      Record<string, never>
    >;
    subitems?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicketRevenue>>,
      Record<string, never>
    >;
  };
  TicketsBaseConfig?: {
    discountTypes?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicketsBaseConfig>>,
      Record<string, never>
    >;
    passTypes?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicketsBaseConfig>>,
      Record<string, never>
    >;
    restrictionTypes?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITicketsBaseConfig>>,
      Record<string, never>
    >;
  };
  Timeline?: {
    attendance?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITimeline>>,
      Record<string, never>
    >;
    eventId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITimeline>>,
      Record<string, never>
    >;
    eventName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITimeline>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITimeline>>,
      Record<string, never>
    >;
    local?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITimeline>>,
      Record<string, never>
    >;
    shorthand?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITimeline>>,
      Record<string, never>
    >;
    timecode?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITimeline>>,
      Record<string, never>
    >;
    virtual?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITimeline>>,
      Record<string, never>
    >;
  };
  TrackItemUseMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITrackItemUseMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITrackItemUseMutationPayload>>,
      Record<string, never>
    >;
    itemTransaction?: GraphCacheUpdateResolver<
      Maybe<WithTypename<ITrackItemUseMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateBranchMutationPayload?: {
    branch?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateBranchMutationPayload>>,
      Record<string, never>
    >;
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateBranchMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateBranchMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateCapMutationPayload?: {
    cap?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateCapMutationPayload>>,
      Record<string, never>
    >;
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateCapMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateCapMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateCharacterActionLogMutationPayload?: {
    attendeeCharacter?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateCharacterActionLogMutationPayload>>,
      Record<string, never>
    >;
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateCharacterActionLogMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateCharacterActionLogMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateCharacterDataMutationPayload?: {
    character?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateCharacterDataMutationPayload>>,
      Record<string, never>
    >;
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateCharacterDataMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateCharacterDataMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateCharacterFellowshipMutationPayload?: {
    characterFellowship?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateCharacterFellowshipMutationPayload>>,
      Record<string, never>
    >;
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateCharacterFellowshipMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateCharacterFellowshipMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateCorrectiveActionMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateCorrectiveActionMutationPayload>>,
      Record<string, never>
    >;
    correctiveAction?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateCorrectiveActionMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateCorrectiveActionMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateEventAttendeeMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateEventAttendeeMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateEventAttendeeMutationPayload>>,
      Record<string, never>
    >;
    eventAttendee?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateEventAttendeeMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateEventLifecycleMutationPayload?: {
    character?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateEventLifecycleMutationPayload>>,
      Record<string, never>
    >;
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateEventLifecycleMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateEventLifecycleMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateEventMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateEventMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateEventMutationPayload>>,
      Record<string, never>
    >;
    event?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateEventMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateEventShiftMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateEventShiftMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateEventShiftMutationPayload>>,
      Record<string, never>
    >;
    shift?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateEventShiftMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateEventTicketMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateEventTicketMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateEventTicketMutationPayload>>,
      Record<string, never>
    >;
    ticket?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateEventTicketMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateFellowshipMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateFellowshipMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateFellowshipMutationPayload>>,
      Record<string, never>
    >;
    fellowship?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateFellowshipMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateItemCraftingComponentMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemCraftingComponentMutationPayload>>,
      Record<string, never>
    >;
    craftingComponent?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemCraftingComponentMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemCraftingComponentMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateItemCraftingFinalProductMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemCraftingFinalProductMutationPayload>>,
      Record<string, never>
    >;
    craftingFinalProduct?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemCraftingFinalProductMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemCraftingFinalProductMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateItemCraftingMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemCraftingMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemCraftingMutationPayload>>,
      Record<string, never>
    >;
    itemCrafting?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemCraftingMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateItemMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemMutationPayload>>,
      Record<string, never>
    >;
    item?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateItemReproductionComponentMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemReproductionComponentMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemReproductionComponentMutationPayload>>,
      Record<string, never>
    >;
    itemReproductionComponent?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemReproductionComponentMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateItemReproductionMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemReproductionMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemReproductionMutationPayload>>,
      Record<string, never>
    >;
    itemReproduction?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemReproductionMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateItemTransactionMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemTransactionMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemTransactionMutationPayload>>,
      Record<string, never>
    >;
    itemTransaction?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateItemTransactionMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateLocationMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateLocationMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateLocationMutationPayload>>,
      Record<string, never>
    >;
    location?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateLocationMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateMembershipMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateMembershipMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateMembershipMutationPayload>>,
      Record<string, never>
    >;
    membership?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateMembershipMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateModAssetMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModAssetMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModAssetMutationPayload>>,
      Record<string, never>
    >;
    modAsset?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModAssetMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateModChallengeMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModChallengeMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModChallengeMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModChallengeMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateModChallengeResolutionOptionMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModChallengeResolutionOptionMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModChallengeResolutionOptionMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModChallengeResolutionOptionMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateModMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateModNarrativeRolePlayMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModNarrativeRolePlayMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModNarrativeRolePlayMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModNarrativeRolePlayMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateModRewardMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModRewardMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModRewardMutationPayload>>,
      Record<string, never>
    >;
    modReward?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModRewardMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateModRewardTemplateMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModRewardTemplateMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModRewardTemplateMutationPayload>>,
      Record<string, never>
    >;
    modRewardTemplate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModRewardTemplateMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateModSectionMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModSectionMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModSectionMutationPayload>>,
      Record<string, never>
    >;
    modSection?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModSectionMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateModSignupMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModSignupMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModSignupMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateModSignupMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateOrganizationMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateOrganizationMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateOrganizationMutationPayload>>,
      Record<string, never>
    >;
    organization?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateOrganizationMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdatePasswordMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdatePasswordMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdatePasswordMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdatePlayerBranchOwnershipMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdatePlayerBranchOwnershipMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdatePlayerBranchOwnershipMutationPayload>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdatePlayerBranchOwnershipMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdatePlayerDataMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdatePlayerDataMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdatePlayerDataMutationPayload>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdatePlayerDataMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdatePlayerOrganizationDataMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdatePlayerOrganizationDataMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdatePlayerOrganizationDataMutationPayload>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdatePlayerOrganizationDataMutationPayload>>,
      Record<string, never>
    >;
  };
  UpdateSpecialDateMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateSpecialDateMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateSpecialDateMutationPayload>>,
      Record<string, never>
    >;
    specialDate?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUpdateSpecialDateMutationPayload>>,
      Record<string, never>
    >;
  };
  UseCoverMutationPayload?: {
    clientMutationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUseCoverMutationPayload>>,
      Record<string, never>
    >;
    error?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUseCoverMutationPayload>>,
      Record<string, never>
    >;
    mod?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUseCoverMutationPayload>>,
      Record<string, never>
    >;
  };
  User?: {
    assistantFlags?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      IUserAssistantFlagsArgs
    >;
    caps?: GraphCacheUpdateResolver<Maybe<WithTypename<IUser>>, IUserCapsArgs>;
    character?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      IUserCharacterArgs
    >;
    characters?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      IUserCharactersArgs
    >;
    correctiveActions?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
    emailAddress?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
    emailCorrespondence?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
    eventAttendances?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      IUserEventAttendancesArgs
    >;
    firstName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
    fullName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
    invitations?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      IUserInvitationsArgs
    >;
    lastMembership?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      IUserLastMembershipArgs
    >;
    lastName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
    mailingAddress?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
    maxActiveCharactersCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
    maxCharactersCount?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
    membershipActiveDuringEvent?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      IUserMembershipActiveDuringEventArgs
    >;
    memberships?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      IUserMembershipsArgs
    >;
    notes?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
    organizations?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
    ownedBranches?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
    preferredName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
    recentEventAttendances?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
    referrals?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      IUserReferralsArgs
    >;
    roleInOrganization?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      IUserRoleInOrganizationArgs
    >;
    temporaryTokens?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
    totalCapsForEvent?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      IUserTotalCapsForEventArgs
    >;
    upcomingEvents?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      IUserUpcomingEventsArgs
    >;
    userOrganization?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      IUserUserOrganizationArgs
    >;
    userOrganizations?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUser>>,
      Record<string, never>
    >;
  };
  UserGrowth?: {
    count?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUserGrowth>>,
      Record<string, never>
    >;
    timeframe?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUserGrowth>>,
      Record<string, never>
    >;
  };
  UserInvoice?: {
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUserInvoice>>,
      Record<string, never>
    >;
    name?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUserInvoice>>,
      Record<string, never>
    >;
  };
  UserOrganization?: {
    assistantFlags?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUserOrganization>>,
      Record<string, never>
    >;
    branch?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUserOrganization>>,
      Record<string, never>
    >;
    branchId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUserOrganization>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUserOrganization>>,
      Record<string, never>
    >;
    organizationId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUserOrganization>>,
      Record<string, never>
    >;
    role?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUserOrganization>>,
      Record<string, never>
    >;
    user?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUserOrganization>>,
      Record<string, never>
    >;
  };
  UserReferral?: {
    createdAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUserReferral>>,
      Record<string, never>
    >;
    id?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUserReferral>>,
      Record<string, never>
    >;
    inviter?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUserReferral>>,
      Record<string, never>
    >;
    newbie?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IUserReferral>>,
      Record<string, never>
    >;
  };
  XpAudit?: {
    applicableOn?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IXpAudit>>,
      Record<string, never>
    >;
    awardedAt?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IXpAudit>>,
      Record<string, never>
    >;
    branchTransferId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IXpAudit>>,
      Record<string, never>
    >;
    destinationBranch?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IXpAudit>>,
      Record<string, never>
    >;
    eventId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IXpAudit>>,
      Record<string, never>
    >;
    eventName?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IXpAudit>>,
      Record<string, never>
    >;
    extraBuildId?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IXpAudit>>,
      Record<string, never>
    >;
    homeGameEventsIndex?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IXpAudit>>,
      Record<string, never>
    >;
    kind?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IXpAudit>>,
      Record<string, never>
    >;
    originBranch?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IXpAudit>>,
      Record<string, never>
    >;
    xpAddOn?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IXpAudit>>,
      Record<string, never>
    >;
    xpAwarded?: GraphCacheUpdateResolver<
      Maybe<WithTypename<IXpAudit>>,
      Record<string, never>
    >;
  };
};

export type GraphCacheConfig = Parameters<typeof cacheExchange>[0] & {
  updates?: GraphCacheUpdaters;
  keys?: GraphCacheKeysConfig;
  optimistic?: GraphCacheOptimisticUpdaters;
  resolvers?: GraphCacheResolvers;
};
